const messagesDE = {
    code: "de",
    messages: {
        cache: {
            management: "Cache-Verwaltung",
            createNew: "Neuen Cache erstellen",
            keySearchPlaceholder: "Schlüssel suchen (Wildcard unterstützt: *chat*, chat*, *chat)",
            type: "Cache-Typ",
            actorType: "Aktortyp",
            selectAutomation: "Automatisierung auswählen",
            selectChatbot: "Chatbot auswählen",
            selectUser: "Benutzer auswählen",
            clearFilters: "Filter löschen",
            deleteSelected: "Ausgewählte löschen",
            extendSelected: "Ausgewählte Dauer verlängern",
            makeSelectedNeverExpire: "Ausgewählte nie ablaufen lassen",
            deleteAllActorCaches: "Alle Caches dieses Aktors löschen",
            emptyState: "Noch kein Cache gefunden",
            editCache: "Cache bearbeiten",
            key: "Cache-Schlüssel",
            keyPlaceholder: "Beispiel: user_session_123",
            value: "Cache-Wert",
            stringValuePlaceholder: "Zeichenfolgenwert",
            dataType: "Datentyp",
            validityDuration: "Gültigkeitsdauer",
            neverExpire: "Nie ablaufen",
            specifyDuration: "Dauer angeben",
            specifyDate: "Datum angeben",
            minutes: "Minuten",
            hours: "Stunden",
            days: "Tage",
            update: "Aktualisieren",
            create: "Erstellen",
            bulkExtend: "Massenverlängerung",
            bulkExtendInfo: "Gültigkeitsdauer von {count} Cache(s) wird verlängert.",
            newValidityDuration: "Neue Gültigkeitsdauer",
            extend: "Verlängern",
            keyLabel: "Schlüssel",
            valueLabel: "Wert",
            typeLabel: "Typ",
            createdBy: "Erstellt von",
            createdAt: "Erstellt am",
            updatedBy: "Aktualisiert von",
            expiresAt: "Läuft ab am",
            actions: "Aktionen",
            edit: "Bearbeiten",
            extendDuration: "Dauer verlängern",
            makeNeverExpire: "Nie ablaufen lassen",
            loadError: "Cache-Liste konnte nicht geladen werden",
            updateSuccess: "Cache aktualisiert",
            createSuccess: "Cache erstellt",
            saveError: "Cache konnte nicht gespeichert werden",
            deleteCache: "Cache löschen",
            confirmDelete: "Ja, löschen",
            deleteSuccess: "Cache gelöscht",
            extendSuccess24h: "Cache-Dauer um 24 Stunden verlängert",
            extendError: "Cache-Dauer konnte nicht verlängert werden",
            deleteActorCaches: "Actor-Caches löschen",
            deleteActorCachesConfirm: "Sind Sie sicher, dass Sie alle Caches von \"{actor}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            confirmDeleteAll: "Ja, alle löschen",
            countDeleted: "{count} Cache(s) gelöscht",
            bulkDelete: "Massenlöschung",
            bulkDeleteConfirm: "{count} Cache(s) werden gelöscht. Sind Sie sicher?",
            bulkMakeNeverExpire: "Massen Nie-Ablaufen",
            bulkMakeNeverExpireConfirm: "Ablauf wird von {count} Cache(s) entfernt. Sind Sie sicher?",
            makeNeverExpireSuccess: "Cache auf nie ablaufen gesetzt",
            makeNeverExpireError: "Cache konnte nicht auf nie ablaufen gesetzt werden",
            bulkExtendError: "Cache-Dauern konnten nicht verlängert werden",
            bulkExtendSuccess: "{count} Cache-Dauer(n) verlängert",
            bulkMakeNeverExpireSuccess: "{count} Cache(s) auf nie ablaufen gesetzt",
            deleteCacheConfirm: "Sind Sie sicher, dass Sie den Cache \"{key}\" löschen möchten?",
            selectedCount: "{count} Cache(s) ausgewählt",
            valueTitle: "Cache-Wert: {key}",
            never: "Nie",
            automation: "Automatisierung",
            chatbot: "Chatbot",
            user: "Benutzer",
            api: "API",
            all: "Alle",
            public: "Öffentlich",
            private: "Privat"
        },
        zoho: {
            SETTING_GROUP: "Einstellungen",
            usermapping: "Benutzerzuordnung"
        },
        chatWindow: {
            descending: "Absteigend",
            ascending: "Aufsteigend",
            filterTable: "Filtern",
            thereIsNoChatContent: "Kein Chat-Inhalt verfügbar.",
            thereIsNoChatContentDsc: "Hier können Sie den Chat-Inhalt anzeigen und Nachrichten senden.",
            interactions: "Interaktionen:",
            departments: "Abteilungen",
            channels: "Kanäle",
            date: "Datum",
            lastChatStatus: "Letzter Chat-Status",
            all: "Alle",
            queued: "Warteschlange",
            open: "Offen",
            closed: "Geschlossen",
            private: "Privat",
            chatbot: "Chatbot",
            lostMissed: "Verloren / Verpasst",
            interaction: "Interaktion",
            myActiveInbox: "Mein aktiver Posteingang",
            activeQueueInbox: "Aktiv + Warteschlange Posteingang",
            chatbotActiveInbox: "Chatbot aktiver Posteingang",
            myDepartmentsActiveInbox: "Aktiver Posteingang meiner Abteilungen",
            notInteractedYesterday: "Gestern keine Interaktionen",
            queueInbox: "Warteschlange Posteingang",
            whatsappActiveInbox: "WhatsApp aktiver Posteingang",
            socialMediaActiveInbox: "Social Media aktiver Posteingang",
            missedThisMonth: "Diesen Monat verpasste Chats",
            chooseAFileOrDragItHere: "Wählen Sie eine Datei oder ziehen Sie sie hierher!",
            watching: "Beobachten",
            selectFilter: "Filter auswählen",
            clearAll: "Alles löschen",
            me: "Ich",
            today: "Heute",
            yesterday: "Gestern",
            thisWeek: "Diese Woche",
            lastWeek: "Letzte Woche",
            last7Days: "Letzte 7 Tage",
            last30Days: "Letzte 30 Tage",
            thisMonth: "Diesen Monat",
            lastMonth: "Letzten Monat",
            last24h: "Letzte 24 Stunden",
            custom: "Benutzerdefiniert",
            startMessage: "Nachricht starten",
            goToAgentReport: "Zum Agentenbericht gehen",
            agentDetail: "Agenten-Detail",
            agentList: "Agentenliste",
            selectedFilter: "Ausgewählter Filter",
            groupBy: "Gruppieren",
            none: "Keine Gruppe",
            agent: "Vertreter",
            department: "Abteilung",
            tag: "Tag",
            website: "Website",
            channel: "Kanal",
            platform: "Plattform",
            answerStatus: "Antwortstatus",
            sortBy: "Sortieren",
            lastPostAbove: "Letzter Beitrag oben",
            newChatsAbove: "Neue Chats oben",
            oldChatsAbove: "Alte Chats oben",
            live: "Live",
            systemStatus: "Systemstatus",
            refresh: "Aktualisieren",
            close: "Schließen",
            totalCustomers: "Gesamtkunden",
            totalAnswered: "Insgesamt beantwortet",
            waitingAnswer: "Wartet auf Antwort",
            totalAgentInChat: "Gesamtzahl der Agenten im Chat",
            onlineAgentCount: "Anzahl der Online-Agenten",
            totalCustomer: "Gesamtkunde",
            answered: "Beantwortet",
            unanswered: "Unbeantwortet",
            noContactWasFoundMatchingTheCurrentFilters: "Es wurde kein Kontakt gefunden, der den aktuellen Filtern entspricht.",
            you: "Du",
            others: "Andere",
            queue: "Warteschlange",
            chatbotContact: "Chatbot",
            closedContact: "Geschlossen",
            myInteractions: "Meine Interaktionen",
            special: "Spezial",
            allInteractions: "Alle Kontakte",
            waiting: "Ausstehend",
            departmentToWhichItIsAffiliated: "Abteilung, der es zugeordnet ist",
            owner: "Besitzer",
            switchToLiveSupportMode: "Zum Live-Support-Modus wechseln",
            switchToLiveSupportModeConfirmation: "Möchten Sie in den Live-Support-Modus wechseln, um diesen Kontakt anzuzeigen?",
            hiddenChatsWarning: "Es gibt {count} Chats, die Sie in dieser Liste nicht sehen können",
            clickToSeeDetails: "Klicken Sie, um Details zu sehen",
            viewDetails: "Details anzeigen",
            hiddenChatsDetails: "Details ausgeblendeter Chats",
            totalHiddenChats: "Gesamt ausgeblendete Chats",
            examples: "Beispiele",
            reasons: {
                visitorNotFound: "Besucher nicht gefunden",
                noChannelAccess: "Sie haben keinen Zugang zu diesem Kanal",
                ownedByOtherNotChannelOwner: "Gehört einem anderen Benutzer (Sie sind nicht der Kanaleigentümer)",
                ownedByOtherNoChannel: "Gehört einem anderen Benutzer (Ohne Kanal)",
                noOwnerAdminOnly: "Chat ohne Eigentümer (Nur Administratoren und Kanaleigentümer können sehen)"
            }
        },
        chat: {
            inbox: "Posteingang",
            layouts: {
                chat: "Chat-Layout",
                table: "Tabellen-Layout",
                kanban: "Kanban-Layout"
            },
            filters: {
                allContacts: "Alle Kontakte",
                myInbox: "Mein Posteingang",
                myContacts: "Meine Kontakte",
                missed: "Verpasst",
                unanswered: "Unbeantwortet",
                unassigned: "Nicht Zugewiesen",
                chatbot: "Chatbot"
            },
            groups: {
                views: "Ansichten",
                customFilters: "Benutzerdefinierte Filter",
                team: "Team",
                contacts: "Kontakte",
                system: "System"
            },
            sidebar: {
                tabScreen: "Tab-Bildschirm",
                search: "Suchen",
                addNewFilter: "Neuen Filter hinzufügen",
                edit: "Bearbeiten",
                showInTable: "Im Tabellenmodus anzeigen",
                showInKanban: "Im Kanban-Modus anzeigen",
                rename: "Umbenennen",
                makePublic: "Öffentlich machen",
                makePrivate: "Privat machen",
                moveToTop: "Nach oben verschieben",
                moveToBottom: "Nach unten verschieben",
                delete: "Löschen",
                renameFilterTitle: "Filter umbenennen",
                filterNamePlaceholder: "Filtername eingeben",
                positionUpdateError: "Fehler beim Aktualisieren der Position",
                filterNameEmpty: "Filtername darf nicht leer sein",
                filterNameUpdated: "Filtername aktualisiert",
                filterNameUpdateError: "Fehler beim Aktualisieren des Filternamens",
                filterVisibilityUpdateError: "Fehler beim Aktualisieren der Filter-Sichtbarkeit",
                filterMadePrivate: "Filter auf privat gesetzt",
                filterMadePublic: "Filter auf öffentlich gesetzt",
                filterMovedToTop: "Filter nach oben verschoben",
                filterMovedToBottom: "Filter nach unten verschoben",
                filterMoveError: "Fehler beim Verschieben des Filters",
                onlyCreatorOrRootCanDeletePublic: "Nur der Ersteller oder Root-Benutzer kann öffentliche Filter löschen",
                deleteFilterTitle: "Filter löschen",
                deleteFilterConfirm: "Sind Sie sicher, dass Sie den Filter \"{name}\" löschen möchten?",
                deleteFilterOk: "Löschen",
                deleteFilterCancel: "Abbrechen",
                filterDeleted: "Filter gelöscht",
                filterDeleteError: "Fehler beim Löschen des Filters",
                websiteAnalytics: "Website-Analyse"
            },
            gridContactList: {
                emptyConversationsTitle: "Kein Chat gefunden",
                emptyConversationsDescription: "Sie haben noch keinen aktiven Chat. Sie können einen neuen Chat von der Kundenseite starten.",
                markAsUnanswered: "Als unbeantwortet markieren",
                markAsAnswered: "Als beantwortet markieren",
                removeVIP: "VIP entfernen",
                markAsVIP: "Als VIP markieren",
                markAsRead: "Als gelesen markieren",
                markAsUnread: "Als ungelesen markieren",
                closeChat: "Chat schließen",
                markedAsAnswered: "Als beantwortet markiert",
                markedAsUnanswered: "Als unbeantwortet markiert",
                operationFailed: "Vorgang fehlgeschlagen",
                markedAsVIP: "Als VIP markiert",
                vipRemoved: "VIP entfernt",
                markedAsUnread: "Als ungelesen markiert",
                markedAsRead: "Als gelesen markiert",
                confirmCloseChat: "Sind Sie sicher, dass Sie den Chat beenden möchten?",
                chatClosed: "Chat geschlossen"
            },
            tableContactList: {
                editFilter: "Filter bearbeiten",
                chatStatus: "Chat-Status",
                grouping: "Gruppierung",
                allContacts: "Alle Kontakte",
                groupNone: "Keine",
                groupTag: "Tag",
                groupDepartment: "Abteilung",
                groupChannel: "Kanal",
                groupPlatform: "Plattform",
                groupOwner: "Besitzer",
                groupUsers: "Teilnehmer",
                groupAnswerStatus: "Antwortstatus",
                statusAll: "Alle",
                statusOpen: "Offen",
                statusClosed: "Geschlossen",
                statusUnknown: "Unbekannt",
                copyLabel: "Kopie",
                filterCreatedSuccess: "Filter erfolgreich erstellt",
                filterCreatedNameDuplicate: "Der Name \"{createName}\" wurde bereits verwendet. Filter wurde als \"{filterName}\" erstellt.",
                filterCreateFailed: "Filter konnte nicht erstellt werden",
                filterCreateError: "Beim Erstellen des Filters ist ein Fehler aufgetreten.",
                platformSupsis: "Supsis",
                platformEmail: "E-Mail",
                platformWhatsapp: "WhatsApp",
                platformWeb: "Web",
                platformInstagram: "Instagram",
                platformTelegram: "Telegram",
                platformMessenger: "Messenger",
                platformMetaLeads: "Meta Leads",
                platformTrendyol: "Trendyol",
                platformLinkedin: "LinkedIn",
                answerStatusAnswered: "Beantwortet",
                answerStatusUnanswered: "Unbeantwortet"
            },
            kanbanContactList: {
                filterHide: "Filter ausblenden",
                filterAdd: "Filter hinzufügen",
                broadcast: "Broadcast",
                broadcastSelectPlaceholder: "Broadcast auswählen...",
                loading: "Wird geladen...",
                broadcastNotFound: "Kein Broadcast gefunden",
                broadcastTitle: "Titel",
                broadcastDate: "Datum",
                broadcastStatus: "Status",
                broadcastProgress: "Fortschritt",
                refresh: "Aktualisieren",
                kanbanLoading: "Kanban wird geladen...",
                deletedUser: "Gelöschter Benutzer",
                unowned: "Ohne Besitzer",
                activeInChat: "Aktiv (im Chat)",
                newInQueue: "Neu (in Warteschlange)",
                agentDown: "Agent ausgefallen",
                closed: "Geschlossen",
                blocked: "Blockiert",
                unblocked: "Nicht blockiert",
                groupsLoadError: "Fehler beim Laden der Gruppen",
                dataLoadError: "Fehler beim Laden der Daten",
                broadcastsLoadError: "Fehler beim Laden der Broadcasts",
                dataRefreshed: "Daten aktualisiert",
                refreshError: "Fehler beim Aktualisieren",
                unknownContact: "Unbekannter Kontakt",
                assigned: "Nicht zugewiesen",
                platformMobile: "Mobil",
                broadcastStatusCreated: "Erstellt",
                broadcastStatusScheduled: "Geplant",
                broadcastStatusQueued: "In Warteschlange",
                broadcastStatusRunning: "Wird gesendet",
                broadcastStatusCompleted: "Abgeschlossen",
                broadcastStatusFailed: "Fehlgeschlagen",
                broadcastStatusCancelled: "Abgebrochen",
                metaLeadNewLead: "Neuer Lead",
                metaLeadInitialContact: "Erster Kontakt",
                metaLeadNeedsAssessment: "Bedarfsanalyse",
                metaLeadProposalSent: "Angebot gesendet",
                metaLeadProposalReview: "Angebotsprüfung",
                metaLeadNegotiation: "Verhandlung",
                metaLeadDecisionStage: "Entscheidungsphase",
                metaLeadClosure: "Abschluss",
                metaLeadFollowUp: "Nachverfolgung",
                broadcastSent: "Gesendet",
                broadcastDelivered: "Zugestellt",
                broadcastRead: "Gelesen",
                broadcastFailed: "Fehlgeschlagen",
                broadcastEdited: "Bearbeitet",
                broadcastDeleted: "Gelöscht",
                triggerTypeApi: "API",
                triggerTypeBroadcast: "Broadcast",
                triggerTypeAutomation: "Automatisierung",
                emptyGroup: "Keine Kontakte in dieser Gruppe",
                loadMore: "Mehr laden...",
                groupSelectTitle: "Gruppierungsfeld auswählen",
                searchPlaceholder: "Suchen...",
                categoryBasic: "Grundlegend",
                categoryDemographic: "Demografisch",
                categoryTags: "Tags & Kategorie",
                categoryMeta: "Meta Leads",
                categoryBroadcast: "Broadcast",
                categoryOther: "Sonstige",
                fieldAnswerStatus: "Antwortstatus",
                fieldLastConversationStatus: "Chat-Status",
                fieldOwner: "Besitzer",
                fieldUsers: "Teilnehmer",
                fieldChannel: "Kanal",
                fieldPlatform: "Plattform",
                fieldCountry: "Land",
                fieldCity: "Stadt",
                fieldBrowser: "Browser",
                fieldPreferredLang: "Sprache",
                fieldTags: "Tags",
                fieldDepartment: "Abteilung",
                fieldMetaLeadStatus: "Lead-Status",
                fieldMetaLeadAdName: "Anzeigenname",
                fieldMetaLeadAdsetName: "Anzeigengruppe",
                fieldMetaLeadCampaignName: "Kampagne",
                fieldMetaLeadFormName: "Formularname",
                fieldMetaLeadPlatform: "Meta-Plattform",
                fieldLastBroadcastStatus: "Broadcast-Status",
                fieldLastBroadcastReason: "Broadcast-Grund",
                fieldBlockedSnapshot: "Blockierstatus",
                fieldLastTriggerType: "Auslösertyp",
                fieldZohoLeadStatus: "Zoho Lead-Status",
                fieldZohoLeadSource: "Zoho Lead-Quelle",
                broadcastTriggerSuccess: "Auf Broadcast-Nachricht geantwortet!",
                broadcastTriggerWaiting: "Warte auf Antwort...",
                unknownUser: "Unbekannter Benutzer",
                unread: "Ungelesen",
                platformIg: "Instagram",
                platformFb: "Facebook"
            },
            gridContactListToolBar: {
                chatStatus: "Chat-Status",
                sortBy: "Sortieren nach",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                allStatus: "Alle",
                lastActivity: "Letzte Aktivität",
                createdAt: "Erstellt am",
                unknown: "Unbekannt"
            },
            chatCloseSettings: {
                selectPhone: "Telefon auswählen",
                selectPhoneDescription: "Mit welchem Telefon möchten Sie {number} anrufen?",
                call: "Anrufen",
                unnamedChannel: "Unbenannter Kanal",
                typeVisitorName: "Besuchername eingeben...",
                webphoneCall: "Mit Webphone anrufen",
                hideSystemMessages: "Systemnachrichten ausblenden",
                chatbotDebugMode: "Chatbot-Debug-Modus",
                createTask: "Aufgabe erstellen",
                showProfile: "Profil anzeigen",
                sendCapiEvent: "CAPI-Ereignis senden",
                noPhoneNumber: "Keine Telefonnummer zum Anrufen gefunden",
                noWebphoneChannel: "Kein Webphone-Kanal gefunden",
                webphoneCalling: "Rufe {number} mit Webphone an...",
                unknown: "Unbekannt",
                channelTypeKirmiziSantral: "Rote Zentrale",
                channelTypeTelnyx: "Telnyx",
                channelTypeNetgsm: "NetGSM",
                channelTypeWebPhone: "Web-Telefon",
                platformWeb: "Web",
                platformWhatsapp: "WhatsApp",
                platformWhatsappBusiness: "WhatsApp Business",
                platformInstagram: "Instagram",
                platformInstagramV2: "Instagram V2",
                platformMessenger: "Messenger",
                platformTelegram: "Telegram",
                platformTrendyol: "Trendyol",
                platformEmail: "E-Mail",
                platformSms: "SMS",
                vipCustomerTooltip: "★ VIP-Kunde"
            },
            contactDetail: {
                removeVIPTooltip: "VIP entfernen",
                markAsVIPTooltip: "Als VIP markieren (VIP-markierte Benutzer werden in Chats immer oben angezeigt).",
                customerOwnership: "Kundenbesitz",
                ownershipDescription: "Wenn der Kundenbesitz zugewiesen wird, können nur der Besitzer und Volladministratoren ihn sehen",
                unowned: "Nicht zugewiesen",
                assignToMe: "Mir zuweisen",
                removeOwnership: "Besitz entfernen",
                dragPlaceholder: "Hierher verschieben",
                currentConversationDepartment: "Aktuelles Gesprächsdepartement",
                pastInteractionDepartments: "Vergangene Interaktionsdepartements",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                zohoSync: "Zoho-Synchronisierung",
                zohoSyncQuestion: "Möchten Sie Kontaktänderungsvorgänge auch in Zoho durchführen?",
                basicInfo: "Kontaktinformationen",
                loginInfo: "Kontaktformularinformationen",
                profileFields: "Profilfelder",
                systemInfo: "Systeminformationen"
            },
            contactDetailItem: {
                removeOwnership: "Besitz entfernen",
                assignOwnershipToMe: "Besitz mir zuweisen",
                vipCustomer: "VIP-Kunde",
                contentCopiedSuccess: "Inhalt erfolgreich kopiert!",
                invalidEmail: "Ungültige E-Mail-Adresse!",
                invalidValue: "Ungültiger Wert!"
            },
            filtersSection: {
                addFilter: "Filter Hinzufügen",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                relevance: "Relevanz",
                lastActivityNewest: "Neueste Aktivität",
                lastActivityOldest: "Älteste Aktivität",
                noParticipant: "Kein Teilnehmer",
                ownershipFilter: "Besitzfilter",
                metaReferral: "Meta-Verweis",
                userStatus: "Benutzerstatus",
                unowned: "Nicht zugewiesen",
                fromAds: "Von Werbung",
                notFromAds: "Nicht von Werbung",
                blockedUsers: "Blockierte Benutzer",
                unblockedUsers: "Nicht blockierte Benutzer",
                unread: "Ungelesen",
                read: "Gelesen",
                yes: "Ja",
                no: "Nein",
                answered: "Beantwortet",
                unanswered: "Unbeantwortet",
                active: "Aktiv",
                lost: "Verloren",
                new: "Neu",
                chatbot: "Chatbot",
                closedStatus: "Geschlossen",
                platform: "Plattform",
                channel: "Kanal",
                department: "Abteilung",
                tag: "Tag",
                participant: "Teilnehmer",
                ownership: "Besitz",
                lastActivityTime: "Letzte Aktivitätszeit",
                fullName: "Vollständiger Name",
                email: "E-Mail",
                phone: "Telefon",
                vipCustomer: "VIP-Kunde",
                hasVIP: "Hat VIP",
                noVIP: "Kein VIP",
                operatingSystem: "Betriebssystem",
                browser: "Browser",
                ipAddress: "IP-Adresse",
                visitingPage: "Besuchte Seite",
                adInteraction: "Werbeinteraktion",
                blockedStatus: "Blockierungsstatus",
                connectionTime: "Verbindungszeit",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                readStatus: "Lesestatus",
                missedChat: "Verpasster Chat",
                answerStatus: "Antwortstatus",
                lastConversationStatus: "Letzter Gesprächsstatus",
                lastTriggerState: "Letzter Trigger-Status",
                type: "Typ",
                name: "Name",
                enterTriggerName: "Trigger-Name eingeben...",
                zohoInfo: "Zoho-Info",
                id: "ID",
                enterContactOrLeadId: "Kontakt- oder Lead-ID eingeben...",
                broadcastMessage: "Broadcast-Nachricht",
                today: "Heute",
                yesterday: "Gestern",
                thisWeek: "Diese Woche",
                lastWeek: "Letzte Woche",
                last7Days: "Letzte 7 Tage",
                last30Days: "Letzte 30 Tage",
                thisMonth: "Diesen Monat",
                lastMonth: "Letzten Monat"
            },
            filterChip: {
                operator: "Operator:",
                enterText: "Text eingeben...",
                enterNumber: "Zahl eingeben...",
                type: "Typ",
                value: "Wert",
                enterValue: "Wert eingeben...",
                addFilter: "Filter Hinzufügen",
                equals: "Gleich",
                contains: "Enthält",
                startsWith: "Beginnt mit",
                endsWith: "Endet mit",
                greaterThan: "Größer als",
                lessThan: "Kleiner als",
                greaterThanOrEqual: "Größer oder gleich",
                lessThanOrEqual: "Kleiner oder gleich",
                between: "Zwischen",
                custom: "Benutzerdefiniert",
                select: "Auswählen"
            },
            filterPanel: {
                backToChat: "Zurück zur Chat-Ansicht",
                publicFilter: "Öffentlicher Filter",
                privateFilter: "Privater Filter",
                editFilterName: "Filtername bearbeiten",
                contactsFound: " Kontakte gefunden",
                enterFilterName: "Filtername eingeben",
                filterSuggestions: "Filtervorschläge",
                private: "Privat",
                public: "Öffentlich",
                createFilter: "Filter Erstellen",
                update: "Aktualisieren",
                changeToPublic: "Auf Öffentlich ändern",
                changeToPrivate: "Auf Privat ändern",
                delete: "Löschen",
                clearSearch: "Suche löschen",
                previous: "Zurück",
                next: "Weiter",
                searchTerm: "Suchbegriff:",
                whichFieldToSearch: "In welchem Feld möchten Sie suchen?",
                contactId: "Kontakt-ID",
                conversationId: "Konversations-ID",
                noSearchAllFields: "Nein, in allen Feldern suchen",
                yesSearchOnlyField: "Ja, nur in {field} suchen",
                search: "Suchen",
                allFields: "Alle Felder",
                fullname: "Vollständiger Name",
                email: "E-Mail",
                whatsappNumber: "WhatsApp-Nummer",
                phone: "Telefon",
                contactIdField: "Kontakt-ID-Feld",
                conversationIdField: "Konversations-ID",
                searchAllFieldsPlaceholder: "Geben Sie ein, wonach Sie in allen Feldern suchen möchten",
                searchFullnamePlaceholder: "Geben Sie ein, wonach Sie nach vollständigem Namen suchen möchten",
                searchEmailPlaceholder: "Geben Sie ein, wonach Sie nach E-Mail suchen möchten",
                searchWhatsappPlaceholder: "Geben Sie ein, wonach Sie nach WhatsApp suchen möchten",
                searchPhonePlaceholder: "Geben Sie ein, wonach Sie nach Telefon suchen möchten",
                searchContactIdPlaceholder: "Geben Sie die Kontakt-ID ein, nach der Sie suchen möchten",
                searchConversationIdPlaceholder: "Geben Sie die Konversations-ID ein, nach der Sie suchen möchten",
                searchPlaceholder: "Suchen",
                edited: " (Bearbeitet)",
                unnamedFilter: "Unbenannter Filter",
                all: "Alle",
                open: "Offen",
                closed: "Geschlossen",
                unknown: "Unbekannt",
                filterUpdatedSuccess: "Filter erfolgreich aktualisiert",
                filterUpdatedDescription: "Filter \"{name}\" wurde aktualisiert.",
                filterUpdateFailed: "Filter konnte nicht aktualisiert werden",
                filterUpdateError: "Beim Aktualisieren des Filters ist ein Fehler aufgetreten.",
                filterSavedSuccess: "Filter erfolgreich gespeichert",
                filterSavedDescription: "Der Name \"{createName}\" wurde bereits verwendet. Filter wurde als \"{filterName}\" erstellt.",
                filterCreatedDescription: "Filter \"{filterName}\" wurde erstellt.",
                filterSaveFailed: "Filter konnte nicht gespeichert werden",
                filterSaveError: "Beim Speichern des Filters ist ein Fehler aufgetreten.",
                aiFilterCreatedSuccess: "AI-Filter erfolgreich erstellt",
                aiFilterCreatedDescription: "Der Name \"{createName}\" wurde bereits verwendet. Filter wurde als \"{filterName}\" erstellt und angewendet.",
                aiFilterCreatedApplied: "Filter \"{filterName}\" wurde erstellt und angewendet.",
                aiFilterCreateFailed: "Filter konnte nicht erstellt werden",
                aiFilterCreateError: "Beim Erstellen des AI-Filters ist ein Fehler aufgetreten.",
                phoneDetected: "Telefonnummer erkannt",
                emailDetected: "E-Mail-Adresse erkannt",
                idFormatDetected: "ID-Format erkannt",
                contactIdDetected: "Kontakt-ID erkannt",
                conversationIdDetected: "Konversations-ID erkannt",
                searchMode: "Suchmodus",
                phoneDetectedMessage: "Der eingegebene Wert sieht wie eine Telefonnummer aus. Möchten Sie nur im Telefonnummerfeld suchen?",
                emailDetectedMessage: "Der eingegebene Wert sieht wie eine E-Mail-Adresse aus. Möchten Sie nur im E-Mail-Feld suchen?",
                idFormatDetectedMessage: "Der eingegebene Wert sieht wie ein ID-Format aus. In welchem Feld möchten Sie suchen?",
                phoneField: "Telefonnummerfeld",
                emailField: "E-Mail-Feld",
                conversationIdFieldName: "Konversations-ID-Feld",
                idField: "ID-Feld",
                deleteFilter: "Filter Löschen",
                deleteFilterConfirm: "Sind Sie sicher, dass Sie den Filter \"{name}\" löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
                cancel: "Abbrechen",
                filterDeletedSuccess: "Filter erfolgreich gelöscht",
                filterDeletedDescription: "Filter \"{name}\" wurde gelöscht.",
                filterDeleteFailed: "Filter konnte nicht gelöscht werden",
                filterDeleteError: "Beim Löschen des Filters ist ein Fehler aufgetreten.",
                visibilityUpdatedSuccess: "Sichtbarkeit erfolgreich aktualisiert",
                visibilityUpdatedDescription: "Filter wurde auf \"{visibility}\" gesetzt.",
                visibilityUpdateFailed: "Sichtbarkeit konnte nicht aktualisiert werden",
                visibilityUpdateError: "Beim Aktualisieren des Filters ist ein Fehler aufgetreten.",
                publicVisibility: "öffentlich",
                privateVisibility: "privat"
            },
            contactList: {
                noContactsFound: "Keine Kontakte gefunden",
                unknownContact: "Unbekannter Kontakt",
                unknown: "Unbekannt",
                fullName: "Vollständiger Name",
                platform: "Plattform",
                email: "E-Mail",
                phone: "Telefon",
                tags: "Tags",
                status: "Status",
                lastActivity: "Letzte Aktivität",
                answerStatus: "Antwortstatus",
                channel: "Kanal",
                owner: "Besitzer",
                vip: "VIP",
                connectionTime: "Verbindungszeit",
                unread: "Ungelesen",
                departments: "Abteilungen",
                operatingSystem: "Betriebssystem",
                browser: "Browser",
                countryCity: "Land - Stadt",
                ipAddress: "IP-Adresse",
                visitingPage: "Besuchte Seite",
                lastConversationDate: "Datum der letzten Unterhaltung",
                blockedStatus: "Blockierungsstatus",
                lastConversationParticipants: "Teilnehmer der letzten Unterhaltung",
                preferredLanguage: "Bevorzugte Sprache",
                createdAt: "Erstellt am",
                updatedAt: "Aktualisiert am",
                broadcastStatus: "Broadcast-Status",
                broadcastAnswer: "Broadcast-Antwort",
                zohoContactId: "Zoho Kontakt-ID",
                zohoLeadId: "Zoho Lead-ID",
                profileFields: "Profilfelder",
                closed: "Geschlossen",
                open: "Offen",
                unknownStatus: "Unbekannt",
                answered: "Beantwortet",
                unanswered: "Unbeantwortet",
                unreadStatus: "Ungelesen",
                readStatus: "Gelesen",
                vipStatus: "VIP",
                normal: "Normal",
                blocked: "Blockiert",
                today: "Heute",
                yesterday: "Gestern",
                enqueued: "In Warteschlange",
                sent: "Gesendet",
                delivered: "Zugestellt",
                read: "Gelesen",
                deleted: "Gelöscht",
                failed: "Fehlgeschlagen",
                replied: "Geantwortet",
                notReplied: "Nicht geantwortet",
                jsonProperty: "JSON-Eigenschaft",
                jsonCopiedSuccess: "JSON-Inhalt erfolgreich kopiert!"
            }
        },
        form: {
            title: {
                titleSettings: "Titel-Einstellungen",
                fullNameSettings: "Einstellungen für den vollständigen Namen",
                emailSettings: "Einstellungen für E-Mail",
                addressSettings: "Adresseinstellungen",
                phoneSettings: "Telefoneinstellungen",
                datePickerSettings: "Datumsauswahl-Einstellungen",
                shortTextSettings: "Einstellungen für kurzen Text",
                longTextSettings: "Einstellungen für langen Text",
                dropDownListSettings: "Einstellungen für Dropdown-Liste",
                singleChoiceSettings: "Einstellungen für Einzelauswahl",
                multipleSelectionSettings: "Einstellungen für Mehrfachauswahl",
                numberSettings: "Zahleneinstellungen",
                hourSettings: "Stundeneinstellungen",
                spinnerSettings: "Spinner-Einstellungen",
                sendSettings: "Sende-Einstellungen",
                starRatingSettings: "Sternebewertungseinstellungen",
                ratingScaleSettings: "Bewertungsskala-Einstellungen",
                separationElementSettings: "Einstellungen für Trennelement",
                fileUploadSettings: "Einstellungen für Datei-Upload",
                imageSettings: "Bildeinstellungen"
            },
            lineColor: "Linienfarbe",
            separatorColorInfo: "Wählen Sie die Farbe des Trenners oder geben Sie sie ein (z. B. #RRGGBB)",
            separatorHeight: "Trennhöhe",
            separatorHeightInfo: "Geben Sie die Höhe des Trenners ein",
            bottomSpace: "Unterer Abstand",
            bottomSpaceInfo: "Fügen Sie unter dem Trennzeichen Abstand hinzu",
            topSpace: "Oberer Abstand",
            topSpaceInfo: "Fügen Sie über dem Trennzeichen Abstand hinzu",
            sideSpace: "Seitenabstand",
            sideSpaceInfo: "Fügen Sie Abstand links und rechts vom Trenner hinzu",
            onlyImageUpload: "Sie können nur ein Bild hochladen!",
            imageSizeLimit: "Die Größe Ihres Bildes darf maximal 5 MB betragen!",
            image: "Bild",
            size: "Größe",
            width: "Breite",
            height: "Höhe",
            imageAlignment: "Bildausrichtung",
            wide: "Weit",
            small: "Klein",
            textAlignment: "Textausrichtung",
            chooseHorizontalAlignment: "Wählen Sie, wie dieser Titel horizontal ausgerichtet werden soll.",
            headerSize: "Überschriftengröße",
            addSmallTextBelowHeader: "Fügen Sie einen kleineren Text unterhalb der Überschrift hinzu",
            subHeaderText: "Unterüberschrift Text",
            subLabel1: "Unterbezeichner(1)",
            subLabel2: "Unterbezeichner(2)",
            validPhoneNumber: "Bitte geben Sie eine gültige Telefonnummer ein",
            masked: "Maskiert",
            copyField: "Feld kopieren",
            copyFieldDescription: "Erstellen Sie eine Kopie dieses Feldes und behalten Sie alle gespeicherten Einstellungen bei",
            enterQuestion: "Stellen Sie eine Frage",
            notRequired: "Nicht erforderlich",
            addDescriptionBelowField: "Fügen Sie eine kurze Beschreibung unter dem Feld hinzu",
            setDefault: "Als Standard festlegen",
            pleaseSelect: "Bitte wählen Sie",
            placeholder: "Platzhalter",
            required: "Erforderlich",
            fieldEmptyError: "Das Formular darf nicht gesendet werden, wenn dieses Feld leer ist",
            subLabels: "Unterbeschriftungen",
            addressLine1: "Adresszeile 1",
            addressLine2: "Adresszeile 2",
            postalCode: "Postleitzahl",
            stateProvince: "Bundesland / Region",
            chooseLabelAlignment: "Wählen Sie, wie der Etikettentext horizontal ausgerichtet werden soll",
            right: "RECHTS",
            left: "LINKS",
            top: "OBEN",
            labelAlignment: "Etikettenausrichtung",
            fieldLabel: "Feldbezeichnung",
            read: "Gelesen",
            itemsPerPage: "Einträge/Seite",
            downloadAllDataAsPDF: "Alle Daten als PDF herunterladen",
            downloadAllDataAsExcel: "Alle Daten als Excel herunterladen",
            downloadSelectedDataAsPDF: "Ausgewählte Daten als PDF herunterladen",
            downloadSelectedDataAsExcel: "Ausgewählte Daten als Excel herunterladen",
            selectItemToViewDetails: "Wählen Sie ein Element aus, um Details anzuzeigen.",
            deleteFormConfirm: "Wenn Sie dieses Formular löschen, werden alle damit verbundenen Daten dauerhaft gelöscht. Sind Sie sicher, dass Sie fortfahren möchten?",
            redicetFormAnswer: "FORMULARANTWORTEN WEITERLEITEN",
            redicetFormAnswerDesc: "Wenn Sie Formularantworten an das Ticketsystem weiterleiten, stellen Sie sicher, dass Sie eine Telefonnummer oder E-Mail-Adresse vom Benutzer im Formular anfordern. Diese Informationen sind wichtig für eine schnellere und effektivere Kommunikation mit dem Benutzer.",
            redicetFormAnswerDesc2: "Formularantworten werden als Tickets an das System weitergeleitet",
            rediectAnswersToTicket: "Eingehende Antworten auf Ticket umleiten",
            errorTicketMode: "Fehler beim Aktualisieren des Ticketmodus:",
            formView: "Formular anzeigen",
            formEdit: "Formular aktualisieren",
            totalResponse: "Antwort insgesamt",
            totalUnreadResponse: "Ungelesene Antworten insgesamt",
            totalReadResponse: "Gesamte Leseantwort",
            totalArchivedResponse: "Gesamte archivierte Antwort",
            singleChoice: "Einzelne Wahl",
            _delete: "Löschen",
            inbox: "Posteingang",
            edit: "bearbeiten",
            forms: "Formulare",
            formsDesc: "Hier können Sie Ihre Formulare verwalten.",
            createaForm: "Formular erstellen",
            allForms: "alle Formulare",
            formPublish: {
                shareFast: "SCHNELL TEILEN",
                shareFastDesc: "Direkter Formular-Link und Social Sharing",
                add: "HINZUFÜGEN",
                addDesc: "Verschiedene Optionen zum Einbetten von Webseiten",
                assignForm: "FORMULAR ZUWEISEN",
                assignFormDesc: "Weisen Sie Ihre Formulare anderen zu",
                emails: "E-MAILS",
                emailsDesc: "Erinnerungen und sofortige Freigabe",
                prefill: "PREFILL",
                prefillDesc: "Formulare vorausgefüllt",
                pdf: "PDF",
                pdfDesc: "Ausfüllbares PDF herunterladen",
                platforms: "PLATTFORMEN",
                platformsDesc: "Veröffentlichungsoptionen für Drittanbieter",
                linkToYour: "LINK-ADRESSE IHRES FORMULARS",
                linkToYourDesc: "Ihr Formular wurde sicher veröffentlicht und steht unter dieser Adresse zur Verwendung bereit.",
                shareWithLink: "MIT LINK TEILEN",
                publicForm: "Öffentliches Formular",
                copyLink: "LINK KOPIEREN",
                openInNewTab: "IN NEUER REGISTERKARTE ÖFFNEN",
                linkCopied: "Link Kopiert",
                codeCopied: "Kopierter Code",
                iframe: "IFRAME",
                iframeDesc: "Fügen Sie das Formular mit iFrame zu Ihrer Seite hinzu",
                openWindow: "OFFENES FENSTER",
                openWindowDesc: "Link zu einem Pop-up-Formular",
                formAddDesc: "Kopieren Sie dieses Snippet, fügen Sie es in Ihren Code ein und platzieren Sie Ihr Formular auf Ihrer Website."
            },
            formSettings: {
                enterNameForm: "Geben Sie einen Namen für dieses Formular ein",
                selectStatusForm: "Wählen Sie den Status Ihres Formulars",
                disabled: "Deaktiviert",
                disableSpecifiedTime: "Deaktivieren zu einer bestimmten Zeit",
                disableFormResponse: "Deaktivieren, wenn das Formularantwortlimit erreicht ist",
                pageShownAfterForm: "Die Seite, die nach dem Absenden des Formulars angezeigt wird",
                formNotFound: "Formular nicht gefunden.",
                errorLoadingform: "Beim Laden des Formulars ist ein Fehler aufgetreten.",
                formUpdated: "Der Formulartitel wurde erfolgreich aktualisiert.",
                formErrorUpdated: "Beim Aktualisieren des Formulartitels ist ein Fehler aufgetreten",
                formSettings: "FORMULAR EINSTELLUNGEN",
                changeFormStateAndProperties: "Formularstatus und -eigenschaften ändern",
                title: "Titel",
                newFormSettings: "Neue Formulareinstellungen",
                formStatus: "Formular Status",
                activateOrDeactivate: "Aktivieren, deaktivieren oder bedingt aktivieren Sie Ihr Formular",
                effective: "EFFEKTIV",
                yourFromIsVisible: "Ihr Formular ist nun sichtbar und kann Antworten empfangen",
                emails: "E-MAILS",
                emailsDesc: "Senden von Autoresponder-E-Mails und Benachrichtigungs-E-Mails",
                conditions: "BEDINGUNGEN",
                conditionsDesc: "Abschnitt mit bedingter Logik, der auf der Grundlage von Formulareingaben Aktionen auslöst",
                thankYouPage: "DANKESCHÖN-SEITE",
                thankYouPageDesc: "Die Seite, die nach dem Absenden des Formulars angezeigt wird",
                integretions: "INTEGRATIONEN",
                integretionsDesc: "Verbinden Sie Ihr Formular mit anderen Anwendungen"
            },
            clickToDeleteYourLogo: "Klicken Sie, um Ihr Logo zu löschen",
            create: "erstellen.",
            settings: "Einstellungen",
            load: "Laden Sie",
            insertFormField: "Formularfeld einfügen",
            addYourLogo: "Ihr Logo hinzufügen",
            surveyElements: {
                surveyElements: "Umfrage-Elemente",
                dataTable: "Daten-Tabelle",
                starRating: "Sterne Bewertung",
                evaluationScale: "Bewertungsskala"
            },
            pageElements: {
                pageElements: "Elemente der Seite",
                separationElement: "Trennungselement",
                partitionCollapse: "Zusammenbruch der Teilung",
                pageBreak: "Ende der Seite"
            },
            basicElements: {
                basicElements: "Grundlegende Elemente",
                shortText: "Kurzer Text",
                longText: "Langer Text",
                paragraph: "Absatz",
                dropDownList: "Auswahlliste",
                singleChoice: "Einzige Wahlmöglichkeit",
                multipleSelection: "Mehrfache Auswahl",
                number: "Nummer",
                image: "Bild",
                fileUpload: "Hochladen von Dateien",
                hour: "Stunde",
                spinner: "Spinner",
                send: "Senden"
            },
            formElements: {
                formElements: "Formular-Elemente",
                title: "Titel",
                fullName: "Voller Name",
                email: "Email",
                address: "Adresse",
                phone: "Telefon",
                datePicker: "Datumspicker",
                appointment: "Ernennung",
                signature: "Unterschrift",
                productList: "Produktliste"
            },
            startWithaBlankForm: "Beginnen Sie mit einem leeren Formular",
            startFromScratch: "Ganz von vorne anfangen",
            createOrTransferaForm: "Erstellen oder Übertragen eines Formulars zum Starten der Datenerfassung",
            createForm: "Formular erstellen",
            trashBin: "Papierkorb",
            formAutomations: "Formular-Automatisierungen",
            trashBinList: {
                title: "Papierkorb",
                description: "Ihre gelöschten Formulare werden hier aufgelistet",
                loading: "Gelöschte Formulare werden geladen...",
                restore: "Wiederherstellen",
                permanentDelete: "Dauerhaft löschen",
                delete: "Löschen",
                emptyTitle: "Papierkorb ist leer",
                emptyDescription: "Keine gelöschten Formulare gefunden",
                totalResponses: "Gesamtantworten",
                unread: "Ungelesen",
                read: "Gelesen",
                archived: "Archiviert",
                restoreConfirmDescription: "Sind Sie sicher, dass Sie dieses Formular wiederherstellen möchten? Das Formular und alle Daten werden zur Liste der aktiven Formulare hinzugefügt.",
                deleteConfirmDescription: "Sind Sie sicher, dass Sie dieses Formular dauerhaft löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden und alle mit dem Formular verbundenen Daten werden gelöscht.",
                deletedToday: "Heute gelöscht",
                deletedYesterday: "Gestern gelöscht",
                deletedDaysAgo: "Vor {count} Tagen gelöscht",
                deletedWeeksAgo: "Vor {weeks} Wochen gelöscht",
                deletedMonthsAgo: "Vor {months} Monaten gelöscht",
                restoreSuccess: "Formular erfolgreich wiederhergestellt",
                restoreError: "Beim Wiederherstellen des Formulars ist ein Fehler aufgetreten",
                deleteSuccess: "Formular dauerhaft gelöscht",
                deleteError: "Beim Löschen des Formulars ist ein Fehler aufgetreten"
            }
        },
        automation: {
            deleteAutomationsTitle: "Automatisierungen Löschen",
            deleteAutomationsConfirmation: "Sind Sie sicher, dass Sie {count} Automatisierungen löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            automationsMoveError: "Fehler beim Verschieben der Automatisierungen",
            noAutomationToMove: "Keine Automatisierung zum Verschieben gefunden",
            deleteCategoryConfirmation: "Sind Sie sicher, dass Sie die Kategorie \"{categoryName}\" löschen möchten? Die Automatisierungen in dieser Kategorie werden in die Kategorie \"{generalCategory}\" verschoben.",
            automationsMovedToCategory: "{count} Automatisierungen in die Kategorie \"{categoryName}\" verschoben",
            automationImportedSuccessfully: "Automatisierung {name} erfolgreich importiert",
            automationPasteError: "Fehler beim Einfügen der Automatisierung",
            invalidAutomationExport: "Kein gültiger Supsis Automatisierungs-Export in der Zwischenablage gefunden",
            invalidAutomationJSON: "Kein gültiges Automatisierungs-JSON in der Zwischenablage gefunden",
            clipboardNotSupported: "Zugriff auf die Zwischenablage wird in diesem Browser nicht unterstützt",
            automationJSONCopyError: "Fehler beim Kopieren der Automatisierung",
            automationCopiedToClipboardFallback: "Automatisierung als JSON in die Zwischenablage kopiert (Fallback-Methode)",
            automationCopiedToClipboard: "Automatisierung als JSON in die Zwischenablage kopiert. Sie können sie mit Strg+V in einem anderen Kunden-Panel einfügen.",
            automationCopyError: "Fehler beim Kopieren der Automatisierung",
            automationCopied: "Automatisierung kopiert",
            automationMoveError: "Fehler beim Verschieben der Automatisierung",
            automationMovedToCategory: "Automatisierung in die Kategorie \"{categoryName}\" verschoben",
            categoryDeletedSuccessfully: "Kategorie erfolgreich gelöscht",
            categoryDeleteError: "Fehler beim Löschen der Kategorie",
            automationsDeleteError: "Fehler beim Löschen der Automatisierungen",
            automationsDeletedSuccessfully: "Erfolgreich gelöschte Automationen",
            categoryUpdatedSuccessfully: "Kategorie aktualisiert",
            categoryUpdateError: "Fehler beim Aktualisieren der Kategorie",
            categorySaveError: "Fehler beim Speichern der Kategorie",
            categoryCreatedSuccessfully: "Kategorie erstellt. Sie können Automatisierungen in diese Kategorie ziehen.",
            categoryNameAlreadyExists: "Eine Kategorie mit diesem Namen existiert bereits",
            categoryNameRequired: "Kategoriename darf nicht leer sein",
            moveAllAutomations: "Alle Automatisierungen Verschieben",
            deleteAutomations: "{count} Automatisierungen gelöscht",
            selectedAutomations: "{count} Automatisierungen ausgewählt",
            pasteInfoMessage: "In die Zwischenablage kopierte Automatisierung erkannt! Erstellen Sie sofort eine neue Automatisierung, indem Sie sie mit <strong>Strg+V</strong> einfügen.",
            categoryName: "Kategoriename",
            categoryNamePlaceholder: "Kategoriename eingeben",
            editCategory: "Kategorie Bearbeiten",
            deleteCategory: "Kategorie Löschen",
            createCategory: "Kategorie Hinzufügen",
            publishAutomation: "Veröffentlicht",
            unpublishAutomation: "Gestoppt",
            timerAutomation: "Geplant",
            eventAutomation: "Ereignis",
            deleteAutomation: "Automatisierung Löschen",
            changeCategory: "Kategorie Ändern",
            copyAutomation: "Automatisierung Kopieren",
            copyAutomationAsJSON: "Als JSON Kopieren",
            emptyCategoryMessage: "Sie können Automatisierungen zur Kategorie hinzufügen, indem Sie sie hierher ziehen",
            whenFormSubmitted: "Wenn ein Formular eingereicht wird",
            taskCreated2: "Aufgabe erstellt",
            waitingTaskCreation: "Warte auf die Erstellung der Aufgabe...",
            calendarEventCreated: "Ereignis im Kalender erstellt",
            calendarEventUpdated: "Ereignis im Kalender aktualisiert",
            calendarEventDeleted: "Ereignis aus dem Kalender gelöscht",
            reservationCreated: "Reservierung erstellt",
            reservationDateChanged: "Reservierungsdatum geändert",
            reservationDeleted: "Reservierung gelöscht",
            chatLost: "Wenn der Chat verloren geht",
            webchatCompleted: "Wenn der Web-Chat abgeschlossen ist",
            instagramCompleted: "Wenn der Chat vom Instagram-Kanal abgeschlossen ist",
            messengerCompleted: "Wenn der Chat vom Messenger-Kanal abgeschlossen ist",
            whatsappCompleted: "Wenn der Chat vom WhatsApp-Kanal abgeschlossen ist",
            telegramCompleted: "Wenn der Chat vom Telegram-Kanal abgeschlossen ist",
            chatAssignedToAgent: "Wenn der Chat einem Agenten zugewiesen wird",
            profileButtonClicked: "Wenn die Automatisierungsschaltfläche im Profil gedrückt wird",
            operatedTask: "Aufgabe wird ausgeführt",
            tableSelection: "Tabellenauswahl",
            selectTable: "Tabelle auswählen",
            whichTableAutomationAddRecords: "Welche Tabelle soll automatisiert werden, wenn ein Datensatz hinzugefügt wird? Bitte auswählen.",
            whichTableAutomationUpdateRecords: "In welcher Tabelle soll die Automatisierung ausgeführt werden, wenn ein Datensatz aktualisiert wird? Bitte wählen Sie.",
            whichTableAutomationDeletedRecords: "Aus welcher Tabelle möchten Sie die Automatisierung ausführen, wenn ein Datensatz gelöscht wird? Bitte wählen Sie aus.",
            whichTableAutomationClickRecords: "In welcher Tabelle soll die Automatisierung ausgeführt werden, wenn auf die Automatisierungsschaltfläche eines Datensatzes geklickt wird? Bitte auswählen.",
            selectAtLeastOneField: "Mindestens ein Feld muss ausgewählt werden",
            generalCategory: "Allgemein",
            configureTrackFields: "Verfolgungsfelder konfigurieren",
            configureMessageFilter: "Nachrichtenfilter konfigurieren",
            makeFreeTier: "Kostenlos machen",
            revertFreeTier: "Zurück zu Normal",
            webhook: "Webhook",
            system: "System",
            freeTierTooltip: "Diese Automatisierung ist im kostenlosen Tarif. Die Nutzung wird nicht von Ihrem Kontingent abgezogen.",
            freeTierBadge: "Kostenloser Tarif",
            trackFieldsLabel: "Zu verfolgende Felder",
            trackFieldsSelectPlaceholder: "Wenn kein Feld ausgewählt wird, werden alle Felder verfolgt",
            selectFieldPlaceholder: "Feld auswählen",
            tableMustBeSelectedFirst: "Zuerst muss eine Tabelle für die Automatisierung ausgewählt werden",
            fieldsLoadError: "Fehler beim Laden der Felder",
            trackFieldsUpdated: "Verfolgungsfelder aktualisiert",
            updateError: "Fehler bei der Aktualisierung",
            automationMadeFreeTier: "Automatisierung auf kostenlosen Tarif gesetzt",
            makeFreeTierError: "Fehler beim Setzen des kostenlosen Tarifs",
            automationRevertedToNormalTier: "Automatisierung auf normalen Tarif zurückgesetzt",
            revertFreeTierError: "Fehler beim Zurücksetzen auf normalen Tarif",
            wrongPassword: "Falsches Passwort!",
            configLoadError: "Fehler beim Laden der Konfiguration",
            messageFilterConfigUpdated: "Nachrichtenfilter-Konfiguration aktualisiert",
            freeTierPasswordPrompt: "Passwort eingeben, um kostenlos zu machen:",
            configurePreFilters: "Vorfilter konfigurieren",
            configureExecutionPrivacy: "Ausführungsberechtigung konfigurieren",
            editDescription: "Beschreibung bearbeiten",
            permissions: {
                title: "Zugriffsberechtigungen",
                mode: "Berechtigungsmodus",
                publicMode: "Öffentlich",
                customMode: "Benutzerdefiniert",
                publicModeDesc: "Alle Benutzer können auf diese Automatisierung zugreifen und sie bearbeiten.",
                customModeDesc: "Nur festgelegte Benutzer und Abteilungen können auf diese Automatisierung zugreifen.",
                confirmPublicMode: "In den öffentlichen Modus wechseln",
                confirmPublicModeDesc: "Nach dieser Aktion können alle Benutzer auf diese Automatisierung zugreifen. Möchten Sie fortfahren?",
                addUser: "Benutzer hinzufügen",
                addDepartment: "Abteilung hinzufügen",
                selectUser: "Benutzer auswählen",
                selectDepartment: "Abteilung auswählen",
                add: "Hinzufügen",
                targetHeader: "Benutzer/Abteilung",
                matrixInfo: "Wählen Sie die Berechtigungen, die Sie jedem Benutzer oder jeder Abteilung gewähren möchten.",
                noTargetsAdded: "Es wurden noch keine Benutzer oder Abteilungen hinzugefügt. Fügen Sie oben einen hinzu, um Berechtigungen zu erteilen.",
                confirmRemoveTarget: "Berechtigung entfernen",
                confirmRemoveTargetDesc: "Sind Sie sicher, dass Sie die Berechtigungen für diesen Benutzer oder diese Abteilung entfernen möchten?",
                saveSuccess: "Zugriffsberechtigungen erfolgreich gespeichert",
                saveError: "Beim Speichern der Zugriffsberechtigungen ist ein Fehler aufgetreten",
                unknownUser: "Unbekannter Benutzer",
                unknownDepartment: "Unbekannte Abteilung",
                noReadAccess: "Sie haben keinen Zugriff auf diese Automatisierung.",
                usersTab: "Benutzer",
                departmentsTab: "Abteilungen",
                authorizedUsers: "Berechtigte Benutzer",
                otherUsers: "Andere Benutzer",
                authorizedDepartments: "Berechtigte Abteilungen",
                otherDepartments: "Andere Abteilungen",
                cannotChangeOwnPermission: "Sie können Ihre eigene Berechtigung nicht ändern",
                you: "Sie",
                customPermissionDefined: "Benutzerdefinierte Berechtigung für diesen Benutzer festgelegt",
                customPermission: "Benutzerdefinierte Berechtigung",
                grantPermission: "Berechtigung erteilen",
                revokePermission: "Berechtigung entfernen",
                applyToOthers: "Auf andere Automatisierungen anwenden",
                applyToOthersDesc: "Diese Berechtigungseinstellungen auf andere von Ihnen ausgewählte Automatisierungen anwenden",
                applyToOthersTitle: "Berechtigungseinstellungen auf andere Automatisierungen anwenden",
                applyToOthersWarning: "Die bestehenden Berechtigungseinstellungen der ausgewählten Automatisierungen werden durch die Einstellungen dieser Automatisierung ersetzt.",
                selectAll: "Alle auswählen",
                selectedCount: "{count} Automatisierungen ausgewählt",
                applyToSelected: "Auf Ausgewählte anwenden",
                noAutomationsFound: "Keine Automatisierungen gefunden",
                searchPlaceholder: "Automatisierung oder Kategorie suchen...",
                applySuccess: "Berechtigungseinstellungen erfolgreich auf {count} Automatisierungen angewendet",
                applyFailed: "Berechtigungseinstellungen konnten nicht auf {count} Automatisierungen angewendet werden",
                applyError: "Fehler beim Anwenden der Berechtigungseinstellungen",
                groups: {
                    basic: "Grundlegend",
                    flow: "Ablauf",
                    meta: "Info",
                    publish: "Veröffentlichen",
                    actions: "Aktionen",
                    plan: "Plan",
                    filter: "Filter"
                },
                scopes: {
                    read: "Ansehen",
                    readDesc: "Berechtigung zum Ansehen der Automatisierung",
                    flowUpdate: "Ablauf bearbeiten",
                    flowUpdateDesc: "Berechtigung zum Hinzufügen, Entfernen und Bearbeiten von Automatisierungsblöcken",
                    metaUpdate: "Info bearbeiten",
                    metaUpdateDesc: "Berechtigung zum Bearbeiten von Name, Beschreibung und Kategorie der Automatisierung",
                    publish: "Veröffentlichen",
                    publishDesc: "Berechtigung zum Veröffentlichen und Aufheben der Veröffentlichung der Automatisierung",
                    delete: "Löschen",
                    deleteDesc: "Berechtigung zum Löschen der Automatisierung",
                    duplicate: "Duplizieren",
                    duplicateDesc: "Berechtigung zum Duplizieren der Automatisierung",
                    planView: "Pläne ansehen",
                    planViewDesc: "Berechtigung zum Ansehen der Ausführungspläne der Automatisierung",
                    planCancel: "Plan abbrechen",
                    planCancelDesc: "Berechtigung zum Abbrechen geplanter Pläne",
                    reschedule: "Neu planen",
                    rescheduleDesc: "Berechtigung zum Neu planen der Automatisierung",
                    prefilterUpdate: "Filter bearbeiten",
                    prefilterUpdateDesc: "Berechtigung zum Bearbeiten der Vorfilter-Konfiguration"
                }
            },
            planStatus: "Planstatus",
            scheduled: "Geplant",
            completed: "Abgeschlossen",
            cancelled: "Abgebrochen",
            startTest: "Test starten",
            unpublish: "Veröffentlichung aufheben",
            whenMessagePicked: "Wenn eine Nachricht über die Chat-Schnittstelle ausgewählt wird",
            whenTaskCompleted: "Wenn eine Aufgabe abgeschlossen wird",
            whenTaskDeleted: "Wenn eine Aufgabe gelöscht wird",
            whenTaskAssigneeChanged: "Wenn ein Aufgabenzuweiser geändert wird",
            whenTaskPriorityChanged: "Wenn die Priorität einer Aufgabe geändert wird",
            whenTaskDueDateChanged: "Wenn das Fälligkeitsdatum einer Aufgabe geändert wird",
            whenTaskStatusChanged: "Wenn sich der Status einer Aufgabe ändert",
            whenTaskArchived: "Wenn eine Aufgabe archiviert wird",
            whenTagAdded: "Wenn der Aufgabe ein Tag hinzugefügt wird",
            whenTagRemovedTask: "Wenn eine Markierung von einer Aufgabe entfernt wird",
            whenTagChecklist: "Wenn eine Aufgaben-Checkliste abgeschlossen wird",
            whenReminderActivated: "Wenn eine Erinnerung aktiviert wird",
            whenTicketCreated: "Wenn ein Ticket erstellt wurde",
            whenTicketStageChanged: "Wenn eine Ticketstufe geändert wird",
            whenTicketAssigneeChanged: "Wenn ein Ticket-Empfänger geändert wird",
            whenTicketClosed: "Wenn eine Anfrage geschlossen wird",
            whenTicketUpdated: "Wenn eine Anfrage aktualisiert wird",
            archivingDate: "Datum der Archivierung",
            autoPlanAndTaskHistory: "Automatisierungsplan und Aufgabenverlauf",
            automation: "Automatisierung",
            botScenario: "Bot-Szenario",
            nameSurname: "Name Nachname",
            phone164: "*Eingabe im E164-Format. Zum Beispiel: 905396667744",
            whichWpChannels: "Welche Whatsapp-Kanäle sollen hinzugefügt werden?",
            findContact: "Kontakt finden",
            findContacts: "Kontakte finden",
            offsetDesc: "Überspringe die ersten N Kontakte. Standardwert ist '0'. Verwenden Sie diesen Wert, um durch die Kontakte zu blättern.",
            limitDesc: "Maximale Anzahl von Kontakten, die nach dem Offset zurückgegeben werden. Standardwert ist '10'. Verwenden Sie dies, um zu paginieren",
            contact: "Kontakt",
            selectAction: "Aktion auswählen",
            addMethod: "Methode hinzufügen",
            selectField: "Feld auswählen",
            schedulerRunningPlanEx: "Beispiel für einen laufenden Plan des Planers",
            schedulerPlanner: "Planer für die Planung",
            taskCreated: "Aufgabe erstellt?",
            taskStatus: "Status der Aufgabe",
            terminateReason: "Grund für die Beendigung",
            taskDuration: "Aufgabendauer",
            taskWakeUpCount: "Anzahl der Aufwachvorgänge der Aufgabe",
            completedAt: "Abgeschlossen",
            cancelledAt: "Abgebrochen",
            nextRunAt: "Nächster Lauf",
            configSchedulerAuto: "Zeitgeber für Automatisierung konfigurieren",
            saveChanges: "Änderungen speichern",
            catchAllWebhooks: "Alle Webhooks von dieser URL abfangen",
            webhookDataExPreview: "Webhook Data Sample Preview (wird nach dem Senden der Anfrage angezeigt)",
            webhookUrlCopied: "Webhook-URL in die Zwischenablage kopiert",
            selectAnBlock: "Einen Block auswählen",
            dataFormats: "Datenformate",
            whenRecordCreated: "Wenn ein Datensatz erstellt wird",
            whenRecordUpdated: "Wenn ein Datensatz aktualisiert wird",
            whenRecordDelete: "Wenn ein Datensatz gelöscht wird",
            whenRecordAutomation: "Wenn eine Schaltfläche zur Datensatzautomatisierung angeklickt wird",
            whenWebhookTriggered: "Wenn ein Webhook ausgelöst wird",
            whenChatCreated: "Wenn ein Chat erstellt wird",
            whenChatClosed: "Wenn ein Chat geschlossen wird",
            whenChatRated: "Wenn ein Chat bewertet wird",
            whenNewContactCreated: "Wenn ein neuer Kontakt erstellt wird",
            whenContactUpdate: "Wenn ein Kontakt aktualisiert wird",
            whenContactPropUpdate: "Wenn eine Kontakteigenschaft aktualisiert wird",
            whenNewTagAdded: "Wenn ein neuer Tag hinzugefügt wird",
            whenTagRemoved: "Wenn ein Tag entfernt wird",
            whenNewEmailReceived: "Wenn eine neue E-Mail empfangen wird",
            whenNewTaskCreated: "Wenn eine neue Aufgabe erstellt wird",
            whenNewMetaleadCreated: "Wenn ein neuer Meta-Lead erstellt wird",
            whenNewAgentCreated: "Wenn ein neuer Agent erstellt wird",
            whenAgentOnline: "Wenn ein Agent online geht",
            whenAgentOffline: "Wenn ein Agent offline geht",
            whenAgentStatusChanged: "Wenn sich der Status eines Agenten ändert",
            whenAgentLogin: "Wenn ein Agent sich anmeldet",
            whenNewInvoiceCreated: "Wenn eine neue Rechnung erstellt wird",
            whenNewWpReceived: "Wenn eine neue Whatsapp-Nachricht eingegangen ist",
            whenNewReservationCreated: "Wenn eine neue Reservierung erstellt wird",
            whenNewChatbotReceived: "Wenn eine neue Chatbot-Nachricht eingeht",
            chatWebhookAutomation: "Einen Webhook abfangen und eine Automatisierung ausführen",
            automationName: "Automatisierungsname",
            supsisObject: "Supsis-Objekt",
            selectModule: "Modell auswählen",
            bodyType: "Körpertyp",
            selectBodyType: "Körpertyp auswählen",
            selectMethod: "Methode auswählen",
            trigger: "Auslöser",
            published: "Veröffentlicht",
            createdAt: "Erstellt am",
            action: "Aktion",
            type: "Typ",
            view: "Siehe",
            createTimerAutomation: "Timer-Automatisierung erstellen",
            createEventBasedAutomation: "Ereignisbasierte Automatisierung erstellen",
            createWebhookAutomation: "Webhook-Automatisierung erstellen",
            automationsCouldNotBeDeleted: "Automatisierungen konnten nicht gelöscht werden",
            timerAutomationCreatedSuccessfully: "Timer-Automatisierung erfolgreich erstellt",
            eventAutomationCreatedSuccessfully: "Ereignisautomatisierung erfolgreich erstellt",
            webhookAutomationCreatedSuccessfully: "Webhook-Automatisierung erfolgreich erstellt",
            automationsCouldNotBeFetched: "Automatisierungen konnten nicht abgerufen werden",
            automationPublishedStateUpdatedSuccessfully: "Veröffentlichungsstatus der Automatisierung erfolgreich aktualisiert",
            automationPublishedStateCouldNotBeUpdated: "Der veröffentlichte Status der Automatisierung konnte nicht aktualisiert werden",
            createAnEventAutomation: "Erstellen einer Ereignisautomatisierung",
            automations: "Automatisierungen",
            allAutomations: "Alle Automatisierungen",
            scheduledAutomations: "Geplante Automatisierungen",
            eventBasedAutomations: "Ereignisbasierte Automatisierungen",
            buttonAutomations: "Schaltflächen-Automatisierungen",
            webhookAutomations: "Webhook-Automatisierungen",
            analytics: "Analytik",
            insights: "Einblicke",
            trash: "Papierkorb",
            sandboxPage: {
                title: "Gelöschte Automatisierungsszenarien",
                description: "Nicht wiederhergestellte Automatisierungen werden vom System innerhalb von 30 Tagen endgültig gelöscht",
                emptyState: "Keine gelöschten Automatisierungen im Papierkorb",
                unnamedAutomation: "Unbenannte Automatisierung",
                restore: "Wiederherstellen",
                timerAutomation: "Zeitgeber-Automatisierung",
                eventAutomation: "Ereignis-Automatisierung",
                webhook: "Webhook",
                buttonAutomation: "Schaltflächen-Automatisierung",
                tableButtonAutomation: "Tabellen-Schaltflächen-Automatisierung",
                chatbotAutomation: "Chatbot-Automatisierung",
                unknown: "Unbekannt",
                user: "Benutzer",
                restoreConfirmTitle: "Sind Sie sicher, dass Sie diese Automatisierung wiederherstellen möchten?",
                restoreConfirmContent: "Die Automatisierung {name} wird wiederhergestellt.",
                restoreSuccess: "Automatisierung wiederhergestellt",
                restoreFailed: "Wiederherstellung fehlgeschlagen",
                loadError: "Fehler beim Laden der gelöschten Automatisierungen"
            },
            insightsPage: {
                title: "Automatisierungsstatistiken",
                selectAutomation: "Automatisierung auswählen",
                dateRange: "Datumsbereich",
                datePlaceholderStart: "Anfang",
                datePlaceholderEnd: "Ende",
                lastWeek: "Letzte Woche",
                lastMonth: "Letzter Monat",
                last3Months: "Letzte 3 Monate",
                statusFilter: "Statusfilter",
                statusScheduled: "Geplant",
                statusRunning: "Läuft",
                statusWaitingReply: "Wartet auf Antwort",
                statusDone: "Abgeschlossen",
                statusFailed: "Fehlgeschlagen",
                statusCancelled: "Abgebrochen",
                clearFilters: "Filter löschen",
                refreshData: "Daten aktualisieren",
                activeFilters: "Aktive Filter:",
                totalTasks: "Gesamte Aufgaben",
                executedTasks: "Ausgeführte Aufgaben",
                successRate: "Erfolgsrate",
                successfulTasks: "Erfolgreiche Aufgaben",
                avgDuration: "Durchschnittliche Dauer",
                avgWorkDuration: "Durchschnittliche Arbeitsdauer",
                activeTasks: "Aktive Aufgaben",
                runningNow: "Läuft gerade",
                dailyTaskExecution: "Tägliche Aufgabenausführung",
                statusDistribution: "Statusverteilung",
                durationDistribution: "Dauerverteilung",
                terminateReasons: "Beendigungsgründe",
                automationPerformance: "Automatisierungsleistung",
                view: "Anzeigen",
                automationName: "Automatisierungsname",
                executionCount: "Ausführungsanzahl",
                actions: "Aktionen",
                totalTasksLegend: "Gesamte Aufgaben",
                successfulLegend: "Erfolgreich",
                failedLegend: "Fehlgeschlagen",
                taskCount: "Aufgabenanzahl",
                ms: "ms",
                sec: "Sek",
                min: "Min",
                hour: "Std",
                automationsLoadError: "Fehler beim Laden der Automatisierungen",
                insightsLoadError: "Fehler beim Laden der Statistiken"
            },
            settingsWidget: {
                viewActivityLogs: "Aktivitätsprotokolle anzeigen",
                activityLogsTitle: "Aktivitätsprotokolle",
                activityLogsEmpty: "Noch keine Aktivitätsaufzeichnungen",
                activityLogsLoadError: "Fehler beim Laden der Aktivitätsprotokolle",
                exportedToClipboard: "Automatisierung in die Zwischenablage kopiert",
                settings: "Einstellungen"
            },
            blocks: {
                ASSIGN_OWNER: "Eigentümer Zuweisen",
                autoForwardToOwnerForce: "Automatische Weiterleitung an Eigentümer (auch bei aktivem Chatbot)",
                SHOW_WIDGET: "Widget anzeigen",
                REPLY_TRENDYOL_QUESTION: "Trendyol-Frage beantworten",
                START_POINT: "STARTPUNKT",
                AI_ASSISTANT: "KI-ASSISTENT",
                BOT_RESPONSE: "BOT-ANTWORT",
                AI_BOT_RESPONSE: "KI-RESPONSE (GPT-4o)",
                AI_CLASSIFICATION: "KI-KLASSIFIZIERUNG",
                AI_MENU_FLOW: "KI-MENÜ",
                OTP_WHATSAPP_FLOW: "OTP Whatsapp",
                OTP_SMS_FLOW: "OTP SMS",
                OTP_MAIL_FLOW: "OTP MAIL",
                AI_INSTAGRAM_FLOW: "AI INSTAGRAM KOMMENTAR",
                PLATTFORM_FLOW: "PLATTFORM",
                DEFAULT_FALLBACK: "STANDARD-FALLBACK",
                DEFAULT_TIMEOUT: "STANDARDMÄSSIGE ZEITÜBERSCHREITUNG",
                AI_FUNCTIONS: "KI-FUNKTIONEN",
                FILTER: "FILTER",
                FLOW: "FLOW",
                ATTACHMENT_INPUT: "ANHANG-EINGABE",
                USER_INPUT: "BENUTZEREINGABE",
                GO_TO_STEP: "GEHE ZU SCHRITT",
                WEBHOOK: "WEBHAKEN",
                SET_ATTRIBUTE: "ATTRIBUT SETZEN",
                QUESTION: "FRAGE",
                CLOSE_CHAT: "CHAT SCHLIESSEN",
                CREATE_TICKET: "TICKET ERSTELLEN",
                TRANSFER_CHAT: "CHAT ÜBERTRAGEN",
                TRANSFER_TO_CHATBOT: "AN CHATBOT WEITERLEITEN",
                TAG_CHAT: "TAG HINZUFÜGEN",
                REMOVE_TAG: "TAG ENTFERNEN",
                SET_DEPARTMENT: "ABTEILUNG FESTLEGEN",
                SEND_TRANSCRIPT: "ABSCHRIFT SENDEN",
                SEND_SMS: "SMS SENDEN",
                SEND_MAIL: "E-MAIL SENDEN",
                CREATE_EVENT: "EREIGNIS ERSTELLEN",
                CREATE_RESERVATION: "RESERVIERUNG ERSTELLEN",
                RESERVATION_OPEN_URL: "RESERVIERUNG ÖFFNEN URL",
                RESERVATION_SELECT_DAY: "RESERVIERUNGSTAG AUSWÄHLEN",
                RESERVATION_EVENT_LIST: "RESERVIERUNGSLISTE BESUCHER",
                RESERVATION_SELECT_TIME: "RESERVIERUNGSZEIT AUSWÄHLEN",
                CREATE_TASK: "AUFGABE ERSTELLEN",
                UPDATE_TASK: "UPDATE-AUFGABE",
                SHOPIFY_SHOW_PRODUCTS: "SHOPIFY PRODUKTE ANZEIGEN",
                SHOPIFY_PRODUCT_AVAILABILITY: "SHOPIFY PRODUKTVERFÜGBARKEIT",
                SHOPIFY_ORDER_STATUS: "SHOPIFY BESTELLSTATUS",
                AKINON_SHOW_PRODUCTS: "AKINON PRODUKTE ANZEIGEN",
                AKINON_FIND_PRODUCT: "AKINON PRODUKT FINDEN",
                AKINON_ORDER_STATUS: "AKINON BESTELLSTATUS",
                AKINON_SELECT_ORDER: "AKINON BESTELLUNG AUSWÄHLEN",
                AKINON_SELECT_SIZE: "AKINON GRÖSSE AUSWÄHLEN",
                AKINON_FIND_NEAREST_STOCK: "LADENBESTAND ANZEIGEN",
                AKINON_FIND_NEAREST_STORES: "NÄCHSTGELEGENE GESCHÄFTE ANZEIGEN",
                AKINON_SHOW_DISCOUNT_CODES: "ZEIGE RABATTCODES",
                SUPPRESSION_ADD: "KONTAKT BLOCKIEREN",
                SUPPRESSION_REMOVE: "KONTAKT FREISCHALTEN",
                ADD_TO_SEGMENT: "SEGMENT HINZUFÜGEN",
                REMOVE_FROM_SEGMENT: "AUS SEGMENT ENTFERNEN",
                IDEASOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                IDEASOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
                IDEASOFT_GET_MEMBER_INFO: "MITGLIEDERINFO AUSFÜLLEN",
                TICKET_UPDATE: "TICKET AKTUALISIEREN",
                TSOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                TSOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
                TICIMAX_V2_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
                TICIMAX_V2_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
                IKAS_GET_MEMBER_INFO: "Mitgliederdetails abrufen",
                IKAS_SELECT_ORDER: "Bestellung auswählen",
                IKAS_ORDER_STATUS: "Bestellstatus abrufen",
                GET_LOCATION: "STANDORT ABRUFEN",
                FALLBACK: "AUSWEICHENDE OPTION",
                TIMEOUT: "ZEITÜBERSCHREITUNG",
                SUCCESS: "ERFOLGREICH",
                FAILURE: "FEHLER",
                PROBEL_SELECT_BRANCH: "Filiale auswählen",
                PROBEL_SELECT_CLINIC: "Poliklinik auswählen",
                PROBEL_SELECT_DAY: "Tag des Termins auswählen",
                PROBEL_SELECT_HOUR: "Uhrzeit des Termins auswählen",
                PROBEL_MAKE_APPOINTMENT: "Termin vereinbaren",
                PROBEL_CANCEL_APPOINTMENT: "Termin stornieren",
                PROBEL_GET_PATIENT_TOKEN: "Patienten-Token abrufen",
                PROBEL_FILL_INFO: "MERNIS-Informationen abrufen",
                PROBEL_SELECT_APPOINTMENT: "Termin auswählen",
                SEND_WP_BUSINESS_MESSAGE: "WHATSAPP-NACHRICHT SENDEN",
                MESSENGER_SEND_MESSAGE: "MESSENGER-NACHRICHT SENDEN",
                INSTAGRAM_SEND_MESSAGE: "INSTAGRAM-NACHRICHT SENDEN",
                INSTAGRAM_COMMENT_REPLY: "KOMMENTAR BEANTWORTEN",
                INSTAGRAM_COMMENT_DELETE: "KOMMENTAR LÖSCHEN",
                INSTAGRAM_COMMENT_SHOW: "KOMMENTAR ANZEIGEN",
                INSTAGRAM_COMMENT_HIDE: "KOMMENTAR AUSBLENDEN",
                INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ANTWORT ALS PRIVAT",
                LOOP: "SCHLEIFEN",
                LOOP_NEXT: "NÄCHSTES ELEMENT IN DER SCHLEIFE",
                LOOP_BREAK: "SCHLEIFE UNTERBRECHEN",
                LOOP_CONTINUE: "SCHLEIFE FORTSETZEN",
                LOOP_FINISH: "SCHLEIFE BEENDEN",
                SLEEP: "PAUSE",
                NOOP: "NOOP",
                CATCH_WEBHOOK: "WEBHOOK ABFANGEN",
                TERMINATE_AUTOMATION: "AUTOMATISIERUNG BEENDEN",
                CREATE_CONTACT: "KONTAKT ERSTELLEN",
                UPDATE_CONTACT: "KONTAKT AKTUALISIEREN",
                FIND_CONTACTS: "KONTAKTE FINDEN",
                FIND_CONTACT: "KONTAKT FINDEN",
                FIND_CHATS: "CHATS FINDEN",
                FIND_CHAT: "CHAT FINDEN",
                WAIT_FOR: "WARTEN AUF",
                STRING_FORMAT: "STRING FORMATIEREN",
                NUMBER_FORMAT: "ZAHL FORMATIEREN",
                DATE_FORMAT: "DATUM FORMATIEREN",
                RECORDS_FROM_CSV: "DATENSÄTZE AUS DER CSV",
                MESSAGE_RECEIVED: "EMPFOHLENE NACHRICHT",
                ASK_AI: "Künstliche Intelligenz",
                TABLE_CREATE_RECORD: "Datensatz erstellen",
                TABLE_DELETE_RECORD: "Datensatz löschen",
                TABLE_UPDATE_RECORD: "Datensatz aktualisieren",
                TABLE_FIND_RECORD: "Datensatz finden",
                TABLE_FIND_RECORDS: "Datensätze auflisten",
                ZOHO_FIND_RECORDS_BY_PHONE: "Zoho Datensatz finden (nach Telefon)",
                ZOHO_ADD_ATTACHMENT_TO_RECORD: "Zoho Datei zum Datensatz hinzufügen",
                ZOHO_UPLOAD_IMAGE_TO_RECORD_FIELD: "Zoho Bild in benutzerdefiniertes Feld hochladen",
                ZOHO_CREATE_RECORD: "Zoho Datensatz erstellen",
                GET_SUPSIS_RECORD_BY_ID: "Datensatz abrufen",
                META_SEND_CAPI_EVENT: "CAPI-Ereignis senden",
                GOOGLE_DRIVE_UPLOAD_FILE: "Datei hochladen",
                GOOGLE_DRIVE_DOWNLOAD_FILE: "Datei herunterladen",
                GOOGLE_DRIVE_GET_FILE_INFO: "Dateiinformationen abrufen",
                GOOGLE_DRIVE_DELETE_FILE: "Datei löschen",
                FEEDBACK_AI_ASSISTANT: "KI-ASSISTENTEN-FEEDBACK",
                INSERT_TO_SYSTEM_PROMPT: "IN SYSTEMPROMPT EINFÜGEN",
                AI_CALL: "KI-ANRUF",
                TAVILY_WEB_SEARCH: "WEBSUCHE (TAVILY)",
                RUN_JAVASCRIPT: "JAVASCRIPT AUSFÜHREN",
                PLATFORM_FLOW: "PLATTFORM",
                SEND_JSON_RESPONSE: "AUF WEBHOOK ANTWORTEN",
                CACHE_WRITE: "CACHE SCHREIBEN",
                CACHE_READ: "CACHE LESEN",
                CACHE_EXTEND: "CACHE VERLÄNGERN",
                CACHE_DELETE: "CACHE LÖSCHEN",
                YOUTUBE_REPLY_COMMENT: "Kommentar beantworten",
                YOUTUBE_UPDATE_COMMENT_STATUS: "Kommentarstatus aktualisieren",
                YOUTUBE_SET_MODERATION_STATUS: "Moderationsstatus festlegen",
                GOOGLE_BUSINESS_REPLY_REVIEW: "Bewertung beantworten",
                GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "Bewertungsstatus aktualisieren",
                GOOGLE_PLAY_REPLY_REVIEW: "Bewertung beantworten",
                GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "Bewertungsstatus aktualisieren",
                APP_STORE_REPLY_REVIEW: "Bewertung beantworten",
                APP_STORE_UPDATE_REVIEW_STATUS: "Bewertungsstatus aktualisieren",
                APP_STORE_DELETE_REVIEW_RESPONSE: "Bewertungsantwort löschen",
                OPENROUTER_RESPONSE: "OpenRouter-KI-Antwort",
                OPENAI_RESPONSE: "Mit OpenAI generieren",
                GOOGLE_AI_RESPONSE: "Mit Google AI generieren",
                ANTHROPIC_RESPONSE: "Mit Anthropic generieren",
                MISTRAL_RESPONSE: "Mit Mistral generieren",
                AZURE_RESPONSE: "Mit Azure generieren",
                BEDROCK_RESPONSE: "Mit AWS Bedrock generieren",
                COHERE_RESPONSE: "Mit Cohere generieren",
                XAI_RESPONSE: "Mit xAI generieren",
                DEEPINFRA_RESPONSE: "Mit DeepInfra generieren",
                TOGETHER_RESPONSE: "Mit Together generieren",
                FIREWORKS_RESPONSE: "Mit Fireworks generieren",
                SILICONFLOW_RESPONSE: "Mit SiliconFlow generieren",
                PARASAIL_RESPONSE: "Mit Parasail generieren",
                NEBIUS_RESPONSE: "Mit Nebius generieren",
                ALIBABA_RESPONSE: "Mit Alibaba generieren",
                XIAOMI_RESPONSE: "Mit Xiaomi generieren",
                SAMBANOVA_RESPONSE: "Mit SambaNova generieren",
                MOONSHOT_RESPONSE: "Mit Moonshot generieren",
                MINIMAX_RESPONSE: "Mit MiniMax generieren",
                NVIDIA_RESPONSE: "Mit NVIDIA generieren",
                FALLIMENTO: "FEHLGESCHLAGEN",
                OPENAI_WEB_SEARCH: "WEBSUCHE (OPENAI)",
                OPEN_AI: "OPEN_AI",
                PUNTO_INICIO: "STARTPUNKT",
                SUCCESSO: "ERFOLG"
            },
            newAutomation: "Neue Automatisierung",
            totalAutomations: "Gesamt {count} Automatisierungen",
            totalAutomationsWithHidden: "Gesamt {total} Automatisierungen ({visible} sichtbar)",
            whenVoiceAgentCallStarted: "Wenn ein Sprachagenten-Anruf gestartet wird",
            whenVoiceAgentCallEnded: "Wenn ein Sprachagenten-Anruf beendet wird",
            whenVoiceAgentCallAnalyzed: "Wenn ein Sprachagenten-Anruf analysiert wird",
            enablePreFilters: "Vorfilter aktivieren",
            preFilterDescription: "Vorfilter ermöglichen es festzulegen, wann die Automatisierung laufen soll. Wenn aktiviert, wird die Automatisierung nur bei Ereignissen ausgelöst, die Ihren Bedingungen entsprechen.",
            preFilters: "Vorfilter",
            executionRules: "Ausführungsregeln",
            preFilterInfo: "Mit Vorfiltern können Sie festlegen, wann die Automatisierung laufen soll. Die Automatisierung wird nur bei Ereignissen ausgelöst, die Ihren Bedingungen entsprechen.",
            preFiltersSaved: "Vorfilter erfolgreich gespeichert",
            preFiltersSaveError: "Fehler beim Speichern der Vorfilter",
            preFiltersConfiguration: "Vorfilter-Konfiguration",
            executionPrivacyTitle: "Ausführungsberechtigung",
            executionPrivacyDescription: "Welche Benutzer oder Abteilungen dürfen diese Automatisierung ausführen? Wenn leer, können alle Benutzer sie ausführen.",
            executionPrivacyPublic: "Alle Benutzer können diese Automatisierung ausführen",
            executionPrivacyConfiguration: "Konfiguration der Ausführungsberechtigung",
            executionPrivacySaved: "Ausführungsberechtigung erfolgreich gespeichert",
            executionPrivacySaveError: "Beim Speichern der Ausführungsberechtigung ist ein Fehler aufgetreten",
            addDescription: "Beschreibung hinzufügen...",
            descriptionPlaceholder: "Automatisierungsbeschreibung eingeben...",
            descriptionSaved: "Beschreibung erfolgreich gespeichert",
            descriptionSaveError: "Beim Speichern der Beschreibung ist ein Fehler aufgetreten",
            makePublicExecution: "Öffentlich machen",
            makePublicExecutionConfirmTitle: "Sind Sie sicher, dass Sie diese Automatisierung öffentlich machen möchten?",
            makePublicExecutionConfirmContent: "Nach dieser Aktion können alle Vertreter diese Automatisierung ausführen.",
            madePublicExecution: "Die Automatisierung wurde öffentlich gemacht",
            openrouterResponse: "OpenRouter-KI-Antwort",
            selectProvider: "Anbieter auswählen",
            modelName: "Modell",
            modelHint: "z. B.: google/gemini-2.0-flash-001, openai/gpt-4o",
            systemInstructions: "Systemanweisungen (Optional)",
            systemInstructionsPlaceholder: "Beschreiben Sie, wie sich die KI verhalten soll...",
            promptPlaceholder: "Formulieren Sie Ihre Frage an die KI...",
            advancedSettings: "Erweiterte Einstellungen",
            temperatureHint: "Niedrigere Werte erzeugen konsistentere Antworten, höhere Werte kreativere (0-2)",
            maxTokens: "Max. Tokens",
            maxTokensHint: "Maximale Anzahl zu generierender Tokens",
            maxTokensPlaceholder: "Standard: Modelllimit",
            selectChannel: "Kanal auswählen (Optional)",
            autoSelectChannel: "Automatisch auswählen",
            automationPublishedStateUpdatedSupdatedSuccessfully: "Veröffentlichungsstatus der Automatisierung erfolgreich aktualisiert",
            automationsCouldNouldNotBeFetched: "Automatisierungen konnten nicht abgerufen werden",
            automazioni: "Automatisierungen",
            cancelado: "Abgebrochen",
            webhookAutomationCutomationCreatedSuccessfully: "Webhook-Automatisierung erfolgreich erstellt"
        },
        modules: {
            kanbanSettings: {
                title: "Einstellungen",
                column: "Spalteneinstellungen",
                selectField: "Wählen Sie ein Feld",
                selectFieldPlaceholder: "Wählen Sie ein Feld",
                card: "Karteinstellungen",
                selectFields: "Wählen Sie Felder, die auf der Karte angezeigt werden sollen",
                cancel: "Abbrechen",
                save: "Speichern",
                kanban: "Kanban-Einstellungen"
            },
            createFailed: "Modulerstellung fehlgeschlagen",
            createSuccess: "Modul erfolgreich erstellt",
            moduleDeletedSuccessfully: "Modul erfolgreich gelöscht",
            deleteModuleTitle: "Modul löschen",
            deleteModuleContent: "Sind Sie sicher, dass Sie dieses Modul löschen wollen?",
            modules: "Module",
            relations: "Beziehungen",
            newRelation: "Neue Beziehung erstellen",
            editRelation: "Beziehung bearbeiten",
            modulesSettings: "Moduleinstellungen",
            displayName: "Anzeigename",
            description: "Beschreibung",
            table: "Tabelle",
            menuApiSettings: "Menü- und API-Einstellungen",
            icon: "Symbol",
            save: "Speichern",
            exampleIcon: "Beispiel: extension, home",
            newModule: "Neues Modul",
            moduleName: "Modulname",
            apiName: "API-Name",
            type: "Typ",
            apiAccess: "API-Zugriff",
            actions: "Aktionen",
            module: "Modul",
            relation: "Beziehung",
            moduleRelationName: "Modul/Beziehungsname",
            moduleRelationTable: "Modul/Beziehungsname",
            showInMainMenu: "Im Hauptmenü anzeigen",
            apiEnabled: "API aktiviert",
            settings: "Einstellungen",
            createModule: "Modul erstellen",
            relationType: "Beziehungsart",
            relationTypeTableToTable: "Tabelle zu Tabelle",
            relationTypeTableToStandart: "Tabelle zu Standardmodul",
            relationTypeStandartToTable: "Standardmodul zu Tabelle",
            fromColumn: "Von",
            toColumn: "Bis",
            apiDoc: "API-Dokumentation",
            standartModule: "Standardmodul",
            customTable: "Benutzerdefiniertes Tabellen",
            localField: "Lokales Feld",
            showingRemoteFieldInList: "Feld in der Liste anzeigen",
            relationSettings: "Beziehungseinstellungen",
            remoteField: "Entferntes Feld",
            localFieldType: "Typ des lokalen Feldes",
            standart: "Standard",
            custom: "Benutzerdefiniert",
            contact: "Kontakt",
            viewRecord: "Datensatz anzeigen",
            recordDetail: "Datensatzdetails",
            recordNotFound: "Datensatz oder Tabelleninformationen nicht gefunden",
            recordViewer: "Datensatz-Anzeige",
            updateSuccess: "Modul erfolgreich aktualisiert",
            updateFailed: "Modulaktualisierung fehlgeschlagen",
            editModule: "Modul bearbeiten",
            relatedLists: "Verknüpfte Listen",
            priority_high: "Hoch",
            priority_highest: "Höchste",
            priority_low: "Niedrig",
            priority_lowest: "Niedrigste",
            priority_medium: "Mittel"
        },
        tables: {
            enterWidgetName: "Widget-Namen eingeben",
            widgetName: "Widget-Name",
            renameWidget: "Widget umbenennen",
            assistantCapabilities: "Assistentenfähigkeiten",
            addNewFieldsToTable: "Kann neue Felder zur Tabelle hinzufügen",
            editExistingFields: "Kann vorhandene Felder bearbeiten",
            deleteUnnecessaryFields: "Kann unnötige Felder löschen",
            filterRecords: "Kann Datensätze filtern",
            groupRecords: "Kann Datensätze gruppieren",
            hideFieldsCapability: "Kann Felder ausblenden",
            createConditionalFormatting: "Kann bedingte Formatierung erstellen",
            createCalculationFormulas: "Kann Berechnungsformeln erstellen",
            createSampleRecords: "Kann Beispieldatensätze erstellen",
            examplePrompt: "Beispiel: Fügen Sie dieser Tabelle die Felder Name, Nachname, E-Mail und Telefon für Kundeninformationen hinzu...",
            supsisAssistantTables: "Supsis Assistent: Tabellen",
            supsisAssistantWritePrompt: "Beschreiben Sie, was der Supsis Assistent tun soll",
            supsisAssistantExamplePrompt: "Erstellen Sie eine Tabelle zur Verfolgung von Besprechungen. Fügen Sie Felder wie Besprechungsthema, Datum, Teilnehmer, verantwortliche Person, getroffene Entscheidungen und Folgeaktionen hinzu.",
            sendSupsisAssistant: "An Supsis Assistent senden",
            examplePromptsTitle: "Beispielanfragen:",
            examplePrompts: {
                addCustomerInfoFields: "Füge dieser Tabelle die Felder Vorname, Nachname, E-Mail und Telefon für Kundeninformationen hinzu.",
                addOrderFields: "Füge der Bestelltabelle die Felder Produktname, Menge, Stückpreis, Gesamtbetrag und Bestelldatum hinzu.",
                addBirthDateField: "Füge dieser Tabelle ein Geburtsdatum-Feld hinzu und stelle das Datumsformat auf TT/MM/JJJJ ein.",
                updateStatusField: "Aktualisiere das Statusfeld, mache es zu einem Dropdown mit den Optionen: Ausstehend, In Bearbeitung, Abgeschlossen, Storniert.",
                replaceAddressFields: "Lösche das Adressfeld und füge stattdessen die Felder Adresszeile 1, Adresszeile 2, Bezirk, Stadt und Postleitzahl hinzu.",
                alignTextFields: "Zentriere alle Textfelder und begrenze die maximale Textlänge auf 100 Zeichen.",
                addAutoIncrementID: "Füge ein automatisch fortlaufendes ID-Feld hinzu und verwende das Präfix PRD- für das Produkt.",
                addTotalAmountFormula: "Füge das Feld Gesamtbetrag als Formel hinzu, um das Produkt aus Menge und Stückpreis zu berechnen.",
                createActiveCustomersFilter: "Erstelle einen Filter, um nur aktive Kunden anzuzeigen.",
                filterRecentUsers: "Filtere Benutzer, die sich in den letzten 30 Tagen registriert haben.",
                groupByStatus: "Gruppiere Datensätze nach der Status-Spalte.",
                hideAllExceptDeliveryAndOrderNo: "Blende alle Felder außer Lieferdatum und Bestellnummer aus.",
                colorCodeOrders: "Markiere verspätete Bestellungen rot, heutige Lieferungen gelb und abgeschlossene grün.",
                highlightHighPaymentRecords: "Hebe Datensätze mit einem Zahlungsbetrag über 1000 TL in Lila hervor.",
                groupAndHighlightUnpaidOrders: "Gruppiere nach Bestelldatum und markiere unbezahlte Bestellungen rot.",
                createSampleRecords: "Erstelle 10 Beispieldatensätze in dieser Tabelle.",
                addSampleRecordsForAliAndAhmet: "Füge 5 Beispieldatensätze mit den Kundennamen Ali und Ahmet hinzu.",
                createRandomSampleOrders: "Erstelle 20 zufällige Bestellungen mit zufällig festgelegtem Status.",
                hrCandidateTracking: "Ich möchte eine Software zur Kandidatenverfolgung (ATS) für unsere HR-Prozesse erstellen. Alles, was ein ATS haben sollte, einschließen. Verwenden Sie türkische Feldnamen.",
                crmModuleCreation: "Erstellen Sie alle notwendigen Module für das Kundenbeziehungsmanagement (CRM). Fügen Sie Kundeninformationen, Besprechungsprotokolle und Chancenmanagement hinzu.",
                realEstatePortfolioManagement: "Ich möchte ein Immobilienportfoliomanagementsystem einrichten. Es sollte Immobiliendetails, Kundenanfragen und Verkaufsverfolgung verwalten.",
                schoolManagementSystem: "Ich möchte die Verfolgung von Schülern, Lehrern und Stundenplänen für ein Schulverwaltungssystem verwalten. Verwenden Sie türkische Feldnamen.",
                projectManagementSystem: "Ich möchte ein Projektmanagementsystem erstellen. Aufgaben, Teammitglieder, Zeiterfassung und Berichtsfunktionen einschließen.",
                inventoryAndWarehouseManagement: "Ich möchte ein System für Lager- und Bestandsverwaltung aufbauen. Es sollte Produkt-Ein- und Ausgänge, Bestandsniveaus und Lieferantenverfolgung verwalten.",
                serviceAndMaintenanceTracking: "Ich möchte ein System zur Verfolgung von Service und Wartung. Es sollte Kundengeräte, Wartungshistorie und Technikerzuweisungen verwalten.",
                restaurantManagementSystem: "Ich möchte ein Restaurantverwaltungssystem einrichten. Tischverfolgung, Bestellmanagement, Küchendisplay und Abrechnungsoperationen einschließen."
            },
            createAppWithSupsisAssistant: "App mit Supsis Assistant erstellen",
            noWidgets: "Noch keine Widgets hinzugefügt",
            widgetLoadError: "Widget konnte nicht geladen werden",
            createDashboardSupsisAssistant: "Dashboard mit Supsis Assistant erstellen",
            youtubeDesc: "Fügen Sie Youtube-Videos in Ihr Panel ein",
            iframeDesc: "Fügen Sie externe Webinhalte in Ihr Panel ein",
            countdownDesc: "Fügen Sie einen Zähler hinzu, um wichtige Fristen zu verfolgen",
            countdown: "Zähler",
            textDesc: "Fügen Sie benutzerdefinierte Textinhalte zu Ihrem Panel hinzu",
            numbersDesc: "Erhalten Sie einen schnellen Überblick über alle Zahlenspalten",
            numbers: "Zahlen",
            addWidget: "Widget hinzufügen",
            graphDesc: "Erstellen Sie einen Diagramm-Widget, um Daten in Ihren Tabellen zu visualisieren",
            graph: "Diagramm",
            suggested: "Vorgeschlagene",
            creationDate: "Erstellungsdatum",
            today: "Heute",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            table: "Tabelle",
            kanban: "Kanban",
            calendar: "Kalender",
            calendarSettings: "Kalendereinstellungen",
            colorBy: "Farbe nach",
            startDateField: "Startdatumsfeld",
            endDateField: "Enddatumsfeld (Optional)",
            eventCardFields: "Ereigniskarten-Felder",
            selectColorField: "Farbfeld auswählen",
            selectStartDateField: "Startdatumsfeld auswählen",
            selectEndDateField: "Enddatumsfeld auswählen",
            cancel: "Abbrechen",
            save: "Speichern",
            kanbanNotAvailable: "Kanban-Ansicht nicht verfügbar",
            needDropdownField: "Um die Kanban-Ansicht zu verwenden, benötigen Sie mindestens ein statisches Dropdown-Feld in Ihrer Tabelle. Sie können in den Tabelleneinstellungen ein neues Feld hinzufügen oder ein vorhandenes bearbeiten.",
            notAvailable: "Kalenderansicht nicht verfügbar",
            needDateField: "Sie benötigen mindestens ein Datumsfeld in Ihrer Tabelle, um die Kalenderansicht zu verwenden. Sie können in den Tabelleneinstellungen ein neues Feld hinzufügen oder ein vorhandenes bearbeiten.",
            switchToTable: "Zur Tabellenansicht wechseln",
            operator: "Operator",
            conditionalColor: "Bedingte Farbe",
            groupField: "Gruppenfeld",
            selectDirection: "Auswahlrichtung",
            showEmptyGroups: "Leere Gruppen anzeigen",
            clearGrouping: "Gruppierung löschen",
            applyGrouping: "Gruppierung anwenden",
            sortDirection: "Sortierungsrichtung",
            downloadSelectedRecords: "Ausgewählte Datensätze herunterladen",
            downloadSelected: "Ausgewählte herunterladen",
            downloadSelectedWithCount: "Ausgewählte herunterladen ({count})",
            downloadThisPage: "Diese Seite herunterladen",
            downloadAll: "Alle herunterladen",
            downloadRecords: "Datensätze herunterladen",
            downloadRecordsSettings: "Datensätze herunterladen - Einstellungen",
            recordLimitExceededTooltip: "Datensatzlimit erreicht. Sie müssen Ihren Plan upgraden, um Datensätze zu importieren.",
            zebraMode: "Zebra-Modus",
            viewName: "Ansichtsname",
            enterViewName: "Ansichtsname eingeben",
            enterDesc: "Beschreibung eingeben",
            viewNameRequired: "Ansichtsname erforderlich",
            runWebhookAutomation: "Webhook-Automatisierung ausführen",
            downloadAllRecords: "Alle Datensätze herunterladen",
            deleteRecords: "Datensätze löschen",
            editRecords: "Datensätze aktualisieren",
            duplicateRecords: "Datensätze duplizieren",
            selected: "Ausgewählt",
            sureDeleteRecords: "Sind Sie sicher, dass Sie Datensätze löschen wollen?",
            selectedRecordSucs: "Ausgewählte Datensätze wurden erfolgreich gelöscht.",
            errorDeletingRecords: "Beim Löschen von Datensätzen ist ein Fehler aufgetreten.",
            sureCopyRecords: "Sind Sie sicher, dass Sie die Datensätze kopieren wollen?",
            copyRecords: "Datensätze kopieren",
            recordsCopiedSucs: "Die ausgewählten Datensätze wurden erfolgreich kopiert.",
            recordsCopiedError: "Beim Kopieren der ausgewählten Datensätze ist ein Fehler aufgetreten.",
            viewSucsCreated: "Die Ansicht wurde erfolgreich erstellt.",
            editMultipleRecords: "Mehrere Datensätze bearbeiten",
            importRecords: "Datensätze importieren",
            importHasStarted: "Der Import hat begonnen. Je nach Umfang Ihrer Daten kann dies einige Minuten dauern. Bitte warten Sie...",
            anErrorImport: "Während des Imports ist ein Fehler aufgetreten.",
            recordCreated: "Datensatz erstellt",
            recordUpdated: "Datensatz aktualisiert",
            recordDeleted: "Datensatz gelöscht",
            noAutomationDefined: "Es ist noch keine Automatisierung definiert",
            nameTheAutomationAdd: "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz zu dieser Tabelle hinzugefügt wird:",
            nameTheAutomationUpdate: "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz in dieser Tabelle aktualisiert wird:",
            nameTheAutomationDelete: "Nennen Sie die Automatisierung, die ausgeführt wird, wenn ein Datensatz aus dieser Tabelle gelöscht wird:",
            editField: "Feld bearbeiten",
            sort: "Sortieren",
            sortAscending: "Sortieren A-Z",
            sortDescending: "Sortieren Z-A",
            clearSort: "Sortierung aufheben",
            markAsIdentifierField: "Als Kennzeichnungsfeld markieren",
            runAI: "KI ausführen",
            ascending: "Aufsteigend",
            descending: "Absteigend",
            createField: "Feld erstellen",
            insertBefore: "Vorher einfügen",
            insertAfter: "Nachher einfügen",
            goToRelatedAuto: "Zur verwandten Automatisierung gehen",
            permission: "Erlaubnis",
            lockField: "Feld sperren",
            hideField: "Feld ausblenden",
            deleteField: "Feld löschen",
            watchVideo: "Video ansehen",
            uploadError: "Fehler beim Hochladen",
            updateError: "Fehler beim Aktualisieren",
            invalidValue: "Ungültiger Wert. Bitte verwenden Sie das richtige Format.",
            errorUpdatingRecord: "Beim Aktualisieren des Datensatzes ist ein Fehler aufgetreten.",
            errorCreatingView: "Beim Erstellen der Ansicht ist ein Fehler aufgetreten.",
            datetimeOptions: "Datum/Uhrzeit Optionen",
            numberOptions: "Zahlen Optionen",
            currencyOptions: "Währungsoptionen",
            dropdownOptions: "Dropdown-Optionen",
            automationButtonOptions: "Automatisierungsschaltflächenoptionen",
            defaultLabel: "Standardbezeichnung",
            disableWhenClicked: "Bei Klick deaktivieren",
            fieldSucsCreate: "Feld erfolgreich erstellt",
            fieldCreatingFailed: "Beim Erstellen des Feldes ist ein Fehler aufgetreten",
            fieldSucsUpdate: "Feld erfolgreich aktualisiert",
            fieldUpdatingFailed: "Beim Aktualisieren des Feldes ist ein Fehler aufgetreten",
            showAll: "Alle anzeigen",
            hideAll: "Alle ausblenden",
            searchFields: "Suchfelder",
            firstRowHeader: "Die erste Zeile enthält die Überschrift",
            seperatorCharacter: "Trennzeichen",
            comma: "Komma",
            semicolan: "Semikolon",
            tableFieldOrFileColumns: "Zuordnung von Tabellenfeldern / Dateispalten",
            exampleResultPreview: "Vorschau des Beispielergebnisses",
            newView: "Neue Ansicht",
            createViewaFiltering: "Erstellen Sie Ansichten, um die Filterung, Sortierung und Ausblendung von Feldern fortzusetzen, ohne die Haupttabelle zu ändern.",
            pleaseUpdateSelected: "Bitte wählen Sie das Feld aus, das Sie für die ausgewählten Datensätze aktualisieren möchten",
            pleaseSelectedNewValue: "Bitte geben Sie einen neuen Wert für das ausgewählte Feld ein.",
            selectedMenuItem: "Ausgewählter Menüpunkt:",
            deleteTable: "Tabelle löschen",
            sureDeleteTable: "Sind Sie sicher, dass Sie diese Tabelle löschen wollen?",
            deleteTableSucs: "Die Tabelle wurde erfolgreich gelöscht.",
            deleteTableError: "Fehler beim Löschen der Tabelle:",
            editTable: "Tabelle bearbeiten",
            createNewField: "Neues Feld erstellen",
            tables: "Tabellen",
            tableName: "Tabellenname",
            description: "Beschreibung",
            createTable: "Tabelle erstellen",
            createNewTable: "Neue Tabelle erstellen",
            allTables: "Alle Tabellen",
            myTables: "Meine Tabellen",
            myFavorites: "Meine Favoriten",
            errorCreatingTable: "Fehler beim Erstellen der Tabelle:",
            customerTable: "Kundentabelle",
            customerTableDesc: "Standard-Kundentabelle",
            leadTracking: "Lead-Verfolgung",
            leadTrackingDesc: "Tabelle zur Lead-Verfolgung",
            todoList: "Aufgabenliste",
            todoListDesc: "Liste zur Verfolgung von Aufgaben",
            approvalReq: "Genehmigungsanfrage",
            approvalReqDesc: "Verwaltung von Genehmigungsanträgen",
            eventSchedule: "Veranstaltungskalender",
            eventScheduleDesc: "Planung anstehender Ereignisse",
            inventoryList: "Inventarliste",
            inventoryListDesc: "Übersicht über die Produktbestände",
            bookingForm: "Buchungsformular",
            bookingFormDesc: "Verfolgt Buchungen",
            bugTracker: "Fehlerverfolger",
            bugTrackerDesc: "Verfolgung von Software-Fehlern",
            employeeDirectory: "Mitarbeiterverzeichnis",
            employeeDirectoryDesc: "Enthält Mitarbeiterinformationen",
            errorPullTable: "Fehler beim Ziehen von Tabellendaten",
            newRecordSucs: "Neuer Datensatz erfolgreich erstellt.",
            failedNewRecord: "Die Erstellung eines neuen Datensatzes ist fehlgeschlagen:",
            newRecordCreateError: "Beim Erstellen eines neuen Datensatzes ist ein Fehler aufgetreten.",
            recordCount: "Anzahl der Datensätze",
            increaseLimit: "Erhöhungsgrenze",
            newRecord: "Neuer Datensatz",
            imports: "Importieren",
            exports: "Exportieren",
            download: "Herunterladen",
            automateYourData: "Automatisieren Sie Ihre Daten",
            recordUpdatedSucs: "Datensatz erfolgreich aktualisiert",
            failedToUpdateRecord: "Datensatz konnte nicht aktualisiert werden",
            recordUpdatingError: "Fehler beim Aktualisieren des Datensatzes",
            mainTable: "Haupttabelle",
            filter: "Filter",
            hideFields: "Felder ausblenden",
            saveAsView: "Als Ansicht speichern",
            search: "Suchen",
            create: "Erstellen",
            left: "Links",
            center: "Mittel",
            rechts: "Rechts",
            selectTimezone: "Zeitzone auswählen",
            createFieldSucs: "Feld erfolgreich erstellt.",
            failedCreateField: "Feld konnte nicht erstellt werden:",
            createFieldError: "Beim Erstellen des Feldes ist ein Fehler aufgetreten.",
            addCondition: "Bedingung hinzufügen",
            applyFilter: "Filter anwenden",
            fieldType: "Feldtyp",
            alignment: "Ausrichtung",
            blankTable: "Leere Tabelle",
            templates: "Vorlagen",
            timezone: "Zeitzone",
            timeFormat: "Zeitformat",
            includeTime: "Einschließlich Zeit",
            decimalFormat: "Dezimalformat",
            currencySymbol: "Währungssymbol",
            mode: "Modus",
            statics: "Statisch",
            dynamisch: "Dynamisch",
            multipleSelection: "Mehrfachauswahl",
            addOption: "Option hinzufügen",
            text: "Text",
            longText: "Langer Text",
            number: "Zahl",
            currency: "Währung",
            datetime: "Datum & Uhrzeit",
            dropdown: "Dropdown-Liste",
            checkbox: "Kontrollkästchen",
            email: "E-Mail",
            phone: "Telefon",
            file: "Datei",
            image: "Bild",
            video: "Video",
            audio: "Audio",
            colour: "Farbe",
            automationButton: "Automatisierungsschaltfläche",
            trashBin: "Papierkorb",
            pasteInfoDetected: "Eine in die Zwischenablage kopierte Tabelle wurde erkannt! Mit Strg+V einfügen, um eine neue Tabelle zu erstellen.",
            addCategory: "Kategorie hinzufügen",
            editCategory: "Kategorie bearbeiten",
            deleteCategory: "Kategorie löschen",
            moveAllTables: "Alle Tabellen verschieben",
            dragTablesToCategory: "Ziehen Sie Tabellen hierher, um sie zu dieser Kategorie hinzuzufügen",
            deleteProtectionActive: "Löschschutz aktiv",
            copyTable: "Tabelle kopieren",
            copyAsJSON: "Als JSON kopieren",
            changeCategory: "Kategorie ändern",
            turnOffDeleteProtection: "Löschschutz deaktivieren",
            turnOnDeleteProtection: "Löschschutz aktivieren",
            privacySettings: "Datenschutzeinstellungen",
            categoryName: "Kategoriename",
            categoryNamePlaceholder: "Kategoriename eingeben",
            categoryUpdate: "Aktualisieren",
            categoryCreate: "Erstellen",
            categoryNameRequired: "Kategoriename darf nicht leer sein",
            categoryAlreadyExists: "Eine Kategorie mit diesem Namen existiert bereits",
            categoryCreated: "Kategorie erstellt. Sie können Tabellen in diese Kategorie ziehen.",
            categorySaveError: "Fehler beim Speichern der Kategorie",
            categoryUpdated: "Kategorie aktualisiert",
            categoryUpdateError: "Fehler beim Aktualisieren der Kategorie",
            deleteCategoryConfirm: "Kategorie löschen",
            deleteCategoryConfirmContent: "Sind Sie sicher, dass Sie \"{name}\" löschen möchten? Tabellen in dieser Kategorie werden in \"Allgemein\" verschoben.",
            categoryDeleted: "Kategorie gelöscht",
            categoryDeleteError: "Fehler beim Löschen der Kategorie",
            tableMovedToCategory: "Tabelle in Kategorie \"{name}\" verschoben",
            tableMoveError: "Fehler beim Verschieben der Tabelle",
            tableProtectedWarning: "Diese Tabelle ist vor dem Löschen geschützt. Entfernen Sie zuerst den Schutz.",
            deleteProtectionEnabled: "Löschschutz aktiviert",
            deleteProtectionDisabled: "Löschschutz deaktiviert",
            protectionUpdateError: "Fehler beim Aktualisieren des Schutzstatus",
            tableCopied: "Tabelle kopiert",
            tableCopyError: "Fehler beim Kopieren der Tabelle",
            tableJsonCopied: "Tabelle als JSON in die Zwischenablage kopiert. Mit Strg+V in einem anderen Kundenpanel einfügen.",
            tableJsonCopiedFallback: "Tabelle als JSON in die Zwischenablage kopiert (Fallback-Methode)",
            tableJsonCopyError: "Fehler beim Kopieren der Tabelle als JSON",
            clipboardNotSupported: "Zwischenablage-Zugriff wird in diesem Browser nicht unterstützt",
            noValidTableJson: "Keine gültige Tabellen-JSON in der Zwischenablage gefunden",
            noValidSupsisExport: "Kein gültiger Supsis-Tabellenexport in der Zwischenablage gefunden",
            tableImported: "Tabelle \"{name}\" erfolgreich importiert",
            tablePasteError: "Fehler beim Einfügen der Tabelle",
            noTablesToMove: "Keine Tabellen zum Verschieben",
            tablesMovedToCategory: "{count} Tabellen in Kategorie \"{name}\" verschoben",
            tablesMoveError: "Fehler beim Verschieben der Tabellen",
            noPermissionEditPrivacy: "Sie haben keine Berechtigung, die Datenschutzeinstellungen dieser Tabelle zu bearbeiten",
            sandboxTitle: "Gelöschte Tabellenszenarien",
            sandboxDesc: "Gelöschte Tabellen werden nach 30 Tagen im Papierkorb automatisch dauerhaft gelöscht",
            sandboxEmpty: "Keine gelöschten Tabellen im Papierkorb",
            unnamedTable: "Unbenannte Tabelle",
            restore: "Wiederherstellen",
            permanentlyDelete: "Dauerhaft löschen",
            unknown: "Unbekannt",
            user: "Benutzer",
            restoreTableConfirm: "Sind Sie sicher, dass Sie diese Tabelle wiederherstellen möchten?",
            restoreTableContent: "Tabelle {name} wird wiederhergestellt.",
            tableRestored: "Tabelle wiederhergestellt",
            restoreFailed: "Wiederherstellung fehlgeschlagen",
            permanentlyDeleteConfirm: "Sind Sie sicher, dass Sie diese Tabelle dauerhaft löschen möchten?",
            permanentlyDeleteContent: "Tabelle {name} wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
            yesPermanentlyDelete: "Ja, dauerhaft löschen",
            tablePermanentlyDeleted: "Tabelle dauerhaft gelöscht",
            permanentDeleteFailed: "Dauerhaftes Löschen fehlgeschlagen",
            deletedTablesLoadError: "Fehler beim Laden der gelöschten Tabellen",
            otherTables: "Andere Tabellen",
            noTablesFound: "Keine Tabellen gefunden",
            renameView: "Ansicht umbenennen",
            enterNewViewName: "Neuen Ansichtsnamen eingeben",
            viewRenamedSuccess: "Ansicht erfolgreich umbenannt.",
            viewRenameError: "Beim Umbenennen der Ansicht ist ein Fehler aufgetreten.",
            deleteView: "Ansicht löschen",
            confirmDeleteView: "Sind Sie sicher, dass Sie diese Ansicht löschen möchten?",
            viewDuplicatedSuccess: "Ansicht erfolgreich dupliziert.",
            viewDuplicateError: "Beim Duplizieren der Ansicht ist ein Fehler aufgetreten.",
            duplicateView: "Ansicht duplizieren",
            confirmDuplicateView: "Sind Sie sicher, dass Sie diese Ansicht duplizieren möchten?",
            viewDeletedSuccess: "Ansicht erfolgreich gelöscht.",
            viewDeleteError: "Beim Löschen der Ansicht ist ein Fehler aufgetreten.",
            errorProcessingFile: "Beim Verarbeiten der Datei ist ein Fehler aufgetreten",
            right: "Rechts",
            dynamic: "Dynamisch",
            color: "Farbe",
            upload: "Hochladen",
            permissions: {
                title: "Tabellen-Datenschutzeinstellungen",
                mode: "Berechtigungsmodus",
                publicMode: "Öffentlich",
                customMode: "Benutzerdefiniert",
                publicModeDesc: "In diesem Modus haben alle Benutzer vollen Zugriff auf die Tabelle.",
                customModeDesc: "In diesem Modus haben nur bestimmte Benutzer und Abteilungen Zugriff auf die Tabelle.",
                confirmPublicMode: "In den öffentlichen Modus wechseln",
                confirmPublicModeDesc: "Wenn Sie in den öffentlichen Modus wechseln, werden alle benutzerdefinierten Berechtigungen gelöscht. Möchten Sie fortfahren?",
                addUser: "Benutzer hinzufügen",
                addDepartment: "Abteilung hinzufügen",
                selectUser: "Benutzer auswählen",
                selectDepartment: "Abteilung auswählen",
                add: "Hinzufügen",
                matrixInfo: "Sie können Berechtigungen für Benutzer und Abteilungen in der Matrix unten verwalten. Angekreuzte Felder bedeuten berechtigt.",
                targetHeader: "Benutzer / Abteilung",
                noTargetsAdded: "Noch keine Benutzer oder Abteilungen hinzugefügt",
                confirmRemoveTarget: "Ziel entfernen",
                confirmRemoveTargetDesc: "Sind Sie sicher, dass Sie diesen Benutzer/diese Abteilung aus den Berechtigungen entfernen möchten?",
                saveSuccess: "Berechtigungseinstellungen erfolgreich gespeichert",
                saveError: "Fehler beim Speichern der Berechtigungseinstellungen",
                unknownUser: "Unbekannter Benutzer",
                unknownDepartment: "Unbekannte Abteilung",
                noPermission: "Sie haben keine Berechtigung für diese Aktion",
                groups: {
                    basic: "Grundlegende Berechtigungen",
                    record: "Datensatz-Berechtigungen",
                    view: "Ansichts-Berechtigungen",
                    page: "Seiten-Berechtigungen",
                    field: "Feld-Berechtigungen",
                    widget: "Widget-Berechtigungen",
                    importExport: "Import/Export"
                },
                scopes: {
                    tableRead: "Ansehen",
                    tableReadDesc: "Tabelle ansehen",
                    tableMetaEdit: "Tabelle bearbeiten",
                    tableMetaEditDesc: "Tabellenname, Kategorie und Beschreibung bearbeiten",
                    recordCreate: "Datensatz erstellen",
                    recordCreateDesc: "Neuen Datensatz erstellen",
                    recordUpdate: "Datensatz aktualisieren",
                    recordUpdateDesc: "Bestehende Datensätze aktualisieren",
                    recordDelete: "Datensatz löschen",
                    recordDeleteDesc: "Datensätze löschen",
                    viewCreate: "Ansicht erstellen",
                    viewCreateDesc: "Neue Ansicht erstellen",
                    viewUpdate: "Ansicht aktualisieren",
                    viewUpdateDesc: "Bestehende Ansichten aktualisieren",
                    viewDelete: "Ansicht löschen",
                    viewDeleteDesc: "Ansichten löschen",
                    pageRead: "Seite ansehen",
                    pageReadDesc: "Spezielle Seiten ansehen",
                    pageCreate: "Seite erstellen",
                    pageCreateDesc: "Neue Seite erstellen",
                    pageUpdate: "Seite aktualisieren",
                    pageUpdateDesc: "Bestehende Seiten aktualisieren",
                    pageDelete: "Seite löschen",
                    pageDeleteDesc: "Seiten löschen",
                    fieldCreate: "Feld erstellen",
                    fieldCreateDesc: "Neues Feld erstellen",
                    fieldUpdate: "Feld aktualisieren",
                    fieldUpdateDesc: "Bestehende Felder aktualisieren",
                    fieldDelete: "Feld löschen",
                    fieldDeleteDesc: "Felder löschen",
                    widgetCreate: "Widget erstellen",
                    widgetCreateDesc: "Neues Widget erstellen",
                    widgetUpdate: "Widget aktualisieren",
                    widgetUpdateDesc: "Bestehende Widgets aktualisieren",
                    widgetDelete: "Widget löschen",
                    widgetDeleteDesc: "Widgets löschen",
                    bulkImport: "Massenimport",
                    bulkImportDesc: "Datensätze im Massenimport",
                    export: "Export",
                    exportDesc: "Datensätze exportieren"
                }
            },
            ascendente: "Aufsteigend",
            centro: "Mitte",
            colore: "Farbe",
            company: "Unternehmen",
            createFailed: "Modulerstellung fehlgeschlagen",
            createSuccess: "Modul erfolgreich erstellt",
            destra: "Rechts",
            dinamico: "Dynamisch",
            discendente: "Absteigend",
            failCreateField: "Feld konnte nicht erstellt werden:",
            failToUpdateRecord: "Datensatz konnte nicht aktualisiert werden",
            immagine: "Bild",
            individual: "Individuell",
            izquierda: "Links",
            priority_high: "Hoch",
            priority_highest: "Höchste",
            priority_low: "Niedrig",
            priority_lowest: "Niedrigste",
            priority_medium: "Mittel",
            semicolon: "Semikolon",
            separatorCharacter: "Trennzeichen",
            sinistra: "Links",
            statica: "Statisch",
            tabelle: "Tabellen"
        },
        plans: {
            manageWithChatbot: "Mit Chatbot verwalten",
            manageInbox: "Posteingang verwalten",
            commentManagement: "Kommentare verwalten",
            privateReplyMessage: "Private Kommentarantworten",
            mentionTicket: "Erwähnungen in Tickets umwandeln",
            week: "Woche",
            readyContents: "Fertige Inhalte",
            webhookIntegration: "Webhook-Integration",
            businessChannel: "WhatsApp Business Kanal",
            confirmationFeature: "Bestätigungsfunktion",
            specialReporting: "Spezielle Berichterstattung",
            aiAssistant: "KI-Assistent",
            flexibleBilling: "Flexible Abrechnung",
            automaticReservation: "Automatische Reservierung",
            taskManagement: "Aufgabenverwaltung",
            calendarIntegration: "Kalenderintegration",
            activeChatbot: "Aktiver Chatbot",
            smsIntegration: "SMS-Integration",
            mailIntegration: "E-Mail-Integration",
            startChatWithVisitor: "Chat mit Besucher starten",
            whatsappManaging: "Whatsapp-Verwaltung",
            automaticChatbotButton: "Automatischer Button/Chatbot",
            personalizedBroadcasts: "Personalisierte Rundsendungen",
            chatWithNonContacts: "Chat mit Nicht-Kontakten",
            broadcastMessaging: "Broadcast-Nachrichten",
            perBroadcast: "Pro Sendung",
            extraPricePerMessage: "Zusätzlicher Preis pro Nachricht",
            smartTrigger: "Intelligenter Auslöser",
            telegramIntegration: "Telegram Integration",
            instagramIntegration: "Instagram Integration",
            ticketFeature: "Ticket-Funktion",
            storage: "Speicher",
            onePanelManagement: "Einzelne Panelverwaltung",
            isolatedDatabaseConnection: "Isolierte Datenbankverbindung",
            removeLogo: "Supis-Logo entfernen",
            chatBaloonCustomization: "Chat-Ballon-Anpassung",
            chatAndNotifications: "Chat und Benachrichtigungen",
            unlimited: "Unbegrenzt",
            specialCustomerSupport: "Spezieller Kundensupport",
            softwareSupport: "Software-Support",
            standardSupport: "Standard-Support",
            teamChatIntegration: "Team-Chat-Integration",
            fileAndVoiceShare: "Datei- und Sprachfreigabe",
            instantVisitor: "Instant-Besuchertracking",
            detailedReporting: "Detaillierte Berichterstattung",
            normalreporting: "Normale Berichterstattung",
            noExtraCosts: "Keine zusätzlichen Kosten",
            accessibleToAllAgents: "Zugänglich für alle Agenten",
            dataSecurity: "Datensicherheit",
            autoTranslate: "Automatische Übersetzung",
            chatbotVersionHistory: "Chatbot-Versionenverlauf",
            chatbotStory: "Chatbot-Geschichte",
            freeAgent: "Kostenloser Agent",
            stableAgentCount: "Stabile Agentenanzahl",
            stableChannelCount: "Stabile Kanalanzahl",
            chipPlans: "Günstige Pläne",
            generalPlan: "Allgemeiner Plan",
            specialPlan: "Spezieller Plan",
            currentPlan: "Aktueller Plan",
            selected: "Ausgewählt",
            popular: "Beliebt",
            trialPkg: "Testpaket",
            support: "24/7 Support",
            flexiblePricing: "Flexible Preisgestaltung",
            rightToCancel: "Recht auf jederzeitige Kündigung",
            unlimitedCBScenario: "Unbegrenzte Chatbot-Szenarien",
            freeFirstScenario: "Kostenloses erstes Szenario",
            unlimitedLearn: "Unbegrenztes Chatbot-Training",
            allPlatformIntegration: "Integration mit allen Plattformen",
            detailedReports: "Detaillierte Berichte",
            aiSupport: "KI-Unterstützung",
            creativeAI: "Schneller und realistischer KI-Chat-Assistent",
            unlimitedSession: "Unbegrenzte Sitzungen gleichzeitig",
            assistantFromWebsite: "Erstellen eines Assistenten von der Website",
            assistantFromDoc: "Erstellen eines Chatbots aus dem Dokument",
            mobileApp: "Mobile App",
            commentManage: "Kommentare verwalten"
        },
        messenger: {
            channel: "Messenger-Kanal",
            manageChannel: "Kanal verwalten",
            channelDetail: "Kanaldetail",
            integrationTitle: "Messenger-Integration",
            deleteDesc: "Möchten Sie den Messenger-Kanal wirklich löschen?",
            channels: "Messenger-Kanäle",
            connectMessenger: "Mit Messenger verbinden",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Messenger-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Messenger-Kommentare",
            adoptimization: "Anzeigen-Optimierung"
        },
        instagram: {
            channel: "Instagram-Kanal",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            commentsettings: "Kommentarverwaltung",
            commentSettingsTitle: "Instagram-Kommentarverwaltung",
            commentSettingsDesc: "Verwalten Sie Ihre Instagram-Kommentare",
            commentSettingsTicket: "Stellt sicher, dass eingehende Kommentare im System als Tickets erfasst werden.",
            commentSettingsChatbot: "Wählen Sie, zu welchem Chatbot-Szenario eingehende Kommentare weitergeleitet werden sollen.",
            leads: "Leads",
            forms: "Formulare",
            showAllInstagramChannels: "Alle Instagram-Kanäle anzeigen",
            brand: "Marke",
            questions: "Fragen",
            showAllLinkedinChannels: "Alle LinkedIn-Kanäle anzeigen",
            showAllTelegramChannels: "Alle Telegram-Kanäle anzeigen",
            adoptimization: "Anzeigen-Optimierung"
        },
        calendar: {
            calendarsDesc: "Vermeiden Sie Terminkonflikte.",
            generalAvailability: "Allgemeine Verfügbarkeit",
            generalAvailabilityDesc: "Geben Sie die Zeiten an, zu denen Sie regelmäßig für Termine zur Verfügung stehen.",
            appointDuration: "Dauer des Termins",
            appointDurationDesc: "Wie lange soll jeder Termin dauern?",
            customDuration: "Benutzerdefinierte Dauer",
            descriptionDesc: "Fügen Sie eine Notiz hinzu, die Ihre Dienstleistung beschreibt. Die von Ihnen hinzugefügte Notiz erscheint auf Ihrer Buchungsseite und in Bestätigungs-E-Mails.",
            resForm: "Buchungsformular",
            resFormDesc: "Passen Sie das Formular an, das die Benutzer für die Buchung eines Termins verwenden werden.",
            addField: "Feld hinzufügen",
            addAnItem: "Ein Element hinzufügen",
            saveItem: "Element speichern",
            planningTimeframe: "Planungszeitrahmen",
            planningTimeframeDesc: "Begrenzen Sie den Zeitrahmen, in dem ein Termin vereinbart werden kann.",
            availableAtMoment: "Jetzt verfügbar",
            startAndEndDate: "Start- und Enddatum",
            maxNumberAppoint: "Maximale Anzahl von Tagen, nach denen ein Termin vereinbart werden kann",
            howLongMinAppoint: "Wie lange, bevor der Termin gebucht werden kann",
            planningIntervalStartEnd: "Start- und Enddatum des Planungsintervalls",
            startTime: "Startzeit",
            done: "Erledigt",
            receivedAppointInterval: "Intervall des empfangenen Termins",
            receivedAppointIntervalDesc: "Empfangene Termine verwalten, damit sie in Ihrem Kalender erscheinen",
            interimTime: "Zwischenzeit",
            interimTimeDesc: "Zeit zwischen den Terminintervallen hinzufügen",
            dayMaxRes: "Maximale Anzahl von Buchungen pro Tag",
            dayMaxResDesc: "Begrenzen Sie die Anzahl der gebuchten Termine, die an einem einzigen Tag angenommen werden können",
            customise: "Benutzerdefiniert einstellen",
            noAvatar: "Kein Avatar",
            organizationName: "Name der Organisation",
            enterFullAdress: "Vollständige Adresse eingeben",
            noCoverPhoto: "Kein Titelfoto",
            enterAboutInfo: "Geben Sie Informationen über den Dienst ein",
            service: "Dienst",
            deleteService: "Dienst löschen",
            enterGoogleMapsUrl: "Google Maps URL eingeben",
            enterLatitude: "Breitengrad eingeben",
            enterLongitude: "Geben Sie den Längengrad ein",
            enterNumber: "Telefonnummer eingeben",
            uploadAvatar: "Avatar hochladen",
            teamMemberDeleteError: "Fehler beim Löschen eines Teammitglieds:",
            setupBookingWebsite: "Buchungswebsite einrichten",
            bookingLandingPageBuilder: "Buchungs-Landingpage-Gestalter",
            coverPhoto: "Titelfoto",
            enterOrganisationName: "Name der Organisation eingeben",
            about: "Über",
            services: "Dienstleistungen",
            deleteServices: "Dienstleistung löschen",
            selectReservationPlan: "Reservierungsplan auswählen",
            addNewService: "Neue Dienstleistung hinzufügen",
            addNewMember: "Neues Mitglied hinzufügen",
            fullAddress: "Vollständige Adresse",
            latitude: "Breitengrad",
            longitude: "Längengrad",
            contactDetails: "Kontaktdetails",
            emailAddress: "E-Mail Adresse",
            enterEmail: "E-Mail-Adresse eingeben",
            websiteURL: "Website-URL",
            enterWebsiteURL: "Website-URL eingeben",
            reservationPolicy: "Reservierungsrichtlinie",
            enterResPolicy: "Geben Sie die Buchungspolitik ein",
            workingHours: "Arbeitszeiten",
            selectEndHour: "Endzeit auswählen",
            addNewHour: "Neue Stunde hinzufügen",
            updateMemberInfo: "Mitgliederinformationen aktualisieren",
            errorRecevingData: "Fehler beim Abrufen von Daten:",
            anonymService: "Anonymer Dienst",
            unknownPlan: "Unbekannter Plan",
            errorCreatingMockPage: "Fehler beim Erstellen der Mock-Seite:",
            failedToCreateBookingPage: "Fehler beim Erstellen der Buchungsseite",
            fileSizeToolLarge: "Dateigröße zu groß",
            errorLoadingTheLogo: "Fehler beim Laden des Logos:",
            failedToLoadLogo: "Das Logo konnte nicht geladen werden",
            errorUpdating: "Fehler beim Aktualisieren:",
            failedToUpdate: "Aktualisierung fehlgeschlagen",
            newMember: "Neues Mitglied",
            errorLoadingAvatar: "Fehler beim Laden des Avatars:",
            avatarFailedToLoad: "Avatar konnte nicht geladen werden",
            teamMemberSuccessfullyDeleted: "Teammitglied erfolgreich gelöscht",
            teamMemberNotDeleted: "Teammitglied konnte nicht gelöscht werden",
            yesDelete: "Ja, löschen",
            sureReservationDelete: "Sind Sie sicher, dass Sie diese Buchung löschen wollen?",
            reservationDetails: "Buchungsdetails",
            infoPersonMakingReservation: "Informationen über die Person, die die Reservierung vornimmt",
            appointmentSchedule: "Zeitplan für den Termin",
            goToAppointmentSettings: "Zu den Einstellungen des Terminprogramms",
            resPlanCreateSuccess: "Reservierungsplan erfolgreich erstellt",
            pleaseEnterTitle: "Bitte Titel eingeben",
            sureContinueSaving: "Sind Sie sicher, dass Sie ohne Speichern fortfahren wollen?",
            appointProgram: "BUCHUNGSPROGRAMM",
            everyMonth: "Jeden Monat",
            firstEveryMonth: "Erster eines jeden Monats",
            dayOf: "Tag",
            notRepeat: "Wird nicht wiederholt",
            daily: "Jeden Tag",
            weekly: "Einmal pro Woche",
            monthly: "Einmal im Monat",
            annually: "Einmal im Jahr",
            custom: "Speziell",
            eventSaved: "Gespeicherte Veranstaltung",
            createAppoint: "Termin erstellen",
            calendarSetting: "Kalendereinstellungen",
            notAuthezord: "Sie sind nicht berechtigt, diese Operation auszuführen",
            notAuthorizedToPerformOperation: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
            reservationWebPage: "Reservierungs-Webseite",
            reservationBuilder: "Reservierungs-Website",
            reservationPrograms: "Reservierungsprogramme",
            automations: "Automatisierungen",
            addReservationProgram: "Reservierungsprogramm hinzufügen",
            resPlanError: "Fehler beim Empfangen der Reservierungsprogramme:",
            resDeleteSure: "Sind Sie sicher, dass Sie dieses Reservierungsprogramm löschen möchten?",
            resDeleteSuccess: "Das Reservierungsprogramm wurde erfolgreich gelöscht.",
            resDeleteError: "Fehler beim Löschen des Reservierungsprogramms:",
            unkownUser: "Unbekannter Benutzer",
            eventNotFound: "Ereignis nicht gefunden",
            reservations: "Reservierungen",
            events: "Veranstaltungen",
            upcoming: "kommende",
            past: "Vergangenheit",
            setting: "Einstellungen",
            delete: "Löschen",
            cancel: "Abbrechen",
            save: "Speichern",
            close: "Schließen",
            deleteRepeatEvent: "Wiederholendes Ereignis löschen",
            thisEvent: "Dieses Ereignis",
            thisAndOtherEvent: "Dieses und folgende Ereignisse",
            allEvent: "Alle Ereignisse",
            ok: "OK",
            googleCalendarLink: "Zum Google Kalender hinzufügen",
            yahooCalendarLink: "Zum Yahoo Kalender hinzufügen",
            subject: "Betreff",
            visitor: "Besucher",
            allDay: "Ganztägig",
            title: "Titel",
            deleteEvent: "Ereignis löschen",
            deleteEvents: "Ereignisse löschen",
            deleteEventsSure: "Sind Sie sicher, dass Sie die Ereignisse in diesem Kalender löschen möchten?",
            deleteEventConfirm: "Sind Sie sicher, dass Sie dieses Ereignis löschen möchten?",
            notEmptyTitle: "Der Titel darf nicht leer sein!",
            tasks: "Aufgaben",
            googleConnect: "Google-Integration",
            googleDisconnect: "Google-Integration trennen",
            sure: "Sind Sie sicher?",
            disconnectGoogleSure: "Sind Sie sicher, dass Sie die Google-Verbindung trennen möchten?",
            yes: "Ja",
            no: "Nein",
            customRepeat: "Benutzerdefinierte Wiederholung",
            recurrenceFrequency: "Wiederholungsfrequenz",
            repeatDays: "An diesen Tagen wiederholen:",
            never: "Niemals",
            thisDate: "An diesem Datum:",
            recurrenceCount: "Anzahl der Wiederholungen:",
            end: "Ende",
            event: "Ereignis",
            calendars: "Kalender",
            newCalendar: "Neuen Kalender erstellen",
            changeColor: "Farbe ändern",
            addCalendar: "Kalender hinzufügen",
            nameCalendar: "Kalendername",
            description: "Beschreibung",
            change: "Ändern",
            deleteCalendar: "Kalender löschen",
            deleteCalendarSure: "Sind Sie sicher, dass Sie diesen Kalender löschen möchten?",
            notEmptyCalendarName: "Der Kalendername darf nicht leer sein",
            myEvents: "Meine Ereignisse",
            everyoneEvents: "Alle Ereignisse",
            haveEvent: "Ereignisse des Vertreters",
            goCalendar: "Zum Kalender gehen",
            goReservation: "Reservierung erstellen",
            agents: "Vertreter",
            today: "Heute",
            month: "Monat",
            week: "Woche",
            day: "Tag",
            list: "Liste",
            planingIntervalStartEnd: "Start- und Enddatum des Planungsintervalls",
            customize: "Benutzerdefiniert festlegen",
            enterOrganizationName: "Organisationsname eingeben",
            teamMemberNotDelete: "Teammitglied konnte nicht gelöscht werden",
            sureResDelete: "Sind Sie sicher, dass Sie diese Buchung löschen möchten?",
            resDetails: "Reservierungsdetails",
            infoPersonMakingRes: "Informationen der buchenden Person",
            appointmentProgram: "Terminplan",
            goToAppointSettings: "Zu den Terminplan-Einstellungen",
            weely: "Wöchentlich",
            annualy: "Jährlich",
            appointmentDuration: "Termindauer",
            calendari: "Kalender"
        },
        ticimax: {
            segment: "Segment",
            settings_group: "Einstellungen",
            waitDayFromLastSend: "Wartezeit in Tagen seit der letzten gesendeten Nachricht",
            automationRuleName: "Name der Automatisierungsregel",
            time: "Zeit",
            year: "Jahr",
            month: "Monat",
            dayOfMonth: "Tag des Monats",
            day: "Tag",
            bySecond: "Pro Sekunde",
            byMinute: "Pro Minute",
            byHour: "Pro Stunde",
            byWeekNo: "Nach Wochennummer",
            byYearDay: "Nach Tag im Jahr",
            byMonthDay: "Nach Tag im Monat",
            byMonth: "Nach Monat",
            december: "Dezember",
            november: "November",
            october: "Oktober",
            september: "September",
            august: "August",
            july: "Juli",
            june: "Juni",
            may: "Mai",
            april: "April",
            march: "März",
            february: "Februar",
            january: "Januar",
            byWeekDay: "Nach Wochentag",
            interval: "Intervall",
            seconds: "Sekunden",
            minutes: "Minuten",
            hourly: "Stündlich",
            daily: "Täglich",
            weekly: "Wöchentlich",
            monthly: "Monatlich",
            yearly: "Jährlich",
            frequency: "Frequenz",
            attributes: {
                vip: "VIP",
                segment: "Segment",
                province: "Provinz",
                country: "Land",
                phone: "Telefon",
                email: "E-Mail",
                fullname: "Vollständiger Name",
                couponPercent: "% Rabatt",
                lastOrderDate: "Letzte Bestellung",
                firstOrderDate: "Erste Bestellung",
                county: "Landkreis",
                lastSource: "Letzte Quelle",
                firstSource: "Erste Quelle",
                lastPaymentType: "Letzte Zahlungsmethode",
                firstPaymentType: "Erste Zahlungsmethode",
                maxOrderAmount: "Maximaler Bestellbetrag",
                minOrderAmount: "Minimaler Bestellbetrag",
                totalOrderAmount: "Gesamtbestellmenge",
                totalOrderCount: "Gesamtanzahl der Bestellungen",
                usedCouponAmount: "Verwendeter Gutscheinbetrag",
                usedCouponCount: "Anzahl der verwendeten Gutscheine",
                tookDayFromLastOrder: "Tage seit der letzten Bestellung",
                isCouponUser: "Ist Gutscheinbenutzer"
            },
            createAutomation: "Automatisierung erstellen",
            previous: "Zurück",
            createAutomationDesc: "Erstellen und verwalten Sie die Automatisierung von Nachrichten",
            newTicimaxChannel: "Neuer Ticimax-Kanal",
            connextToTicimaxXml: "Mit Ticimax XML-Dienst verbinden",
            connectTicimax: "Mit Ticimax verbinden",
            examplePreview: "Beispielvorschau",
            completeAutomationRule: "Automatisierungsregel abschließen",
            configureMessage: "Nachricht konfigurieren",
            automationTimer: "Automatisierungs-Timer",
            findTargetMembers: "Zielmitglieder finden",
            createAutomationRule: "Automatisierungsregel erstellen",
            action: "Aktion",
            status: "Status",
            triggeredUserCount: "Ausgelöste Benutzeranzahl",
            nextScheduled: "Nächste geplante",
            timerRule: "Timer-Regel",
            automationRules: "Automatisierungsregeln",
            apply: "Anwenden",
            searchAMember: "Mitglied suchen",
            segmentedMembersDesc: "Listen und automatisieren Sie segmentierte Mitglieder",
            manageVisibilityDesc: "Verwalten Sie die Sichtbarkeit des Kanals",
            xmlOrderListURL: "URL der XML-Bestellliste",
            manageIntegrationDesc: "Verwalten Sie Ihre Ticimax-Integration",
            detail: "Detail",
            ticimaxChannelsTitle: "Ticimax-Kanäle",
            ticimaxDetail: "Ticimax-Detail",
            settingsGroup: "Einstellungen",
            visibility: "Sichtbarkeit",
            members: "Mitglieder",
            automation: "Automatisierung",
            integrationChannel: "Integrationskanal",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            channelUpdateFailed: "Aktualisierung des Kanals fehlgeschlagen"
        },
        notification: {
            taskArchive: "Benachrichtigung wird gesendet, wenn eine Aufgabe archiviert wird.",
            taskComplet: "Benachrichtigung wird gesendet, wenn eine abgeschlossene Aufgabe geschlossen wird.",
            adjustNow: "Jetzt anpassen",
            chatAssignedMe: "Wenn ein Chat mir zugewiesen wird.",
            ticketAssignedMe: "Wenn ein Ticket mir zugewiesen wird.",
            myChatClosed: "Wenn ein Chat, den ich besitze, geschlossen wird.",
            contactOwner: "Wenn der Eigentümer des Chats wechselt, wenn das Eigentum zugewiesen oder entfernt wird.",
            tagActionsToVisitor: "Wenn ein Tag zu einem Besucher hinzugefügt oder entfernt wird.",
            ticketCreated: "Wenn ein Besucher oder Chatbot ein Ticket erstellt.",
            notesActions: "Wenn eine Notiz zu einem Kunden hinzugefügt oder entfernt wird.",
            visitorProfileUpdated: "Wenn das Profil eines Besuchers aktualisiert wird.",
            chatStartedByAnyPlatform: "Wenn ein Chat von einem beliebigen Kanal gestartet wird.",
            userActions: "Wenn ein Benutzer erstellt, aktualisiert oder gelöscht wird.",
            departmentActions: "Wenn eine Abteilung erstellt, aktualisiert oder gelöscht wird.",
            settingsActions: "Wenn Einstellungen erstellt, aktualisiert oder gelöscht werden.",
            integrationsActions: "Wenn ein Integrationskanal erstellt, aktualisiert oder gelöscht wird.",
            loginFormActions: "Wenn das Anmeldeformular aktualisiert oder aktiviert wird.",
            bannedWordActions: "Wenn ein verbotenes Wort erstellt, aktualisiert oder gelöscht wird.",
            emailActions: "Wenn ein E-Mail-Konto erstellt, aktualisiert oder gelöscht wird.",
            preparedContentActions: "Wenn vorbereiteter Inhalt erstellt, aktualisiert oder gelöscht wird.",
            roleActions: "Wenn eine Rolle erstellt, aktualisiert oder gelöscht wird.",
            tagActions: "Wenn ein Tag erstellt, aktualisiert oder gelöscht wird.",
            welcomeMessageActions: "Wenn eine Willkommensnachricht erstellt, aktualisiert oder gelöscht wird.",
            webhookActions: "Wenn ein Webhook erstellt, aktualisiert oder gelöscht wird.",
            billingEvents: "Wenn eine Rechnung erstellt oder ihr Status aktualisiert wird.",
            systemStatus: "Wenn der Status des Live-Support-Systems aktualisiert wird.",
            reservationMessageCrud: "Wenn eine Reservierung erstellt, aktualisiert oder gelöscht wird.",
            ipAddressWhiteListEvents: "Wenn eine erlaubte IP-Adresse hinzugefügt, aktualisiert oder gelöscht wird.",
            taskAssignedMe: "Wenn mir eine Aufgabe zugewiesen wird.",
            workflowCreated: "Wenn ein Workflow erstellt wird.",
            workflowDeleted: "Wenn ein Workflow gelöscht wird.",
            createdTask: "Wenn eine Aufgabe erstellt wird.",
            deletedTask: "Wenn eine Aufgabe gelöscht wird.",
            chatbotStoryCrud: "Wenn eine Chatbot-Geschichte erstellt, aktualisiert oder gelöscht wird.",
            chatbotForwardAgent: "Der Chatbot leitet einen Chat an einen Agenten weiter.",
            userSegmentCrud: "Wenn ein Benutzersegment erstellt, aktualisiert oder gelöscht wird.",
            chatbotCreditLow: "Wenn das Guthaben des Chatbots niedrig ist.",
            wpCreditLow: "Wenn das WhatsApp-Guthaben unter 100 TL fällt.",
            wpCustomerGroupCrud: "Wenn eine WhatsApp-Kundengruppe erstellt, aktualisiert oder gelöscht wird.",
            wpBroadcastMessageStatus: "Wenn das Senden einer WhatsApp-Broadcast-Nachricht gestartet, abgeschlossen oder abgebrochen wird.",
            wpTemplateMesssageCrud: "Wenn eine WhatsApp-Vorlagen-Nachricht erstellt, aktualisiert oder gelöscht wird.",
            whatsappQrChannelStatusUpdated: "Wenn der Verbindungsstatus des WhatsApp QR-Kanals aktualisiert wird.",
            activityTypeLabels: {
                "chat-assign": "Wenn mir ein Chat zugewiesen wird",
                "ticket-assign": "Wenn mir ein Ticket zugewiesen wird",
                "task-assign": "Wenn mir eine Aufgabe zugewiesen wird",
                "task-complet": "Wenn eine Aufgabe abgeschlossen wird",
                "chat-close-own": "Wenn ein Chat, der mir gehört, geschlossen wird",
                "tag-actions-to-visitor": "Tags werden zu einem Kontakt hinzugefügt oder entfernt",
                "create-ticket": "Ticket wird von Besucher oder Chatbot erstellt. Auch wenn eine Offline-Nachricht aus dem Chat-Fenster gesendet wird",
                "note-actions-to-visitor": "Notizen werden zu einem Kontakt hinzugefügt oder entfernt",
                "visitor-profile-updates": "Besucherprofil wird aktualisiert",
                "chat-start": "Chat wird auf einer beliebigen Plattform von Kontakt oder Agent gestartet",
                "user-crud": "Benutzer wird erstellt, aktualisiert oder gelöscht",
                "department-crud": "Abteilung wird erstellt, aktualisiert oder gelöscht",
                "settings-crud": "Einstellungen werden erstellt, aktualisiert oder gelöscht",
                "integration-channel-crud": "Integrationskanal wird erstellt, aktualisiert oder gelöscht",
                "login-form-crud": "Anmeldeformular wird aktualisiert, aktiviert oder deaktiviert",
                "banned-word-crud": "Verbotenes Wort wird erstellt, aktualisiert oder gelöscht",
                "email-account-crud": "E-Mail-Konto wird erstellt oder gelöscht",
                "prepared-content-crud": "Vorbereiteter Inhalt wird erstellt oder gelöscht",
                "role-crud": "Rolle wird erstellt, aktualisiert oder gelöscht",
                "tag-crud": "Tag wird erstellt, aktualisiert oder gelöscht",
                "welcome-message-crud": "Begrüßungsnachricht wird erstellt, aktualisiert oder gelöscht",
                "webhook-crud": "Webhook wird erstellt, aktualisiert oder gelöscht",
                "automation-created": "Automatisierung wird erstellt",
                "automation-deleted": "Automatisierung wird gelöscht",
                "automation-published": "Automatisierung wird veröffentlicht",
                "automation-unpublished": "Automatisierung wird nicht mehr veröffentlicht",
                "automation-updated": "Automatisierung wird aktualisiert",
                "billing-events": "Abrechnungsereignisse",
                "task-workflow-crud": "Aufgaben-Workflow wird erstellt, aktualisiert oder gelöscht",
                "task-crud": "Aufgabe wird erstellt, aktualisiert oder gelöscht",
                "system-status": "System online oder offline Statusänderungen",
                "chatbot-story-crud": "Chatbot-Geschichte wird erstellt, aktualisiert oder gelöscht",
                "chatbot-forward-chat": "Chatbot leitet einen Chat an einen Agenten weiter",
                "chatbot-user-segment-crud": "Benutzersegment wird erstellt, aktualisiert oder gelöscht",
                "chatbot-credit-low": "Wenn Chatbot-Guthaben niedrig ist",
                "whatsapp-credit-low": "Wenn WhatsApp-Guthaben niedrig ist",
                "whatsapp-customer-group-crud": "Wenn WhatsApp-Kundengruppe erstellt, aktualisiert oder gelöscht wird",
                "whatsapp-broadcast-message-crud": "Wenn WhatsApp-Broadcast-Nachricht gesendet, abgeschlossen oder abgebrochen wird",
                "whatsapp-template-message-crud": "Wenn WhatsApp-Vorlagennachricht erstellt, aktualisiert oder gelöscht wird",
                "form-created": "Formular wird erstellt",
                "form-updated": "Formular wird aktualisiert",
                "form-deleted": "Formular wird gelöscht",
                "form-restored": "Formular wird wiederhergestellt",
                "form-downloaded": "Formular wird heruntergeladen",
                "user-role-changed": "Benutzerrolle wird geändert",
                "user-password-changed": "Benutzerpasswort wird geändert",
                "user-email-changed": "Benutzer-E-Mail-Adresse wird geändert",
                "user-name-changed": "Benutzername wird geändert",
                "user-phone-changed": "Benutzertelefon wird geändert",
                "user-disabled": "Benutzer wird deaktiviert/aktiviert",
                "role-updated": "Rolle wird aktualisiert",
                "task-workflow-updated": "Aufgaben-Workflow wird aktualisiert",
                "task-workflow-pipeline-stage-added": "Aufgaben-Workflow-Pipeline-Stufe wird hinzugefügt",
                "task-workflow-pipeline-stage-updated": "Aufgaben-Workflow-Pipeline-Stufe wird aktualisiert",
                "task-workflow-pipeline-stage-deleted": "Aufgaben-Workflow-Pipeline-Stufe wird gelöscht",
                "drive-folder-created": "Drive-Ordner wird erstellt",
                "drive-folder-deleted": "Drive-Ordner wird gelöscht",
                "drive-folder-renamed": "Drive-Ordner wird umbenannt",
                "drive-file-added": "Datei wird zu Drive hinzugefügt",
                "drive-file-deleted": "Datei wird aus Drive gelöscht",
                "task-module-rules-enabled": "Aufgabenmodul-Regeln werden aktiviert",
                "task-module-rules-disabled": "Aufgabenmodul-Regeln werden deaktiviert",
                "task-module-rules-rule-added": "Regel wird zum Aufgaben-Workflow hinzugefügt",
                "task-module-rules-rule-deleted": "Regel wird aus Aufgaben-Workflow gelöscht",
                "task-module-rules-rule-updated": "Regel wird im Aufgaben-Workflow aktualisiert",
                "task-module-rules-rule-enabled": "Regel wird im Aufgaben-Workflow aktiviert",
                "task-module-rules-rule-disabled": "Regel wird im Aufgaben-Workflow deaktiviert",
                "contact-module-rules-enabled": "Kontaktmodul-Regeln werden aktiviert",
                "contact-module-rules-disabled": "Kontaktmodul-Regeln werden deaktiviert",
                "contact-module-rules-rule-added": "Regel wird zum Kontaktmodul hinzugefügt",
                "contact-module-rules-rule-updated": "Regel wird im Kontaktmodul aktualisiert",
                "contact-module-rules-rule-deleted": "Regel wird aus Kontaktmodul gelöscht",
                "contact-module-rules-rule-enabled": "Regel wird im Kontaktmodul aktiviert",
                "contact-module-rules-rule-disabled": "Regel wird im Kontaktmodul deaktiviert",
                "developer-token-changed": "Entwickler-Token wird aktualisiert",
                "table-created": "Tabelle wird erstellt",
                "table-field-added": "Feld wird zur Tabelle hinzugefügt",
                "table-field-updated": "Feld wird in Tabelle aktualisiert",
                "table-field-deleted": "Feld wird aus Tabelle gelöscht",
                "table-view-added": "Ansicht wird zur Tabelle hinzugefügt",
                "table-view-updated": "Ansicht wird in Tabelle aktualisiert",
                "table-view-deleted": "Ansicht wird aus Tabelle gelöscht",
                "table-page-added": "Seite wird zur Tabelle hinzugefügt",
                "table-page-updated": "Seite wird in Tabelle aktualisiert",
                "table-page-deleted": "Seite wird aus Tabelle gelöscht",
                "table-widget-added": "Widget wird zur Tabellenseite hinzugefügt",
                "table-widget-updated": "Widget wird auf Tabellenseite aktualisiert",
                "table-widget-deleted": "Widget wird von Tabellenseite gelöscht",
                "table-privacy-changed": "Tabellendatenschutzeinstellungen werden aktualisiert",
                "web-app-created": "Webanwendung wird erstellt",
                "web-app-updated": "Webanwendung wird aktualisiert",
                "web-app-deleted": "Webanwendung wird gelöscht",
                "web-tab-created": "Web-Tab wird erstellt",
                "web-tab-updated": "Web-Tab wird aktualisiert",
                "web-tab-deleted": "Web-Tab wird gelöscht",
                "module-created": "Modul wird erstellt",
                "module-updated": "Modul wird aktualisiert",
                "module-deleted": "Modul wird gelöscht",
                "relation-created": "Beziehung wird erstellt",
                "relation-updated": "Beziehung wird aktualisiert",
                "voice-agent-created": "Sprach-Agent wird erstellt",
                "voice-agent-updated": "Sprach-Agent wird aktualisiert",
                "voice-agent-deleted": "Sprach-Agent wird gelöscht",
                "voice-agent-phone-number-inbound-agent-changed": "Telefonnummer eingehender Anruf-Agent wird geändert",
                "voice-agent-phone-number-outbound-agent-changed": "Telefonnummer ausgehender Anruf-Agent wird geändert",
                "voice-agent-batch-call-created": "Batch-Anruf wird erstellt",
                "voice-agent-knowledge-base-created": "Wissensdatenbank wird erstellt",
                "voice-agent-knowledge-base-deleted": "Wissensdatenbank wird gelöscht",
                "table-data-downloaded": "Tabellendaten werden heruntergeladen",
                "table-data-imported": "Massenimport von Daten in Tabelle",
                "table-data-batch-updated": "Tabellendaten werden stapelweise aktualisiert",
                "table-data-batch-deleted": "Tabellendaten werden stapelweise gelöscht",
                "contact-batch-updated": "Kontakte werden stapelweise aktualisiert",
                "chat-data-downloaded": "Chat-Verlauf wird heruntergeladen",
                "automation-restored": "Wenn eine Automatisierung aus dem Papierkorb wiederhergestellt wird",
                "waba-supsis-partner-remove": "Wenn ein WhatsApp Business API V2-Partner entfernt wird",
                "waba-supsis-account-deleted": "Wenn ein WhatsApp Business API V2-Konto gelöscht wird",
                "waba-supsis-account-violation": "Wenn eine WhatsApp Business API V2-Konto-Verletzung festgestellt wird",
                "waba-supsis-ad-account-linked": "Wenn ein WhatsApp Business API V2-Werbekonto verknüpft wird",
                "waba-supsis-auth-intl-price-eligibility-update": "Wenn die internationale Preisberechtigung für WhatsApp Business API V2 aktualisiert wird",
                "waba-supsis-disabled-update": "Wenn eine WhatsApp Business API V2-Deaktivierungsaktualisierung erfolgt",
                "waba-supsis-mm-lite-terms-signed": "Wenn die WhatsApp Business API V2 MM Lite-Bedingungen unterzeichnet werden",
                "waba-supsis-partner-app-installed": "Wenn die WhatsApp Business API V2-Partner-App installiert wird",
                "waba-supsis-partner-app-uninstalled": "Wenn die WhatsApp Business API V2-Partner-App deinstalliert wird",
                "waba-supsis-partner-client-certification-status-update": "Wenn der Partner-Kundenzertifizierungsstatus für WhatsApp Business API V2 aktualisiert wird",
                "waba-supsis-business-primary-location-country-update": "Wenn das primäre Standortland für WhatsApp Business API V2 aktualisiert wird",
                "waba-supsis-volume-based-pricing-tier-update": "Wenn die volumenbasierte Preisstufe für WhatsApp Business API V2 aktualisiert wird",
                "waba-supsis-message-template-components-update": "Wenn die Nachrichtenvorlagen-Komponenten für WhatsApp Business API V2 aktualisiert werden",
                "waba-supsis-message-template-status-update": "Wenn der Nachrichtenvorlagen-Status für WhatsApp Business API V2 aktualisiert wird",
                waba_supsis_partner_remove: "WhatsApp Business API V2-Partner wurde entfernt",
                waba_supsis_account_deleted: "WhatsApp Business API V2-Konto wurde gelöscht",
                waba_supsis_account_violation: "WhatsApp Business API V2-Konto-Verletzung wurde festgestellt",
                waba_supsis_ad_account_linked: "WhatsApp Business API V2-Werbekonto wurde verknüpft",
                waba_supsis_auth_intl_price_eligibility_update: "Internationale Preisberechtigung für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_disabled_update: "WhatsApp Business API V2-Deaktivierungsaktualisierung wurde durchgeführt",
                waba_supsis_mm_lite_terms_signed: "WhatsApp Business API V2 MM Lite-Bedingungen wurden unterzeichnet",
                waba_supsis_partner_added: "WhatsApp Business API V2-Partner wurde hinzugefügt",
                waba_supsis_partner_app_installed: "WhatsApp Business API V2-Partner-App wurde installiert",
                waba_supsis_partner_app_uninstalled: "WhatsApp Business API V2-Partner-App wurde deinstalliert",
                waba_supsis_partner_client_certification_status_update: "Partner-Kundenzertifizierungsstatus für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_business_primary_location_country_update: "Primäres Standortland für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_volume_based_pricing_tier_update: "Volumenbasierte Preisstufe für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_message_template_components_update: "Nachrichtenvorlagen-Komponenten für WhatsApp Business API V2 wurden aktualisiert",
                waba_supsis_message_template_status_update: "Nachrichtenvorlagen-Status für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_template_category_update: "Vorlagenkategorie für WhatsApp Business API V2 wurde aktualisiert",
                waba_supsis_PARTNER_REMOVE: "WhatsApp Business API V2-Partner wurde entfernt",
                waba_supsis_ACCOUNT_DELETED: "WhatsApp Business API V2-Konto wurde gelöscht",
                "task-workflow-restored": "Wenn ein Aufgaben-Workflow aus dem Papierkorb wiederhergestellt wird",
                "task-workflow-permanently-deleted": "Wenn ein Aufgaben-Workflow dauerhaft aus dem Papierkorb gelöscht wird",
                "table-deleted": "Wenn eine Tabelle gelöscht wird",
                "table-restored": "Wenn eine Tabelle aus dem Papierkorb wiederhergestellt wird",
                "table-permanently-deleted": "Wenn eine Tabelle dauerhaft aus dem Papierkorb gelöscht wird"
            },
            crmActions: "CRM-Aktionen",
            mobileApp: "Mobile-Anwendung",
            webPanel: "Web-Panel",
            notifications: "Benachrichtigungen",
            whatsappActions: "Whatsapp-Aktionen",
            chatbotActions: "Chatbot-Aktionen",
            companyActions: "Unternehmensaktionen",
            basicActions: "Grundlegende Aktionen",
            notificationSettingsDesc: "Wählen Sie aus, welche Benachrichtigungen Sie erhalten möchten und wo Sie sie erhalten möchten.",
            noNotificationDesc2: "Hier sehen Sie alle Benachrichtigungen zu den Stellenangeboten, Bewerbern und Talentpools, die Sie verfolgen. Sie können Benachrichtigungen anpassen, indem Sie die Einstellungen anpassen.",
            noNotificationTitle2: "Noch keine Benachrichtigungen.",
            noNotificationTitle1: "Keine Benachrichtigungen. Genießen Sie die Stille.",
            adjustSettings: "Einstellungen anpassen",
            showAll: "Alle anzeigen",
            showOnlyUnread: "Nur Ungelesene anzeigen",
            mailWasSent: "E-Mail wurde gesendet.",
            mailAdressRemoved: "E-Mail-Adresse entfernt.",
            chatbotPublished: "Version <b>{version}</b> des Chatbots wurde von <b>{user}</b> veröffentlicht.",
            chatbotDeleted: "Der Chatbot <b>{chatbot}</b> wurde von <b>{user}</b> gelöscht.",
            settingsUpdatedWoDetail: "Die Einstellungen wurden von <b>{user}</b> aktualisiert.",
            noActivityDesc: "Derzeit gibt es keine Aktivität im System. Ein paar Ereignisse müssen eintreten",
            noActivityTitle: "Bisher keine Aktivität",
            actionType: "Aktionsart",
            dateBetween: "Datum zwischen",
            selectActor: "Benutzer auswählen",
            activities: "Aktivitäten",
            chatbotCreated: "Der Chatbot mit dem Namen <b>{chatbot}</b> wurde von <b>{user}</b> erstellt.",
            taskAddedTags: "<b>{user}</b> hat diese Tags zur Aufgabe (<b>{taskTitle}</b>) hinzugefügt: <b>{tags}</b>",
            taskStageChanged: "Die Stufe der Aufgabe <b>{task}</b> wurde von <b>{user}</b> von <b>{oldStage}</b> auf <b>{newStage}</b> geändert.",
            taskCreated: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> erstellt.",
            contactPropRemoved: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> entfernt.",
            contactPropAdded: "Das Besucherattribut <b>{prop}</b> wurde von <b>{user}</b> hinzugefügt.",
            userRemoved: "<b>{oldUser}</b> Benutzer wurde von <b>{user}</b> entfernt.",
            loginFormUpdated: "Das Anmeldeformular für Besucher wurde von <b>{user}</b> aktualisiert.",
            loginFormDeactivated: "Das Benutzeranmeldeformular wurde von <b>{user}</b> deaktiviert.",
            loginFormActivated: "Das Benutzeranmeldeformular wurde von <b>{user}</b> aktiviert.",
            invoiceRefunded: "Die Rückerstattung wurde von <b>{user}</b> vorgenommen.",
            paymentMethodAdded: "Eine neue Zahlungsmethode wurde von <b>{user}</b> hinzugefügt.",
            invoicePaymentFailed: "Die Rechnungszahlung wurde von <b>{user}</b> nicht akzeptiert.",
            invoicePaymentReceived: "Die Rechnungszahlung wurde von <b>{user}</b> akzeptiert.",
            planStarted: "<b>{user}</b> hat das Abonnement <b>{title}</b> (<b>{altTitle}</b>) gestartet.",
            planStartedAgent: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{details} Vertreter</b>) gestartet.",
            planStartedChatbot: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sitzung</b>) gestartet.",
            planStartedWhatsapp: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} WhatsApp-Kanäle</b>) gestartet.",
            planStartedWhatsappApi: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} WhatsApp-Geschäftskanäle</b>) gestartet.",
            PlanCanceled: "<b>{user}</b> hat das Abonnement <b>{title}</b> (<b>{altTitle}</b>) gekündigt.",
            planCanceledAgent: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{details} Vertreter</b>) gekündigt.",
            planCanceledChatbot: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{chatbot} Sitzung</b>) gekündigt.",
            planCanceledWhatsapp: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{whatsapp} WhatsApp-Kanäle</b>) gekündigt.",
            planCanceledWhatsappApi: "<b>{user}</b> hat das Abonnement <b>{title}</b> <b>{altTitle}</b> (<b>{whatsappApi} WhatsApp-Geschäftskanäle</b>) gekündigt.",
            invoiceCreated: "Rechnung wurde von <b>{user}</b> erstellt.",
            billingAddressUpdated: "Adressinformationen wurden von <b>{user}</b> aktualisiert.",
            taskWorkflowDeleted: "Workflow <b>{workflow}</b> wurde von <b>{user}</b> gelöscht.",
            whatsappBroadcastFailed: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> ist fehlgeschlagen.",
            whatsappBroadcastCancelled: "Der Versand der Rundnachricht mit dem Titel <b>{title}</b> wurde abgebrochen.",
            whatsappBroadcastCompleted: "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde erfolgreich an <b>{numbers}</b> Empfänger gesendet.",
            whatsappBroadcastCreated: "Eine Rundnachricht mit dem Titel <b>{title}</b> wurde an <b>{numbers}</b> Empfänger von <b>{user}</b> gesendet.",
            ticketAssigned: "Ein Ticket wurde <b>{user1}</b> an <b>{user2}</b> zugewiesen.",
            userLoggedIn: "<b>{user}</b> hat sich bei SUPSIS angemeldet.",
            chatJoined: "<b>{agent}</b> ist dem Chat mit <b>{visitor}</b> beigetreten.",
            chatForwarded: "Der Chat mit <b>{visitor}</b> wurde von <b>{user}</b> an <b>{agent}</b> weitergeleitet.",
            chatAssigned: "Der Chat mit <b>{visitor}</b> wurde von dem System <b>{agent}</b> zugewiesen.",
            customerGroupUpdated: "Gruppe <b>{group}</b> wurde von <b>{user}</b> aktualisiert.",
            customerGroupRemoved: "Gruppe <b>{group}</b> wurde von <b>{user}</b> entfernt.",
            customerGroupAdded: "Gruppe <b>{group}</b> wurde von <b>{user}</b> erstellt.",
            contentRemoved: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> entfernt.",
            contentAdded: "Fertiger Inhalt <b>{content}</b> wurde von <b>{user}</b> hinzugefügt.",
            channelVisibilityChanged: "Die Sichtbarkeit des Integrationskanals <b>{channel}</b> wurde von <b>{user}</b> geändert.",
            taskDeleted: "Die Aufgabe <b>{task}</b> wurde von <b>{user}</b> gelöscht.",
            taskCompleted: "<b>{task}</b> Aufgabe wurde von <b>{user}</b> abgeschlossen.",
            taskArchived: "<b>{user}</b> von <b>{task}</b> wurde archiviert.",
            userRemovedToDepartment: "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> aus der <b>{department}</b> Abteilung entfernt.",
            userAddedToDepartment: "<b>{user2}</b> Benutzer wurde von <b>{user1}</b> zur <b>{department}</b> Abteilung hinzugefügt.",
            mailAddressAdded: "<b>{email}</b> E-Mail-Adresse hinzugefügt von <b>{user}</b>",
            settingUpdate: "Aktualisiert von <b>{user}</b>:",
            taskWFlowCreated: "<b>{Wflow}</b> Aufgabenworkflow erstellt von <b>{user}</b>.",
            bannedWordRemoved: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> entfernt.",
            bannedWordCreated: "<b>{bWord}</b> verbotenes Wort wurde von <b>{user}</b> erstellt.",
            taskPriorityUpdated: "<b>{user}</b> hat die Priorität der Aufgabe <b>{taskTitle}</b> von <b>{oldPriority}</b> auf <b>{newPriority}</b> geändert",
            welcomeMessageRemoved: "<b>{welcome}</b> Willkommensnachricht wurde von <b>{user}</b> entfernt.",
            welcomeMessageAdded: "<b>{welcome}</b> Willkommensnachricht erstellt von <b>{user}</b>.",
            tagRemoved: "Tag <b>{tag}</b> entfernt von <b>{user}</b>.",
            tagAdded: "Tag <b>{tag}</b> hinzugefügt von <b>{user}</b>.",
            roleRemoved: "Rolle <b>{role}</b> entfernt von <b>{user}</b>.",
            roleAdded: "Rolle <b>{role}</b> hinzugefügt von <b>{user}</b>.",
            departmentRemoved: "Abteilung <b>{department}</b> entfernt von <b>{user}</b>.",
            departmentAdded: "Abteilung <b>{department}</b> hinzugefügt von <b>{user}</b>.",
            triggerUpdated: "Ein Trigger aktualisiert von <b>{user}</b>.",
            triggerRemoved: "Ein Trigger entfernt von <b>{user}</b>.",
            triggerAdded: "Ein neuer Trigger erstellt von <b>{user}</b>.",
            webhookRemoved: "Webhook von <b>{user1}</b>, entfernt von <b>{user2}</b>",
            webhookAdded: "Webhook hinzugefügt von <b>{user1}</b>, hinzugefügt von <b>{user2}</b>.",
            chatClosed: "Der Chat mit <b>{visitor}</b> wurde von <b>{agent}</b> beendet.",
            chatOwnerUpdated: "<b>{agent}</b> hat <b>{visitor}</b> von <b>{oldOwner}</b> zu <b>{newOwner}</b> neu zugewiesen.",
            customerOwnershipRemoved: "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von <b>{oldOwner}</b> entfernt und unzugeordnet gelassen.",
            customerOwnershipAssigned: "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von unzugeordnet zu <b>{newOwner}</b> zugewiesen.",
            customerOwnershipReassigned: "<b>{actor}</b> hat die Eigentümerschaft von <b>{visitor}</b> von <b>{oldOwner}</b> zu <b>{newOwner}</b> neu zugewiesen.",
            chatOpenedByAgent: "<b>{agent}</b> hat einen <b>{platform}</b>-Chat mit <b>{visitor}</b> gestartet.",
            chatOpenedByVisitor: "Ein <b>{platform}</b>-Chat wurde von <b>{visitor}</b> gestartet.",
            channelRemoved: "<b>{channel}</b>-Kanal wurde von <b>{agent}</b> entfernt.",
            userAdded: "<b>{agent}</b> hat einen Vertreter namens <b>{newAgent}</b> erstellt.",
            visitorUnblocked: "Besucher <b>{visitor}</b> wurde von Benutzer <b>{agent}</b> entsperrt.",
            visitorBlocked: "Besucher <b>{visitor}</b> wurde von <b>{agent}</b> blockiert.",
            userStatusChanged: "Benutzer <b>{name}</b> hat den Status von <b>{oldStatus}</b> auf <b>{newStatus}</b> geändert.",
            channelCreated: "Kanal <b>{channel}</b> wurde von <b>{name}</b> erstellt.",
            reservationCreatedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> für den <b>{date}</b> geplant.",
            reservationUpdatedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> aktualisiert.",
            reservationDeletedPlan: "<b>{name}</b> Benutzer hat den Termin mit dem Namen <b>{title}</b> gelöscht.",
            reservationCreated: "Eine Reservierung wurde für Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> erstellt.",
            reservationDeleted: "Der Termin zwischen Benutzer <b>{name}</b> und Besucher <b>{visitor}</b> am <b>{date}</b> wurde storniert.",
            taskStatusChanged: "Wenn sich der Aufgabenstatus ändert",
            taskWorkflowCrud: "Aufgabenworkflow wird erstellt, aktualisiert oder gelöscht",
            taskCrud: "Aufgabe wird erstellt, aktualisiert oder gelöscht",
            autoRebalanceEvents: "Wenn ein automatischer Ausgleich abgeschlossen, fehlgeschlagen oder deaktiviert wird.",
            automationActions: "Automatisierungsaktionen",
            automationCreated: "{user} hat eine Automatisierung mit dem Namen {automation} erstellt.",
            automationDeleted: "{user} hat eine Automatisierung mit dem Namen {automation} gelöscht.",
            automationRestored: "{user} hat die Automatisierung {automation} aus dem Papierkorb wiederhergestellt.",
            automationPublished: "{user} hat eine Automatisierung mit dem Namen {automation} veröffentlicht.",
            automationUnpublished: "{user} hat die Veröffentlichung der Automatisierung {automation} aufgehoben.",
            automationUpdated: "{user} hat eine Automatisierung mit dem Namen {automation} aktualisiert.",
            automationCreatedNotification: "Wenn eine Automatisierung erstellt wird.",
            automationDeletedNotification: "Wenn eine Automatisierung gelöscht wird.",
            automationRestoredNotification: "Wenn eine Automatisierung aus dem Papierkorb wiederhergestellt wird.",
            automationPublishedNotification: "Wenn eine Automatisierung veröffentlicht wird.",
            automationUnpublishedNotification: "Wenn die Veröffentlichung einer Automatisierung aufgehoben wird.",
            automationUpdatedNotification: "Wenn eine Automatisierung aktualisiert wird.",
            formDeleted: "{user} hat das Formular \"{formName}\" (ID: {formId}) gelöscht.",
            formDeletedPermanent: "{user} hat das Formular \"{formName}\" (ID: {formId}) dauerhaft gelöscht.",
            formRestored: "{user} hat das Formular \"{formName}\" (ID: {formId}) aus dem Papierkorb wiederhergestellt.",
            formCreated: "{user} hat das Formular \"{formName}\" erstellt.",
            formUpdated: "{user} hat das Formular \"{formName}\" aktualisiert.",
            formDownloaded: "{user} hat die Daten des Formulars \"{formName}\" (ID: {formId}) heruntergeladen.",
            userRoleChanged: "{actor} hat die Rolle von \"{userName}\" von \"{oldRoleName}\" auf \"{newRoleName}\" geändert.",
            userPasswordChanged: "{actor} hat das Passwort von \"{userName}\" geändert.",
            userEmailChanged: "{actor} hat die E-Mail-Adresse von \"{userName}\" von \"{oldEmail}\" auf \"{newEmail}\" geändert.",
            userNameChanged: "{actor} hat den Namen von \"{userName}\" von \"{oldName}\" auf \"{newName}\" geändert.",
            userPhoneChanged: "{actor} hat die Telefonnummer von \"{userName}\" von \"{oldPhone}\" auf \"{newPhone}\" geändert.",
            userDisabled: "{actor} hat \"{userName}\" deaktiviert.",
            userEnabled: "{actor} hat \"{userName}\" aktiviert.",
            roleUpdated: "{actor} hat die Rolle \"{roleName}\" aktualisiert.",
            taskWorkflowUpdated: "{actor} hat den Aufgaben-Workflow \"{workflowTitle}\" aktualisiert.",
            taskWorkflowPipelineStageAdded: "{actor} hat die Stufe \"{stageName}\" zum Workflow \"{workflowTitle}\" hinzugefügt.",
            taskWorkflowPipelineStageUpdated: "{actor} hat die Stufe \"{stageName}\" im Workflow \"{workflowTitle}\" aktualisiert.",
            taskWorkflowPipelineStageDeleted: "{actor} hat die Stufe \"{stageName}\" aus dem Workflow \"{workflowTitle}\" gelöscht.",
            driveFolderCreated: "{actor} hat den Ordner \"{folderName}\" erstellt.",
            driveFolderDeleted: "{actor} hat den Ordner \"{folderName}\" gelöscht.",
            driveFolderRenamed: "{actor} hat den Ordner \"{oldName}\" in \"{newName}\" umbenannt.",
            driveFileAdded: "{actor} hat die Datei \"{fileName}\" hinzugefügt.",
            driveFileDeleted: "{actor} hat die Datei \"{fileName}\" gelöscht.",
            taskModuleRulesEnabled: "{actor} hat die Aufgabenregeln für den Workflow \"{workflowTitle}\" aktiviert.",
            taskModuleRulesDisabled: "{actor} hat die Aufgabenregeln für den Workflow \"{workflowTitle}\" deaktiviert.",
            taskModuleRulesRuleAdded: "{actor} hat die Regel \"{ruleName}\" zum Workflow \"{workflowTitle}\" hinzugefügt.",
            taskModuleRulesRuleDeleted: "{actor} hat die Regel \"{ruleName}\" aus dem Workflow \"{workflowTitle}\" gelöscht.",
            taskModuleRulesRuleUpdated: "{actor} hat die Regel \"{ruleName}\" im Workflow \"{workflowTitle}\" aktualisiert.",
            taskModuleRulesRuleEnabled: "{actor} hat die Regel \"{ruleName}\" im Workflow \"{workflowTitle}\" aktiviert.",
            taskModuleRulesRuleDisabled: "{actor} hat die Regel \"{ruleName}\" im Workflow \"{workflowTitle}\" deaktiviert.",
            contactModuleRulesEnabled: "{actor} hat die Kontaktmodul-Regeln aktiviert.",
            contactModuleRulesDisabled: "{actor} hat die Kontaktmodul-Regeln deaktiviert.",
            contactModuleRulesRuleAdded: "{actor} hat die Regel \"{ruleName}\" zum Kontaktmodul hinzugefügt.",
            contactModuleRulesRuleUpdated: "{actor} hat die Regel \"{ruleName}\" im Kontaktmodul aktualisiert.",
            contactModuleRulesRuleDeleted: "{actor} hat die Regel \"{ruleName}\" aus dem Kontaktmodul gelöscht.",
            contactModuleRulesRuleEnabled: "{actor} hat die Regel \"{ruleName}\" im Kontaktmodul aktiviert.",
            contactModuleRulesRuleDisabled: "{actor} hat die Regel \"{ruleName}\" im Kontaktmodul deaktiviert.",
            developerTokenChanged: "{actor} hat den Entwickler-Zugangs-Token aktualisiert.",
            tableCreated: "{actor} hat die Tabelle \"{tableName}\" erstellt.",
            tableDeleted: "{actor} hat die Tabelle \"{tableName}\" gelöscht.",
            tableRestored: "{actor} hat die Tabelle \"{tableName}\" aus dem Papierkorb wiederhergestellt.",
            tablePermanentlyDeleted: "{actor} hat die Tabelle \"{tableName}\" dauerhaft aus dem Papierkorb gelöscht.",
            tableFieldAdded: "{actor} hat das Feld \"{fieldName}\" zur Tabelle \"{tableName}\" hinzugefügt.",
            tableFieldUpdated: "{actor} hat das Feld \"{fieldName}\" in der Tabelle \"{tableName}\" aktualisiert.",
            tableFieldDeleted: "{actor} hat das Feld \"{fieldName}\" aus der Tabelle \"{tableName}\" gelöscht.",
            tableViewAdded: "{actor} hat die Ansicht \"{viewName}\" zur Tabelle \"{tableName}\" hinzugefügt.",
            tableViewUpdated: "{actor} hat die Ansicht \"{viewName}\" in der Tabelle \"{tableName}\" aktualisiert.",
            tableViewDeleted: "{actor} hat die Ansicht \"{viewName}\" aus der Tabelle \"{tableName}\" gelöscht.",
            tablePageAdded: "{actor} hat die Seite \"{pageName}\" zur Tabelle \"{tableName}\" hinzugefügt.",
            tablePageUpdated: "{actor} hat die Seite \"{pageName}\" in der Tabelle \"{tableName}\" aktualisiert.",
            tablePageDeleted: "{actor} hat die Seite \"{pageName}\" aus der Tabelle \"{tableName}\" gelöscht.",
            tableWidgetAdded: "{actor} hat das Widget \"{widgetTitle}\" ({widgetType}) zur Seite \"{pageName}\" der Tabelle \"{tableName}\" hinzugefügt.",
            tableWidgetUpdated: "{actor} hat das Widget \"{widgetTitle}\" ({widgetType}) auf der Seite \"{pageName}\" der Tabelle \"{tableName}\" aktualisiert.",
            tableWidgetDeleted: "{actor} hat das Widget \"{widgetTitle}\" ({widgetType}) von der Seite \"{pageName}\" der Tabelle \"{tableName}\" gelöscht.",
            tablePermissionChanged: "{actor} hat die Datenschutzeinstellungen der Tabelle \"{tableName}\" aktualisiert.",
            tableDataDownloaded: "{actor} hat {recordCount} Datensätze aus der Tabelle \"{tableName}\" heruntergeladen.",
            tableDataImported: "{actor} hat {successCount}/{recordCount} Datensätze in die Tabelle \"{tableName}\" importiert.",
            tableDataBatchUpdated: "{actor} hat das Feld \"{fieldName}\" von {recordCount} Datensätzen in der Tabelle \"{tableName}\" stapelweise aktualisiert.",
            tableDataBatchDeleted: "{actor} hat {recordCount} Datensätze aus der Tabelle \"{tableName}\" stapelweise gelöscht.",
            contactDataDownloaded: "{actor} hat {contactCount} Kontaktdaten heruntergeladen.",
            contactBatchUpdated: "{actor} hat für {contactCount} Kontakte die Stapelaktion {action} durchgeführt.",
            chatDataDownloaded: "{actor} hat {chatCount} Chat-Verläufe heruntergeladen.",
            chatDataDownloadedWithVisitor: "{actor} hat den Chat-Verlauf mit \"{visitorName}\" heruntergeladen.",
            visitorTagAdded: "{actor} hat {visitorName} das Etikett {tagNames} hinzugefügt.",
            visitorTagRemoved: "{actor} hat {visitorName} das Etikett {tagNames} entfernt.",
            unknownVisitor: "Unbekannter Kontakt",
            tagsLabel: "Tags",
            webAppCreated: "{actor} hat die Webanwendung \"{appName}\" ({appSlug}) erstellt.",
            webAppUpdated: "{actor} hat die Webanwendung \"{appName}\" ({appSlug}) aktualisiert.",
            webAppDeleted: "{actor} hat die Webanwendung \"{appName}\" ({appSlug}) gelöscht.",
            webTabCreated: "{actor} hat den Web-Tab \"{tabName}\" bei {placement} hinzugefügt.",
            webTabUpdated: "{actor} hat den Web-Tab \"{tabName}\" aktualisiert.",
            webTabDeleted: "{actor} hat den Web-Tab \"{tabName}\" ({placement}) gelöscht.",
            moduleCreated: "{actor} hat \"{moduleName}\" ({moduleType}) erstellt.",
            moduleUpdated: "{actor} hat \"{moduleName}\" ({moduleType}) aktualisiert.",
            moduleDeleted: "{actor} hat \"{moduleName}\" ({moduleType}) gelöscht.",
            relationCreated: "{actor} hat die Beziehung \"{relationName}\" erstellt.",
            relationUpdated: "{actor} hat die Beziehung \"{relationName}\" aktualisiert.",
            voiceAgentCreated: "{actor} hat den Sprach-Agenten \"{agentName}\" ({agentId}) erstellt.",
            voiceAgentUpdated: "{actor} hat den Sprach-Agenten \"{agentName}\" ({agentId}) aktualisiert.",
            voiceAgentDeleted: "{actor} hat den Sprach-Agenten \"{agentName}\" ({agentId}) gelöscht.",
            voiceAgentPhoneNumberInboundAgentChanged: "{actor} hat den Anruf-Agenten für die Nummer {phoneNumber} auf \"{agentName}\" geändert.",
            voiceAgentPhoneNumberOutboundAgentChanged: "{actor} hat den ausgehenden Anruf-Agenten für die Nummer {phoneNumber} auf \"{agentName}\" geändert.",
            voiceAgentBatchCallCreated: "{actor} hat den Sammelanruf \"{batchCallName}\" erstellt ({taskCount} Kontakte).",
            voiceAgentKnowledgeBaseCreated: "{actor} hat die Wissensdatenbank \"{knowledgeBaseName}\" erstellt.",
            voiceAgentKnowledgeBaseDeleted: "{actor} hat die Wissensdatenbank \"{knowledgeBaseName}\" gelöscht.",
            webTabCreatedNotification: "Wenn ein Web-Tab erstellt wird.",
            webTabUpdatedNotification: "Wenn ein Web-Tab aktualisiert wird.",
            webTabDeletedNotification: "Wenn ein Web-Tab gelöscht wird.",
            moduleCreatedNotification: "Wenn ein Modul oder eine Beziehung erstellt wird.",
            moduleUpdatedNotification: "Wenn ein Modul oder eine Beziehung aktualisiert wird.",
            moduleDeletedNotification: "Wenn ein Modul oder eine Beziehung gelöscht wird.",
            relationCreatedNotification: "Wenn eine Beziehung erstellt wird.",
            relationUpdatedNotification: "Wenn eine Beziehung aktualisiert wird.",
            voiceAgentCreatedNotification: "Wenn ein Sprach-Agent erstellt wird.",
            voiceAgentUpdatedNotification: "Wenn ein Sprach-Agent aktualisiert wird.",
            voiceAgentDeletedNotification: "Wenn ein Sprach-Agent gelöscht wird.",
            voiceAgentPhoneNumberInboundAgentChangedNotification: "Wenn der Anruf-Agent einer Telefonnummer geändert wird.",
            voiceAgentPhoneNumberOutboundAgentChangedNotification: "Wenn der ausgehende Anruf-Agent einer Telefonnummer geändert wird.",
            voiceAgentBatchCallCreatedNotification: "Wenn ein Sammelanruf erstellt wird.",
            voiceAgentKnowledgeBaseCreatedNotification: "Wenn eine Wissensdatenbank erstellt wird.",
            voiceAgentKnowledgeBaseDeletedNotification: "Wenn eine Wissensdatenbank gelöscht wird.",
            formDeletedNotification: "Wenn ein Formular gelöscht wird.",
            formRestoredNotification: "Wenn ein Formular aus dem Papierkorb wiederhergestellt wird.",
            formCreatedNotification: "Wenn ein Formular erstellt wird.",
            formUpdatedNotification: "Wenn ein Formular aktualisiert wird.",
            formDownloadedNotification: "Wenn Formulardaten heruntergeladen werden.",
            userRoleChangedNotification: "Wenn die Benutzerrolle geändert wird.",
            userPasswordChangedNotification: "Wenn das Benutzerpasswort geändert wird.",
            userEmailChangedNotification: "Wenn die Benutzer-E-Mail-Adresse geändert wird.",
            userNameChangedNotification: "Wenn der Benutzername geändert wird.",
            userPhoneChangedNotification: "Wenn die Benutzertelefonnummer geändert wird.",
            userDisabledNotification: "Wenn ein Benutzer deaktiviert oder aktiviert wird.",
            roleUpdatedNotification: "Wenn eine Rolle aktualisiert wird.",
            taskWorkflowUpdatedNotification: "Wenn ein Aufgaben-Workflow aktualisiert wird.",
            taskWorkflowPermanentlyDeletedNotification: "Wenn ein Aufgaben-Workflow dauerhaft aus dem Papierkorb gelöscht wird.",
            taskWorkflowPipelineStageAddedNotification: "Wenn eine neue Stufe zum Workflow hinzugefügt wird.",
            taskWorkflowPipelineStageUpdatedNotification: "Wenn eine Workflow-Stufe aktualisiert wird.",
            taskWorkflowPipelineStageDeletedNotification: "Wenn eine Stufe aus dem Workflow gelöscht wird.",
            driveFolderCreatedNotification: "Wenn ein Drive-Ordner erstellt wird.",
            driveFolderDeletedNotification: "Wenn ein Drive-Ordner gelöscht wird.",
            driveFolderRenamedNotification: "Wenn ein Drive-Ordner umbenannt wird.",
            driveFileAddedNotification: "Wenn eine Datei zu Drive hinzugefügt wird.",
            driveFileDeletedNotification: "Wenn eine Datei aus Drive gelöscht wird.",
            taskModuleRulesEnabledNotification: "Wenn Aufgabenregeln aktiviert werden.",
            taskModuleRulesDisabledNotification: "Wenn Aufgabenregeln deaktiviert werden.",
            taskModuleRulesRuleAddedNotification: "Wenn eine neue Regel zum Workflow hinzugefügt wird.",
            taskModuleRulesRuleDeletedNotification: "Wenn eine Regel aus dem Workflow gelöscht wird.",
            taskModuleRulesRuleUpdatedNotification: "Wenn eine Regel im Workflow aktualisiert wird.",
            taskModuleRulesRuleEnabledNotification: "Wenn eine Regel im Workflow aktiviert wird.",
            taskModuleRulesRuleDisabledNotification: "Wenn eine Regel im Workflow deaktiviert wird.",
            contactModuleRulesEnabledNotification: "Wenn Kontaktmodul-Regeln aktiviert werden.",
            contactModuleRulesDisabledNotification: "Wenn Kontaktmodul-Regeln deaktiviert werden.",
            contactModuleRulesRuleAddedNotification: "Wenn eine neue Regel zum Kontaktmodul hinzugefügt wird.",
            contactModuleRulesRuleUpdatedNotification: "Wenn eine Regel im Kontaktmodul aktualisiert wird.",
            contactModuleRulesRuleDeletedNotification: "Wenn eine Regel aus dem Kontaktmodul gelöscht wird.",
            contactModuleRulesRuleEnabledNotification: "Wenn eine Regel im Kontaktmodul aktiviert wird.",
            contactModuleRulesRuleDisabledNotification: "Wenn eine Regel im Kontaktmodul deaktiviert wird.",
            developerTokenChangedNotification: "Wenn der Entwickler-Zugangs-Token aktualisiert wird.",
            tableCreatedNotification: "Wenn eine neue Tabelle erstellt wird.",
            tableDeletedNotification: "Wenn eine Tabelle gelöscht wird.",
            tableRestoredNotification: "Wenn eine Tabelle aus dem Papierkorb wiederhergestellt wird.",
            tablePermanentlyDeletedNotification: "Wenn eine Tabelle dauerhaft aus dem Papierkorb gelöscht wird.",
            tableFieldAddedNotification: "Wenn ein neues Feld zur Tabelle hinzugefügt wird.",
            tableFieldUpdatedNotification: "Wenn ein Feld in der Tabelle aktualisiert wird.",
            tableFieldDeletedNotification: "Wenn ein Feld aus der Tabelle gelöscht wird.",
            tableViewActionsNotification: "Wenn eine Tabellenansicht hinzugefügt, aktualisiert oder gelöscht wird.",
            tablePageActionsNotification: "Wenn eine Tabellenseite hinzugefügt, aktualisiert oder gelöscht wird.",
            tableWidgetActionsNotification: "Wenn ein Widget zu einer Tabellenseite hinzugefügt, aktualisiert oder gelöscht wird.",
            tablePermissionChangedNotification: "Wenn die Tabellen-Datenschutzeinstellungen aktualisiert werden.",
            tableDataDownloadedNotification: "Wenn Tabellendaten heruntergeladen werden.",
            tableDataImportedNotification: "Wenn Datensätze in eine Tabelle importiert werden.",
            tableDataBatchUpdatedNotification: "Wenn Tabellendaten stapelweise aktualisiert werden.",
            tableDataBatchDeletedNotification: "Wenn Datensätze stapelweise aus einer Tabelle gelöscht werden.",
            contactBatchUpdatedNotification: "Wenn Kontakte stapelweise aktualisiert werden.",
            chatDataDownloadedNotification: "Wenn Chat-Verläufe heruntergeladen werden.",
            webAppCreatedNotification: "Wenn eine Webanwendung erstellt wird.",
            webAppUpdatedNotification: "Wenn eine Webanwendung aktualisiert wird.",
            webAppDeletedNotification: "Wenn eine Webanwendung gelöscht wird.",
            formActions: "Wenn ein Formular erstellt, aktualisiert oder gelöscht wird.",
            userInfoActions: "Wenn Benutzerinformationen wie Rolle, Passwort, E-Mail, Name, Telefon oder Status geändert werden.",
            driveActions: "Drive-Ordner- und Dateivorgänge.",
            developerActions: "Wenn der Entwickler-Zugangs-Token aktualisiert wird.",
            contactModuleRulesActions: "Wenn Kontaktmodul-Regeln aktiviert/deaktiviert werden oder Regeln hinzugefügt, aktualisiert oder gelöscht werden.",
            tableActions: "Wenn eine Tabelle erstellt wird oder Felder hinzugefügt, aktualisiert oder gelöscht werden.",
            wabaSupsisPartnerRemove: "Wenn ein WhatsApp Business API V2-Partner entfernt wird.",
            wabaSupsisAccountDeleted: "Wenn ein WhatsApp Business API V2-Konto gelöscht wird.",
            wabaSupsisAccountViolation: "Wenn eine WhatsApp Business API V2-Konto-Verletzung festgestellt wird.",
            wabaSupsisAdAccountLinked: "Wenn ein WhatsApp Business API V2-Werbekonto verknüpft wird.",
            wabaSupsisAuthIntlPriceEligibilityUpdate: "Wenn die internationale Preisberechtigung für WhatsApp Business API V2 aktualisiert wird.",
            wabaSupsisDisabledUpdate: "Wenn eine WhatsApp Business API V2-Deaktivierungsaktualisierung erfolgt.",
            wabaSupsisMmLiteTermsSigned: "Wenn die WhatsApp Business API V2 MM Lite-Bedingungen unterzeichnet werden.",
            wabaSupsisPartnerAdded: "Wenn ein WhatsApp Business API V2-Partner hinzugefügt wird.",
            wabaSupsisPartnerAppInstalled: "Wenn die WhatsApp Business API V2-Partner-App installiert wird.",
            wabaSupsisPartnerAppUninstalled: "Wenn die WhatsApp Business API V2-Partner-App deinstalliert wird.",
            wabaSupsisPartnerClientCertificationStatusUpdate: "Wenn der Partner-Kundenzertifizierungsstatus für WhatsApp Business API V2 aktualisiert wird.",
            wabaSupsisBusinessPrimaryLocationCountryUpdate: "Wenn das primäre Standortland für WhatsApp Business API V2 aktualisiert wird.",
            wabaSupsisVolumeBasedPricingTierUpdate: "Wenn die volumenbasierte Preisstufe für WhatsApp Business API V2 aktualisiert wird.",
            wabaSupsisMessageTemplateComponentsUpdate: "Wenn die Nachrichtenvorlagen-Komponenten für WhatsApp Business API V2 aktualisiert werden.",
            wabaSupsisMessageTemplateStatusUpdate: "Wenn der Nachrichtenvorlagen-Status für WhatsApp Business API V2 aktualisiert wird.",
            wabaSupsisTemplateCategoryUpdate: "Wenn die Vorlagenkategorie für WhatsApp Business API V2 aktualisiert wird.",
            chatbotRestored: "Der Chatbot <b>{chatbot}</b> wurde von <b>{user}</b> aus dem Papierkorb wiederhergestellt.",
            taskWorkflowRestored: "Der Aufgaben-Workflow <b>{workflow}</b> wurde von <b>{user}</b> aus dem Papierkorb wiederhergestellt.",
            taskWorkflowPermanentlyDeleted: "Der Aufgaben-Workflow <b>{workflow}</b> wurde von <b>{user}</b> dauerhaft aus dem Papierkorb gelöscht.",
            userLoggenIn: "<b>{user}</b> hat sich bei SUPSIS angemeldet.",
            channelForwardConfigUpdated: "{actor} hat die Kanalweiterleitungskonfiguration für \"{channelName}\" ({channelType}) aktualisiert.",
            channelZohoConfigUpdated: "{actor} hat die Zoho-Integrationskonfiguration für \"{channelName}\" ({channelType}) aktualisiert.",
            webhookUpdated: "{actor} hat den Webhook \"{webhookName}\" ({webhookUrl}) aktualisiert."
        },
        search: {
            prefix: {
                jump: "Gehe zu",
                new: "Neu",
                visitor: "Besucher",
                dm: "DM",
                chatbot: "Chatbot",
                automation: "Automatisierung",
                table: "Tabelle",
                module: "Modul",
                message: "Nachricht"
            },
            kalender: "Kalender",
            soundSettings: "Audio-Benachrichtigungen",
            allNotificationSettings: "Benachrichtigungseinstellungen",
            allAuditLogs: "Audit-Protokolle",
            allNotifications: "Alle Benachrichtigungen",
            allActivities: "Alle Aktivitäten",
            workFlow: "Arbeitsablauf",
            editTask: "Aufgabe bearbeiten",
            tasks: "Aufgaben",
            todo: "Zu erledigende Aufgaben",
            tapTo: "Drücken Sie ⇥ für ‚{Präfix}‘-Vorgänge",
            newUsers: "Neuer ⇥ Benutzer",
            newTags: "Neuer ⇥ Tag",
            newRole: "Neue ⇥ Rolle",
            newTrigger: "Neuer ⇥ Trigger",
            newDepartment: "Neue ⇥ Abteilung",
            newTicket: "Neues ⇥ Ticket",
            jumpSettings: "Gehe ⇥ Einstellungen",
            jumpIntegrations: "Gehe ⇥ Integrationen",
            jumpTeam: "Gehe zu ⇥ Team",
            jumpUsers: "Gehe zu ⇥ Benutzer",
            jumpReport: "Gehe zu ⇥ Bericht",
            timingSettings: "Timing-Einstellungen",
            exampleVisitorMail: "Besucher@mail.com",
            languageAndRegion: "Sprache und Region",
            theme: "Thema",
            appearance: "Erscheinungsbild",
            color: "Farbe",
            background: "Hintergrund",
            intelligent: "Intelligent",
            teamChat: "Team-Chat",
            chatbot: "ChatBot",
            chatbotTraining: "Chatbot-Schulung",
            chatbotUserSegments: "Chatbot-Benutzersegmente",
            chatbotIntegration: "Chatbot-Integration",
            chatbotEntities: "Chatbot-Entitäten",
            chatbotIntegrationWebHook: "Chatbot-WebHook-Integration",
            chatbotArchiv: "Chatbot-Archiv",
            chatbotTemplatesAI: "Chatbot-Vorlagen für künstliche Intelligenz",
            chatbotTemplates: "Chatbot-Vorlagen",
            chatbotReportsOverall: "Chatbot-Gesamtberichte",
            chatbotReportsAllChats: "Chatbot-Berichte über alle Chats",
            chatbotReportsRatingDistribution: "Bewertungsverteilung von Chatbot-Berichten",
            chatbotReportsPaidChats: "Chatbot-Berichte über bezahlte Chats",
            chatbotReportsBusiestPeriod: "Geschäftigster Zeitraum des Chatbots",
            chatbotTemplatesAllMessages: "Chatbot-Vorlagen für alle Nachrichten",
            chatbotTemplatesAverage: "Chatbot-Vorlagen Durchschnitt",
            chatbotTemplatesPopularity: "Beliebtheit von Chatbot-Vorlagen",
            chatbotTemplatesAllUser: "Chatbot-Vorlagen für alle Benutzer",
            ticket: "Supportanfragen",
            archives: "Archiv",
            tags: "Tags",
            offlineSupportRequests: "Offline-Support-Anfragen",
            roles: "Rollen",
            users: "Benutzer",
            departments: "Abteilungen",
            contents: "Sofortige Inhalte",
            welcomeMessages: "Systemnachrichten",
            catalog: "Katalog",
            bannedWords: "Verbotene Wörter",
            bannedVisitors: "Verbotene Besucher",
            application: "Anwendung",
            mails: "Mailer",
            visitors: "Besucher",
            integrationsWebhook: "Webhook-Integration",
            billing: "Rechnung",
            reportNew: "Neuer Bericht",
            integrations: "Integrationen",
            chatbotStory: "Chatbot-Geschichten",
            searchPlaceHolder: "Suchen, Gehen oder Hinzufügen...",
            searchAreaTitle: "Supsis suchen",
            searchAreaDesc1: "Sie können nach allem suchen. Nur",
            searchAreaDesc2: "oder",
            searchAreaDesc3: "Tippen Sie oder suchen Sie nach irgendetwas.",
            navigateBtn: "Navigieren",
            selectBtn: "Auswählen",
            cancelBtn: "Abbrechen",
            integration: {
                shouldByInstaPack: "Sie sollten Instagram-Pakete kaufen, um einen Instagram-Kanal zu erstellen. Sie können die Pakete mit erschwinglichen Preisen sofort erreichen.",
                createInstaLimitMax: "Sie haben das Limit für die Erstellung eines Instagram-Kanals erreicht. Maximum",
                createInstaContinue: "Sie können einen Instagram-Kanal erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Instagram-Kanäle.",
                privatePolicy: "Datenschutzrichtlinie",
                termsAndCondition: "Allgemeine Geschäftsbedingungen",
                readAndAgree: "Ich habe gelesen und stimme zu",
                shouldByMessengerPack: "Sie müssen ein Messenger-Paket erwerben, um einen Messenger-Kanal zu erstellen. Sie können die Pakete mit erschwinglichen Preisen sofort erreichen.",
                createMessengerLimitMax: "Sie haben das Limit für die Erstellung von Messenger-Kanälen erreicht. Maximum",
                createMessengerContinue: "Sie können einen Messenger-Kanal erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Messenger-Channels.",
                selectMessengerAccount: "Messenger-Konto auswählen",
                forwardLiveAgents: "👉 An Live-Agenten weiterleiten",
                allDepartments: "Alle Abteilungen",
                deleteAll: "Alle löschen",
                wpBusinessAPI: "Integrationen - Whatsapp Business API-Kanäle",
                wpV1: "Integrationen - Mehrere Whatsapp-Kanäle",
                instagram: "Integrationen - Instagram",
                instagramContactList: "Integrationen - Instagram Kontaktliste",
                mail: "Integrationen - Mail",
                whatsapp: "Integrationen - Whatsapp",
                whatsappContactList: "Integrationen - Whatsapp-Kontaktliste",
                wpBCRequests: "Integrationen - Whatsapp Bulk Message Requests",
                wpBCCustomerGroups: "Integrationen - Whatsapp Massenkundengruppen",
                wpBCTemplates: "Integrationen - Whatsapp Massen-Nachrichtenvorlagen",
                chatbot: "Integrationen - ChatBot",
                allSections: "Alle Bereiche",
                createInstaInstaLimitMax: "Sie haben das Limit für die Erstellung eines Instagram-Kanals erreicht. Maximum.",
                createMessengerMessengerLimitMax: "Sie haben das Limit für die Erstellung eines Messenger-Kanals erreicht. Maximum.",
                directClientsForward: "👉 Direkt an Agenten weiterleiten",
                shouldByByMessengerPack: "Sie müssen ein Messenger-Paket erwerben, um einen Messenger-Kanal zu erstellen. Sie können die Pakete zu günstigen Preisen sofort nutzen.",
                wpBCRichieste: "Integrationen – WhatsApp-Massen-Nachrichten-Anfragen",
                messenger: "Integrationen - Messenger",
                telegram: "Integrationen - Telegram",
                whatsappV3: "Integrationen - WhatsApp V3",
                waba: "Integrationen - WhatsApp Business API V2",
                metaLeads: "Integrationen - Meta Leads",
                linkedin: "Integrationen - LinkedIn",
                youtubeComments: "Integrationen - YouTube Kommentare",
                googleBusinessReviews: "Integrationen - Google Business Bewertungen",
                googlePlayReviews: "Integrationen - Google Play Bewertungen",
                appstoreReviews: "Integrationen - App Store Bewertungen",
                googleDrive: "Integrationen - Google Drive",
                openai: "Integrationen - OpenAI",
                openrouter: "Integrationen - OpenRouter AI",
                ideasoft: "Integrationen - Ideasoft",
                bitrix24: "Integrationen - Bitrix24",
                zoho: "Integrationen - Zoho CRM",
                ticimax: "Integrationen - Ticimax",
                ticimaxV2: "Integrationen - Ticimax V2",
                teamgram: "Integrationen - TeamGram",
                holidayplus: "Integrationen - HolidayPlus",
                trendyol: "Integrationen - Trendyol",
                tSoft: "Integrationen - T-Soft",
                ikas: "Integrationen - Ikas",
                postacell: "Integrationen - PostaCell SMS",
                telnyx: "Integrationen - Telnyx",
                netgsm: "Integrationen - NetGSM",
                webtabs: "Integrationen - Web Tabs",
                webapps: "Integrationen - Web Apps",
                instagramV2: "Integrationen - Instagram V2",
                voiceAgent: "Integrationen - KI-Sprachagent",
            },
            settings: {
                settings: "Einstellungen",
                features: "Einstellungen - Funktionen",
                languageAndRegion: "Einstellungen - Sprache und Region",
                bubbleSettings: "Einstellungen - Sprechblaseneinstellungen",
                bubbleActions: "Einstellungen - Sprechblasen-Aktionen",
                themeSettings: "Einstellungen - Themen-Einstellungen",
                visitorLoginForm: "Einstellungen - Anmeldeformular für Besucher",
                visitorAttribute: "Einstellungen - Besucherattribute",
                talkSettings: "Einstellungen - Sprech-Einstellungen",
                autoAssign: "Einstellungen - Automatische Zuweisung",
                chatTimingSettings: "Einstellungen - Chat-Zeiteinstellungen",
                availability: "Einstellungen - Verfügbarkeit",
                websiteIntegration: "Einstellungen - Website-Integration",
                developer: "Einstellungen - Entwickler",
                wallet: "Einstellungen - Geldbörse",
                accessControl: "Einstellungen - Zugriffskontrolle",
                sessions: "Einstellungen - Sitzungsverwaltung",
                contactModuleRules: "Einstellungen - Kontaktmodul-Regeln",
                taskModuleRules: "Einstellungen - Aufgabenmodul-Regeln",
                notifications: "Einstellungen - Benachrichtigungen",
                billing: "Einstellungen - Abrechnung",
                company: "Einstellungen - Firmeninformationen",
                companyUsers: "Einstellungen - Benutzer",
                departments: "Einstellungen - Abteilungen",
                roles: "Einstellungen - Rollen",
                systemMessages: "Einstellungen - Systemnachrichten",
                templates: "Einstellungen - Fertige Inhalte",
                forbiddenInputs: "Einstellungen - Verbotene Wörter",
                timingsSettings: "Einstellungen - Zeiteinstellungen",
                autoAssignSettings: "Einstellungen - Automatische Zuweisung",
                availabilitySettings: "Einstellungen - Verfügbarkeit",
            },
            calendar: "Kalender",
            smart: "Intelligent",
            chatbotArchive: "Chatbot-Archiv",
            chatbotTemplatesAvarage: "Chatbot-Vorlagen Durchschnitt",
            subjects: "Themen",
            applicazione: "Anwendung",
            archivi: "Archiv",
            audioSettings: "Audioeinstellungen",
            content: "Sofortige Inhalte",
            contenuti: "Sofortige Inhalte",
            emails: "E-Mail",
            fondo: "Hintergrund",
            forbiddenWords: "Verbotene Wörter",
            integraciones: "Integrationen",
            integrationOperations: "Integrationsvorgänge",
            integrazioni: "Integrationen",
            integrazioniWebhook: "Webhook-Integration",
            invoices: "Rechnung",
            mail: "E-Mail",
            mailMessages: "E-Mail-Nachrichten",
            navigation: "Navigation",
            newReport: "Neuer Bericht",
            newSection: "Neuer Bereich",
            ruoli: "Rollen",
            soggetti: "Abteilungen",
            tag: "Tag",
            topics: "Themen",
            utenti: "Benutzer",
            visitatori: "Besucher",
            webhookIntegration: "Webhook-Integration",
            workflow: "Arbeitsablauf",
            profile: "Profil",
            chatbotBlockMarket: "Chatbot Block-Markt",
            chatbotSandbox: "Chatbot Sandbox",
            allAutomations: "Alle Automatisierungen",
            scheduledAutomations: "Geplante Automatisierungen",
            eventBasedAutomations: "Ereignisbasierte Automatisierungen",
            buttonAutomations: "Schaltflächen-Automatisierungen",
            webhookAutomations: "Webhook-Automatisierungen",
            automationInsights: "Automatisierungs-Einblicke",
            automationSandbox: "Automatisierungs-Sandbox",
            mailInbox: "E-Mail-Posteingang",
            mailTemplates: "E-Mail-Vorlagen",
            mailBroadcast: "Massen-E-Mail",
            mailCustomerGroups: "E-Mail-Kundengruppen",
            reservation: "Reservierung",
            reservationLandingPage: "Reservierungs-Landingpage",
            reservationPrograms: "Reservierungsprogramme",
            reservationAutomations: "Reservierungsautomatisierungen",
            calendarEvents: "Kalender-Ereignisse",
            calendarReservations: "Kalender-Reservierungen",
        },
        mail: {
            errorStatus: "Fehlerstatus",
            mailSendErrorTitle: "Nicht zugestellte E-Mails",
            mailSendErrorDescription: "Gesamtzahl der nicht zugestellten E-Mails",
            fixGrammarTitle: "Grammatik-Korrektur",
            expandTextTitle: "Texterweiterung",
            summaryTitle: "Zusammenfassung",
            changeToneTitle: "Ton ändern",
            translationTitle: "Übersetzung",
            replyTitle: "Antwort",
            customRequestTitle: "Antwort auf Sonderwunsch",
            viewMode: "Ansichtsmodus",
            singleView: "Einzelansicht",
            splitView: "Geteilte Ansicht",
            folders: "Ordner",
            sendError: "Beim Senden der E-Mail ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
            visitorCreationError: "Fehler beim Erstellen des Besuchers. Bitte versuchen Sie es später erneut.",
            onlyImageAllowed: "Nur Bilddateien sind erlaubt.",
            imageFileTooLarge: "Die Bilddatei ist zu groß. Die maximale Größe beträgt 10 MB.",
            imageUploaded: "Bild erfolgreich hochgeladen.",
            imageUploadError: "Beim Hochladen des Bildes ist ein Fehler aufgetreten.",
            mailAiAssistant: {
                aiCreateSummarized: "KI-Zusammenfassung erstellen",
                aiSentimentAnalysis: "KI-Stimmungsanalyse",
                contentRequired: "E-Mail-Inhalt ist erforderlich, um diese Funktion zu nutzen",
                grammarFixed: "Grammatik wurde korrigiert",
                aiError: "Der KI-Assistent ist auf einen Fehler gestoßen",
                contentExpanded: "E-Mail-Inhalt wurde erweitert",
                emailSummarized: "E-Mail wurde zusammengefasst",
                toneChanged: "Ton geändert zu {tone}",
                emailTranslated: "E-Mail wurde ins {language} übersetzt",
                replyGenerated: "Automatische Antwort wurde erstellt",
                contentUpdated: "Inhalt wurde aktualisiert",
                contentRebuilt: "Inhalt wurde neu erstellt",
                contentRebuildFailed: "Neuerstellung des Inhalts fehlgeschlagen",
                customRequestEmpty: "Bitte geben Sie eine Anfrage ein",
                customRequestApplied: "Benutzerdefinierter Inhalt wurde angewendet",
                loadingText: "KI arbeitet",
                loadingDescription: "Text wird analysiert, bitte warten...",
                aiTitle: "E-Mail KI-Assistent",
                aiDescription: "KI-Tools zum Verbessern, Bearbeiten und Analysieren Ihrer E-Mail",
                emptyContentTitle: "Kein E-Mail-Inhalt gefunden",
                emptyContentDescription: "Zum Verwenden der KI-Funktionen ist E-Mail-Inhalt erforderlich.",
                limitedAccessDescription: "Nur eingeschränkte Funktionen verfügbar, da kein Inhalt vorhanden ist.",
                resultEmotions: "Erkannte Emotionen",
                analysisDescription: "Analysebeschreibung",
                recommendationsList: "Verbesserungsvorschläge",
                mailSummarize: "E-Mail-Zusammenfassung",
                aiResponse: "Von KI generiert",
                rebuild: "Neu erstellen",
                applyText: "Text übernehmen",
                specialRequest: "Benutzerdefinierte Anfrage",
                specialRequestPlaceholder: "Geben Sie hier Ihre benutzerdefinierten Anweisungen ein...",
                sendRequest: "Anfrage senden",
                fixGrammarTitle: "Grammatik korrigieren",
                fixGrammardescription: "Rechtschreib- und Grammatikfehler automatisch korrigieren",
                expandTextTitle: "Text erweitern",
                expandTextDescription: "Macht Ihren Text umfassender und detaillierter",
                changeToneTitle: "Ton ändern",
                changeToneDescription: "Ändert Ton und Stil des Textes entsprechend Ihrem Wunsch",
                changeTone_ProfessionalTitle: "Professionell",
                changeTone_ProfessionalDescription: "Formeller und professioneller Ton für den Arbeitsplatz",
                changeTone_FriendlyTitle: "Freundlich",
                changeTone_FriendlyDescription: "Herzlicher und freundlicher Ansatz",
                changeTone_CasualTitle: "Locker",
                changeTone_CasualDescription: "Entspannter und umgangssprachlicher Ton",
                changeTone_FormalTitle: "Formell",
                changeTone_FormalDescription: "Sehr formeller und geschäftlicher Stil",
                changeTone_ConfidentTitle: "Selbstbewusst",
                changeTone_ConfidentDescription: "Starker und eindrucksvoller Ausdrucksstil",
                translateTitle: "Übersetzen",
                translateDescription: "Übersetzt Ihren Text in verschiedene Sprachen",
                generateReplyTitle: "Antwort generieren",
                generateReplyDescription: "Erstellt automatisch eine passende Antwort auf die empfangene E-Mail",
                customPromptTitle: "Benutzerdefinierte Anfrage",
                customPromptDescription: "Erstellt E-Mail-Inhalt basierend auf Ihren benutzerdefinierten Anweisungen"
            },
            searchEmail: "E-Mail suchen...",
            emailAttachments: "Anhänge ({count})",
            signatureMessage: "Ihre E-Mail-Signatur ist vorhanden. Möchten Sie sie dem Inhalt hinzufügen?",
            emailSubject: "E-Mail-Betreff",
            takeItBack: "Rückgängig",
            fastForward: "Wiederholen",
            addEmoji: "Emoji hinzufügen",
            addLink: "Link hinzufügen",
            bold: "Fett",
            italic: "Kursiv",
            underline: "Unterstrichen",
            fontFamily: "Schriftart",
            textColor: "Textfarbe",
            stringFormats: "Textformate",
            alignLeft: "Links ausrichten",
            alignRight: "Rechts ausrichten",
            alignCenter: "Zentrieren",
            normalText: "Normaler Text",
            participantList: "{first}, {second}, {third} +{remaining} weitere",
            noMailFound: "Keine E-Mails gefunden",
            selectedMail: "{count} E-Mail ausgewählt",
            recipientEmailAddress: "E-Mail-Adresse des Empfängers",
            CCreceivers: "CC-Empfänger",
            BCCreceivers: "BCC-Empfänger",
            emptyStateMessage: "Wählen Sie eine E-Mail oder erstellen Sie eine neue",
            FromName: "Name des Absenders",
            broadcastCreatedSuccess: "Übertragung erfolgreich erstellt",
            confirmArchive: "Sind Sie sicher, dass Sie diese Übertragung archivieren möchten?",
            archive: "Archivieren",
            cancel: "Abbrechen",
            archiveSuccess: "Übertragung erfolgreich archiviert",
            archiveError: "Fehler beim Archivieren der Übertragung",
            empty: "Leer",
            summerDiscounts: "Sommerangebote",
            opportunities: "Möglichkeiten",
            newMailTemplateCreated: "Neue E-Mail-Vorlage erstellen.",
            dateRange: "Datumsbereich",
            templateName: "Name der Vorlage",
            category: "Kategorie",
            templateUpdateSucs: "Die Vorlage wurde erfolgreich aktualisiert.",
            templateUpdateError: "Bei der Aktualisierung der Vorlage ist ein Fehler aufgetreten.",
            marketing: "Marketing",
            operativ: "Operativ",
            custom: "Speziell",
            pleaseEnterTemplateName: "Bitte geben Sie den Vorlagennamen ein",
            pleaseEnterTemplateSubject: "Bitte geben Sie den Betreff der Vorlage ein",
            pleaseSelectTemplateCategories: "Bitte wählen Sie die Kategorie der Vorlage",
            representMails: "Repräsentative Mails",
            otherRepresentMails: "Sie können eingehende und ausgehende E-Mails an und von den E-Mail-Adressen anderer Vertreter verfolgen.",
            signatureAutoAdd: "Der Status des automatischen Hinzufügens von Unterschriften wurde erfolgreich geändert",
            autoAdd: "Automatisches Hinzufügen",
            forwardEmailAddSucs: "Weiterleitungs-E-Mail-Adresse erfolgreich hinzugefügt.",
            errorAddingForwardEmail: "Beim Hinzufügen einer Weiterleitungs-E-Mail-Adresse ist ein Fehler aufgetreten",
            mailAddForward: "Manuelles Hinzufügen (Weiterleitung abgeschlossen)",
            mailAddForwarding: "Manuelles Hinzufügen (ich habe die Weiterleitung abgeschlossen)",
            broadcast: "Veröffentlichungen",
            templates: "Vorlagen",
            newMailArrived: "Neue E-Mail eingetroffen.",
            mailSentSucs: "Mail erfolgreich gesendet",
            representativeMails: "Repräsentative Mail",
            composeNewEmail: "Neue E-Mail verfassen",
            couldNotUserMail: "Konnte keine E-Mail senden, weil es keine Benutzer-Mail gibt",
            mailAddressReq: "Mail-Adresse erforderlich.",
            emailAddressInvalid: "Mail-Adresse ungültig.",
            departmentIsNotValid: "Abteilung nicht gültig",
            mailSendNotValid: "Ungültige Mailadresse",
            routingSteps: "Routing-Schritte",
            owner: "Besitzer",
            whereHeDirected: "Wohin er geleitet hat",
            forwardingEmailAddress: "Weiterleitungs-E-Mail-Adresse",
            deleteMailDesc: "Dieser Vorgang kann nicht rückgängig gemacht werden.",
            deleteMailTitle: "Möchten Sie diese E-Mail-Adresse wirklich löschen?",
            gmailForwardMail: "Gmail E-Mail-Weiterleitung",
            senderMailAddressDesc: "Bitte geben Sie die E-Mail-Adresse des Absenders ein",
            verified: "Verifiziert",
            notForwarded: "Nicht weitergeleitet",
            notVerified: "Nicht verifiziert",
            default: "Standard",
            isVerified: "Verifiziert",
            forwarding: "Weiterleitung",
            mailAdress: "E-Mail-Adresse",
            addSenderAddress: "Absenderadresse hinzufügen",
            outlookForward: "Microsoft (Outlook/Exchange) Weiterleitung",
            gmailForward: "Google (Gmail) Weiterleitung",
            senderMail: "Absendermail",
            mailDetail: "E-Mail-Detail",
            mailNotFound: "E-Mail nicht gefunden",
            mailSelecting: "E-Mail-Auswahl",
            newMail: "Neue E-Mail",
            myMails: "Meine E-Mails",
            inbox: "Posteingang",
            sent: "Gesendet",
            departmentMails: "Abteilungsemails",
            newTemplate: "Neue Vorlage",
            unread: "Ungelesen",
            unreply: "Unbeantwortet",
            reply: "Antworten",
            attachments: "E-Mail-Anhänge",
            To: "An",
            From: "Von",
            placeHolders: "Platzhalter",
            attacheFiles: "Dateien anhängen",
            replyAll: "Allen antworten",
            forward: "Weiterleiten",
            deleteThread: "Thread löschen",
            markAsRead: "Als gelesen markieren",
            markAsAllRead: "Alle als gelesen markieren",
            emailEditor: "E-Mail-Editor",
            integrateYourMail: "Integrieren Sie Ihre E-Mail",
            connect: "Verbinden",
            departmentMail: "Abteilungs-E-Mail",
            createMailAddress: "E-Mail-Adresse erstellen",
            createNewMail: "Neue E-Mail erstellen",
            operational: "Operativ",
            canNotUserMail: "E-Mail konnte nicht gesendet werden, da kein Benutzer-E-Mail-Konto vorhanden ist",
            createNewEmail: "Neue E-Mail erstellen",
            ly: "Antwort",
            ply: "Antworten"
        },
        visitor: {
            ownership: "Eigentum",
            visitors: "Besucher",
            bannedVisitors: "Gesperrte Besucher",
            tags: "Tags",
            profileFields: "Profilfelder",
            downloadAll: "Alle herunterladen",
            saveAsCustomerGroup: "Als Kundengruppe speichern",
            saveSearchFavorite: "Suche als Favorit speichern",
            editOrDeleteFavorite: "Favorit bearbeiten oder löschen",
            mail: "Mail",
            visitorDetail: "Besucherdetails",
            selectedUser: "{selectedUser} von {totalUsers} Benutzern ausgewählt",
            uncheck: "Alle abwählen",
            checkAll: "Alle auswählen",
            matchedUsers: "{checkedCount} Benutzer übereinstimmend",
            more: "Mehr",
            exportUsers: "Ausgewählte Benutzer exportieren",
            exportAllUsers: "Alle Benutzer exportieren",
            addSegment: "Segment hinzufügen",
            deleteCheckedUser: "Ausgewählte Benutzer löschen",
            deleteAllUser: "Alle Benutzer löschen",
            matchedFilter: "Alle Filter übereinstimmend",
            visitor: "Besucher",
            deleteUser: "Benutzer löschen",
            userData: "Benutzerdaten",
            lastSession: "Letzte Sitzung",
            notUserData: "Keine Benutzerdaten gefunden",
            segments: "Segmente",
            addTag: "Tag hinzufügen",
            userChats: "Benutzer-Chats",
            seeAll: "Alle anzeigen",
            confirm: "Bestätigen",
            manageSegments: "Segment verwalten",
            search: "Suchen",
            manageTags: "Tags verwalten",
            allAttributes: "Alle Attribute anzeigen",
            noData: "Keine Daten",
            noEmail: "Keine E-Mail",
            noIpAddress: "IP-Adresse nicht gefunden.",
            noWpNumber: "Nummer nicht gefunden.",
            filterName: "Filtername..",
            matchedContacts: "{chechkedCount} Kontakte abgeglichen",
            channelContacts: "Kanal-Kontakte",
            searchInAllFields: "In allen Feldern suchen",
            searchInName: "Im Namen suchen",
            importContacts: "Kontakte importieren",
            addNewContact: "Neuen Kontakt hinzufügen",
            importContactsTitle: "Kontakte importieren",
            addSingleContactTitle: "Einzelnen Kontakt hinzufügen",
            downloadRecordsSettings: "Datensätze herunterladen - Einstellungen",
            excelExport: "Excel-Export",
            exportTotalRecords: "Gesamt {total} Datensätze",
            exportCancel: "Abbrechen",
            whatsappContacts: "WhatsApp-Kontakte",
            instagramContacts: "Instagram-Kontakte",
            messengerContacts: "Messenger-Kontakte",
            linkedinContacts: "LinkedIn-Kontakte",
            telegramContacts: "Telegram-Kontakte",
            metaLeadsContacts: "MetaLeads-Kontakte",
            searchPlaceholderAll: "Geben Sie hier ein, um in allen Feldern zu suchen",
            searchPlaceholderFullname: "Geben Sie hier ein, um nach Namen zu suchen",
            searchPlaceholderEmail: "Geben Sie hier ein, um nach E-Mail zu suchen",
            searchPlaceholderPhone: "Geben Sie hier ein, um nach Telefon zu suchen",
            searchPlaceholderWhatsapp: "Geben Sie hier ein, um nach WhatsApp zu suchen",
            searchPlaceholderDefault: "Suchen",
            searchFieldAll: "Alle Felder",
            searchFieldName: "Name",
            searchFieldEmail: "E-Mail",
            searchFieldPhone: "Telefonnummer",
            searchFieldWhatsapp: "WhatsApp-Nummer",
            searchModePhoneDetected: "Telefonnummer erkannt",
            searchModeEmailDetected: "E-Mail-Adresse erkannt",
            searchModeNotPhone: "Keine Telefonnummer",
            searchModeNotEmail: "Keine E-Mail",
            searchMode: "Suchmodus",
            searchModePhoneMessage: "\"{query}\" wurde als Telefonnummer erkannt. Sie befinden sich derzeit im Feld {field}. Möchten Sie im Telefonnummerfeld suchen?",
            searchModeEmailMessage: "\"{query}\" wurde als E-Mail-Adresse erkannt. Sie befinden sich derzeit im Feld {field}. Möchten Sie im E-Mail-Feld suchen?",
            searchModeNotPhoneMessage: "\"{query}\" hat kein Telefonnummerformat. Möchten Sie in allen Feldern oder im Namensfeld suchen?",
            searchModeNotEmailMessage: "\"{query}\" hat kein E-Mail-Format. Möchten Sie in allen Feldern oder im Namensfeld suchen?",
            unknownTag: "Unbekannt",
            noRecordsToDownload: "Keine Datensätze zum Herunterladen",
            excelCreatedSuccess: "Excel-Datei erfolgreich erstellt",
            exportCancelled: "Export abgebrochen",
            excelCreateError: "Beim Erstellen der Excel-Datei ist ein Fehler aufgetreten",
            yes: "Ja",
            no: "Nein",
            unowned: "Nicht zugewiesen",
            whatsappGroupCreatedSuccess: "WhatsApp-Kundengruppe erfolgreich erstellt.",
            whatsappGroupCreateError: "Beim Erstellen der WhatsApp-Kundengruppe ist ein Fehler aufgetreten.",
            mailGroupCreatedSuccess: "E-Mail-Kundengruppe erfolgreich erstellt.",
            mailGroupCreateError: "Beim Erstellen der E-Mail-Kundengruppe ist ein Fehler aufgetreten.",
            messageHistory: "Nachrichtenverlauf",
            pastConversations: "Vergangene Unterhaltungen",
            defaultUser: "Benutzer",
            blockManagement: "Blockierungsverwaltung",
            vipCustomer: "VIP-Kunde",
            startChat: "Chat starten",
            createEvent: "Ereignis erstellen",
            createTask: "Aufgabe erstellen",
            selectTask: "Aufgabe auswählen",
            webphoneCall: "Mit Webphone anrufen",
            capiEventSend: "CAPI-Ereignis senden",
            defaultName: "Besucher",
            notAvailable: "N/V",
            relatedList: "Verwandte Liste",
            adReferrals: "Anzeigen-Referrals",
            calls: "Anrufe",
            generalInfo: "Allgemeine Informationen",
            callHistory: "Anrufverlauf",
            webTab: "Web-Tab",
            widgetUrlError: "Widget-URL konnte nicht erstellt werden",
            deleteSuccess: "Besucher erfolgreich gelöscht.",
            taskStatusUpdateSuccess: "Aufgabenstatus erfolgreich aktualisiert",
            taskStatusUpdateError: "Fehler beim Aktualisieren des Aufgabenstatus",
            copyToClipboard: "In Zwischenablage kopiert",
            noPhoneNumber: "Keine Telefonnummer zum Anrufen",
            webphoneCalling: "Rufe {phoneNumber} mit Webphone an...",
            filterResultMax5000: "Das Filterergebnis ist auf maximal 5000 Kontakte begrenzt",
            onlyContactsPhoneNumber: "Nur Kontakte mit Telefonnummer werden in die Gruppe übernommen",
            enterGroupName: "Gruppenname eingeben",
            showInColumns: "In Spalten anzeigen",
            sendMailSucs: "E-Mail erfolgreich gesendet",
            equal: "Gleich",
            notEqual: "Ungleich",
            contains: "Enthält",
            notContains: "Enthält nicht",
            startsWith: "Beginnt mit",
            endWith: "Endet mit",
            deletedCheckedUser: "Ausgewählte Benutzer löschen",
            userMails: "Benutzer-E-Mails"
        },
        chatbotv2: {
            Ticket_Actions: "Ticket-Aktionen",
            Task_Actions: "Aufgaben-Aktionen",
            Contact_Actions: "Personen-Aktionen",
            Calendar_Actions: "Kalender-Aktionen",
            "T-Soft_Actions": "T-Soft-Aktionen",
            "Ticimax-V2_Actions": "Ticimax-Aktionen",
            TSOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
            TSOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
            TICIMAX_V2_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
            TICIMAX_V2_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
            Ikas_Actions: "Ikas Aktionen",
            IKAS_GET_MEMBER_INFO: "Mitgliederdetails abrufen",
            IKAS_SELECT_ORDER: "Bestellung auswählen",
            IKAS_ORDER_STATUS: "Bestellstatus abrufen",
            IDEASOFT_PRODUCT_SEARCH: "Produktsuche",
            privateMessageDescription: "Private Nachrichten können nur von Vertretern eingesehen werden und bleiben für Besucher verborgen.",
            AI_RANDOM_TEXT: "KI-Zufallstext",
            AI_IMAGE: "KI-Bild",
            PRIVATE_MESSAGE: "Private Nachricht",
            aiPrompt: "Aufforderung",
            variants: "Varianten",
            Zoho_Actions: "Zoho-Aktionen",
            Table_Actions: "Tabellenaktionen",
            Cache_Actions: "Cache-Aktionen",
            File_Actions: "Dateiaktionen",
            Google_Drive_Actions: "Google Drive-Aktionen",
            Artificial_Intelligence: "Künstliche Intelligenz",
            Data_Formatters: "Datenformatierer",
            Loop_Actions: "Schleifenaktionen",
            importSuccess: "Vorlage erfolgreich importiert",
            importFailed: "Fehler beim Importieren der Vorlage",
            creatingBlank: "Leerer ChatBOT wird erstellt...",
            untitledChatbot: "Unbenannter ChatBOT",
            errorCreating: "Fehler beim Erstellen des ChatBOT",
            typeAutomationTitle: "Geben Sie den Automatisierungstitel ein",
            typeStoryTitle: "Schreiben Sie einen Geschichten-Titel",
            setUpYourChatbot: "Richten Sie Ihren Chatbot ein",
            setUpYourChatbotDesc: "Trainieren Sie Ihren Chatbot mit Daten, verwenden Sie unsere gebrauchsfertigen Vorlagen oder fangen Sie ganz von vorne an.",
            blankBot: "Leerer Bot",
            blankBotDesc: "Erstellen Sie einen leeren Chatbot, den Sie später trainieren und anpassen können.",
            aiBotDesc: "Erstellen Sie einen RAG-basierten KI-Chatbot. Fügen Sie eine Wissensdatenbank hinzu und wählen Sie Ihr LLM-Modell.",
            recommended: "Empfohlen",
            websiteDesc: "Scannen Sie den Inhalt Ihrer Website, um Antworten auf beliebte Nutzerfragen zu erhalten.",
            yourNeedEnterYourOpenAi: "Sie müssen Ihren OpenAI-API-Schlüssel eingeben, um einen automatisierten Chatbot durch Crawlen Ihrer Website zu erstellen.",
            createOpenAiKey: "Api-Schlüssel erstellen",
            aiKnowledge: "Wissen über künstliche Intelligenz",
            modalUsage: "Modale Verwendung",
            usedContentSources: "Verwendete Inhaltsquellen",
            websites: "Websites",
            articles: "Artikel",
            faq: "Häufig gestellte Fragen",
            files: "Dateien",
            functions: "Funktionen",
            settings: "Einstellungen",
            disableAi: "KI deaktivieren",
            enableAi: "Künstliche Intelligenz einschalten",
            lastEdited: "Zuletzt bearbeitet",
            state: "Status",
            frequentlyAskedQuestions: "Häufig gestellte Fragen (FAQ)",
            faqIsCreated: "FAQ erstellt",
            selectKnowEnabled: "Aktivieren der ausgewählten Wissensdatenbanken...",
            selectKnowDisabled: "Die ausgewählten Wissensdatenbanken sind deaktiviert...",
            selectKnowNotEnabled: "Die ausgewählten Wissensbasen sind nicht aktiviert...",
            selectKnowNotDisabled: "Die ausgewählten Wissensdatenbanken sind nicht deaktiviert.",
            answered: "Beantwortet",
            answer: "Antwort",
            addFile: "Datei hinzufügen",
            fileDeleted: "Dateien gelöscht",
            fileDeletedFailed: "Es gab ein Problem beim Löschen von Dateien",
            noFileAdded: "Keine Datei hinzugefügt",
            aiFunctions: "AI-Funktionen",
            addFunction: "Funktion hinzufügen",
            aiFunctionCreateHint: "Verwenden Sie beim Erstellen von KI-Funktionen keine türkischen Zeichen. Verwenden Sie nur englische Buchstaben, Zahlen und Unterstriche in Funktionsnamen.",
            builtInFunctionsTitle: "Integrierte Funktionen",
            builtInFunctionsDesc: "Dies sind vordefinierte Funktionen, die von der künstlichen Intelligenz verwendet werden können.",
            builtInFunctionsOptionButtonsTitle: "KI kann Nachrichten mit Buttons senden",
            builtInFunctionsOptionButtonsDesc: "Ermöglicht der KI, dem Benutzer klickbare Buttons anzuzeigen. Wenn aktiv, kann die KI dem Benutzer Optionsbuttons anbieten.",
            builtInFunctionsCloseConversationTitle: "KI kann das Gespräch beenden",
            builtInFunctionsCloseConversationDesc: "Ermöglicht der KI, das Gespräch bei Bedarf zu beenden. Wenn aktiv, kann die KI den Chat schließen.",
            builtInFunctionsTransferChatTitle: "KI kann an Live-Support übertragen",
            builtInFunctionsTransferChatDesc: "Ermöglicht der KI, das Gespräch bei Bedarf an den Live-Support zu übertragen. Wenn aktiv, kann die KI das Gespräch an einen menschlichen Agenten übertragen.",
            parameterCount: "Anzahl der Parameter",
            auto: "Auto",
            usedByAI: "Von KI verwendet",
            usedByAi: "Von der KI verwendet",
            notUsed: "Nicht benutzt",
            saveAndClose: "Speichern und schließen",
            contentPreview: "Inhaltsvorschau",
            addContent: "Inhalt hinzufügen",
            populerUserQuestion: "Durchsucht den Inhalt Ihrer Website, um Antworten auf beliebte Nutzerfragen zu erhalten.",
            enterUrlAddress: "Geben Sie eine URL-Adresse ein",
            sharingYourUrl: "Indem Sie Ihre URL freigeben, bestätigen Sie, dass Sie die notwendigen Rechte haben, um den Inhalt freizugeben.",
            pageSelected: "Ausgewählte Seiten",
            trainChatbot: "Den Chatbot trainieren",
            thereAreOnePages: "Es befindet sich 1 Seite darin",
            categoryDesc: "Kategorie. Wählen Sie, welche Sie zum Trainieren Ihres KI-Modells verwenden möchten.",
            scarpOrAddContent: "Scannen oder Hinzufügen von Inhalten, die AI Assist verwenden kann, um die Anfragen Ihrer Kunden zu beantworten",
            noContentAdded: "Kein Inhalt hinzugefügt",
            howItWorks: "Wie es funktioniert",
            editEntries: "Einträge bearbeiten",
            newEntries: "Neue Einträge",
            chatbotManagement: "Chatbot-Verwaltung",
            chatbotScenarioList: "Chatbot-Szenario-Liste",
            exportDiagramToClipboard: "Diagramm in die Zwischenablage exportieren",
            selectedStory: "{count} Geschichte ausgewählt",
            Meta_Actions: "Meta-Aktionen",
            suppressionRemoved: "Unterdrückung entfernt",
            suppressionAdded: "Unterdrückung hinzugefügt",
            didntSuppression: "Sie haben keine Unterdrückung vorgenommen.",
            whatsappIntegrationTitle: "WhatsApp V1 und WhatsApp V2 Integration",
            whatsappApiIntegrationTitle: "WhatsApp Business API Integration",
            ReadyTemplateBadge: "Fertige Vorlage",
            readyTemplates: "Fertige Vorlagen",
            regex: "Regex",
            regexDescription: "Mit Regex alles erfassen",
            chatbotLogo: "ChatBot-Logo",
            chatbotName: "ChatBot-Name",
            allSecnario: "Liste der Chatbot-Szenarien",
            ChatbotScenarioList: "Liste der Chatbot-Szenarien",
            Scenario: "Szenario",
            filters: {
                equal: "gleich",
                not_equal: "nicht gleich",
                contain: "enthält",
                not_contain: "enthält nicht",
                starts_with: "Beginnt mit",
                ends_with: "endet mit",
                empty: "Wenn es leer ist",
                non_empty: "Wenn nicht leer",
                longer_than: "Wenn länger",
                shorter_than: "Wenn kürzer",
                less_than: "Wenn klein",
                less_or_equal: "Wenn klein oder gleich",
                greater_than: "Wenn groß",
                greater_or_equal: "Wenn groß oder gleich"
            },
            planRequired: "{integratable} Plan ist erforderlich.",
            noDefaultStoryTitle: "Standardgeschichte",
            noDefaultStory: "Sie haben nicht die Standardgeschichte.",
            noMessage: "Keine Nachricht",
            loading: "Wird geladen",
            loadMore: "Mehr",
            hostname: "Hostname",
            allTemplates: "Alle Vorlagen",
            allAITemplates: "Alle KI-Vorlagen",
            templatesFromTheIndustry: "Vorlagen aus der Industrie",
            basicTemplate: "Grundlegende Vorlage",
            proTemplate: "Erweiterte Vorlage",
            goToStory: "in die Geschichte gehen",
            noResultFound: "Es wurden keine Ergebnisse gefunden",
            checkYourFilterCombination: "Überprüfen Sie die Filterkombination",
            clearYourSearch: "Reinigen Sie die Suche",
            andTryAgain: "und versuchen Sie es erneut",
            withBot: "& Bot",
            userWithBot: "Benutzer & Bot",
            chatDetail: "Chat-Details",
            allUserDetail: "Alle Benutzerdetails anzeigen",
            sessionData: "Sitzungsdaten",
            supsisChatWidget: "SUPSIS-Chat-Widget",
            integratedWith: "Integriert in Folgendes:",
            integration: "Integration",
            Users: "Benutzer",
            user_id: "Benutzer-ID",
            botStory: "Bot-Geschichte",
            categories: "Kategorien",
            worksWith: "Arbeitet mit",
            importBot: "Verwenden Sie Bot",
            keyFeatures: "HAUPTEIGENSCHAFTEN",
            importing: "hinzugefügt",
            comingSoon: "Bald zu Ihrem Service",
            pickStory: "Wählen Sie Geschichte",
            conversationId: "Gesprächs-ID",
            integrateStoryWithSupsisWidget: "Supsis-Widget in die Chatbot-Geschichte integrieren",
            integrateStoryWithWhatsapp: "WhatsApp in die Chatbot-Geschichte integrieren",
            integrateStoryWithInstagram: "Instagram in die Chatbot-Geschichte integrieren",
            selectIntegratingStory: "Integrierte Geschichte auswählen",
            install: "Installieren",
            attr: {
                weekday: "Wochentag",
                channelId: "Kanal",
                email: "E-Mail",
                phone: "Telefon",
                language: "Sprache",
                timezone: "Zeitzone",
                gender: "Geschlecht",
                country: "Land",
                referrer: "Referenz",
                url: "Besuchs-URL",
                ip: "IP",
                last_seen: "Zuletzt gesehen",
                name: "Name",
                user_id: "Benutzernummer",
                department: "Abteilung",
                message: "Nachricht",
                akinon_brand: "Marke",
                akinon_order_id: "Bestellnummer",
                akinon_product_id: "Produktnummer",
                akinon_user_id: "Benutzer-ID",
                akinon_user_name: "Nutzername",
                akinon_user_email: "Benutzer Email",
                akinon_invoice_url: "Rechnungs -URL",
                akinon_order_status: "Bestellstatus",
                akinon_order_price: "Bestellpreis",
                akinon_shipper_name: "Cargo Firmenname",
                akinon_product_size: "Produktkörper",
                akinon_sku: "Skue",
                akinon_product_url: "Produkt -URL",
                akinon_product_title: "Produktüberschrift",
                akinon_product_image: "Produktbild",
                akinon_product_stock: "Produktbestand",
                akinon_order_date: "Auftragsdatum",
                akinon_track_number: "Versandnummer",
                akinon_track_url: "Frachtverfolgungs -URL",
                akinon_latitude: "Breitengrad (Ort)",
                akinon_longitude: "Länge (Ort)",
                ideasoft_user_id: "Mitglieds-ID",
                ideasoft_invoice_url: "Rechnungs-URL",
                ideasoft_order_id: "Bestellnummer",
                ideasoft_order_status: "Bestellstatus",
                ideasoft_order_price: "Bestellpreis",
                ideasoft_shipper_name: "Versandunternehmen",
                ideasoft_product_size: "Produktgröße",
                ideasoft_sku: "SKU",
                ideasoft_product_url: "Produkt-URL",
                ideasoft_product_title: "Produkttitel",
                ideasoft_product_image: "Produktbild",
                ideasoft_product_stock: "Produktbestand",
                ideasoft_order_date: "Bestelldatum",
                ideasoft_track_number: "Sendungsnummer",
                ideasoft_track_url: "Sendungsverfolgungs-URL",
                idleUserTime: "Letzte Benutzeraktion (Sekunden)",
                ai_class_result: "KI-Klassenergebnis",
                meta_comment_id: "Meta-Kommentar-ID",
                meta_comment: "Meta-Kommentar",
                meta_post_id: "Meta-Beitrags-ID",
                last_meta_post_id: "Letzte Meta-Post-ID",
                last_meta_post_caption: "Letzte Meta-Post-Beschriftung",
                last_meta_post_type: "Letzter Meta-Post-Typ",
                visitor_trigger_type: "Besucher-Triggertyp",
                visitor_trigger_name: "Name des Besucher-Triggers",
                offline_mode: "Offline-Modus",
                available_agents: "Geeignete Vertreter",
                platform: "Plattform",
                hour: "Stunde",
                segments: "Segments",
                tags: "Tags",
                ticket: "Ticket",
                metaReferrals: "Meta-Verweise",
                owner: "Eigentümer",
                trendyol_question: "Produktfrage",
                trendyol_question_id: "Produktfrage-ID",
                trendyol_product_id: "Produkt-ID",
                trendyol_product: "Produktdaten",
                id: "ID",
                conversationId: "Gesprächs-ID",
                probel_sube_kodu: "Filialcode",
                probel_brans_adi: "Filialname",
                probel_brans_kodu: "Filialcode",
                probel_doktor_adi: "Arztname",
                probel_doktor_kodu: "Arztcode",
                probel_poliklinik_adi: "Poliklinikname",
                probel_poliklinik_kodu: "Poliklinikcode",
                probel_randevu_tarihi: "Termindatum",
                probel_date: "Termindatum",
                probel_randevu_saati: "Terminzeit",
                probel_randevu_id: "Termin-ID",
                probel_hasta_token: "Patienten-Token",
                probel_kimlik_tipi: "Ausweistyp",
                probel_kimlik_no: "Ausweisnummer",
                probel_hasta_adi: "Patientenname",
                probel_hasta_soyadi: "Patientennachname",
                probel_hasta_cinsiyet: "Geschlecht",
                probel_hasta_dogum_tarihi: "Geburtsdatum",
                probel_hasta_telefon: "Telefon",
                b2cargo_companyCode: "Unternehmenscode",
                b2cargo_takipNo: "Sendungsnummer",
                b2cargo_takipseri: "Sendungsserie",
                b2cargo_evrakdurum: "Bestellstatus",
                b2cargo_teslimtar: "Lieferdatum",
                b2cargo_gonderen: "Absendername",
                b2cargo_aliciAdi: "Empfängername",
                b2cargo_cikisIl: "Abgangsprovinz",
                b2cargo_varisIl: "Ankunftsprovinz",
                b2cargo_teslim: "Produktstatus",
                b2cargo_urun: "Produkttyp",
                b2cargo_atfTarih: "Produkt-ATF-Datum",
                b2cargo_palet: "Produktpalette",
                b2cargo_koli: "Produktpaket",
                b2cargo_kg: "Produktgewicht",
                b2cargo_desi: "Produkt DESI",
                b2cargo_zimmetno: "Zimmet-Nr.",
                b2cargo_varissube: "Ankunftsfiliale",
                b2cargo_atfDurum: "ATF-Status",
                holiday_plus_room_id: "Zimmer-ID",
                holiday_plus_room_title: "Zimmertitel",
                holiday_plus_room_description: "Zimmerbeschreibung",
                holiday_plus_room_size: "Zimmergröße",
                holiday_plus_room_price: "Zimmerpreis",
                holiday_plus_room_price_offer: "Zimmerpreisangebot",
                holiday_plus_room_discount_price: "Zimmer-Rabattpreis",
                holiday_plus_selected_hotel_id: "Ausgewählte Hotel-ID",
                holiday_plus_checkin: "Check-in",
                holiday_plus_checkout: "Check-out",
                holiday_plus_child_count: "Anzahl Kinder",
                holiday_plus_adult_count: "Anzahl Erwachsene",
                holiday_plus_child_dates: "Kind-Daten",
                reservation_time: "Reservierungszeit",
                reservation_day: "Reservierungstag"
            },
            storyList: "Geschichtenliste",
            douYouWannaDeleteItem: "Möchten Sie diesen Artikel löschen?",
            douYouWannaDeleteWithChildren: "Möchten Sie dieses Element mit den Unterelementen löschen?",
            stories: "Geschichten",
            templates: "Vorlagen",
            aitemplates: "KI-Vorlagen",
            integrations: "Integrationen",
            all: "Alle",
            installed: "Hochgeladen",
            installationOK: "Geladen",
            uninstall: "Deinstallieren",
            remainingMessageDesc: "Verbleibende kostenlose Nachricht:",
            openAISiteRoutingDescStart: "Einen Apikey bekommen",
            openAISiteRoutingDescEnd: "Sie können auf den Link klicken.",
            integrationOK: "Integriert",
            chatWidget: "SUPSIS -Chat -Ballon",
            artificialIntelligence: "Künstliche Intelligenz",
            integratePlatform: "Chatbot kann in {integretable} integriert werden.",
            integrateOpenAIWithChatbot: "Integrieren Sie Chat GPT-4 in Chatbot",
            integrateChatBotWithChatGPT3: "Integration von Chatbot mit CHAT GPT-4",
            integrateStoryWithTelegram: "Integration mit Telegramm -Chatbot",
            webhooks: "Webhaken",
            archive: "Archiv",
            reports: "Berichte",
            uncheckAll: "Alle abwählen",
            userSegments: "Benutzerabschnitte",
            sandbox: "Papierkorb",
            sandboxPage: {
                title: "Chatbot Gelöschte Szenarien",
                description: "Ihre gelöschten Szenarien werden nach 30 Tagen im Papierkorb automatisch entfernt",
                emptyState: "Keine gelöschten Szenarien im Papierkorb",
                unnamedScenario: "Unbenanntes Szenario",
                restore: "Wiederherstellen",
                permanentlyDelete: "Dauerhaft löschen",
                unknown: "Unbekannt",
                user: "Benutzer",
                restoreConfirmTitle: "Sind Sie sicher, dass Sie dieses Szenario wiederherstellen möchten?",
                restoreConfirmContent: "Szenario {story} wird wiederhergestellt.",
                restoreSuccess: "Szenario erfolgreich wiederhergestellt",
                restoreError: "Wiederherstellung fehlgeschlagen",
                permanentDeleteConfirmTitle: "Sind Sie sicher, dass Sie dieses Szenario dauerhaft löschen möchten?",
                permanentDeleteConfirmContent: "Diese Aktion kann nicht rückgängig gemacht werden. Das Szenario wird dauerhaft gelöscht.",
                permanentDeleteSuccess: "Szenario dauerhaft gelöscht",
                permanentDeleteError: "Löschvorgang fehlgeschlagen",
                loadError: "Fehler beim Laden der gelöschten Szenarien"
            },
            customBlocks: "Benutzerdefinierte Blöcke",
            blockMarket: "Block-Markt",
            browseBlockMarket: "Block-Markt durchsuchen",
            searchBlocks: "Blöcke suchen...",
            unknownBlock: "Unbekannter Block",
            aiModelsComparison: "KI-Modell-Vergleich",
            aiModelsChangeModel: "Modell ändern",
            aiModelsRecommended: "Empfohlen",
            aiModelsEconomic: "Wirtschaftlich",
            aiModelsCodex: "Codex",
            comingSoonVectorIntro: "Mit OpenAI Vector Storage können Sie Ihren Chatbot mit Ihren eigenen Inhalten trainieren.",
            comingSoonStep1Title: "Dateien hochladen",
            comingSoonStep1Desc: "Fügen Sie PDF-, Word-, Excel-, Textdateien oder andere Dokumente zum System hinzu.",
            comingSoonStep2Title: "Automatische Verarbeitung",
            comingSoonStep2Desc: "Ihre Dateien werden von OpenAI analysiert und in das Vektorformat umgewandelt.",
            comingSoonStep3Title: "Intelligente Antworten",
            comingSoonStep3Desc: "Ihr Chatbot liefert präzise und aussagekräftige Antworten basierend auf den hochgeladenen Inhalten.",
            comingSoonTip: "Tipp: Je mehr Inhalte Sie hinzufügen, desto mehr erweitert sich die Wissensbasis Ihres Chatbots und er kann umfassendere Antworten geben.",
            comingSoonGotIt: "Verstanden",
            imageProcessingSettings: {
                title: "Bildverarbeitungseinstellungen",
                description: "Bestimmen Sie, wie an den Chatbot gesendete Bilder verarbeitet werden.",
                processingMode: "Verarbeitungsmodus",
                processWithBlock: "Mit Block verarbeiten",
                processWithBlockDesc: "Bilder an den lokalen Blockfluss weiterleiten",
                processWithAI: "Mit KI verarbeiten",
                processWithAIDesc: "Bilder mit künstlicher Intelligenz verarbeiten",
                fallbackBlock: "Fallback-Block",
                fallbackBlockDesc: "Block, zu dem bei Fehlern während der Bildverarbeitung weitergeleitet wird",
                fallbackBlockPlaceholder: "Fallback-Block auswählen",
                directJumpBlock: "Direkt-Sprung-Block",
                directJumpBlockDesc: "Alle Bilder direkt an diesen Block weiterleiten",
                directJumpBlockPlaceholder: "Direkt-Sprung-Block auswählen (optional)",
                aiProcessingMode: "KI-Verarbeitungsmodus",
                processIndividual: "Einzeln verarbeiten",
                processIndividualDesc: "Jedes Bild einzeln an die KI senden",
                processParallel: "Parallel verarbeiten",
                processParallelDesc: "Bilder innerhalb einer bestimmten Zeit sammeln und gemeinsam senden",
                bufferTime: "Pufferzeit (Sekunden)",
                bufferTimeDesc: "Wartezeit zum Sammeln der Bilder",
                saveSuccess: "Bildverarbeitungseinstellungen erfolgreich aktualisiert",
                saveError: "Fehler beim Speichern der Einstellungen"
            },
            addSegment: "Segment hinzufügen",
            addToSegment: "Zum Segment hinzufügen",
            removeFromSegment: "Aus Segment entfernen",
            plansVTippyContent: "Die Abrechnung für dieses Paket erfolgt zu Beginn jeden Monats, und falls Sie kündigen möchten, wird Ihr Verbrauch bis zum Monatsbeginn berechnet und Ihr Paket läuft ab.<br><br>Der Paketpreis ist exklusive Mehrwertsteuer.<br><br>Paketänderungen werden am nächsten Tag auf der Rechnung ausgewiesen.",
            segmentName: "Segmentname",
            sameSegment: "Ein Segment mit diesem Namen existiert bereits!",
            usersInSegment: "Benutzer im Segment",
            noUsersAdded: "Keine Benutzer hinzugefügt",
            updateSegment: "Segment aktualisieren",
            newSegment: "Neues Segment",
            selectAll: "Alle auswählen",
            queriesSelected: "Fragen ausgewählt",
            noBlocksFound: "Der Block wurde nicht gefunden!",
            userQuery: "Benutzerabfrage",
            date: "Geschichte",
            unmatched: "Unverkennbar",
            goToChat: "Geh zum Chat",
            selectStory: "Wählen Sie Geschichte",
            selectBlock: "Wählen Sie Block",
            training: "Bot -Training",
            trainingAlert: "Um die Änderungen, die Sie auf der Bot-Trainingsseite vorgenommen haben, umzusetzen, müssen Sie die neue Version des von Ihnen modifizierten Szenarios veröffentlichen.",
            unmatchedPhrases: "Nicht zusammenfassende Ausdrücke",
            ignored: "Unbedeutend",
            story: "Geschichte",
            timePeriod: "Zeitraum",
            wholeTimeSpan: "Jederzeit",
            selectAStory: "Wählen Sie eine Geschichte",
            searchUserQuery: "Suchen Sie die Benutzerabfrage",
            time: {
                today: "Heute",
                yesterday: "Gestern",
                last7: "Letzten 7 Tage",
                last30: "Letzte 30 Tage",
                "this-month": "Diesen Monat",
                "last-month": "Im vergangenen Monat",
                "last-3-month": "Letzte 3 Monate",
                "this-year": "Dieses Jahr",
                "last-year": "Letztes Jahr",
                custom: "Wählen Sie ein anderes Datum"
            },
            emailProvider: "E-Mail-Anbieter",
            triggerFromAnywhere: "Kann von überall aus ausgelöst werden",
            editWebhook: "Webhook bearbeiten",
            newWebhook: "Neues Webhook",
            webhookTitle: "Webhook -Titel",
            webhookUrl: "Webhook URL",
            webhookToken: "Webhook Token",
            webhookUsername: "Webhook Benutzername",
            webhookPassword: "Webhook Passwort",
            allIntegrations: "Alle Integrationen",
            integrateYourCBwithChatWidget: "Integriert in Chatbothe Chat -Widget.",
            integrateYourCBwithChatGpt3: "Chatbot kann in GPT-4 integriert werden. GPT-4-API-Schlüssel ist erforderlich.",
            integrateYourCBwithWebHook: "Leiten Sie die Chat -Informationen zwischen Chatbot und Webdiensten einfach weiter.",
            integrateYourCBwithIntegratable: "Leicht die Chat -Informationen zwischen Chatbot und {integratable} einfach weiter weiter weiter weiterzuleiten.",
            addWebhook: "Fügen Sie Webhook hinzu",
            editBlock: "Block bearbeiten",
            moveBlock: "Verschieben",
            copyBlock: "Kopieren",
            chatbot: "Chatbot",
            addFilter: "Filter hinzufügen",
            addFilterGroup: "Filtergruppe hinzufügen",
            clearFilter: "Filter löschen",
            in: "innen",
            and: "Und",
            or: "oder",
            allStories: "Alle Geschichten",
            addBot: "Erstellen Sie einen Bot",
            testBot: "Testen Sie den Bot",
            publish: "Veröffentlichen",
            editName: "Namen bearbeiten",
            search: "Rufen Sie in Ihrer Geschichte an ...",
            typeMoreThan3Char: "Geben Sie mindestens 3 Zeichen ein",
            expand: "Erweiterung",
            expandAll: "Alle erweitern",
            noMatchingItem: "Kein passender Artikel",
            hint: "Hinweis",
            select: "Wählen",
            navigate: "Reisen",
            dismiss: "Schließen",
            choseAttribute: "Wählen Sie den Filtertyp",
            selectReply: "Wählen Sie den Antworttyp",
            preview: "Vorschau",
            draft: "Entwurf",
            lastUpdate: "Letztes Update",
            published: "Es wurde veröffentlicht",
            newStory: "Neue Geschichte",
            updateStory: "Aktualisieren Sie die Geschichte",
            storyDescription: "Geschichte Beschreibung",
            storyTitle: "Geschichtenentitel",
            deleteSingleBlock: "Einen Block löschen",
            deleteWithChildren: "Mit inneren Zweigen löschen",
            startTestFromHere: "Starten Sie den Test hier",
            copyBlockId: "Block -ID kopieren",
            gotoLiveLink: "Live-Link von hier erstellen",
            copyBlockIdSuccessfull: "Block-ID kopiert",
            collapse: "Einklappen",
            collapseAll: "Alle einklappen",
            snDelay: "{delay} Sn Delay",
            blockUpdated: "Block aktualisiert",
            addPayload: "Antwort hinzufügen",
            previewModeCaution: "Sie sehen sich momentan eine der Versionen Ihrer Geschichte vor. Sie können Änderungen im Vorschaudermodus nicht aufzeichnen!",
            enterText: "Hier schreiben ...",
            trackpad: "Trackpad",
            navigation: "Navigation",
            navigationDesc: "Bitte wählen Sie Ihren Navigationsmodus. Sie können wählen, ob Sie Rechteck- oder Mausoptionen ansehen können.",
            botSetting: "Starteinstellung",
            botSettingDesc: "Bitte bestimmen Sie das Vertrauensniveau. Dies ist ein Prozentsatz von 0 bis 100 und definiert die Genauigkeit von Chatbot -Kommentaren zu Benutzereingaben.",
            languageSettingsDesc: "Bitte stellen Sie sicher, dass die Sprache, auf die Sie antworten, die Sprache ist, die Sie bevorzugen.",
            mouse: "Maus",
            Interactions: "Interaktionen",
            Actions: "Aktionen",
            Supsis_Actions: "SUPSIS-Aktionen",
            Shopify_Actions: "Shopify-Aktionen",
            Akinon_Actions: "Akinon-Aktionen",
            IdeaSoft_Actions: "Ideasoft-Aktionen",
            START_POINT: "STARTPUNKT",
            AI_ASSISTANT: "AI ASSISTANT",
            BOT_RESPONSE: "Bots Antwort",
            AI_BOT_RESPONSE: "Künstliche Intelligenz Antwort (GPT-4o)",
            AI_CLASSIFICATION: "AI CLASSIFICATION",
            Templates: "Template Blocks",
            AI_MENU_FLOW: "AI MENU",
            OTP_WHATSAPP_FLOW: "OTP Whatsapp",
            OTP_SMS_FLOW: "OTP SMS",
            OTP_MAIL_FLOW: "OTP MAIL",
            AI_INSTAGRAM_FLOW: "AI INSTAGRAM COMMENT",
            PLATFORM_FLOW: "PLATFORM",
            DEFAULT_FALLBACK: "Standardend ansonsten",
            FILTER: "FILTER",
            addNewFilter: "Neuen Filter hinzufügen",
            FLOW: "FLUSS",
            ATTACHMENT_INPUT: "Dateieinführung",
            USER_INPUT: "BENUTZER-ANMELDUNG",
            GO_TO_STEP: "Gehen Sie zu Schritt",
            WEBHOOK: "Webhaken",
            SET_ATTRIBUTE: "Feature festlegen",
            QUESTION: "FRAGE",
            CLOSE_CHAT: "CHAT SCHLIESSEN",
            CREATE_TICKET: "TICKET ERSTELLEN",
            TRANSFER_CHAT: "CHAT ÜBERTRAGEN",
            TRANSFER_TO_CHATBOT: "AN CHATBOT WEITERLEITEN",
            TAG_CHAT: "TAG HINZUFÜGEN",
            REMOVE_TAG: "TAG ENTFERNEN",
            SET_DEPARTMENT: "ABTEILUNG FESTLEGEN",
            SEND_TRANSCRIPT: "Transkript senden",
            SEND_SMS: "SEND SMS",
            SEND_MAIL: "E-MAIL SENDEN",
            CREATE_EVENT: "EREIGNIS ERSTELLEN",
            CREATE_RESERVATION: "RESERVIERUNG ERSTELLEN",
            RESERVATION_OPEN_URL: "Reservierungs-URL öffnen",
            RESERVATION_SELECT_DAY: "Reservierungstag auswählen",
            RESERVATION_EVENT_LIST: "Reservierungsliste Besucher",
            RESERVATION_SELECT_TIME: "Reservierungszeit auswählen",
            CREATE_TASK: "AUFGABE ERSTELLEN",
            SHOPIFY_SHOW_PRODUCTS: "Shopify Produkte anzeigen",
            SHOPIFY_PRODUCT_AVAILABILITY: "Shopify Produktverfügbarkeit",
            SHOPIFY_ORDER_STATUS: "Shopify Bestellstatus",
            AKINON_SHOW_PRODUCTS: "Akinon Produkte anzeigen",
            AKINON_FIND_PRODUCT: "Akinon Produkt finden",
            AKINON_ORDER_STATUS: "Akinon Bestellstatus",
            AKINON_SELECT_ORDER: "Akinon Bestellung auswählen",
            AKINON_SELECT_SIZE: "Akinon Größe auswählen",
            AKINON_FIND_NEAREST_STOCK: "Ladenbestand anzeigen",
            AKINON_FIND_NEAREST_STORES: "Nächstgelegene Geschäfte anzeigen",
            AKINON_SHOW_DISCOUNT_CODES: "Rabattcodes anzeigen",
            IDEASOFT_SELECT_ORDER: "BESTELLUNG AUSWÄHLEN",
            IDEASOFT_ORDER_STATUS: "BESTELLSTATUS ABFRAGEN",
            IDEASOFT_GET_MEMBER_INFO: "MITGLIEDERINFO AUSFÜLLEN",
            MESSENGER_SEND_MESSAGE: "MESSENGER-NACHRICHT SENDEN",
            INSTAGRAM_SEND_MESSAGE: "INSTAGRAM-NACHRICHT SENDEN",
            INSTAGRAM_COMMENT_REPLY: "KOMMENTAR BEANTWORTEN",
            INSTAGRAM_COMMENT_DELETE: "KOMMENTAR LÖSCHEN",
            INSTAGRAM_COMMENT_SHOW: "KOMMENTAR ANZEIGEN",
            INSTAGRAM_COMMENT_HIDE: "KOMMENTAR VERBERGEN",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATE: "ALS PRIVAT ANTWORTEN",
            followingAttributesFilled: "Die folgenden Qualifikationen werden voll sein.",
            GET_LOCATION: "Standort nehmen",
            FALLBACK: "Ansonsten",
            SUCCESS: "ERFOLGREICH",
            FAILURE: "ERFOLGLOS",
            Probel_Actions: "Probelaktionen",
            PROBEL_SELECT_BRANCH: "Wählen Sie Branch",
            PROBEL_SELECT_CLINIC: "Wählen Sie Polyclinic",
            PROBEL_SELECT_DAY: "Wählen Sie einen Termin am Tag",
            PROBEL_SELECT_HOUR: "Wählen Sie eine Terminzeit",
            PROBEL_MAKE_APPOINTMENT: "Einen Termin erstellen",
            PROBEL_CANCEL_APPOINTMENT: "Termin stornieren",
            PROBEL_GET_PATIENT_TOKEN: "Patienten-Token abrufen",
            PROBEL_FILL_INFO: "MERNIS-Informationen ausfüllen",
            PROBEL_SELECT_APPOINTMENT: "Wählen Sie einen Termin",
            message: "Nachricht",
            condition: "Zustand",
            score: "Punktzahl",
            equal: "gleich",
            not_equal: "nicht gleich",
            contain: "enthält",
            not_contain: "beteiligt",
            starts_with: "Beginnt mit",
            ends_with: "endet mit",
            empty: "leer",
            longer_than: "Größer",
            shorter_than: "kürzer",
            less_than: "weniger",
            less_than_equal: "Kleiner oder gleich",
greater_than: "Größer als",
                greater_than_equal: "Größer oder gleich",
            value: "Wert",
            failures: "Erfolglos",
            email: "Email",
            name: "Name",
            username: "Nutzername",
            source: "Quelle",
            language: "Sprache",
            timezone: "Zeitzone",
            region: "Bereich",
            country: "Land",
            referrer: "Referrer",
            url: "URL",
            ip: "SEIL",
            city: "Stadt",
            lastSeen: "Zuletzt gesehen",
            userId: "Benutzer-ID",
            selectStep: "Wählen Sie Schritt",
            keywords: "Stichwort",
            userSays: "Was der Benutzer sagt",
            addKeyword: "Keyword hinzufügen",
            addUserMessage: "Benutzerpost hinzufügen",
            set: "Besonderheit",
            to: "mit",
            gender: "Geschlecht",
            go_to_failure: "Gehen Sie zum erfolglosen Antwortschritt",
            go_to_success: "Gehen Sie zum erfolgreichen Antwortschritt",
            untilFilled: "ständig",
            time1: "Einmal",
            time2: "2 mal",
            time3: "dreimal",
            time4: "4 Mal",
            time5: "5 mal",
            any: "Irgendetwas",
            anytext: "Beliebiger Text",
            anytextDescription: "Passt nur auf Wörter und Leerzeichen",
            alphanumeric: "Buchstaben und Zahlen",
            integer: "Ganze Zahl",
            no: "NEIN",
            number: "Nummer",
            phone: "Telefon",
            yes: "Ja",
            yesNo: "ja Nein",
            anyDescription: "Übereinstimmung mit allem, was nicht leer ist.",
            alphanumericDescription: "Es entspricht sowohl Buchstaben als auch Zahlen.",
            integerDescription: "Passen Sie eine ganze ganze Zahl überein.",
            noDescription: "Es entspricht nicht mit Synonymwörtern.",
            numberDescription: "Es stimmt mit sequentiellen Grundlagen überein.",
            phoneDescription: "Passen Sie die Telefonnummer an.",
            yesDescription: "Ja, es passt zu den Synonymen des Wortes.",
            yesNoDescription: "Ja und nein, dass keine Wörter mit den Synonymen der Wörter übereinstimmen.",
            emailDescription: "Passen Sie es mit E-Mail an.",
            urlDescription: "URL-Format abgleichen.",
            temperature: "Hitze",
            askWhenInvalid: "Fragen Sie, ob es ungültig ist",
            applyFilter: "Filter hinzufügen",
            notificationMessageStartSuccess: "Block",
            notificationMessageEndSuccess: "Hinzugefügt",
            notificationMessageStartError: "Es ist ein Fehler aufgetreten, Block",
            notificationMessageEndError: "konnte nicht hinzugefügt werden",
            blockChangedWannaUpdate: "Möchten Sie das Update speichern?",
            TEXT: "Schreiben",
            IMAGE: "Bild",
            GALLERY: "Galerie",
            BUTTON: "Taste",
            RANDOM_TEXT: "Willkürlich",
            QUICK_REPLY: "Schnelle Antwort",
            FILE: "Datei",
            responses: "Reaktionen",
            flow: "Fluss",
            active: "Aktiv",
            passive: "Passiv",
            chooseAttributeType: "Wählen Sie den Funktionstyp",
            imageAttachment: "Bild hinzuzufügen",
            audioAttachment: "Klang",
            videoAttachment: "Video hinzufügen",
            documentAttachment: "Hinzufügen von Dokument",
            anyAttachment: "Irgendwelche zusätzlichen",
            typeAttributeValue: "Geben Sie den Funktionswert ein",
            typeSearchValue: "Schreiben Sie den Suchwert",
            male: "Männlich",
            addAttribute: "Feature hinzufügen",
            addAttributeDescription: "Der Name des Attributs kann nur A-Z-Buchstaben, 0-9 Zahlen und Alphaysalzeichen mit Reifen oder unterer Linie enthalten.",
            USER_DATA: "Nutzerinformation",
            CUSTOM_ATTRIBUTES: "Besondere Attribute",
            enterBotResponseHere: "Schreiben Sie die Frage, die Bot hier stellen wird ...",
            enterPrivateBotResponseHere: "Geben Sie die private Nachricht ein, die der Bot senden wird ...",
            addCard: "Karte hinzufügen",
            addButton: "Taste hinzufügen",
            typeCardTitle: "Kartenkopf",
            typeCardDescription: "Kartenabrechnung",
            dragAndDropBrowse: "Laden Sie ein Bild hoch",
            dragAndDropBrowseFile: "Datei hochladen",
            button: "Taste",
            enterYourMessage: "Gib deine Nachricht ein",
            imageView: "Bildansicht",
            imageUploading: "Das Bild lädt ...",
            fileUploading: "Datei hochladen ...",
            clickToChooseNewImage: "Klicken Sie hier, um ein neues Bild auszuwählen",
            clickToChooseNewFile: "Klicken Sie hier, um eine neue Datei auszuwählen",
            removeTheExistingOne: "Entfernen Sie, was verfügbar ist",
            validateResponseWithEntity: "Überprüfen Sie die Antwort",
            actionOnFailureInput: "Was sollte bei falscher Rechtschreibung getan werden?",
            askNextQuestion: "Die nächste Frage stellen",
            goToSuccessBlock: "Gehen Sie zum erfolgreichen Blog",
            goToFailureBlock: "Gehen Sie zum erfolglosen Block",
            saveResposeToAttribute: "Notieren Sie die Antwort",
            selectReplyType: "Wählen Sie den Antworttyp aus",
            questionVariants: "Arten von Fragen",
            systemEntities: "Definierte Verifizierungsausdrücke",
            delay: "Verzögerung",
            retrySectionTextPart: "Herr.",
            retrySectionText: "Wenn die Antwort des Benutzers ungültig ist",
            addNextQuestion: "Fügen Sie die nächste Frage hinzu",
            typeBlockTitle: "Blockkopf",
            versionHistory: "Versionsgeschichte",
            restore: "Wiederherstellen",
            versionName: "Versionsname",
            restoreModalText: "Diese Aktion stellt die ausgewählte Version wieder her. Sind Sie sicher, dass Sie diese Version wiederherstellen möchten?",
            restoreVersion: "Version wiederherstellen",
            newVersion: "Neue Version",
            synonymMustBeUnique: "Es gibt nicht mehr als ein Wort mit demselben Synonym",
            save: "Speichern",
            entries: "Eingänge",
            youHaveNoEntries: "Eingabe nicht gefunden",
            inputsCantBeEmpty: "Die Felder können nicht leer gelassen werden",
            entryNamesMustBeUnique: "Das Schlüsselwort kann nicht das gleiche sein!",
            entityNameCantBeEmpty: "Der Name des Vermögenswerts kann nicht leer gelassen werden",
            entityNameMustBeUnique: "Der Name des Vermögenswerts kann nicht der gleiche sein",
            synonyms: "Synonyme",
            title: "Stichwort",
            entryName: "Name eingeben",
            entities: "Vermögenswerte",
            entityhasbeenUpdatedSuccessfully: "Erfolgreich aufgenommen werden",
            emptyError: "Die erforderlichen Bereiche können nicht leer bleiben",
            allChats: "Alle Gespräche",
            paidChats: "Bezahlte Chats",
            busiestPeriod: "Die intensivste Zeit",
            ratingDistribution: "Bewertungsverteilung",
            allMessages: "Alle Artikel",
            avarageMessages: "Durchschnittliche Nachrichten",
            popularity: "Popularität",
            allUsers: "Alle Nutzer",
            interactionName: "Interaktionsname",
            numberOfMessage: "Anzahl der Nachrichten",
            ofAllUsersMessage: "% Alle Benutzernachrichten",
            totalData: "Gesamtdaten",
            avgData: "Durchschnittliche Daten",
            exportToCsv: "Übertragung zu CSV",
            exportToExcel: "Übertragung zu Excel",
            inMaintenance: "Im Bau",
            ADD_TO_SEGMENT: "Zum Segment hinzufügen",
            REMOVE_FROM_SEGMENT: "Aus Segment entfernen",
            users: "Benutzer",
            webhookName: "Webhook-Name",
            webHookUrl: "Webhook-URL",
            webHookToken: "Webhook-Token",
            delete: "Löschen",
            basicAuth: "Basic auth",
            requiredFieldsCannotBeLeftBlank: "Obligatorische Bereiche können nicht leer bleiben",
            yourVerificationToken: "Zeichen",
            yourWebHookName: "Ihr Webhook-Name",
            yourWebHookUrl: "Ihre Webhook-URL",
            enterKey: "Taste",
            password: "Passwort",
            headerValue: "Wert",
            saveSuccessfully: "Ihre Transaktion wurde erfolgreich aufgezeichnet.",
            urlTypeError: "Bitte füllen Sie das Feld korrekt aus (https://api.example.com/webhook)",
            gpt3: {
                apiKeyRequired: "OpenAI Chat GPT-4 API-Schlüssel ist erforderlich.",
                apiKeyDesc: "Der API-Schlüssel wird für die Chatbot- und Chat-GPT-4-Integration benötigt. Bitte geben Sie Ihren API-Schlüssel ein oder nutzen Sie den Test-API-Schlüssel. Sie können für Tests nur 20 Nachrichten verwenden.",
                getApiKey: "API-Schlüssel erhalten",
                typeApiKey: "API-Schlüssel eingeben",
                ownApiKey: "Eigenen OpenAI-API-Schlüssel verwenden",
                trialApiKey: "Test-API-Schlüssel (limitiert auf 20 Nachrichten)",
                useOurTrial: "Kostenlose Testversion nutzen",
                twentyMessages: "Sie können 20 Nachrichten kostenlos nutzen.",
                enableChatGpt3: "Chat GPT-4 aktivieren"
            },
            YouTube_Actions: "YouTube-Aktionen",
            Google_Business_Actions: "Google-Business-Aktionen",
            Google_Play_Actions: "Google-Play-Aktionen",
            App_Store_Actions: "App-Store-Aktionen",
            META_SEND_CAPI_EVENT: "CAPI-EREIGNIS SENDEN",
            META_SEND_CAPI_EVENTDesc: "Sendet Conversion-Ereignisse zur Anzeigenoptimierung über die Meta Conversions API (CAPI). Hilft dabei, die Leistung Ihrer Instagram- und Messenger-Anzeigen zu verbessern.",
            CUSTOM_BLOCK: "Benutzerdefinierter Block",
            CUSTOM_BLOCKDesc: "Führt benutzerdefinierten JavaScript-Code mit konfigurierbaren Parametern aus. Erweitern Sie Ihren Chatbot mit Blöcken aus dem Marketplace.",
            exampleOutput: "Beispielausgabe",
            outputSchema: "Ausgabeschema (JSON)",
            FEEDBACK_AI_ASSISTANTDesc: "Der Supsis-KI-Assistent ist eine intelligente Lösung zur Optimierung von Kundenservice und Geschäftsprozessen. Er bietet 24/7-Service durch automatische Beantwortung von Kundenanfragen, mehrsprachige Unterstützung und Integration mit Plattformen wie WhatsApp, Instagram und Facebook. Er erleichtert Vertrieb, Marketing und Terminplanung und bietet personalisierte Erlebnisse für höhere Kundenzufriedenheit. Der Assistent steigert Effizienz und Kosteneinsparungen und bietet Unternehmen eine moderne, effektive Kundenservice-Lösung durch schnellen und präzisen Informationsfluss.",
            INSERT_TO_SYSTEM_PROMPTDesc: "Der Block „In Systemprompt einfügen“ ermöglicht es dem Chatbot, eine Nachricht in den Systemprompt einzufügen. Die Nachricht wird an der angegebenen Position in den Systemprompt eingefügt.",
            API_REQUESTDesc: "Dieser Block definiert die Struktur und Parameter für API-Anfragen. Die API-Request-URL gibt die Zieladresse an, die Methode (GET, POST usw.) den Anfragetyp. Headers enthalten Authentifizierung und Content-Type, Body Type definiert das Datenformat, der Body die zu sendenden Daten. Die Beispielantwort zeigt ein erwartetes API-Antwortformat. Der Block erleichtert API-Integrationen und automatisiert den Datenaustausch.",
            BOT_RESPONSEDesc: "Der Block „Bot-Antwort“ verbessert die Interaktion durch Antworten mit Text, Bildern und Dateien. Er sendet Klartext (Text), zufällige Textvarianten (Zufallstext), Bilder oder Dateien. Außerdem bietet er Schaltflächen: Galerie zeigt Bilder mit Beschreibungen, Schaltfläche bietet Optionen auf allen Plattformen, Schnellantwort ermöglicht schnelle Auswahl und verschwindet nach der Auswahl. Auf der Website sind unbegrenzt viele Galerie-Buttons möglich, auf WhatsApp nur eine Karte. Auf Instagram und Messenger wird jede Galeriekarte als eigene Nachricht gesendet. Schnellantwort bietet auf Instagram und Messenger mehr als 3 Buttons oberhalb des Nachrichtenfelds.",
            TAVILY_WEB_SEARCHDesc: "Die Websuche ermöglicht das Abrufen von Informationen von verschiedenen Websites über KI-gestützte Systeme. Bei einer Suchanfrage werden die relevantesten Ergebnisse je nach Suchtiefe gescannt und bedarfsgerecht aufbereitet. Rohinhalt, Bilder und Bildbeschreibungen können einbezogen werden. Die Daten können zusammengefasst oder im Rohformat angezeigt werden. Nutzer können Suchergebnisse nach Domains filtern. KI-gestützte Websuchen optimieren so die schnelle und präzise Informationsbeschaffung.",
            AI_BOT_RESPONSEDesc: "Dieses System ermöglicht der KI, personalisierte Antworten aus Benutzereingaben und vordefinierten Anweisungen zu erzeugen; es liefert präzise Antworten über vorbereitete Vorlagen und erfasst Feedback zur Verbesserung künftiger Antworten.",
            AI_CLASSIFICATIONDesc: "Der KI-Klassifizierungsblock analysiert Benutzernachrichten und ordnet sie vordefinierten Kategorien zu, wodurch passende Aktionen ausgelöst werden. Die Klassifizierung steuert das Routing nach Inhalt, Kategorien können flexibel verwaltet werden. Klassifizierte Daten werden gefiltert, um die passendsten Aktionen auszulösen. Instagram-Nachrichten und -Kommentare können ebenfalls klassifiziert werden und automatisierte Antworten oder Aktionen auslösen.",
            DEFAULT_TIMEOUTDesc: "Der Standard-Time-out wird zu Szenariobeginn ausgelöst und hat Vorrang, wenn er kürzer als der lokale Time-out ist; für nur lokalen Time-out muss der Standard gelöscht werden. Die Time-out-Dauer darf die Sitzungsdauer nicht überschreiten; mehrere Time-outs können mit Benutzereingaben kombiniert werden. Diese Struktur wird ausgelöst, wenn keine Benutzerantwort kommt, und eignet sich für Erinnerungsnachrichten oder das Neustarten bestimmter Abläufe.",
            FILTERDesc: "Die Supsis-KI-Plattform ermöglicht Chatbots, Benutzerdaten nach angepassten Attributen, Benutzerinformationen (Name, E-Mail, Telefon, Sprache, Zeitzone, Geschlecht usw.) und Besucherprofilinformationen (Land, IP, Referrer, Besuchsadresse usw.) zu filtern. Mit „und“- und „oder“-Operatoren können komplexe Bedingungen erstellt werden, z. B. Live-Support zu Geschäftszeiten oder spezielle Antworten nach Land, Telefonnummer oder Besuchsadresse. Die Auswertung des Nutzerverhaltens ermöglicht personalisierte, schnelle und effektive Antworten und steigert so die Kundenzufriedenheit und Chatbot-Effizienz.",
            ATTACHMENT_INPUTDesc: "Der Block „Dateieingabe“ speichert vom Benutzer empfangene Dateien sicher und erzeugt eine herunterladbare URL, die z. B. per E-Mail oder WhatsApp geteilt werden kann. Dateien können nur in einer definierten Dateieingabe gesendet werden; sonst leitet das System zum lokalen oder Standard-„Sonst“-Ablauf weiter. Bilder, Audio, Video, Dokumente und andere Anhänge werden unterstützt; das System startet automatisch den passenden Prozess und leitet bei Bedarf an zuständige Einheiten weiter.",
            USER_INPUTDesc: "Der Block „Benutzereingabe“ verarbeitet, validiert und speichert Benutzerdaten und löst passende Aktionen aus. Globale Schlüsselwörter gelten überall, lokale nur in bestimmten Schritten. Eingaben können per Regex validiert und im Benutzerprofil gespeichert werden. Das Konfidenzniveau steuert die Chatbot-Reaktion. Mit „Zum Block“ und „Nachricht senden“ können Nutzer zu bestimmten Schritten geführt oder mit dem Chatbot interagieren. So lassen sich Benutzerinteraktionen effizienter steuern.",
            GO_TO_STEPDesc: "Die Aktion „Zum Schritt“ leitet Chatbot-Nutzer zu vordefinierten Schritten. Dynamisches Routing sorgt für den richtigen Ablauf je nach Anfrage oder ausgelöster Aktion. Blocknamen können bearbeitet werden, sodass der Ablauf verständlich und Verbindungen leicht verwaltbar sind. Die Aktion „Zum Schritt“ eignet sich besonders für Übergänge in komplexen Abläufen. Der Schaltflächentyp „Zum Block“ leitet beim Klick auf die Schaltfläche zu einem vordefinierten Block; die Auswahl legt den Zielblock fest und optimiert die Nutzererfahrung.",
            WEBHOOKDesc: "Die Webhook-Aktion ermöglicht den Datenaustausch zwischen Chatbot und externen Systemen. Der Benutzerablauf wird nach erfolgreichen und fehlgeschlagenen Szenarien gesteuert. Bei Erfolg geht der Ablauf nach erfolgreichem Versand weiter; bei Fehler wird eine Fehlermeldung angezeigt und der Nutzer weitergeleitet. Webhook-Integration ermöglicht Interaktion und Datenaustausch mit externen Systemen und erhöht die Flexibilität des Chatbots. Für die Integration sind Anpassungen gemäß der API-Dokumentation des Systems nötig.",
            SET_ATTRIBUTEDesc: "Der Block „Attribut setzen“ speichert von Benutzern empfangene Daten in der Profilkarte und unterscheidet statische, dynamische und spezielle Daten. Statisch = feste Werte, dynamisch = sich ändernde Informationen aus Benutzereingaben, speziell = zufällig erzeugte Werte (z. B. Zufallszahlen oder OTP). Profil- und Besucherinformationen werden während der Interaktion erfasst und für künftige Interaktionen bereitgehalten. Der Block unterstützt die Nutzerverwaltung und personalisierte, präzisere Antworten.",
            ASSIGN_OWNERDesc: "Der Block „Eigentümer zuweisen“ weist einen laufenden Chat per Chatbot einem ausgewählten Vertreter zu. Der Zuweisungsalgorithmus wählt den passendsten Vertreter anhand der Kontaktanzahl und optionaler Zeiträume. Zuweisungen können nur an online Vertreter erfolgen; bestimmte Vertreter können ausgeschlossen werden. Die Zuweisung wird mit Zoho CRM synchronisiert und die Daten des zugewiesenen Vertreters im CRM gespeichert, um den Kundensupport effizienter zu steuern.",
            QUESTIONDesc: "Der Block „Frage“ lässt den Chatbot Fragen stellen und Antworten validieren und verarbeiten. Bei richtiger Antwort wird das Erfolgsszenario ausgelöst und der Ablauf fortgesetzt. Bei falscher Antwort wird das Fehlerszenario ausgelöst und der Nutzer erhält eine weitere Chance. Antworten werden anhand von Validierungsparametern geprüft; korrekte Daten werden in der Profilkarte gespeichert (z. B. E-Mail-Format). Bei falschen Antworten kann der Nutzer korrigieren. So wird die Interaktion personalisierter und genauer.",
            TRANSFER_TO_CHATBOTDesc: "Der Block „An Chatbot übertragen“ leitet den Nutzer zu einem anderen, vordefinierten Chatbot-Ablauf und ermöglicht eine personalisierte Erfahrung. Nutzer wechseln zwischen Abläufen und werden bedarfsgerecht zum richtigen Szenario geführt. Die Szenarioauswahl nutzt Filter und Tags, damit Nutzer anhand ihrer Attribute dem richtigen Ablauf zugeordnet werden. So sind flexible und dynamische Reaktionen auf Nutzeranfragen möglich.",
            TAG_CHATDesc: "Der Block „Tag hinzufügen“ fügt Profilen anhand der Nutzerinteraktion Tags hinzu und ermöglicht Segmentierung und Chatbot-Filterung. Benutzereingaben werden ausgewertet, um zur richtigen Abteilung zu leiten und bei Bedarf an einen Vertreter zu übergeben. Tags optimieren Kundensupport- und Vertriebsprozesse.",
            REMOVE_TAGDesc: "Der Block „Tag entfernen“ entfernt überflüssige oder veraltete Tags aus Benutzerprofilen, damit Chatbot-Auswertungen aktuell und genau bleiben. Tags werden automatisch bereinigt; Segmentierung und Datenverwaltung werden effizienter.",
            SET_DEPARTMENTDesc: "Der Block „Abteilung setzen“ leitet Nutzer automatisch oder manuell anhand ihres Bedarfs zur richtigen Abteilung. Die Abteilung wird aus Benutzerauswahl oder Systemdaten ermittelt; für die Segmentierung werden Tags gesetzt und bei Bedarf an einen Vertreter übergeben.",
            SEND_TRANSCRIPTDesc: "Der Block „Transkript senden“ sendet automatisch eine Chat-Aufzeichnung mit dem Nutzer an eine angegebene E-Mail-Adresse und unterstützt Support und Auswertung. Das Transkript kann an die E-Mail der Profilkarte oder eine manuell eingegebene Adresse gesendet werden.",
            SEND_SMSDesc: "Der Block „SMS senden“ ermöglicht den Versand automatisierter und personalisierter Nachrichten über die Supsis-Integration mit Postacell oder einem anderen SMS-Anbieter. Der Inhalt wird dynamisch aus der Telefonnummer der Profilkarte und Systemdaten erzeugt. Für Integration und weitere Informationen: Live-Support oder info@supsis.com.",
            SEND_MAILDesc: "Der Block „E-Mail senden“ ermöglicht automatischen E-Mail-Versand mit über den Chatbot gesammelten Informationen. Der Inhalt kann anhand von Profilkarten-Attributen personalisiert werden; Betreff und Inhalt sind dynamisch anpassbar. Automatische Benachrichtigungen können an Nutzer und zuständige Teams für Supportanfragen gesendet werden. Das Supsis-E-Mail-Modul bindet sich in bestehende E-Mail-Infrastrukturen ein.",
            CREATE_EVENTDesc: "Der Block „Ereignis erstellen“ fügt über den Chatbot automatisch Termine in die Kalender der Nutzer ein. Titel, Beschreibung und Dauer werden aus den Profildaten übernommen; Eigentümer und weitere Vertreter können zugewiesen werden. Teilnehmer werden automatisch benachrichtigt; die Verwaltung erfolgt über Kalender-Integrationen (Google Calendar, Microsoft Teams) und optimiert die Zeitplanung.",
            CREATE_RESERVATIONDesc: "Der Block „Reservierung erstellen“ startet automatisch einen Reservierungsprozess mit Attributen aus der Profilkarte oder manuell eingegebenen Formulardaten. Profilinformationen wie E-Mail werden für Kalendertermine genutzt. Der Block bündelt die über das Reservierungsformular eingehenden Daten durch Zusammenarbeit mit anderen Blöcken und startet die Reservierung schnell und personalisiert.",
            RESERVATION_OPEN_URLDesc: "Der Block „Reservierungsansicht“ listet über einen vordefinierten Reservierungskalender verfügbare Termine für den Nutzer. Auf dem Bildschirm werden die verfügbaren Termine angezeigt. Die Termindauer kann aus vordefinierten Optionen (z. B. 5, 15, 30 Minuten) gewählt werden. Diese Funktion gilt nur für Website-Chatbots und bietet komfortable Reservierungsoptionen.",
            RESERVATION_SELECT_DAYDesc: "Der Block „Reservierungstag wählen“ bietet eine Auswahl wöchentlicher Reservierungstage; der gewählte Tag wird im System gespeichert. Relevante Daten werden aus den Profilkarten-Attributen geladen. Der Block steuert den Nutzer per Schaltflächen zum passenden Reservierungstag; der Ablauf ist personalisiert und mit dem Ereigniskalender verknüpft.",
            RESERVATION_EVENT_LISTDesc: "Die Kunden-Reservierungsliste zeigt schnell und übersichtlich Reservierungsdaten zu der E-Mail-Adresse des Nutzers. Über die E-Mail des Kunden werden alle zugehörigen Reservierungen aufgelistet.",
            RESERVATION_SELECT_TIMEDesc: "Der Block „Reservierungszeit wählen“ bietet für den gewählten Reservierungstag verfügbare Zeiten. Der Nutzer wählt eine passende Zeit aus den Optionen. Die Zeiten basieren auf den Daten des Blocks „Reservierungstag wählen“. Die gewählte Zeit wird gespeichert und mit Profilinformationen und Attributen verknüpft.",
            CREATE_TASKDesc: "Der Block „Aufgabe erstellen“ fügt dem Aufgabenmodul automatisch oder manuell Aufgaben basierend auf Nutzeranfragen hinzu. Titel, Beschreibung, Dringlichkeit, Workflow und Pipeline (Spalte) werden festgelegt und Vertretern zugewiesen. Personalisierte Aufgaben aus der Profilkarte werden per System- und E-Mail-Benachrichtigung gemeldet. Integrationen mit Google Calendar und Microsoft Teams erleichtern die Nachverfolgung. Z. B. erstellt der Chatbot bei einer Kundenanfrage nach weiteren Informationen automatisch eine Aufgabe in der Spalte „Kontakt erwartet“ des Vertriebsprozesses und benachrichtigt den zuständigen Vertreter.",
            GET_LOCATIONDesc: "Das Modul „Standort abrufen“ erfasst geografische Standortdaten der Nutzer. Bei der Anfrage wird eine spezielle Meldung angezeigt; Breiten- und Längengrad werden in der Profilkarte gespeichert. Der Nutzer kann den Standort manuell per Adresseingabe oder Karte angeben. Besonders nützlich im E-Commerce, in Logistik und Zustellung für eine personalisierte Nutzererfahrung, z. B. zur Erfassung einer Lieferadresse.",
            SUPPRESSION_ADDDesc: "Der Block „Sperre“ sperrt einen Nutzer auf einer gewählten Plattform (WhatsApp, Web-Besucher, Instagram, Messenger). Der zu sperrende Wert kann aus Attributen geladen oder manuell eingegeben werden. Die Sperre kann für eingehend (Empfang), ausgehend (Versand) oder beides gelten. Z. B.: Plattform WhatsApp wählen, Telefonnummer angeben und eingehende sowie ausgehende Sperre aktivieren.",
            SUPPRESSION_REMOVEDesc: "Der Block „Sperre aufheben“ entsperrt einen zuvor gesperrten Nutzer auf einer Plattform (WhatsApp, Web, Instagram usw.) anhand des Sperrwertes (z. B. Telefonnummer, Benutzer-ID). Der Wert kann aus den Profilkarten-Attributen geladen werden, sodass die Entsperrung schnell und automatisch erfolgen kann.",
            SEND_WP_BUSINESS_MESSAGEDesc: "Der Block „WhatsApp-Nachricht senden“ ermöglicht personalisierte Nachrichten über die WhatsApp Business API. Beim Auslösen wird eine Nachricht über den WhatsApp-Kanal mit einer vordefinierten Vorlage gesendet. Der Inhalt kann aus Profilkarten-Attributen und manuellen Eingaben personalisiert werden. Die Nummer kann manuell eingegeben oder aus Benutzerdaten übernommen werden. Vorlagen sind genehmigte Formate der API; bestehende können gewählt oder neue erstellt werden. Variablen in der Vorlage ermöglichen personalisierte Nachrichten. Medien (JPEG, PNG usw.) können angehängt werden. Der Block eignet sich für Kampagnen, Supportanfragen oder Sonderbenachrichtigungen.",
            MESSENGER_SEND_MESSAGEDesc: "Dieser Block ermöglicht dem Chatbot, Nachrichten über Messenger zu senden. Der Chatbot kann Text-, Bild- oder andere Mediennachrichten an einen bestimmten Empfänger senden.",
            INSTAGRAM_SEND_MESSAGEDesc: "Dieser Block ermöglicht dem Chatbot, Direktnachrichten über Instagram zu senden. Der Chatbot kann Text- oder Mediennachrichten an einen bestimmten Nutzer senden.",
            INSTAGRAM_COMMENT_REPLYDesc: "Dieser Block dient dazu, auf einen Kommentar zu einem Instagram-Beitrag zu antworten. Der Chatbot kann auf einen bestimmten Kommentar reagieren.",
            INSTAGRAM_COMMENT_DELETEDesc: "Dieser Block löscht einen Kommentar zu einem Instagram-Beitrag. Der Chatbot kann unerwünschte oder unangemessene Kommentare entfernen.",
            INSTAGRAM_COMMENT_SHOWDesc: "Dieser Block dient dazu, einen Kommentar zu einem Instagram-Beitrag anzuzeigen. Der Chatbot kann einen bestimmten Kommentar und die Meinungen anderer Nutzer einsehen.",
            INSTAGRAM_COMMENT_HIDEDesc: "Dieser Block blendet einen Kommentar zu einem Instagram-Beitrag aus. Der Chatbot kann einen Kommentar unsichtbar machen, sodass Follower ihn nicht sehen.",
            INSTAGRAM_COMMENT_REPLY_AS_PRIVATEDesc: "Dieser Block antwortet auf einen Kommentar zu einem Instagram-Beitrag per privater Nachricht (DM). Der Chatbot kann dem Kommentator privat antworten und so eine persönlichere Kommunikation herstellen.",
            TABLE_CREATE_RECORDDesc: "Dieser Block fügt der gewählten Tabelle einen neuen Datensatz hinzu. Aus Benutzerangaben oder anderen Systemattributen wird ein neuer Datensatz erstellt und in die Tabelle eingetragen, z. B. für neue Kunden- oder Produktdaten.",
            TABLE_DELETE_RECORDDesc: "Dieser Block löscht einen Datensatz aus der Tabelle. Wenn ein nicht mehr gültiger oder fehlerhafter Datensatz entfernt werden soll, wird dieser Block ausgeführt. Der gelöschte Datensatz wird endgültig entfernt und kann nicht wiederhergestellt werden, z. B. bei Kunden- oder ungültigen Bestelldatensätzen.",
            TABLE_UPDATE_RECORDDesc: "Dieser Block aktualisiert den Inhalt eines Datensatzes in der Tabelle. Wenn bestehende Informationen geändert werden sollen (z. B. Kundenadresse oder Produktpreis), wird dieser Block verwendet. Nur der angegebene Datensatz wird geändert; andere Datensätze bleiben unberührt.",
            TABLE_FIND_RECORDDesc: "Dieser Block sucht einen bestimmten Datensatz in der Tabelle. Wenn nach konkreten Daten (z. B. Benutzername oder Produkt-ID) gesucht werden soll, wird dieser Block verwendet, um schnell den passenden Datensatz zu finden.",
            TABLE_FIND_RECORDSDesc: "Dieser Block zeigt dem Nutzer vorhandene Datensätze in der Tabelle an. Wenn alle oder nach Kriterien gefilterte Datensätze angezeigt werden sollen, wird dieser Block verwendet; die Anzeige kann Sortierung und Filterung umfassen.",
            ADD_TO_SEGMENTDesc: "Die Aktion „Zu Segment hinzufügen“ fügt Nutzer nach bestimmten Schritten definierten Segmenten hinzu. So lässt sich das Nutzerverhalten in Segmenten auswerten und individuelle Berichte erstellen. Nutzer werden über die Segmentauswahl den passenden Segmenten zugeordnet; neue Segmenten können im Chatbot-Menü angelegt werden. Z. B. wird bei einer VIP-Kampagnenanfrage der Nutzer dem VIP-Segment hinzugefügt. Segmentberichte zeigen, welchen Segmenten Nutzer zugeordnet wurden und ihre Anfragen.",
            REMOVE_FROM_SEGMENTDesc: "Die Aktion „Aus Segment entfernen“ entfernt Nutzer aus bestimmten Segmenten. So werden Segmenten aktualisiert und die Auswertung pro Segment genauer. Nach Auswahl des zu entfernenden Segmentes werden Nutzer automatisch aus dem Segment entfernt. Über die Berichte können Segmentänderungen und Nutzerverhalten nachverfolgt werden.",
            Messaging_Actions: "Nachrichten-Aktionen",
            exportDiagram: "Diagramm exportieren",
            exportDiagramDescription: "Wählen Sie die zu exportierenden Komponenten. Die Daten werden in die Zwischenablage kopiert und können in ein anderes Szenario importiert werden.",
            diagram: "Diagramm",
            diagramExportDesc: "Chatbot-Ablaufdiagramm (erforderlich)",
            aiSettings: "KI-Einstellungen",
            aiSettingsExportDesc: "KI-Modell-Einstellungen, Prompt und Parameter",
            aiFunctionsExportDesc: "KI-Funktionen zum Export auswählen",
            knowledgeBase: "Wissensdatenbank",
            knowledgeBaseExportDesc: "Wissensdatenbank-Typen zum Export auswählen",
            webPages: "Webseiten",
            noKnowledgeBase: "Keine Wissensdatenbank zum Export gefunden",
            exportToClipboard: "In Zwischenablage kopieren",
            exportSuccess: "Szenario erfolgreich in die Zwischenablage kopiert",
            exportError: "Beim Export ist ein Fehler aufgetreten",
            exportDataFetchError: "Fehler beim Abrufen der Exportdaten",
            model: "Modell",
            topP: "Top P",
            toolChoice: "Tool-Auswahl",
            prompt: "Prompt",
            B2Cargo_Actions: "B2Cargo-Aktionen",
            Holiday_Plus_Actions: "Holiday+-Aktionen",
            HOLIDAY_PLUS_GET_ROOMS: "ZIMMER AUFLISTEN",
            HOLIDAY_PLUS_GET_HOTELS: "HOTELS AUFLISTEN",
            ZOHO_CREATE_RECORD: "Zoho-Datensatz erstellen",
            B2CARGO_LOGIN_USER: "Benutzeranmeldung",
            B2CARGO_PRODUCT_STATUS: "Produktstatus",
            createNewBlock: "Neuen Block erstellen",
            marketplace: "Marketplace",
            myBlocks: "Meine Blöcke",
            importedBlocks: "Importierte Blöcke",
            pendingApproval: "Ausstehende Freigabe",
            utility: "Dienstprogramm",
            dataTransform: "Datenumwandlung",
            custom: "Benutzerdefiniert",
            mostUsed: "Am häufigsten verwendet",
            topRated: "Bestbewertet",
            newest: "Neueste",
            uses: "Verwendungen",
            import: "Importieren",
            imported: "Importiert",
            pending: "Ausstehend",
            approved: "Genehmigt",
            rejected: "Abgelehnt",
            unlist: "Aus Liste entfernen",
            confirmDeleteBlock: "Sind Sie sicher, dass Sie diesen Block löschen möchten?",
            noBlocksCreated: "Noch keine Blöcke erstellt",
            enterChangelog: "Changelog eingeben (optional)",
            publishBlock: "Block veröffentlichen",
            blockPublished: "Block erfolgreich veröffentlicht",
            blockUnlisted: "Block erfolgreich aus der Liste entfernt",
            blockDeleted: "Block erfolgreich gelöscht",
            cannotDeleteActiveBlock: "Block mit aktiver Nutzung kann nicht gelöscht werden",
            noImportedBlocks: "Keine importierten Blöcke",
            confirmRemoveImport: "Sind Sie sicher, dass Sie diesen Import entfernen möchten?",
            remove: "Entfernen",
            importRemoved: "Import erfolgreich entfernt",
            creator: "Ersteller",
            viewDetails: "Details anzeigen",
            approve: "Genehmigen",
            reject: "Ablehnen",
            noPendingBlocks: "Keine ausstehenden Blöcke",
            enterRejectionReason: "Ablehnungsgrund eingeben",
            rejectBlock: "Block ablehnen",
            blockApproved: "Block erfolgreich genehmigt",
            blockRejected: "Block erfolgreich abgelehnt",
            blockImported: "Block erfolgreich importiert",
            parameters: "Parameter",
            noParameters: "Keine Parameter erforderlich",
            ratings: "Bewertungen",
            writeReview: "Bewertung schreiben...",
            selectOrTypeCategory: "Kategorie auswählen oder eingeben",
            changelogPlaceholder: "Changelog eingeben (optional)",
            category: "Kategorie",
            description: "Beschreibung",
            tags: "Tags",
            submitRating: "Bewertung absenden",
            noRatings: "Noch keine Bewertungen",
            latest: "Neueste",
            pinned: "Angeheftet",
            createBlock: "Block erstellen",
            basicInfo: "Grundinformationen",
            blockName: "Blockname",
            enterBlockName: "Blocknamen eingeben",
            enterDescription: "Beschreibung eingeben",
            icon: "Symbol",
            addTags: "Tags hinzufügen",
            javascriptCode: "JavaScript-Code",
            addParameter: "Parameter hinzufügen",
            parameterName: "Parametername (Variable)",
            parameterLabel: "Anzeigebezeichnung",
            parameterDescription: "Beschreibung (Hilfetext)",
            defaultValue: "Standardwert",
            allowAutoUpdate: "Ausgabeschema bei Ausführung automatisch aktualisieren",
            visibility: "Sichtbarkeit",
            allowedSiteIds: "Erlaubte Standort-IDs",
            enterSiteIds: "Standort-IDs eingeben",
            saveDraft: "Entwurf speichern",
            fillRequired: "Bitte erforderliche Felder ausfüllen",
            blockCreated: "Block erstellt",
            selectCustomBlock: "Benutzerdefinierten Block auswählen",
            selectCustomBlockDesc: "Wählen Sie einen benutzerdefinierten Block aus Ihren importierten Blöcken",
            outputPreview: "Ausgabevorschau",
            blockNotFound: "Block nicht gefunden",
            pleaseSelectRating: "Bitte eine Bewertung auswählen",
            ratingSubmitted: "Bewertung abgesendet",
            plans: "Pläne",
            chatBotPlans: "Chatbot-Pläne",
            FEEDBACK_AI_ASSISTANT: "KI-ASSISTENTEN-FEEDBACK",
            INSERT_TO_SYSTEM_PROMPT: "IN SYSTEMPROMPT EINFÜGEN",
            API_REQUEST: "API-ANFRAGE",
            AI_CALL: "KI-ANRUF",
            TAVILY_WEB_SEARCH: "WEBSUCHE",
            OPENAI_WEB_SEARCH: "WEBSUCHE (OPENAI)",
            RUN_JAVASCRIPT: "JAVASCRIPT AUSFÜHREN",
            DEFAULT_TIMEOUT: "STANDARD-TIMEOUT",
            AI_FUNCTIONS: "KI-FUNKTIONEN",
            ASSIGN_OWNER: "Eigentümer zuweisen",
            CACHE_WRITE: "CACHE WRITE",
            CACHE_READ: "CACHE READ",
            CACHE_EXTEND: "CACHE EXTEND",
            CACHE_DELETE: "CACHE DELETE",
            YOUTUBE_REPLY_COMMENT: "YOUTUBE REPLY COMMENT",
            YOUTUBE_UPDATE_COMMENT_STATUS: "YOUTUBE UPDATE COMMENT STATUS",
            YOUTUBE_SET_MODERATION_STATUS: "YOUTUBE SET MODERATION STATUS",
            GOOGLE_BUSINESS_REPLY_REVIEW: "GOOGLE BUSINESS REPLY REVIEW",
            GOOGLE_BUSINESS_UPDATE_REVIEW_STATUS: "GOOGLE BUSINESS UPDATE REVIEW STATUS",
            GOOGLE_PLAY_REPLY_REVIEW: "GOOGLE PLAY REPLY REVIEW",
            GOOGLE_PLAY_UPDATE_REVIEW_STATUS: "GOOGLE PLAY UPDATE REVIEW STATUS",
            APP_STORE_REPLY_REVIEW: "APP STORE REPLY REVIEW",
            APP_STORE_UPDATE_REVIEW_STATUS: "APP STORE UPDATE REVIEW STATUS",
            APP_STORE_DELETE_REVIEW_RESPONSE: "APP STORE DELETE REVIEW RESPONSE",
            TIMEOUT: "TIMEOUT",
            SUPPRESSION_ADD: "BLOCK CONTACT",
            SUPPRESSION_REMOVE: "UNBLOCK CONTACT",
            SEND_WP_BUSINESS_MESSAGE: "SEND WHATSAPP MESSAGE",
            TABLE_CREATE_RECORD: "Datensatz erstellen",
            TABLE_DELETE_RECORD: "Datensatz löschen",
            TABLE_UPDATE_RECORD: "Datensatz aktualisieren",
            TABLE_FIND_RECORD: "Datensatz finden",
            TABLE_FIND_RECORDS: "Datensätze finden",
            OPENAI_WEB_SEARCHDesc: "Die Websuche ermöglicht das Abrufen von Informationen von verschiedenen Websites über KI-gestützte Systeme. Bei einer Suchanfrage werden die relevantesten Ergebnisse je nach Suchtiefe gescannt und bedarfsgerecht aufbereitet. Rohinhalt, Bilder und Bildbeschreibungen können einbezogen werden. Die Daten können zusammengefasst oder im Rohformat angezeigt werden. Nutzer können Suchergebnisse nach Domains filtern. KI-gestützte Websuchen optimieren die schnelle und präzise Informationsbeschaffung.",
            TICKET_UPDATE: "TICKET AKTUALISIEREN",
            b2cargo_login_user: "Benutzeranmeldung",
            b2cargo_product_status: "Produktstatus",
            cardInfos: "Karteninformationen",
            ficheros: "Dateien",
            file: "Datei",
            fileCancellato: "Datei gelöscht",
            impostazioni: "Einstellungen",
            risposta: "Antwort",
            setUpUpYourChatbot: "Richten Sie Ihren Chatbot ein",
            setUpUpYourChatbotDesc: "Trainieren Sie Ihren Chatbot mit Daten, nutzen Sie unsere Vorlagen oder starten Sie von Grund auf.",
            yourNeedEnterEnterYourOpenAi: "Sie müssen Ihren OpenAI-API-Schlüssel eingeben, um einen Chatbot durch Crawling Ihrer Website zu erstellen."
        },
        coupon: {
            code: "Code",
            discount: "Rabatt",
            endDate: "Endtermin",
            name: "Name",
            email: "Email",
            phone: "Telefon",
            add: "Gutschein hinzufügen",
            coupons: "Gutscheine",
            couponDeleted: "Gutschein gelöscht",
            limit: "Grenze",
            visitorBan: "Besucher wurde gesperrt.",
            visitorUnBlock: "Sperrung aufgehoben."
        },
        instagramTitle: "Klicken Sie auf die Schaltfläche unten, um die Instagram-Funktionen zu aktivieren.",
        instegramFunctionActive: "Aktivieren Sie die Instagram Funktion",
        ChatBOT: "Chat-Bot",
        WhatsappContacts: "WhatsApp Kontakte",
        InstagramContacts: "Instagram Kontakte",
        MessengerContacts: "Messenger-Kontakte",
        volumeUp: "Lautstärke",
        minimize: "Schrumpfen",
        maximize: "Erweiterung",
        auditLogs: {
            auditLogsTitle: "Audit-Logs",
            auditLogsSub: "Audit-Logs ermöglichen es Ihnen, Ereignisse zu verfolgen, die in Ihrem Unternehmen in den letzten 30 Tagen stattgefunden haben.",
            actor: "Akteur",
            actorSelect: "Akteur auswählen",
            actorSystem: "System (Supsis Ai)",
            actorChatbot: "Chatbot",
            actorApi: "API",
            actorVisitor: "Beliebiger Besucher",
            actorAgent: "Beliebiger Agent",
            adminUserSuffix: "(Admin-Benutzer)",
            activityType: {
                blocked: "Blockiert",
                unblocked: "Entsperrt",
                "chat-opened": "Chat geöffnet",
                "chat-closed": "Chat geschlossen",
                "chat-rating": "Chat bewertet",
                "chat-assigned-to-user": "Chat Benutzer zugewiesen",
                "chat-forwarded-to-user": "Chat an Benutzer weitergeleitet",
                "contact-owner-updated": "Kontakteigentümer aktualisiert",
                "user-joined-to-chat": "Benutzer ist Chat beigetreten",
                "ticket-assigned-to-user": "Ticket Benutzer zugewiesen",
                online: "Online",
                offline: "Offline",
                "page-changed": "Seite geändert",
                "create-ticket": "Ticket erstellt",
                "video-calling-started": "Videoanruf gestartet",
                "video-calling-closed": "Videoanruf beendet",
                "voice-calling-started": "Sprachanruf gestartet",
                "voice-calling-closed": "Sprachanruf beendet",
                "visitor-tag-added": "Besucher-Tag hinzugefügt",
                "visitor-tag-removed": "Besucher-Tag entfernt",
                "note-created": "Notiz erstellt",
                "note-updated": "Notiz aktualisiert",
                "visitor-profile-updated": "Besucherprofil aktualisiert",
                "user-added": "Benutzer hinzugefügt",
                "user-removed": "Benutzer entfernt",
                "user-status-changed": "Benutzerstatus geändert",
                "user-logged-in": "Benutzer angemeldet",
                "user-added-to-department": "Benutzer zu Abteilung hinzugefügt",
                "user-removed-from-depart": "Benutzer aus Abteilung entfernt",
                "user-role-changed": "Benutzerrolle geändert",
                "user-password-changed": "Benutzerpasswort geändert",
                "user-email-changed": "Benutzer-E-Mail geändert",
                "user-name-changed": "Benutzername geändert",
                "user-phone-changed": "Benutzertelefon geändert",
                "user-disabled": "Benutzer deaktiviert",
                "user-enabled": "Benutzer aktiviert",
                "settings-updated": "Einstellungen aktualisiert",
                "whatsapp-broadcast-created": "WhatsApp-Rundnachricht erstellt",
                "whatsapp-broadcast-completed": "WhatsApp-Rundnachricht abgeschlossen",
                "whatsapp-broadcast-canceled": "WhatsApp-Rundnachricht abgebrochen",
                "whatsapp-broadcast-failed": "WhatsApp-Rundnachricht fehlgeschlagen",
                "whatsapp-v1-bot-state-changed": "WhatsApp v1 Bot-Status geändert",
                "whatsapp-v2-bot-state-changed": "WhatsApp v2 Bot-Status geändert",
                "channel-created": "Kanal erstellt",
                "channel-removed": "Kanal entfernt",
                "channel-visibility-changed": "Kanalsichtbarkeit geändert",
                "channel-zoho-config-updated": "Kanal-Zoho-Konfiguration aktualisiert",
                "channel-forward-config-updated": "Kanal-Weiterleitungskonfiguration aktualisiert",
                "login-form-activated": "Anmeldeformular aktiviert",
                "login-form-deactivated": "Anmeldeformular deaktiviert",
                "login-form-updated": "Anmeldeformular aktualisiert",
                "chatbot-created": "Chatbot erstellt",
                "chatbot-deleted": "Chatbot gelöscht",
                "chatbot-restored": "Chatbot aus Papierkorb wiederhergestellt",
                "chatbot-published": "Chatbot veröffentlicht",
                "chatbot-webhook-added": "Chatbot-Webhook hinzugefügt",
                "chatbot-webhook-removed": "Chatbot-Webhook entfernt",
                "banned-word-added": "Verbotenes Wort hinzugefügt",
                "banned-word-removed": "Verbotenes Wort entfernt",
                "mail-address-added": "E-Mail-Adresse hinzugefügt",
                "mail-address-removed": "E-Mail-Adresse entfernt",
                "mail-was-sent": "E-Mail gesendet",
                "content-added": "Inhalt hinzugefügt",
                "content-removed": "Inhalt entfernt",
                "role-added": "Rolle hinzugefügt",
                "role-removed": "Rolle entfernt",
                "role-updated": "Rolle aktualisiert",
                "department-added": "Abteilung hinzugefügt",
                "department-removed": "Abteilung entfernt",
                "tags-added": "Tags hinzugefügt",
                "tags-removed": "Tags entfernt",
                "trigger-added": "Trigger hinzugefügt",
                "trigger-removed": "Trigger entfernt",
                "trigger-updated": "Trigger aktualisiert",
                "welcome-message-added": "Willkommensnachricht hinzugefügt",
                "welcome-message-removed": "Willkommensnachricht entfernt",
                "customer-group-added": "Kundengruppe hinzugefügt",
                "customer-group-removed": "Kundengruppe entfernt",
                "customer-group-updated": "Kundengruppe aktualisiert",
                "webhook-added": "Webhook hinzugefügt",
                "webhook-removed": "Webhook entfernt",
                "webhook-updated": "Webhook aktualisiert",
                "contact-prop-added": "Kontakteigenschaft hinzugefügt",
                "contact-prop-removed": "Kontakteigenschaft entfernt",
                "invoice-created": "Rechnung erstellt",
                "invoice-updated": "Rechnung aktualisiert",
                "invoice-payment-received": "Rechnungszahlung erhalten",
                "invoice-payment-failed": "Rechnungszahlung fehlgeschlagen",
                "invoice-refunded": "Rechnung erstattet",
                "invoice-deleted": "Rechnung gelöscht",
                "payment-method-added": "Zahlungsmethode hinzugefügt",
                "billing-address-updated": "Rechnungsadresse aktualisiert",
                "plan-started": "Plan gestartet",
                "plan-canceled": "Plan gekündigt",
                "task-workflow-created": "Task workflow created",
                "task-workflow-deleted": "Task workflow deleted",
                "task-workflow-restored": "Task workflow restored from trash",
                "task-workflow-permanently-deleted": "Task workflow permanently deleted",
                "task-workflow-updated": "Task workflow updated",
                "task-workflow-pipeline-stage-added": "Task workflow stage added",
                "task-workflow-pipeline-stage-updated": "Workflow-Pipeline-Phase aktualisiert",
                "task-workflow-pipeline-stage-deleted": "Workflow-Pipeline-Phase gelöscht",
                "task-created": "Aufgabe erstellt",
                "task-deleted": "Aufgabe gelöscht",
                "task-stage-changed": "Aufgabenphase geändert",
                "task-workflow-changed": "Aufgabenworkflow geändert",
                "task-assigned-to-user": "Aufgabe Benutzer zugewiesen",
                "task-update-priority": "Aufgabenpriorität aktualisiert",
                "task-added-tags": "Tags zu Aufgabe hinzugefügt",
                "task-removed-tags": "Tags von Aufgabe entfernt",
                "task-update-title": "Aufgabentitel aktualisiert",
                "task-update-description": "Aufgabenbeschreibung aktualisiert",
                "task-update-start-date": "Aufgabenstartdatum aktualisiert",
                "task-update-end-date": "Aufgabenenddatum aktualisiert",
                "task-update-owner": "Aufgabeninhaber aktualisiert",
                "task-added-followers": "Follower zu Aufgabe hinzugefügt",
                "task-removed-followers": "Follower von Aufgabe entfernt",
                "task-added-collaborators": "Mitarbeiter zu Aufgabe hinzugefügt",
                "task-update-checklist": "Aufgaben-Checkliste aktualisiert",
                "task-added-subtask": "Teilaufgabe hinzugefügt",
                "task-removed-subtask": "Teilaufgabe entfernt",
                "task-added-attachment": "Anhang zu Aufgabe hinzugefügt",
                "task-comment-added": "Kommentar zu Aufgabe hinzugefügt",
                "task-comment-updated": "Aufgabenkommentar aktualisiert",
                "task-comment-deleted": "Aufgabenkommentar gelöscht",
                "task-completed": "Aufgabe abgeschlossen",
                "task-archived": "Aufgabe archiviert",
                "task-restored": "Aufgabe aus Papierkorb wiederhergestellt",
                "task-unarchived": "Aufgabe aus Archiv wiederhergestellt",
                "chatbot-credit-low": "Chatbot-Guthaben niedrig",
                "chatbot-credit-done": "Chatbot-Guthaben aufgebraucht",
                "system-status": "Systemstatus",
                "whatsapp-credit-low": "WhatsApp-Guthaben niedrig",
                "reservation-created-plan": "Reservierungsplan erstellt",
                "reservation-updated-plan": "Reservierungsplan aktualisiert",
                "reservation-deleted-plan": "Reservierungsplan gelöscht",
                "reservation-created": "Reservierung erstellt",
                "reservation-updated": "Reservierung aktualisiert",
                "reservation-deleted": "Reservierung gelöscht",
                "white-list-added": "Whitelist hinzugefügt",
                "white-list-removed": "Whitelist entfernt",
                "site-suspended": "Standort gesperrt",
                "site-dead": "Standort deaktiviert",
                "site-enabled": "Standort aktiviert",
                custom: "Benutzerdefinierte Aktivität",
                "auto-rebalance-success": "Automatische Guthaben-Aufladung erfolgreich",
                "auto-rebalance-failed": "Automatische Guthaben-Aufladung fehlgeschlagen",
                "auto-rebalance-disabled": "Automatische Guthaben-Aufladung deaktiviert",
                "automation-created": "Automatisierung erstellt",
                "automation-deleted": "Automatisierung gelöscht",
                "automation-restored": "Automatisierung aus Papierkorb wiederhergestellt",
                "automation-published": "Automatisierung veröffentlicht",
                "automation-unpublished": "Automatisierung zurückgezogen",
                "automation-updated": "Automatisierung aktualisiert",
                "form-created": "Formular erstellt",
                "form-updated": "Formular aktualisiert",
                "form-deleted": "Formular gelöscht",
                "form-restored": "Formular aus Papierkorb wiederhergestellt",
                "form-downloaded": "Formulardaten heruntergeladen",
                "table-created": "Tabelle erstellt",
                "table-deleted": "Tabelle gelöscht",
                "table-restored": "Tabelle aus Papierkorb wiederhergestellt",
                "table-permanently-deleted": "Tabelle dauerhaft gelöscht",
                "table-field-added": "Tabellenfeld hinzugefügt",
                "table-field-updated": "Tabellenfeld aktualisiert",
                "table-field-deleted": "Tabellenfeld gelöscht",
                "table-view-added": "Tabellenansicht hinzugefügt",
                "table-view-updated": "Tabellenansicht aktualisiert",
                "table-view-deleted": "Tabellenansicht gelöscht",
                "table-page-added": "Tabellenseite hinzugefügt",
                "table-page-updated": "Tabellenseite aktualisiert",
                "table-page-deleted": "Tabellenseite gelöscht",
                "table-widget-added": "Tabellen-Widget hinzugefügt",
                "table-widget-updated": "Tabellen-Widget aktualisiert",
                "table-widget-deleted": "Tabellen-Widget gelöscht",
                "table-permission-changed": "Tabellenberechtigungen geändert",
                "table-data-downloaded": "Tabellendaten heruntergeladen",
                "table-data-imported": "Tabellendaten importiert",
                "table-data-batch-updated": "Tabellendaten Stapelaktualisierung",
                "table-data-batch-deleted": "Tabellendaten Stapellöschung",
                "contact-data-downloaded": "Kontaktdaten heruntergeladen",
                "contact-batch-updated": "Kontaktdaten Stapelaktualisierung",
                "chat-data-downloaded": "Chatdaten heruntergeladen",
                "voice-agent-created": "Sprachagent erstellt",
                "voice-agent-updated": "Sprachagent aktualisiert",
                "voice-agent-deleted": "Sprachagent gelöscht",
                "voice-agent-phone-number-inbound-agent-changed": "Eingehender-Anruf-Agent geändert",
                "voice-agent-phone-number-outbound-agent-changed": "Ausgehender-Anruf-Agent geändert",
                "voice-agent-batch-call-created": "Sprachagent-Stapelanruf erstellt",
                "voice-agent-knowledge-base-created": "Sprachagent-Wissensdatenbank erstellt",
                "voice-agent-knowledge-base-updated": "Sprachagent-Wissensdatenbank aktualisiert",
                "drive-folder-created": "Drive-Ordner erstellt",
                "drive-folder-deleted": "Drive-Ordner gelöscht",
                "drive-folder-renamed": "Drive-Ordner umbenannt",
                "drive-file-added": "Drive-Datei hinzugefügt",
                "drive-file-deleted": "Drive-Datei gelöscht",
                "task-module-rules-rule-added": "Aufgabenmodul-Regel hinzugefügt",
                "task-module-rules-rule-updated": "Aufgabenmodul-Regel aktualisiert",
                "task-module-rules-rule-deleted": "Aufgabenmodul-Regel gelöscht",
                "task-module-rules-rule-enabled": "Aufgabenmodul-Regel aktiviert",
                "task-module-rules-rule-disabled": "Aufgabenmodul-Regel deaktiviert",
                "task-module-rules-enabled": "Aufgabenmodul-Regeln aktiviert",
                "task-module-rules-disabled": "Aufgabenmodul-Regeln deaktiviert",
                "contact-module-rules-rule-added": "Kontaktmodul-Regel hinzugefügt",
                "contact-module-rules-rule-updated": "Kontaktmodul-Regel aktualisiert",
                "contact-module-rules-rule-deleted": "Kontaktmodul-Regel gelöscht",
                "contact-module-rules-rule-enabled": "Kontaktmodul-Regel aktiviert",
                "contact-module-rules-rule-disabled": "Kontaktmodul-Regel deaktiviert",
                "contact-module-rules-enabled": "Kontaktmodul-Regeln aktiviert",
                "contact-module-rules-disabled": "Kontaktmodul-Regeln deaktiviert",
                "module-created": "Modul erstellt",
                "module-updated": "Modul aktualisiert",
                "module-deleted": "Modul gelöscht",
                "relation-created": "Relation erstellt",
                "relation-updated": "Relation aktualisiert",
                "relation-deleted": "Relation gelöscht",
                "web-app-created": "Web-App erstellt",
                "web-app-updated": "Web-App aktualisiert",
                "web-app-deleted": "Web-App gelöscht",
                "web-tab-created": "Web-Tab erstellt",
                "web-tab-updated": "Web-Tab aktualisiert",
                "web-tab-deleted": "Web-Tab gelöscht",
                "developer-token-created": "Entwickler-Token erstellt",
                "developer-token-changed": "Entwickler-Token geändert"
            },
            activityTypeSelect: "Aktivitätstyp auswählen",
            dateRange: "Datumsbereich",
            startDate: "Startdatum",
            endDate: "Enddatum",
            reset: "Zurücksetzen",
            filter: "Filtern",
            activeFilters: "Aktive Filter:",
            auditLogsTable: "Audit-Logs",
            noActivityYet: "Noch keine Aktivität",
            ipAddress: "IP-Adresse",
            tablePagination: {
                goto: "Gehe zu",
                pagePer: " / Seite",
                total: "Gesamt",
                prev5: "Vorherige 5 Seiten",
                next5: "Nächste 5 Seiten",
                cut: "Ausschneiden",
                copy: "Kopieren",
                insertRowAbove: "Zeile darüber einfügen",
                insertRowBelow: "Zeile darunter einfügen",
                removeRow: "Zeile(n) entfernen",
                emptyRow: "Zeile(n) leeren",
                emptyColumn: "Spalte(n) leeren",
                emptyCell: "Zelle leeren",
                leftFixedColumnTo: "Spalte links fixieren",
                cancelLeftFixedColumnTo: "Spalte links fixieren aufheben",
                rightFixedColumnTo: "Spalte rechts fixieren",
                cancelRightFixedColumnTo: "Spalte rechts fixieren aufheben"
            }
        },
        task: {
            taskID: "Aufgabe ID",
            completeTask: "Aufgabe abschließen",
            closedTasks: "Geschlossene Aufgaben",
            moveToArchive: "In Archiv verschieben",
            changeWorkflow: "In einen anderen Workflow verschieben",
            selectWorkflow: "Arbeitsablauf auswählen",
            taskNumber: "Aufgabe #",
            priority_lowest: "Niedrigste",
            priority_low: "Niedrig",
            priority_medium: "Mittel",
            priority_high: "Hoch",
            priority_highest: "Höchste",
            workflowActions: "Workflow-Aktionen",
            workflowTitle: "Workflow-Titel",
            deleteTask: "Aufgabe löschen",
            archivingDate: "Datum der Archivierung",
            selectOption: "Wählen Sie eine Option",
            notAuthorisedCreateTask: "Sie sind nicht berechtigt, eine Aufgabe zu erstellen",
            notAuthorisedCreateTaskDesc: "Sie sind nicht befugt, diese Aufgabe auszuführen",
            goToMessage: "Zur Nachricht gehen",
            goToChat: "Zum Chat gehen",
            showVisitor: "Besucher anzeigen",
            closeTheTask: "Aufgabe schließen",
            sureAddCompletedList: "Sind Sie sicher, dass Sie die Aufgabe zur Erledigungsliste hinzufügen möchten?",
            success: "Erfolg",
            successDesc: "Neues Feld erfolgreich hinzugefügt.",
            moveAndDeleteTask: "Aufgaben verschieben und löschen",
            justDelete: "Einfach löschen",
            selectColumnMoveTask: "Wählen Sie die Spalte aus, in die Sie die Aufgaben verschieben möchten",
            todos: "Zu erledigende Aufgaben",
            inProgress: "In Bearbeitung",
            approval: "Genehmigt",
            addAComment: "Einen Kommentar hinzufügen...",
            deleteComment: "Sind Sie sicher, dass Sie den Kommentar löschen möchten?",
            edited: "Bearbeitet",
            comments: "Kommentare",
            addComment: "Kommentar hinzufügen",
            workflow: "Arbeitsablauf",
            workflowDetail: "Arbeitsablauf Details",
            workflowPerm: "Arbeitsablauf Berechtigungen",
            perm: "Berechtigungen",
            detail: "Details",
            userPerm: "Benutzerberechtigungen",
            deleteCard: "Karte löschen",
            createCard: "Karte erstellen",
            editCard: "Karte bearbeiten",
            dragCard: "Karte verschieben",
            allWorkflow: "Alle Arbeitsabläufe",
            createworkflow: "Arbeitsablauf erstellen",
            editDragActive: "Bearbeitung aktiv",
            editSortOrder: "Sortierung bearbeiten",
            deleteWorkflow: "Sind Sie sicher, dass Sie diesen Arbeitsablauf löschen möchten?",
            permEditTask: "Sie haben keine Berechtigung, diese Aufgabe zu bearbeiten",
            permEditTaskDes: "Wenden Sie sich an Ihren Administrator, um Bearbeitungsberechtigungen zu erhalten.",
            createTaskError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            createTaskErrorDesc: "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Erstellen von Aufgaben zu erhalten.",
            moveTaskError: "Sie haben keine Berechtigung, den Aufgabenstatus zu ändern",
            moveTaskErrorDesc: "Wenden Sie sich an Ihren Administrator, um Berechtigungen zur Änderung des Aufgabenstatus zu erhalten.",
            deleteTaskError: "Sie haben keine Berechtigung, Aufgaben zu löschen",
            deleteTaskErrorDesc: "Wenden Sie sich an Ihren Administrator, um Berechtigungen zum Löschen von Aufgaben zu erhalten.",
            permissionError: "Sie haben keine Berechtigung, Aufgaben zu erstellen",
            permissionErrorDesc: "Bitte wenden Sie sich an Ihren Administrator, um Berechtigungen zur Aufgabenerstellung zu erhalten",
            whatsappContactProfileTitle: "{name} / {number} Profil",
            createTaskVisitor: "Aufgabe erstellen (Besucher)",
            editWorkflow: "Workflow bearbeiten",
            visitor: "Besucherprofil",
            createTaskMessage: "Aufgabe erstellen (Nachricht)",
            createStage: "Stufe erstellen",
            stagesAndStatuses: "Phasen und Status",
            workflowCreateDesc: "Workflow-Beschreibung",
            subTasks: "Teilaufgaben",
            followers: "Anhänger",
            collaborators: "Mitarbeiter",
            addRelations: "Beziehungen hinzufügen",
            relations: "Beziehungen",
            main: "Haupt",
            name: "Name",
            completedOfCheck: "{completed} von {total} Aufgaben abgeschlossen",
            workflowUpdateMs: "Workflow erfolgreich aktualisiert",
            taskUpdateMs: "Aufgabe erfolgreich aktualisiert",
            workflowCreatedMs: "Workflow erfolgreich erstellt",
            workflowCreateError: "Der Workflow konnte nicht erstellt werden",
            taskCreatedMs: "Aufgabe erfolgreich erstellt",
            settingsDesc3: "Darüber hinaus ermöglicht Ihnen das Supsis-Aufgabenmodul, Ihren eigenen Workflow mit anpassbarer Automatisierung zu erstellen, sodass Sie Aufgaben effektiver verwalten und die Zusammenarbeit im Team verbessern können.",
            settingsDesc4: "Auf diese Weise können Sie jede Ihrer Aufgaben im Detail verfolgen, Aufgaben an Teammitglieder zuweisen und insgesamt Ihre Geschäftsprozesse effizienter verwalten. Das Supsis-Aufgabenmodul bietet Ihnen eine umfassende Lösung für die Aufgabenverwaltung und Teamkoordination.",
            settingsDesc2: "Das Supsis-Aufgabenmodul lässt keine Aufgabe unbeachtet. Sie können Aufgaben basierend auf jedem Parameter filtern, Arbeitslasten für jeden Workflow-Schritt verfolgen und Ihren Kalender organisieren, um sich an Ihre Zeitpläne anzupassen.",
            settingsDesc1: "Das Aufgabenmodul ermöglicht es Ihnen, die Zusammenarbeit zu organisieren, Aufgaben zu delegieren und den Fortschritt Ihres Teams zu verfolgen. Sie können Ihre Aufgaben nach Bedarf anpassen, indem Sie eine beliebige Ansicht auswählen und Ihre eigenen benutzerdefinierten Workflows mit Automatisierungen erstellen.",
            taskModuleSettingsTitle: "Aufgabenmodul-Einstellungen",
            high: "Hoch",
            medium: "Mittel",
            low: "Niedrig",
            priority: "Priorität",
            addExistsSubtask: "Vorhandene Teilaufgabe hinzufügen",
            addSubtask: "Teilaufgabe hinzufügen",
            add: "Hinzufügen",
            newCheckList: "Neue Checkliste",
            subtaskTitle: "Teilaufgabentitel",
            view: "Anzeigen",
            attachFiles: "Dateien anhängen",
            createTaskDesc: "Aufgabenbeschreibung",
            title: "Titel",
            createWorkflow: "Workflow erstellen",
            editTask: "Aufgabe bearbeiten",
            createTask: "Aufgabe erstellen",
            deleteColumnCont: "Sind Sie sicher, dass Sie diese Spalte löschen möchten?",
            changeStage: "Status ändern",
            filterBar: {
                searchTasksPlaceholder: "In Aufgaben suchen...",
                otherUsers: "Andere Benutzer",
                searchUserPlaceholder: "Benutzer suchen...",
                filter: "Filtern",
                clearFilters: "Filter löschen",
                apply: "Anwenden",
                prioritySelection: "Aufgabenpriorität auswählen",
                priorityDescription: "Sie können Aufgaben nach Prioritätsstufe filtern. Wählen Sie die Prioritätsstufen aus, nach denen Sie Aufgaben filtern möchten.",
                aboutPriorityLevels: "Über Prioritätsstufen",
                priorityInfoText: "Prioritätsstufen geben die Wichtigkeit von Aufgaben an. Aufgaben mit hoher Priorität zeigen Arbeit, auf die sich Ihr Team zuerst konzentrieren sollte, während Aufgaben mit niedriger Priorität weniger dringende Arbeit anzeigen.",
                userSelection: "Benutzerauswahl",
                assigneesDescription: "Sie können nach zugewiesenen Benutzern filtern. Wählen Sie die Benutzer aus, um nur deren zugewiesene Aufgaben zu sehen.",
                unassigned: "Nicht zugewiesen",
                ownerSelection: "Aufgabeninhaber auswählen",
                ownerDescription: "Sie können nach Aufgabeninhabern filtern. Wählen Sie die Benutzer aus, um nur deren Aufgaben zu sehen.",
                searchOwnerPlaceholder: "Aufgabeninhaber suchen...",
                followersSelection: "Aufgabenverfolger auswählen",
                followersDescription: "Sie können nach Aufgabenverfolgern filtern. Wählen Sie die Benutzer aus, um nur deren verfolgte Aufgaben zu sehen.",
                searchFollowerPlaceholder: "Verfolger suchen...",
                creatorSelection: "Aufgabenersteller auswählen",
                creatorDescription: "Sie können nach dem Ersteller der Aufgabe oder dem System filtern. Wählen Sie Benutzer oder Systemtypen zum Filtern der Aufgaben.",
                createdBySystem: "Vom System erstellt",
                createdByUsers: "Von Benutzern erstellt",
                searchCreatorPlaceholder: "Benutzer suchen...",
                filterByCreatedDate: "Nach Erstellungsdatum filtern",
                today: "Heute",
                thisWeek: "Diese Woche",
                thisMonth: "Dieser Monat",
                startDate: "Startdatum",
                endDate: "Enddatum",
                aboutDateFilter: "Über Datumsfilter",
                filterByStartDate: "Nach Startdatum filtern",
                filterByEndDate: "Nach Enddatum filtern",
                overdueTasks: "Überfällige Aufgaben",
                showOverdueTasks: "Überfällige Aufgaben anzeigen",
                importantInfo: "Wichtige Information",
                filterByUpdateDate: "Nach Aktualisierungsdatum filtern",
                taskTags: "Aufgaben-Tags",
                searchTagPlaceholder: "Tag suchen...",
                tagsLoading: "Tags werden geladen...",
                noTagsMatchingSearch: "Keine Tags entsprechen den Suchkriterien.",
                noTagsCreated: "Noch keine Tags erstellt.",
                aboutTags: "Über Tags",
                pipelineSelection: "Pipeline-Status auswählen",
                searchPipelinePlaceholder: "Pipeline suchen...",
                order: "Reihenfolge",
                pipelinesLoading: "Pipelines werden geladen...",
                noPipelinesMatchingSearch: "Keine Pipelines entsprechen den Suchkriterien.",
                noPipelinesCreated: "Noch keine Pipelines erstellt.",
                aboutPipelines: "Über Pipelines",
                selected: "ausgewählt",
                closeTask: "Aufgabe schließen",
                tabPriorities: "Priorität",
                tabOwners: "Aufgabeninhaber",
                tabFollowers: "Aufgabenverfolger",
                tabCreatedBy: "Ersteller",
                tabCreatedDate: "Erstellungsdatum",
                tabUpdateDate: "Aktualisierungsdatum",
                tabStartDate: "Startdatum",
                tabEndDate: "Enddatum",
                tabTags: "Tags",
                tabOverdue: "Überfällige Aufgaben",
                tabStatus: "Status",
                tabSortBy: "Sortierung",
                sortBySelection: "Sortierung Auswahl",
                sortByDescription: "Wählen Sie die Reihenfolge, in der Aufgaben aufgelistet werden. Die neuesten Aufgaben erscheinen zuerst.",
                sortByCreatedAt: "Nach Erstellungsdatum",
                sortByCreatedAtDescription: "Aufgaben werden vom neuesten zum ältesten Erstellungsdatum sortiert.",
                sortByUpdatedAt: "Nach Aktualisierungsdatum",
                sortByUpdatedAtDescription: "Aufgaben werden vom zuletzt aktualisierten zum ältesten sortiert.",
                sortByEndDate: "Nach Enddatum",
                sortByEndDateDescription: "Aufgaben werden nach Enddatum von nächstem zu entferntestem sortiert.",
                aboutSortBy: "Über die Sortierung",
                sortByInfoText: "Ohne Sortierung verwendet die Kanban-Ansicht die Drag-and-Drop-Reihenfolge, die Listenansicht das Erstellungsdatum.",
                priorityLowest: "Niedrigste Priorität",
                priorityLow: "Niedrige Priorität",
                priorityMedium: "Mittlere Priorität",
                priorityHigh: "Hohe Priorität",
                priorityHighest: "Höchste Priorität",
                createdByApi: "Von API erstellte Aufgaben",
                createdByChatbot: "Von Chatbot erstellte Aufgaben",
                createdByAutomation: "Von Automatisierung erstellte Aufgaben",
                dateRangeCreatedDescription: "Legen Sie Start- und Enddatum fest, um Aufgaben zu filtern, die in Ihrem ausgewählten Datumsbereich erstellt wurden. Dieser Filter filtert Aufgaben nach ihrem Erstellungsdatum (createdAt).",
                dateInfoCreatedText: "Der Datumsfilter begrenzt die Ergebnisse nach dem Erstellungsdatum der Aufgaben. So können Sie leicht Aufgaben finden, die in einem bestimmten Zeitraum erstellt wurden.",
                dateRangeStartDescription: "Legen Sie das Startdatum fest, um Aufgaben zu filtern, die in Ihrem ausgewählten Datumsbereich erstellt wurden. Dieser Filter filtert Aufgaben nach ihrem Startdatum (startDate).",
                dateInfoStartText: "Der Datumsfilter begrenzt die Ergebnisse nach dem Startdatum der Aufgaben. So können Sie leicht Aufgaben finden, die in einem bestimmten Zeitraum beginnen.",
                dateRangeEndDescription: "Legen Sie das Enddatum fest, um Aufgaben zu filtern, die in Ihrem ausgewählten Datumsbereich erstellt wurden. Dieser Filter filtert Aufgaben nach ihrem Enddatum (endDate).",
                dateInfoEndText: "Der Datumsfilter begrenzt die Ergebnisse nach dem Enddatum der Aufgaben. So können Sie leicht Aufgaben finden, die in einem bestimmten Zeitraum enden.",
                dateRangeUpdateDescription: "Legen Sie Start- und Enddatum fest, um Aufgaben zu filtern, die in Ihrem ausgewählten Datumsbereich aktualisiert wurden. Dieser Filter filtert Aufgaben nach ihrem Aktualisierungsdatum (updatedAt).",
                dateInfoUpdateText: "Der Datumsfilter begrenzt die Ergebnisse nach dem letzten Aktualisierungsdatum der Aufgaben. So können Sie leicht Aufgaben finden, die in einem bestimmten Zeitraum aktualisiert wurden.",
                overdueDescription: "Sie können Aufgaben filtern, deren Fälligkeitsdatum überschritten ist und die noch unvollständig sind. Wenn dieser Filter aktiv ist, werden nur überfällige Aufgaben angezeigt.",
                overdueDetail: "Aufgaben, deren Fälligkeitsdatum überschritten ist und die noch unvollständig sind, werden angezeigt, wenn dieser Filter aktiv ist. Dies sind in der Regel die Aufgaben, die Ihr Team so schnell wie möglich bearbeiten muss.",
                overdueInfoText: "Überfällige Aufgaben sind Aufgaben, deren Fälligkeitsdatum überschritten ist, die aber noch nicht abgeschlossen sind. Diese Aufgaben weisen auf wichtige Arbeit hin, die die Aufmerksamkeit Ihres Teams erfordert.",
                tagsDescription: "Sie können Aufgaben nach ihren Tags filtern. Aufgaben mit den von Ihnen ausgewählten Tags werden angezeigt.",
                tagsInfoText: "Tags helfen Ihnen, Aufgaben zu kategorisieren und sie leichter zu finden. Wenn Sie mehrere Tags auswählen, werden Aufgaben mit einem der ausgewählten Tags angezeigt.",
                pipelineDescription: "Sie können Aufgaben nach Pipeline-Status filtern. Durch Auswahl der gewünschten Pipelines können Sie nur Aufgaben in diesen Phasen sehen.",
                pipelinesInfoText: "Pipelines zeigen an, in welcher Phase sich Aufgaben befinden. Wenn Sie mehrere Pipelines auswählen, werden Aufgaben in einer der ausgewählten Pipelines angezeigt."
            },
            assignees: "Beauftragte",
            owner: "Besitzer",
            stage: "Status",
            writeSomething: "Schreiben Sie etwas",
            selectAssginee: "Zuweisung auswählen",
            assignee: "Beauftragter",
            enterNewTaskDesc: "Neue Aufgabenbeschreibung eingeben",
            enterNewTaskTitle: "Neuen Aufgabentitel eingeben",
            task: "Aufgabe",
            deleteTaskCont: "Möchten Sie diese Aufgaben wirklich löschen?",
            deleteWorkFlowCont: "Sind Sie sicher, dass Sie diesen Workflow löschen möchten?",
            completed: "Abgeschlossen",
            todo: "Zu erledigen",
            kanbanBoard: "Kanban-Board",
            listView: "Listenansicht",
            taskNotifications: "Aufgabenbenachrichtigungen",
            reports: "Berichte",
            workflowSettings: "Workflow-Einstellungen",
            trashBin: "Papierkorb",
            taskReports: {
                title: "Aufgabenberichte",
                selectWorkflow: "Workflow auswählen",
                filters: "Filter",
                clear: "Löschen",
                dateRange: "Datumsbereich:",
                dateRangePlaceholder: "Anfang - Ende",
                assignees: "Zugewiesene:",
                selectUser: "Benutzer auswählen",
                unassigned: "Nicht zugewiesen",
                priority: "Priorität:",
                selectPriority: "Priorität auswählen",
                emptyTitle: "Workflow auswählen, um Berichte anzuzeigen",
                emptyDescription: "Wählen Sie oben einen Workflow aus, um Aufgabenberichte anzuzeigen.",
                loadingTitle: "Bericht wird erstellt",
                loadingSubtitle: "Aufgabendaten werden analysiert...",
                tasksClosed: "Aufgaben geschlossen",
                tasksUpdated: "Aufgaben aktualisiert",
                tasksCreated: "Aufgaben erstellt",
                upcomingDeadlines: "Bevorstehende Fristen",
                statusOverview: "Statusübersicht",
                statusOverviewSubtitle: "Sehen Sie den Status Ihrer Tickets auf einen Blick.",
                totalTickets: "Gesamte Tickets",
                priorityDistribution: "Prioritätsverteilung",
                teamWorkload: "Team-Arbeitslast",
                tooltipTasks: "{name}: {count} Aufgaben ({percentage}%)",
                errorTitle: "Fehler beim Laden des Berichts",
                retry: "Erneut versuchen",
                last7Days: "Letzte 7 Tage",
                dateRangeIn: "zwischen {start} - {end}",
                upcomingCount: "{count} Elemente haben bevorstehende Fristen (nächste 7 Tage)",
                upcomingCountZero: "0 Elemente haben bevorstehende Fristen (nächste 7 Tage)",
                upcomingInRange: "{count} Elemente haben Fristen ({start} - {end})",
                upcomingInRangeZero: "0 Elemente haben Fristen ({start} - {end})",
                invalidWorkflowId: "Ungültiges Workflow-ID-Format: {id}",
                loadSuccess: "Berichtsdaten erfolgreich geladen.",
                unknownError: "Ein unbekannter Fehler ist aufgetreten",
                error: "Fehler"
            },
            taskNotification: {
                title: "Aufgabenbenachrichtigungs-Einstellungen",
                description: "Sie können Ihre Aufgabenbenachrichtigungs-Einstellungen hier verwalten."
            },
            workflowSandbox: {
                title: "Gelöschte Workflows",
                description: "Workflows, die 30 Tage lang nicht verwendet werden, werden automatisch vom System gelöscht",
                emptyState: "Keine gelöschten Workflows im Papierkorb",
                unnamedWorkflow: "Unbenannter Workflow",
                restore: "Wiederherstellen",
                permanentlyDelete: "Dauerhaft löschen",
                unknown: "Unbekannt",
                user: "Benutzer",
                restoreConfirmTitle: "Sind Sie sicher, dass Sie diesen Workflow wiederherstellen möchten?",
                restoreConfirmContent: "{title} Workflow wird wiederhergestellt.",
                restoreSuccess: "Workflow erfolgreich wiederhergestellt",
                restoreFailed: "Wiederherstellung fehlgeschlagen",
                deleteConfirmTitle: "Sind Sie sicher, dass Sie diesen Workflow dauerhaft löschen möchten?",
                deleteConfirmContent: "{title} Workflow wird dauerhaft gelöscht. Diese Aktion kann nicht rückgängig gemacht werden.",
                deleteOkText: "Ja, dauerhaft löschen",
                cancel: "Abbrechen",
                deleteSuccess: "Workflow dauerhaft gelöscht",
                deleteFailed: "Dauerhafte Löschung fehlgeschlagen",
                loadError: "Fehler beim Laden der gelöschten Workflows"
            },
            notAuthorizedCreateTask: "Sie sind nicht berechtigt, eine Aufgabe zu erstellen",
            notAuthorizedCreateTaskDesc: "Sie sind nicht berechtigt, diese Aktion auszuführen.",
            taskDesc: "Aufgabenbeschreibung",
            archiveAndTrash: "Archiv und Papierkorb",
            trash: "Papierkorb",
            loading: "Wird geladen...",
            startDate: "Startdatum",
            endDate: "Enddatum",
            clearFilter: "Filter löschen",
            noArchivedTasks: "Keine archivierten Aufgaben gefunden",
            noDeletedTasks: "Keine Aufgaben im Papierkorb gefunden",
            total: "Gesamt",
            error: "Fehler",
            moveToBoard: "Zum Board verschieben",
            unarchive: "Aus Archiv wiederherstellen",
            taskMovedToBoard: "Aufgabe zum Board verschoben",
            taskMoveError: "Beim Verschieben der Aufgabe zum Board ist ein Fehler aufgetreten",
            taskDeleted: "Aufgabe gelöscht",
            taskDeleteError: "Beim Löschen der Aufgabe ist ein Fehler aufgetreten",
            taskUnarchived: "Aufgabe aus Archiv wiederhergestellt",
            taskUnarchiveError: "Beim Wiederherstellen der Aufgabe aus dem Archiv ist ein Fehler aufgetreten",
            aprobado: "Genehmigt",
            kanbanSettings: {
                cancel: "Abbrechen",
                card: "Karteinstellungen",
                column: "Spalteneinstellungen",
                kanban: "Kanban-Einstellungen",
                save: "Speichern",
                selectField: "Feld auswählen",
                selectFieldPlaceholder: "Feld auswählen",
                selectFields: "Felder auswählen, die auf der Karte angezeigt werden",
                title: "Einstellungen"
            }
        },
        permissionErrors: {
            userCreate: "Sie haben keine Berechtigung, Benutzer hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            userRead: "Sie haben keine Berechtigung, Benutzer anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            userUpdate: "Sie haben keine Berechtigung, Benutzer zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            userDelete: "Sie haben keine Berechtigung, Benutzer zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorBlock: "Sie haben keine Berechtigung, Besucher zu blockieren. Bitte konsultieren Sie Ihren Administrator.",
            visitorUnblock: "Sie haben keine Berechtigung, Besucher zu entsperren. Bitte konsultieren Sie Ihren Administrator.",
            visitorDetailRead: "Sie haben keine Berechtigung, Besucherdetails anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorListRead: "Sie haben keine Berechtigung, die Besucherliste anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            visitorDelete: "Sie haben keine Berechtigung, Besucher zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            visitorExcel: "Sie haben keine Berechtigung, Excel-Ausgabe zu erhalten. Bitte konsultieren Sie Ihren Administrator.",
            visitorUpdate: "Sie haben keine Berechtigung, Besucher zu aktualisieren. Bitte konsultieren Sie Ihren Administrator.",
            bannedVisitorRead: "Sie haben keine Berechtigung, die Liste der gesperrten Besucher anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordCreate: "Sie haben keine Berechtigung, gesperrte Wörter hinzuzufügen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordRead: "Sie haben keine Berechtigung, gesperrte Wörter anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            bannedWordDelete: "Sie haben keine Berechtigung, gesperrte Wörter zu löschen. Bitte konsultieren Sie Ihren Administrator.",
            chatRead: "Sie haben keine Berechtigung, Chats anzuzeigen. Bitte konsultieren Sie Ihren Administrator.",
            chatUpdate: "Sie haben keine Berechtigung, Chats zu bearbeiten. Bitte wenden Sie sich an Ihren Administrator.",
            archiveRead: "Sie haben keine Berechtigung, Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleCreate: "Sie haben keine Berechtigung, Rollen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            roleRead: "Sie haben keine Berechtigung, Rollen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            roleUpdate: "Sie haben keine Berechtigung, Rollen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            roleDelete: "Sie haben keine Berechtigung, Rollen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentCreate: "Sie haben keine Berechtigung, Abteilungen hinzuzufügen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentRead: "Sie haben keine Berechtigung, Abteilungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            departmentUpdate: "Sie haben keine Berechtigung, Abteilungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            departmentDelete: "Sie haben keine Berechtigung, Abteilungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentCreate: "Sie haben keine Berechtigung, vorbereiteten Inhalt zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentRead: "Sie haben keine Berechtigung, vorbereiteten Inhalt anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentUpdate: "Sie haben keine Berechtigung, vorbereiteten Inhalt zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            preparedContentDelete: "Sie haben keine Berechtigung, vorbereiteten Inhalt zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeCreate: "Sie haben keine Berechtigung, Begrüßungsnachrichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeRead: "Sie haben keine Berechtigung, Begrüßungsnachrichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeUpdate: "Sie haben keine Berechtigung, Begrüßungsnachrichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            welcomeDelete: "Sie haben keine Berechtigung, Begrüßungsnachrichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            settingCreate: "Sie haben keine Berechtigung, Einstellungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            settingRead: "Sie haben keine Berechtigung, Einstellungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            settingUpdate: "Sie haben keine Berechtigung, Einstellungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            settingDelete: "Sie haben keine Berechtigung, Einstellungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            reportCreate: "Sie haben keine Berechtigung, Berichte zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            reportRead: "Sie haben keine Berechtigung, Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            reportUpdate: "Sie haben keine Berechtigung, Berichte zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            reportDelete: "Sie haben keine Berechtigung, Berichte zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestCreate: "Sie haben keine Berechtigung, Offline-Supportanfragen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestRead: "Sie haben keine Berechtigung, Offline-Supportanfragen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestUpdate: "Sie haben keine Berechtigung, auf Offline-Supportanfragen zu antworten. Bitte wenden Sie sich an Ihren Administrator.",
            offlineSupportRequestDelete: "Sie haben keine Berechtigung, Offline-Supportanfragen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogCreate: "Sie haben keine Berechtigung, Kataloge zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogRead: "Sie haben keine Berechtigung, Kataloge anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            catalogUpdate: "Sie haben keine Berechtigung, Kataloge zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            catalogDelete: "Sie haben keine Berechtigung, Kataloge zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryCreate: "Sie haben keine Berechtigung, Chatbot-Geschichten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryRead: "Sie haben keine Berechtigung, Chatbot-Geschichten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryUpdate: "Sie haben keine Berechtigung, Chatbot-Geschichten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotStoryDelete: "Sie haben keine Berechtigung, Chatbot-Geschichten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateRead: "Sie haben keine Berechtigung, Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTemplateAiRead: "Sie haben keine Berechtigung, KI-Chatbot-Vorlagen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotIntegrationsRead: "Sie haben keine Berechtigung, Chatbot-Integrationen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotArchiveRead: "Sie haben keine Berechtigung, Chatbot-Archive anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesRead: "Sie haben keine Berechtigung, Chatbot-Entitäten anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesCreate: "Sie haben keine Berechtigung, Chatbot-Entitäten zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesUpdate: "Sie haben keine Berechtigung, Chatbot-Entitäten zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotEntitiesDelete: "Sie haben keine Berechtigung, Chatbot-Entitäten zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotReportRead: "Sie haben keine Berechtigung, Chatbot-Berichte anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotTrainRead: "Sie haben keine Berechtigung, das Training des Chatbots anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentCreate: "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentRead: "Sie haben keine Berechtigung, Chatbot-Benutzersegmente anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentUpdate: "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            chatbotSegmentDelete: "Sie haben keine Berechtigung, Chatbot-Benutzersegmente zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationsRead: "Sie haben keine Berechtigung, die Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            whatsappIntegrationRead: "Sie haben keine Berechtigung, die WhatsApp-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            instagramIntegrationRead: "Sie haben keine Berechtigung, die Instagram-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            telegramIntegrationRead: "Sie haben keine Berechtigung, die Telegramm-Integrationsseite anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            integrationCreate: "Sie haben keine Berechtigung, Integrationen zu aktivieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerCreate: "Sie haben keine Berechtigung, Trigger zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerRead: "Sie haben keine Berechtigung, Trigger anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            triggerUpdate: "Sie haben keine Berechtigung, Trigger zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            triggerDelete: "Sie haben keine Berechtigung, Trigger zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            billingRead: "Sie haben keine Berechtigung, die Rechnungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskCreate: "Sie haben keine Berechtigung, Aufgaben zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            taskRead: "Sie haben keine Berechtigung, Aufgaben anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            taskUpdate: "Sie haben keine Berechtigung, Aufgaben zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            taskDelete: "Sie haben keine Berechtigung, Aufgaben zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarCreate: "Sie haben keine Berechtigung, Kalender/Reservierungen zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarRead: "Sie haben keine Berechtigung, den Kalender/die Reservierungen anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            calendarUpdate: "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            calendarDelete: "Sie haben keine Berechtigung, den Kalender/die Reservierungen zu löschen. Bitte wenden Sie sich an Ihren Administrator.",
            mailCreate: "Sie haben keine Berechtigung, E-Mails zu erstellen. Bitte wenden Sie sich an Ihren Administrator.",
            mailRead: "Sie haben keine Berechtigung, E-Mails anzuzeigen. Bitte wenden Sie sich an Ihren Administrator.",
            mailUpdate: "Sie haben keine Berechtigung, E-Mails zu aktualisieren. Bitte wenden Sie sich an Ihren Administrator.",
            mailDelete: "Sie haben keine Berechtigung, E-Mails zu löschen. Bitte wenden Sie sich an Ihren Administrator."
        },
        message: {
            artificialIntelligence: "Künstliche Intelligenz",
            appBreadcrumb: {
                tasks: "Aufgaben",
                broadcastLabel: "Broadcast-Nachricht",
                walletBalanceTooltip: "Ihr Wallet-Guthaben: {amount}₺",
                broadcastStatusCreated: "Erstellt",
                broadcastStatusScheduled: "Geplant",
                broadcastStatusQueued: "In Warteschlange",
                broadcastStatusRunning: "Wird gesendet",
                broadcastStatus: "Status",
                broadcastProgress: "Fortschritt"
            },
            confirmDeleteRedStationIntegration: "Sind Sie sicher, dass Sie diesen Roten-Santral-Kanal löschen möchten?",
            enterRedStationIntegration: "Geben Sie Ihre Rote-Santral-API-Anmeldedaten ein",
            redStationIntegration: "Rote-Santral-Integration",
            copyChannelID: "Kanal-ID kopieren",
            redStationChannels: "Rote-Santral-Kanäle",
            bannedUserError: "Beim Hinzufügen der Sperre ist ein Fehler aufgetreten.",
            bannedUserSuccess: "Sperre erfolgreich hinzugefügt.",
            selectAtLeastOneOption: "Bitte wählen Sie mindestens eine Option aus.",
            enterValidValue: "Bitte geben Sie einen gültigen Wert ein.",
            enterValidIpAddress: "Bitte geben Sie eine gültige IP-Adresse ein.",
            enterValidVisitorId: "Bitte geben Sie eine gültige Besucher-ID ein.",
            enterValidWhatsappNumber: "Bitte geben Sie eine gültige WhatsApp-Nummer ein.",
            invalidEmailAddress: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
            bannedUser: "Gesperrt",
            unbannedUser: "Nicht gesperrt",
            banModalDescription: "Geben Sie Plattform und Wert ein, um den Benutzer zu sperren.",
            exampleNumber: "Beispielnummer: 905551111111",
            clearSelectedFiltersTooltip: "Löscht die ausgewählten Filterwerte auf der Seite",
            minutesText: "{count} Minuten",
            secondsText: "{count} Sekunden",
            downloadCooldownWarning: "Bitte warten Sie {time}, um eine neue Download-Anfrage zu erstellen.",
            excelExportReceiveQuestion: "Wie möchten Sie die Excel-Datei erhalten?",
            sendToMe: "An mich senden",
            sendToSomeoneElse: "An jemand anderen senden",
            enterEmailAddress: "E-Mail-Adresse eingeben",
            exportRequestSuccess: "Ihre Anfrage wurde erstellt, wir werden sie Ihnen so schnell wie möglich per E-Mail zusenden",
            maxDateRangeWarning: "Der ausgewählte Datumsbereich kann maximal 45 Tage betragen",
            ticketOnlyMail: "Diese Anfrage kann nur per E-Mail beantwortet werden. Über WhatsApp gesendete Nachrichten können nicht weitergeleitet werden.",
            cardInfoUpdateError: "Beim Aktualisieren der Kartendaten ist ein Fehler aufgetreten",
            billingInfoSavedSuccessfully: "Ihre Abrechnungsinformationen wurden erfolgreich gespeichert",
            billingInfoSaveError: "Fehler beim Speichern der Abrechnungsinformationen:",
            paymentInfoSavedSuccessfully: "Ihre Zahlungsinformationen wurden erfolgreich gespeichert",
            annualDiscount: "Erhalten Sie 20% Rabatt auf jährliche Käufe",
            annualDiscountDescription: "Sie können durch die Wahl eines Jahresabonnements erheblich sparen.",
            payOnlyForUsedFeatures: "Zahlen Sie nur für das, was Sie nutzen",
            payOnlyForUsedFeaturesDescription: "Zahlen Sie nur für die Funktionen, die Sie nutzen, nicht für mehr.",
            cancelAnytime: "Jederzeit kündbar",
            cancelAnytimeDescription: "Keine langfristigen Verträge erforderlich, Sie können jederzeit kündigen.",
            noPermissionDescription: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
            creditCardRequired: "Kreditkarteninformationen erforderlich",
            creditCardRequiredDescription: "Sie haben kostenpflichtige Abonnements. Sie können fortfahren, indem Sie Ihre Kreditkarteninformationen eingeben oder Ihre Abonnements kündigen.",
            creditCardRequiredDescription2: "Sie müssen Kreditkarteninformationen eingeben, da Sie kostenpflichtige Abonnements in Ihrem Konto haben.",
            subscriptionManagement: "Abonnementverwaltung",
            addCreditCard: "Kreditkarteninformationen hinzufügen",
            transferOwnership: "Eigentum Übertragen und Weiterleiten",
            errorLoadingAgents: "Ein Fehler ist beim Laden der Agenten aufgetreten",
            pleaseFillRequiredFields: "Bitte füllen Sie die erforderlichen Felder aus",
            callStartedSuccessfully: "Anruf erfolgreich gestartet",
            errorStartingCall: "Ein Fehler ist beim Starten des Anrufs aufgetreten",
            errorLoadingData: "Ein Fehler ist beim Laden der Daten aufgetreten",
            errorLoadingDataPhoneNumbers: "Ein Fehler ist beim Laden der Telefonnummern aufgetreten",
            noVariablesFound: "Keine Variablen im Prompt gefunden. Variablen sollten im Format <code v-pre>{{ variablen_name }}</code> sein.",
            aiVoiceAgentSpecialVariables: "Spezielle Variablenwerte",
            addAiVoiceAgentChannel: "Kanal Hinzufügen",
            multiLanguageSupport: "Mehrsprachige Unterstützung",
            customerService247: "24/7 Kundendienst",
            autoCallAnswer: "Automatische Anrufannahme",
            aiVoiceAgentChannelRequired: "KI-Sprachagent-Kanal Erforderlich",
            aiVoiceAgentChannelRequiredDescription: "Sie müssen einen KI-Sprachagent-Kanal hinzufügen, um diese Funktion zu nutzen.",
            aiVoiceAgentChannelRequiredDescription2: "Der KI-Sprachagent ist ein KI-gestützter Assistent, der Telefongespräche mit Ihren Kunden führen kann.",
            startCall: "Anruf Starten",
            selectContactFieldPlaceholder: "Kontaktinformationen auswählen",
            aiVoiceAgentVariableValuePlaceholder: "Wert eingeben",
            aiVoiceAgentVariables: "Variableninformationen des Agenten",
            aiVoiceAgentVariableManual: "Manuell",
            aiVoiceAgentVariableContact: "Kontaktinformationen",
            toNumberHelpText: "Muss im E.164-Format sein. Beispiel: +905321234567",
            toNumber: "Anzurufende Nummer",
            selectAiVoiceAgentHelpText: "Falls nicht ausgewählt, wird der Standard-Ausgangsagent der Nummer verwendet",
            selectAiVoiceAgent: "Agent auswählen (optional)",
            aiVoiceAgent: "Agent",
            selectFromNumber: "Anrufernummer auswählen",
            fromNumber: "Anrufernummer",
            startAiCall: "Anruf mit KI-Sprachagent Starten",
            aiCall: "Anruf mit KI-Sprachagent Durchführen",
            groupByNone: "Keine Gruppierung angewendet",
            groupByAgent: "Kontakte nach den Agenten ihrer letzten Sitzung gruppieren",
            groupByDepartment: "Kontakte nach der in ihrer letzten Sitzung ausgewählten Abteilung gruppieren",
            groupByChannel: "Kontakte nach dem Kanal gruppieren, von dem sie kommen",
            groupByPlatform: "Kontakte nach der Plattform gruppieren, von der sie kommen",
            groupByWebsite: "Kontakte nach der Website gruppieren, von der sie kommen",
            groupByTag: "Kontakte nach ihren Tags gruppieren",
            groupByAnswerStatus: "Kontakte nach ihrem Antwortstatus ihrer letzten Sitzung gruppieren",
            groupByOwner: "Kontakte nach ihren Besitzern gruppieren",
            changeGroupBy: "Gruppierungsmodus Ändern",
            changeSortMode: "Sortiermodus Ändern",
            selectIcon: "Symbol Auswählen",
            iconPickerTitle: "Symbol-Auswahl",
            searchIconPlaceholder: "Symbol suchen...",
            profileFieldsDescriptionChat: "Klicken Sie, um Ihre Profilfelder anzupassen",
            createCommentSuccess: "Kommentar erfolgreich erstellt",
            createCommentError: "Fehler beim Erstellen des Kommentars",
            updateCommentSuccess: "Kommentar erfolgreich aktualisiert",
            updateCommentError: "Fehler beim Aktualisieren des Kommentars",
            deleteCommentSuccess: "Kommentar erfolgreich gelöscht",
            deleteCommentError: "Fehler beim Löschen des Kommentars",
            formSubmission: "Formularübermittlung",
            selectForm: "Formular auswählen",
            updateOwnerUsers: "Eigentümer aktualisieren",
            updateOwnerUsersDesc: "Möchten Sie die Eigentümer dieses Benutzers aktualisieren? Sie können sie einem anderen Benutzer zuweisen oder die Eigentümerlosigkeit entfernen.",
            deposit: "Einzahlung",
            creditUsage: "Kreditnutzung",
            businessMarketing: "Marketing",
            businessUtility: "Nützlichkeit",
            businessAuthentication: "Authentifizierung",
            businessService: "Dienst",
            incomingSessionMessage: "Eingehende Nachricht",
            outgoingSessionMessage: "Ausgehende Nachricht",
            freeTierConversation: "Kostenloses Gespräch (FTC)",
            chatStart: "Chat starten",
            wpMessage: "Whatsapp QR Massen-Nachricht",
            pin: "Anheften",
            rename: "Umbenennen",
            browserSpeechRecognitionNotSupported: "Ihr Browser unterstützt keine Spracherkennung. Wir empfehlen die Verwendung des Chrome-Browsers.",
            spaceKeyReleaseToSave: "Es wird gespeichert, wenn Sie die Leertaste loslassen",
            spaceKeyHint: "Sie können sprechen, indem Sie die Leertaste gedrückt halten",
            listeningInProgress: "Zuhören...",
            speakNow: "Jetzt sprechen...",
            toggleAllPermissions: "Alle Rolle Berechtigungen aktivieren/deaktivieren",
            rolePermissions: "Rolle Berechtigungen",
            roleSaved: "Die Rolle wurde aufgezeichnet.",
            creatingRole: "Rolle wird erstellt...",
            savingRole: "Rolle wird gespeichert...",
            editRole: "Rolle bearbeiten",
            newRoleCreate: "Neue Rolle erstellen",
            descriptionEmail: "Fügt die E-Mail-Adresse des Besuchers im Chat automatisch in das Nachrichtenfeld ein und ermöglicht das Senden",
            exampleEmail: "Beispiel: @email hallo",
            nameDescription: "Fügt den Namen des Besuchers im Chat automatisch in das Nachrichtenfeld ein und ermöglicht das Senden",
            exampleName: "Beispiel: @name hallo",
            pmDescription: "Ermöglicht das Senden einer privaten Nachricht. Diese Nachrichten können nur andere Kundendienstmitarbeiter sehen, Besucher nicht.",
            examplePm: "Beispiel: pm: Diese Nachricht ist privat",
            chatShortcuts: "Chat-Shortcuts",
            showSystemStatus: "Systemstatus anzeigen",
            endChatWizard: "Sitzungsbeendigung-Assistent",
            terminationError: "Fehler beim Beenden der Sitzung",
            profileFieldsUpdateError: "Fehler beim Aktualisieren der Profilfelder",
            profileFieldsUpdated: "Profilfelder aktualisiert",
            aiSuggestionError: "AI Vorschläge konnten nicht abgerufen werden",
            profileFieldsDescription: "Sie können dieser Person zusätzliche Informationen hinzufügen, um Ihrem Team mehr Informationen zu geben.",
            categoryTags: "Sie können dieser Person Tags hinzufügen, um sie schnell zu kategorisieren.",
            manageTags: "Tags verwalten",
            enterNote: "Not eingeben",
            noteDescription: "Sie können Notizen zu dieser Person hinzufügen. Diese Notizen werden auch nach der Konversation angezeigt.",
            suggestedProfileFields: "Vorgeschlagene Profilfelder:",
            suggestedTags: "Vorgeschlagene Tags",
            suggestedNote: "Vorgeschlagene Notiz:",
            applyAll: "Alle anwenden",
            aiSuggestionTitle: "Künstliche Intelligenz Vorschläge",
            aiSuggestion: "Supsis Asistan-Vorschläge",
            searchItem: "Suche nach Element",
            makeSelection: "Auswahl Treffen",
            FromName: "Name des Absenders",
            taskClosingDate: "Aufgabenabschlussdatum",
            confirmDeleteTask: "Sind Sie sicher, dass Sie diese Aufgabe löschen möchten?",
            taskDeletedSuccess: "Aufgabe erfolgreich gelöscht",
            taskDeleteError: "Fehler beim Löschen der Aufgabe",
            selectColumns: "Wählen Sie die Spalten aus, die Sie in der Tabelle sehen möchten",
            linkedinChannels: "LinkedIn-Kanäle",
            updateLinkedinChannelDesc: "Aktualisieren Sie Ihren LinkedIn-Kanal",
            deleteLinkedinChannel: "LinkedIn-Kanal Löschen",
            confirmDeleteLinkedinChannel: "Sind Sie sicher, dass Sie diesen LinkedIn-Kanal löschen möchten?",
            contactIdPlaceholder: "Kontakt-ID",
            contactId: "Kontakt-ID",
            enterOwnerId: "Besitzer-ID eingeben",
            selectOwner: "Besitzer auswählen",
            dynamic: "Dynamisch",
            owner: "Besitzer",
            addCollaborator: "Mitarbeiter hinzufügen",
            dynamicValue: "Dynamischer Wert",
            selectCollaborator: "Mitarbeiter auswählen",
            collaborator: "Mitarbeiter",
            collaborators: "Mitarbeiter",
            addFollower: "Follower hinzufügen",
            selectFollower: "Follower auswählen",
            followers: "Follower",
            follower: "Follower",
            addAssignee: "Zugewiesenen hinzufügen",
            selectUser: "Benutzer auswählen",
            assignees: "Zugewiesene",
            assignee: "Zugewiesener",
            pipelineStage: "Pipeline-Phase",
            selectPipelineStage: "Pipeline-Phase auswählen",
            title: "Titel",
            taskTitle: "Aufgabentitel",
            description: "Beschreibung",
            taskDescription: "Aufgabenbeschreibung",
            priority: "Priorität",
            selectPriority: "Priorität auswählen",
            workflow: "workflow",
            selectWorkflow: "Workflow auswählen",
            packagePurchase: "Paketkauf",
            upcomingInvoice: "Kommende Rechnung",
            invoiceUpdated: "Rechnung aktualisiert",
            invoiceMarkedInvalid: "Rechnung als ungültig markiert.",
            invoiceUpdateError: "Fehler bei der Rechnungsaktualisierung",
            invoiceMarkInvalidError: "Beim Markieren der Rechnung als ungültig ist ein Fehler aufgetreten.",
            refunded: "Erstattet",
            paid: "Bezahlt",
            pending: "Ausstehend",
            unpaid: "Unbezahlt",
            paymentFailed: "Zahlung fehlgeschlagen",
            paymentProcessError: "Während des Zahlungsvorgangs ist ein Fehler aufgetreten.",
            paymentSuccessful: "Zahlung erfolgreich",
            paymentProcessSuccessful: "Der Zahlungsvorgang wurde erfolgreich abgeschlossen.",
            invoiceRefund: "Rechnungserstattung",
            invoiceRefundedSuccessfully: "Die Rechnung wurde erfolgreich erstattet.",
            invoicePaymentError: "Fehler bei der Rechnungszahlung",
            invoicePaymentProcessError: "Während der Rechnungszahlung ist ein Fehler aufgetreten.",
            invoicePaid: "Rechnung bezahlt",
            invoiceMarkedAsPaid: "Die Rechnung wurde erfolgreich als bezahlt markiert.",
            invoicePriceUpdateError: "Beim Aktualisieren des Rechnungspreises ist ein Fehler aufgetreten.",
            invoicePriceUpdatedSuccessfully: "Der Rechnungspreis wurde erfolgreich aktualisiert.",
            invoicePdf: "Rechnung PDF",
            viewInvoice: "Rechnung anzeigen",
            makePayment: "Zahlung durchführen",
            autoForwardToOwnerForceDescription: "In allen Fällen werden Kontakte mit Eigentümer automatisch an ihren Eigentümer weitergeleitet. Sie werden weder in der Warteschlange gehalten noch an den Chatbot übertragen. Selbst wenn diese Einstellung deaktiviert ist, werden sie an ihren Eigentümer weitergeleitet, wenn der Chatbot im System nicht aktiv ist.",
            utoForwardToOwnerForce: "Automatische Weiterleitung an Eigentümer (auch bei aktivem Chatbot)",
            socialMedia: "Soziale Medien",
            web: "Web",
            email: "Email",
            sms: "SMS",
            crm: "CRM",
            ecommerce: "E-Commerce",
            utilities: "Dienstprogramme",
            advertising: "Werbung",
            cancelPlanTitle: "Planabbrechung",
            cancelPlanDescription: "Nach der Planabbrechung wird Ihr Paket bis zum Ende des Tages weiter verwendet.",
            voteSuccess: "Abstimmung erfolgreich gespeichert",
            voteSuccessDescription: "Wir haben Ihre Anfrage erhalten, die Integration {integrationName} zu Supsis hinzuzufügen.",
            companyName: "Name des Unternehmens",
            company: "Unternehmen",
            languageTitle1: "Standardsprache des Panels",
            languageTitle2: "Standardsprache der Nachrichten",
            languageTitle3: "Region & Zeitzone",
            languageTitle4: "Automatische Spracheinstellung für Kunden",
            languageTitle5: "Auswahl der Sprache für Kunden-Nachrichten im WebChat",
            languageDesc1: "Legt die Sprache des Supsis AI-Panels fest",
            languageDesc2: "Hier können Sie die Standardsprache der Nachrichten ändern.",
            languageDesc3: "Legt die Region und die Zeitzone fest",
            languageDesc4: "Ermöglicht die automatische Erkennung der Sprache der Kunden-Nachrichten mit Unterstützung von KI.",
            languageDesc5: "Aktiviert die Funktion, die es dem Kunden ermöglicht, seine gesprochene Sprache im WebChat-Kanal auszuwählen.",
            featuresTitle1: "Abteilungswahl",
            featuresTitle2: "Anzahl der wartenden Kunden anzeigen",
            featuresTitle3: "Einschränkung verbotener Wörter",
            featuresTitle4: "Kunden das Erstellen von Tickets erlauben",
            featuresTitle5: "Sprachanruf",
            featuresTitle6: "Videoanruf",
            featuresTitle7: "Sprachnachricht senden (Agent)",
            featuresTitle8: "Sprachnachricht senden (Kunde)",
            featuresTitle9: "Automatische Anrufweiterleitung",
            featuresTitle10: "Chat zwischen Vertretern anzeigen",
            featuresTitle11: "Datei senden (Agent)",
            featuresTitle12: "Datei senden im WebChat (Kunde)",
            featuresTitle13: "Nachrichtensenden vor der Verbindung des Vertreters erlauben",
            featuresTitle14: "Systemnachrichten von Vertretern ausblenden",
            featuresTitle15: "Kunden das Löschen persönlicher Informationen erlauben",
            featuresTitle16: "Benachrichtigung über Online-Status des Kunden",
            featuresTitle17: "Automatische Übersetzung",
            featuresTitle18: "Automatische Anmeldung des Besuchers",
            featuresTitle19: "Standortfreigabe im WebChat (Kunde)",
            featuresTitle20: "Standortfreigabe (Vertreter)",
            featuresTitle21: "Chat AI Copilot",
            featuresTitle22: "Warteschlange für unbesessene Gespräche",
            featuresTitle23: "Kontaktinformationen ausblenden",
            featuresDesc1: "Verpflichtende Weiterleitung zu Abteilungen basierend auf den vom Kunden ausgewählten Themen.",
            featuresDesc2: "Zeigt Kunden ihre Position in der Warteschlange, wenn die Vertreter beschäftigt sind.",
            featuresDesc3: "Verhindert, dass Vertreter verbotene Wörter, die im System definiert sind, an Kunden senden, wenn die Einschränkung verbotener Wörter aktiv ist.",
            featuresDesc4: "Aktiviert die Option, ein Ticket im WebChat-Fenster zu erstellen.",
            featuresDesc5: "Aktiviert die Sprachruf-Funktion im WebChat-Fenster.",
            featuresDesc6: "Aktiviert die Videoanruf-Funktion im WebChat-Fenster.",
            featuresDesc7: "Ermöglicht es Vertretern, Sprachnachrichten zu senden.",
            featuresDesc8: "Ermöglicht es Kunden, Sprachnachrichten im WebChat-Kanal zu senden.",
            featuresDesc9: "Weist wartende Anrufe automatisch verfügbaren Vertretern zu.",
            featuresDesc10: "Zeigt das Gesprächsfenster zwischen Vertretern an.",
            featuresDesc11: "Ermöglicht es Vertretern, Dateien zu senden.",
            featuresDesc12: "Ermöglicht es Kunden, Dateien im WebChat-Kanal zu senden.",
            featuresDesc13: "Ermöglicht es Kunden, Nachrichten zu senden, bevor ein Vertreter sich verbindet.",
            featuresDesc14: "Blendet Systemnachrichten von Vertretern aus, sodass Kunden diese nicht sehen können.",
            featuresDesc15: "Aktiviert die Möglichkeit für Kunden, ihre persönlichen Informationen mit einem Klick im WebChat-Fenster zu löschen.",
            featuresDesc16: "Benachrichtigt Vertreter mit einer Systemnachricht, wenn ein Kunde den WebChat-Kanal verlässt oder zurückkehrt.",
            featuresDesc17: "Übersetzt automatisch Nachrichten von Kunden in die Sprache des Vertreters.",
            featuresDesc18: "Beginnt das Gespräch, sobald der Besucher auf das Fenster klickt.",
            featuresDesc19: "Aktiviert die Möglichkeit für Kunden, ihren Standort im WebChat-Kanal zu teilen.",
            featuresDesc20: "Aktiviert die Möglichkeit für Vertreter, ihren Standort zu teilen.",
            featuresDesc21: "Aktiviert die Nutzung von KI-Hilfe für Vertreter zur Korrektur von Tippfehlern, zur Änderung des Tons von Nachrichten und zur Generierung von KI-unterstützten Antworten.",
            featuresDesc22: "Aktiviert diese Funktion, um Personen ohne Eigentum in der Warteschlange zu halten.",
            featuresDesc23: "Verhindert, dass Vertreter die Telefonnummern und E-Mail-Adressen der Kunden sehen.",
            featuresTitle24: "Sitzungsende-Assistent",
            featuresDesc24: "Zeigt den Sitzungsbeendigungs-Assistenten den Vertretern vor dem Schließen des Gesprächs an",
            groupBy: "Gruppieren",
            privacyPolicyAndTerms: "Datenschutzrichtlinie / Nutzungsbedingungen",
            privacyPolicyTitle: "Datenschutzrichtlinie für Supsis Live Support & Chatbot-Systeme",
            privacyPolicyDescription: "Diese Datenschutzrichtlinie beschreibt, wie Softcand Yazılım Hizmetleri A.S. („Softcand“, „wir“, „uns“ oder „unser“) Informationen über Benutzer („Sie“ oder „Ihr“) der Supsis-Webanwendung („Supsis“) sammelt, verwendet und offenlegt. Diese Datenschutzrichtlinie gilt für die Informationen, die wir sammeln, wenn Sie Supsis verwenden; diese Informationen sind gültig, wenn sie über unsere Website, mobile Anwendungen oder andere Plattformen, auf denen die Datenschutzrichtlinie veröffentlicht ist, abgerufen werden.",
            informationWeCollect: "Informationen, die wir sammeln",
            weCollectFollowingInformation: "Wir sammeln die folgenden Informationen",
            customerAccountInformation: "Kundenkontoinformationen",
            customerAccountData: "Bei der Erstellung eines Supsis-Kontos sammeln wir die folgenden Daten: Vorname, Nachname, Telefonnummer und E-Mail-Adresse.",
            userInformation: "Benutzerinformationen",
            userProvidedInformation: "Von den Benutzern der Anwendung bereitgestellte Informationen, einschließlich Vorname, Nachname und E-Mail-Adresse.",
            dataDeletionProcess: "Datenlöschprozess",
            dataDeletionProcedures: "Wir folgen diesen Verfahren zur Datenlöschung",
            automaticDeletion: "Automatische Löschung",
            automaticDeletionInfo: "Kundenkonten werden automatisch gelöscht, wenn sie geschlossen werden oder nach sechs Monaten Inaktivität.",
            directRequest: "Direkte Anfrage",
            directRequestInfo: "Kunden können die Löschung aller ihrer Daten anfordern, indem sie uns direkt kontaktieren.",
            websiteVisitorDataDeletion: "Löschung von Daten von Website-Besuchern",
            websiteVisitorDataDeletionInfo: "Website-Besucher können ihre Daten, einschließlich Chatverlauf, Nachrichten und Dateien, direkt über die Web-Chat-Oberfläche löschen.",
            howToContactUs: "Wie Sie uns kontaktieren können",
            contactChannels: "Sie können uns über die folgenden Kanäle erreichen",
            dataProcessingAndSharing: "Datenverarbeitung und -weitergabe",
            handleCustomerData: "Wir verarbeiten Kundendaten wie folgt",
            noThirdPartySharing: "Keine Weitergabe an Dritte",
            noThirdPartySharingInfo: "Supsis gibt keine Kundendaten an Dritte, Organisationen oder Einzelpersonen weiter.",
            promotionalEmails: "Werbe-E-Mails",
            promotionalEmailsInfo: "Wir können Kunden Werbe-E-Mails senden; sie können sich von diesen E-Mails abmelden.",
            visitorAndConversationData: "Daten von Besuchern und Gesprächen",
            noSharingVisitorData: "Wir teilen oder verwenden keine Informationen über Kundenbesucher und Chats.",
            thirdPartyServices: "Dienste Dritter",
            googleOAuth: "Google OAuth",
            googleCalendar: "Google Kalender",
            googleCalendarInfo: "Supsis verwendet Google Kalender, um kalenderbezogene Funktionen innerhalb der Anwendung zu aktivieren. Daten, die aus Kalendern synchronisiert werden, werden nicht mit anderen geteilt und sind nur für den Benutzer sichtbar. Wenn Google OAuth abläuft, werden alle synchronisierten Ereignisse von Supsis und Google Kalender automatisch gelöscht.",
            googleAccountPublicProfile: "Öffentliches Profil des Google-Kontos",
            googleAccountPublicProfileInfo: "Supsis sammelt Name und E-Mail-Informationen, um Benutzer während der Anmeldung zu überprüfen und zu authentifizieren. Diese Informationen werden nach der Überprüfung nicht gespeichert.",
            changesToPrivacyPolicy: "Änderungen an dieser Datenschutzrichtlinie",
            privacyPolicyUpdateInfo: "Wir können diese Datenschutzrichtlinie von Zeit zu Zeit aktualisieren. Wenn wir wesentliche Änderungen vornehmen, werden wir Sie über unsere Website oder andere Kommunikationskanäle informieren.",
            privacyPolicyContactInfo: "Wenn Sie Fragen zu dieser Datenschutzrichtlinie haben, kontaktieren Sie uns bitte unter m@softcand.com.",
            termsOfServiceTitle: "Nutzungsbedingungen für Supsis Live Support & Chatbot-Systeme",
            lastUpdated: "Letzte Aktualisierung",
            inEffect: "In Kraft",
            importantTerms: "Wichtig: Diese Nutzungsbedingungen, die auch unsere Datenschutzrichtlinie enthalten, bilden einen verbindlichen Vertrag zwischen der Person, die im Registrierungsprozess als Benutzer des Dienstes bezeichnet wird („Sie“), und Softcand Yazılım Hizmetleri Anonim Şirketi (handelnd unter dem Namen Supsis oder Supsis Live Support oder Supsis Live Support und Chatbot-Systeme) („wir“) und regeln Ihre Nutzung unserer Websites, die sich auf supsis.com (Produkt-Startseite), softcand.com (Unternehmenswebsite) oder supsis.live (Produktanwendung) oder beta.supsis.live (Beta-Version der Produktanwendung) befinden. Aus diesem Grund sind diese Bedingungen wichtig, und Sie sollten sicherstellen, dass Sie sie sorgfältig lesen und uns bei Fragen vor der Nutzung des Dienstes kontaktieren.",
            termsDescription: "Diese Nutzungsbedingungen regeln Ihre Nutzung unserer Websites, die sich auf supsis.com (Produkt-Startseite), softcand.com (Unternehmenswebsite) oder supsis.live (Produktanwendung) oder beta.supsis.live (Beta-Version der Produktanwendung) befinden.",
            applicationOfTerms: "Anwendung der Bedingungen",
            termsApplyToAllUsers: "Diese Bedingungen gelten für alle Benutzer des Dienstes, unabhängig davon, ob Sie den Dienst in Ihrem eigenen Namen oder im Namen einer anderen Person oder Organisation nutzen.",
            termsUpdateNotice: "Wir können die Bedingungen jederzeit nach unserem Ermessen aktualisieren oder ändern. Wenn wir die Bedingungen ändern, werden wir Sie informieren, indem wir Sie über unsere Webplattform und per E-Mail benachrichtigen.",
            termsDisagreementNotice: "Sie müssen den aktualisierten Bedingungen zustimmen, indem Sie Ihre Zustimmung in der Ihnen vorgelegten Mitteilung anklicken, bevor Sie den Dienst weiterhin nutzen.",
            consumerRightsNotice: "Wenn Sie gemäß geltendem Recht als 'Verbraucher' eingestuft werden, haben Sie möglicherweise gesetzliche Rechte gemäß diesem lokalen Recht, die die Anwendung aller oder Teile einiger der in diesen Bedingungen festgelegten Einschränkungen und Ausschlüsse für Sie verbieten, und in diesem Fall gelten diese Teile nicht für Sie.",
            theService: "Der Dienst",
            serviceGrant: "Wir gewähren Ihnen ein nicht-exklusives, weltweites, nicht übertragbares, widerrufbares Recht zur Nutzung des Dienstes gemäß diesen Bedingungen.",
            serviceAccess: "Sie können auf den Dienst zugreifen und ihn nutzen (einschließlich aller zufälligen Kopien, die im Rahmen dieser Nutzung entstehen) gemäß diesen Bedingungen.",
            serviceAgentAppointment: "Wenn Sie sich in den Dienst einloggen und ein Social-Media-Konto mit dem Dienst verbinden, ernennen Sie uns zu Ihrem Vertreter in Bezug auf dieses Konto, um in Ihrem Namen und nach Ihren Anweisungen (z. B. um auf eine direkte Nachricht auf Instagram oder einer anderen Plattform zu antworten) zu handeln, um Ihnen den Dienst bereitzustellen.",
            additionalAccountsAppointment: "Wenn Sie zusätzliche Konten mit dem Dienst verbinden, ernennen Sie uns auch zu Ihrem Vertreter in Bezug auf diese Konten, um die Aktivitäten im Rahmen der Agentur durchzuführen.",
            accountControl: "Sie garantieren, dass Sie jedes Konto kontrollieren und dass Sie befugt sind, uns als Ihren Vertreter mit der Befugnis zu ernennen, die Aktivitäten im Rahmen der Agentur in Ihrem Namen für jedes Konto durchzuführen.",
            serviceAffiliation: "Sie erkennen an und stimmen zu, dass der Dienst nicht mit Instagram, Facebook, Twitter oder einem anderen sozialen Dienst verbunden oder von diesen autorisiert ist, für den wir den Dienst bereitstellen, und dass jeder Zugriff auf jede Plattform (einschließlich über den Dienst) durch die Nutzungsbedingungen der jeweiligen Plattform geregelt wird.",
            serviceLinks: "Der Dienst enthält Links zu anderen Websites sowie Inhalte, die von Personen erstellt wurden, die nicht wir sind. Wir unterstützen, sponsern oder genehmigen keinen solchen nutzergenerierten Inhalt oder Inhalte, die auf einer verlinkten Website verfügbar sind.",
            contentMonitoring: "Wir haben keine Verpflichtung, Inhalte zu überwachen, zu bearbeiten oder zu entfernen, die von unseren Benutzern in den Dienst hochgeladen oder veröffentlicht und dann auf einem Konto auf einer der Plattformen veröffentlicht werden.",
            serviceControl: "Sie erkennen an und stimmen zu, dass: (1) wir die Kontrolle über den Dienst behalten und den Dienst jederzeit nach unserem Ermessen ändern, ergänzen oder einstellen können (wir werden Sie angemessen über jede Änderung informieren, die die Funktionalität des Dienstes erheblich negativ beeinflusst); (2) der Dienst von Zeit zu Zeit nicht verfügbar sein kann (einschließlich zu Wartungszwecken), und soweit möglich werden wir Sie über geplante Ausfallzeiten informieren; und (3) wir können die Veröffentlichung von Inhalten, die Sie dem Dienst hinzufügen, ablehnen, wenn wir der Meinung sind, dass diese Inhalte, nach unserem Ermessen, nicht mit Abschnitt 3 dieser Bedingungen übereinstimmen.",
            yourRightsAndObligations: "Ihre Rechte und Pflichten",
            contentAdditionRestriction: "Sie dürfen keine Inhalte zum Dienst hinzufügen: (1) es sei denn, Sie besitzen alle erforderlichen Rechte, Lizenzen und Zustimmungen; (2) die dazu führen könnten, dass Sie oder wir gegen ein Gesetz oder eine Vorschrift oder eine andere rechtlich durchsetzbare Regel, einen Kodex oder eine andere Verpflichtung verstoßen; (3) die spam, obszön, unangemessen, verleumderisch, herabwürdigend, unanständig, aufrührerisch, beleidigend, pornografisch, bedrohlich, missbräuchlich, zu Hass aufstachelnd, rechtswidrig, diskriminierend, blasphemisch, das Vertrauen verletzend oder gegen ein Datenschutzgesetz verstoßend ist; (4) die uns oder den Dienst in Misskredit bringen würde; oder (5) die die geistigen Eigentumsrechte oder andere Rechte einer Person verletzen.",
            restrictionsOnServiceUse: "Sie dürfen Folgendes nicht tun: (1) versuchen, den Dienst, Inhalte, die wir in Bezug auf den Dienst veröffentlichen, oder anderes Material, das Sie nicht besitzen oder für das Sie keine entsprechende Lizenz haben, zu duplizieren, zu replizieren oder zu reproduzieren, zu ändern oder abgeleitete Werke zu erstellen; (2) Viren oder andere bösartige Codes zu verbreiten; (3) den Dienst zu nutzen, um irreführende oder täuschende Informationen zu veröffentlichen; (4) ohne Erlaubnis auf das Konto einer anderen Person in unserem Dienst zuzugreifen; (5) einen Aspekt des Dienstes zu ändern, zu deaktivieren, zu stören oder zu umgehen oder den Dienst zu testen oder zurückzuentwickeln, um Einschränkungen, Schwachstellen zu finden oder Filterfähigkeiten zu umgehen; oder (6) irgendetwas zu tun, das den Zugang zum Dienst oder die Integrität des Dienstes beeinträchtigen könnte.",
            payments: "Zahlungen",
            paymentAcknowledgment: "Sie erkennen an und stimmen zu, dass:",
            paymentMethodDebit: "Wir werden am angegebenen Rechnungsdatum (dem Tag, an dem Ihre Testphase endet) jeden Monat, Jahr oder anderen Rechnungszeitraum (sofern zutreffend) im Voraus von der von Ihnen angegebenen Zahlungsmethode abbuchen; und",
            cancellationPolicy: "Wenn Sie den Dienst kündigen, haben Sie bis zu Ihrem nächsten Rechnungsdatum weiterhin Zugang zum Dienst, und eine Rückerstattung von für den aktuellen Rechnungszeitraum gezahlten Beträgen liegt in unserem Ermessen (d. h. Zahlungen sind nicht erstattungsfähig, es sei denn, es liegt in unserem Ermessen).",
            intellectualProperty: "Geistiges Eigentum",
            contentDefinition: "In diesen Bedingungen umfasst 'Inhalt' Materialien in Text-, Audio-, Grafik-, Bild- und Videoform oder jede Kombination von Materialien in jeder Form.",
            intellectualPropertyRightsTransfer: "Nichts in diesen Bedingungen stellt eine Übertragung von Rechten an geistigem Eigentum dar. Sie erkennen an und stimmen zu, dass wir alle Rechte an geistigem Eigentum im Dienst besitzen (d. h. wir besitzen die Rechte an den Anwendungen, die wir Ihnen zur Verfügung stellen – wir besitzen keine Rechte an geistigem Eigentum an Ihrem Inhalt – siehe unten in 5(3)).",
            userContentRights: "Wir erkennen an, dass Sie zwischen Ihnen und uns alle Rechte an geistigem Eigentum an den Inhalten, die Sie dem Dienst zur Verfügung stellen oder uns anderweitig zur Verfügung stellen, um den Dienst bereitzustellen, besitzen oder eine Lizenz dafür haben.",
            grantLicense: "Sie gewähren uns ein unbefristetes, nicht-exklusives, lizenzfreies, unwiderrufliches, weltweites und übertragbares Recht und eine Lizenz zur Nutzung, auf jede Weise (einschließlich durch Veröffentlichung auf einem Konto auf einer Plattform, wie von Ihnen angewiesen): (a) Inhalte, die Sie dem Dienst hinzufügen; und (b) Profilinhalte auf sozialen Medienplattformen, die mit Ihrem Konto verbunden sind (einschließlich, aber nicht beschränkt auf, durch Vervielfältigung, Änderung oder Anpassung und öffentliche Kommunikation dieser Inhalte) zu Zwecken der Bereitstellung des Dienstes für Sie.",
            subLicense: "Wir können die Lizenz in Absatz 5(4) an Drittanbieter, die uns bei der Bereitstellung des Dienstes unterstützen, unterlizenzieren.",
            moralRights: "In einigen Ländern, in denen der Dienst betrieben wird, erkennt das lokale Recht an, dass Autoren von Inhalten möglicherweise 'moralische Rechte' in Bezug auf die Inhalte haben. Beispiele für moralische Rechte können das Recht umfassen, als Autor von Inhalten genannt zu werden, das Recht, gegen falsche Zuschreibungen der Urheberschaft von Inhalten Einspruch zu erheben, und das Recht, in bestimmten Fällen gegen herabwürdigende Behandlungen von Inhalten Einspruch zu erheben.",
            licenseSurvival: "Die Lizenz in Absatz 5(4) bleibt auch nach Beendigung dieser Bedingungen in Kraft.",
            rightsRepresentation: "Sie erklären und garantieren uns, dass Sie alle erforderlichen Rechte haben, um die in diesem Absatz 5 festgelegten Lizenzen und anderen Verpflichtungen zu gewähren.",
            warranties: "Garantien",
            warrantiesAcknowledgment: "Sie erklären und garantieren uns, dass:",
            accountOwnership: "Alle Konten, auf jeder Plattform, die dem Dienst hinzugefügt werden, gehören oder werden von Ihnen kontrolliert;",
            serviceUsageAgreement: "Sie werden den Dienst in Übereinstimmung mit diesen Bedingungen nutzen; und",
            legalCapacity: "Sie haben die rechtliche Fähigkeit und die Befugnis, diese Bedingungen einzugehen.",
            liability: "Haftung",
            liabilityForLoss: "Sie sind für jeden Verlust oder Schaden verantwortlich, der entsteht, wenn Sie Ihre Verpflichtungen aus diesen Bedingungen verletzen oder wenn Sie bei der Nutzung des Dienstes nicht die angemessene Sorgfalt walten lassen. Ihre Haftung wird in dem Maße reduziert, in dem wir diesen Verlust oder Schaden durch unser eigenes Verschulden oder unsere eigene Unterlassung bei der Bereitstellung des Dienstes verursachen oder dazu beitragen.",
            indemnification: "Sie stellen uns von allen Verlusten oder Schäden frei, die wir aufgrund Ihrer Verletzung dieser Bedingungen (einschließlich der Garantien, die Sie uns gemäß diesen Bedingungen geben) oder aufgrund von vorsätzlichem Fehlverhalten, rechtswidrigen Handlungen oder Fahrlässigkeit bei Ihrer Nutzung oder missbräuchlichen Nutzung des Dienstes erleiden.",
            exclusionOfLiability: "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen schließen wir jegliche Haftung für alle Ansprüche, Ausgaben, Verluste, Schäden und Kosten aus, die gegen Sie geltend gemacht werden oder die Sie direkt oder indirekt im Zusammenhang mit Ihrer Nutzung des Dienstes oder Ihrer Unfähigkeit, den Dienst zu nutzen, erleiden, einschließlich wirtschaftlicher Verluste, Datenverluste, Betriebsunterbrechungen oder sonstige Folgeschäden.",
            totalLiabilityLimit: "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen ist unsere Gesamthaftung Ihnen gegenüber für Vertragsverletzungen gemäß diesen Bedingungen, für Delikte (einschließlich Fahrlässigkeit) oder aus einem anderen Grund auf einen Betrag beschränkt, der der Gesamtsumme entspricht, die Sie für den Dienst im Monat vor dem Tag, an dem unsere Haftung entstanden ist, gezahlt oder zu zahlen haben.",
            exclusionOfTerms: "Soweit gesetzlich zulässig und vorbehaltlich der Bestimmungen 7(5) und 7(6) dieser Bedingungen schließen wir alle Bedingungen, Erklärungen, Garantien, Bedingungen, Zusicherungen oder Verpflichtungen (ob ausdrücklich oder stillschweigend) aus, die nicht ausdrücklich in diesen Bedingungen festgelegt sind.",
            statutoryObligations: "In einigen Rechtsordnungen kann das Gesetz verlangen, dass bestimmte Garantien, Bedingungen, Zusicherungen oder Verpflichtungen in Bezug auf den Dienst in diese Bedingungen aufgenommen oder unserer Bereitstellung des Dienstes auferlegt werden ('gesetzliche Verpflichtungen'). Darüber hinaus kann das Gesetz andere Bedingungen, die den Ausschluss, die Begrenzung oder die Änderung auferlegter Bedingungen oder die Ausübung von Rechten und Rechtsmitteln oder die Rückforderung von Entschädigungen, die Ihnen zur Verfügung stehen, wenn wir eine auferlegte Bedingung verletzen, verbieten oder für nichtig erklären ('gesetzliches Verbot').",
            statuteProhibition: "Wenn das in Absatz 7(6) genannte Gesetz auf diese Bedingungen, wie sie von Ihnen akzeptiert wurden, oder auf den Ihnen bereitgestellten Dienst anwendbar ist, ist nichts in diesen Bedingungen dazu bestimmt, ein gesetzliches Verbot zu sein oder zu wirken. Insbesondere ist kein Teil dieser Bedingungen dazu bestimmt, unsere Haftung zu beschränken, wo dieser Teil ein gesetzliches Verbot wäre.",
            termination: "Kündigung",
            terminationAutomatic: "Diese Bedingungen enden automatisch, wenn wir aus irgendeinem Grund den Dienst einstellen.",
            terminationNotice: "Wir können Ihren Zugang zum Dienst auch sofort kündigen oder aussetzen, wenn wir der Meinung sind, dass Sie diese Bedingungen in irgendeiner Weise verletzt haben.",
            cancelService: "Sie können den Dienst jederzeit kündigen, indem Sie uns benachrichtigen, und Sie können bis zum Ende Ihres aktuellen Abrechnungszeitraums weiterhin auf den Dienst zugreifen.",
            terminationRights: "Alle Ihnen in diesen Bedingungen gewährten Rechte enden mit der Kündigung.",
            assignmentRestriction: "Sie dürfen Ihre Rechte aus diesen Bedingungen nicht abtreten, unterlizenzieren oder anderweitig damit verfahren.",
            invalidProvision: "Wenn eine Bestimmung dieser Bedingungen ungültig oder nicht durchsetzbar ist, ist sie in dem erforderlichen Umfang zu lesen oder zu trennen, ohne die Gültigkeit oder Durchsetzbarkeit der verbleibenden Bestimmungen zu beeinträchtigen.",
            expenseResponsibility: "Jede Partei muss auf eigene Kosten alles tun, was vernünftigerweise erforderlich ist, um diesem Vertrag und den darin vorgesehenen Ereignissen volle Wirkung zu verleihen.",
            governingLaw: "Diese Bedingungen unterliegen den Gesetzen der Türkei, und jede Partei unterwirft sich der Gerichtsbarkeit der Gerichte der Türkei.",
            privacyPolicyTab: "Datenschutzrichtlinie",
            termsAndConditionsTab: "Nutzungsbedingungen",
            placeholders: "Platzhalter",
            deleteOperation: "Löschvorgang",
            deleteConfirmationMessage: "Sind Sie sicher, dass Sie diesen Filter löschen möchten?",
            deleteSuccess: "Filter erfolgreich gelöscht",
            filterSavedSuccessfully: "Der Filter wurde erfolgreich gespeichert",
            filterCreatedMessage: "Der soeben erstellte Filter {filterName} ist jetzt verfügbar und kann jederzeit verwendet werden.",
            copyImage: "Bild kopieren",
            copyText: "Text kopieren",
            translateVisitorMessage: "Nachricht übersetzen",
            replyMessage: "Antworten",
            downloading: "Datei wird heruntergeladen...",
            downloadSuccess: "Datei erfolgreich heruntergeladen",
            downloadFailed: "Datei-Download fehlgeschlagen",
            filterName: "Filtername",
            enterFilterName: "Geben Sie den Filternamen ein",
            selectVisibility: "Sichtbarkeit auswählen",
            public: "Öffentlich",
            private: "Privat",
            includeExistingFilters: "Bestehende Filter einbeziehen",
            includeSearchTerm: "Suchbegriff einbeziehen",
            includeSortOrder: "Sortierreihenfolge einbeziehen",
            includeGroupingSelection: "Gruppierungsauswahl einbeziehen",
            saveFilter: "Filter speichern",
            ban: "Sperren",
            forwardToDepartmentAndAssign: "An Abteilung weiterleiten und zuweisen",
            storageSpace: "Speicherplatz",
            completed: "Abgeschlossen",
            failed: "Fehlgeschlagen",
            cancelled: "Storniert",
            running: "Läuft",
            paused: "Pausiert",
            queued: "In der Warteschlange",
            scheduled: "Geplant",
            metaLead: "Meta Lead",
            agent: "Agent",
            invoice: "Rechnung",
            whatsapp: "WhatsApp",
            reservation: "Reservierung",
            chatbot: "Chatbot",
            webhook: "Webhook",
            table: "Tabelle",
            tag: "Tag",
            low: "Niedrig",
            lowest: "Am niedrigsten",
            medium: "Mittel",
            high: "Hoch",
            highest: "Am höchsten",
            createDepartment: "Abteilung erstellen",
            goToLink: "Zum Link gehen",
            emailAddressYouProvide: "Mit der angegebenen E-Mail-Adresse wurde bereits ein Konto erstellt.",
            channelPrivacyPolicyNotMet: "Die Kanal-Datenschutzrichtlinie wird nicht erfüllt",
            userIsNotInDepartment: "Der Benutzer befindet sich nicht in dieser Abteilung",
            currentDepartment: "Aktuelle Abteilung",
            validDepartment: "Gültige Abteilung",
            youCanForwardToThisDepartment: "Sie können die Konversation an diese Abteilung weiterleiten",
            goToSettings: "Zu den Einstellungen gehen",
            changeDepartmentAndForward: "Abteilung ändern und weiterleiten",
            selectDepartmentToForwardAgent: "Bitte wählen Sie aus, durch welche Abteilung Sie das Gespräch für den Agenten mit dem Namen {selectAgentName} leiten möchten.",
            selectDepartmentToForward: "Bitte wählen Sie die Abteilung, an die Sie weitergeleitet werden möchten",
            packageConfirmationMessage: "Sind Sie sicher, dass Sie das Paket kaufen möchten? Das Paket, das Sie kaufen, unterliegt Echtzeitgebühren. Nach der Stornierung können Sie es ein Jahr lang weiter nutzen. Der Preis dieses Produkts ist ohne 20% MwSt.",
            packagePurchaseConfirmation: "Sind Sie sicher, dass Sie das Paket kaufen möchten? Monatlich abonnierte Pakete werden zu Beginn jedes Monats berechnet. Die Nutzung des Pakets endet nach dem Stornierungsdatum. Der Preis dieses Produkts ist ohne 20% MwSt.",
            annualPurchaseDiscount: "Nutzen Sie das 30%-Rabattangebot bei Jahreskäufen!",
            customerTables: "Kunden-Tabellen",
            formIntegration: "Formularintegration",
            automationIntegration: "Automatisierungsintegration",
            remainingAutomationTask: "Verbleibende Automatisierungsaufgabe",
            createUserError: "Ein Fehler ist beim Erstellen des Benutzers aufgetreten",
            sendTemplateMessage: "Vorlagennachricht senden",
            startChatWithDifferentChannel: "Chat mit anderem Kanal starten",
            whatsappChatStarter: "WhatsApp-Chat-Starter",
            pressEnterToJoin: "Drücken Sie Enter, um dem Chat beizutreten",
            pressEnterToStartChat: "Drücken Sie Enter, um den Chat zu starten",
            cannotSendMessage: "Sie können dieser Person keine Nachricht senden",
            cannotSendSessionMessage: "Sie können dieser Person keine Sitzungsnachricht senden",
            conversationNotInYourDepartments: "Diese Konversation gehört zu keiner Ihrer Abteilungen",
            customizeImage: "Wenn Sie das Bild anpassen möchten",
            clickToUpload: "Klicken Sie hier, um ein Bild hochzuladen",
            uploadNote: "Folgende Dateiformate und deren Größen werden für den Upload akzeptiert",
            imageSize: "Das Bild konnte nicht hochgeladen werden, da es größer als 2 MB ist",
            videoSize: "Das Video konnte nicht hochgeladen werden, da es größer als 20 MB ist",
            documentSize: "Das Dokument konnte nicht hochgeladen werden, da es größer als 2 MB ist",
            uploading: "Bild wird hochgeladen, bitte warten...",
            uploadSuccess: "Bild erfolgreich hochgeladen",
            note: "Hinweis",
            gridView: "Tabellenansicht",
            completedTasks: "Abgeschlossene Aufgaben",
            system: "System",
            destroyedBy: "Gelöscht von",
            brand: "Marke",
            channelCreatedSuccess: "Kanal erfolgreich erstellt",
            channelCreatedError: "Kanal konnte nicht erstellt werden",
            plans: {
                types: {
                    supsis: "Vertreterpakete",
                    chatbot: "Chatbot",
                    automation: "Automatisierung",
                    customer_tables: "Kundentabelle",
                    mail: "E-Mail",
                    tasks: "Aufgaben",
                    form: "Formular",
                    whatsapp: "WhatsApp Web (QR)",
                    whatsapp_business: "WhatsApp Business API",
                    instagram: "Instagram",
                    messenger: "Messenger",
                    meta_lead: "Meta Lead",
                    trendyol: "Trendyol",
                    artificial_intelligence: "Künstliche Intelligenz",
                    webhook: "Webhook",
                    telegram: "Telegram",
                    webphone: "Web Phone"
                }
            },
            vipCustomerDescription: "Das Markieren dieser Person als VIP-Kunde bringt sie an die Spitze der Warteschlange und sorgt dafür, dass sie prioritären Service erhält.",
            switchOn: "Ein",
            switchOff: "Aus",
            ownerDescription: "Diese Funktion zeigt den Besitzer eines Chats an. Unabhängig vom Status des Besitzers (online oder offline) werden Chats immer dem Besitzer zugewiesen. Besessene Chats können nur vom jeweiligen Besitzer angezeigt werden und können nicht vom Chatbot beantwortet werden.",
            permissionError: "Sie haben keine Berechtigung, diese Aktion auszuführen!",
            copySuccess: "Inhalt erfolgreich kopiert!",
            unowned: "Unbesessen",
            add: "Hinzufügen",
            copy: "Kopieren",
            cancel: "Abbrechen",
            edit: "Bearbeiten",
            update: "Aktualisieren",
            search: "Suche starten",
            save: "Speichern",
            jsonPreview: "JSON-VORSCHAU",
            enterNewValue: "Neuen Wert eingeben",
            updatePreferredLanguage: "Bevorzugte Sprache aktualisieren",
            updateTags: "Tags aktualisieren",
            updateEmail: "E-Mail aktualisieren",
            enterNewEmail: "Neue E-Mail eingeben",
            deleteConfirmation: "Löschbestätigung",
            confirmDelete: "Sind Sie sicher, dass Sie diese Funktion löschen möchten?",
            yesDelete: "Ja, löschen",
            vipCustomer: "★ VIP-Kunde",
            takeControlFromChatbot: "Kontrol von Chatbot übernehmen",
            enterJoin: "Sie können der Konversation beitreten, indem Sie die Eingabetaste drücken",
            watchChat: "Konversation ansehen",
            untitledAutomation: "👉 Unbenanntes Profil Klick-Automatisierung",
            event: "Ereignis",
            chatbotSettings: "Chatbot-Routing-Einstellungen",
            chatbotScenarioNotFound: "Chatbot-Szenario nicht gefunden",
            noChatbotScenario: "Im System wurde kein Chatbot-Szenario gefunden.",
            scenarioNotFound: "Szenario nicht gefunden",
            descNotAvailable: "Beschreibung nicht verfügbar",
            lastRegulation: "Letzte Regelung",
            taskCreator: "Aufgabensteller",
            noPermission: "Sie haben keine Berechtigung, Aufgaben zu erstellen.",
            notAppointed: "Nicht ernannt",
            changeStage: "Stufe ändern",
            selectedCandidates: "1 ausgewählter Kandidat(en)",
            coverPhotoRemove: "Titelbild entfernen",
            coverPhotoSet: "Als Titelbild festlegen",
            autoTransfer: "Kontakte automatisch nach Zoho übertragen",
            autoTransferDescription: "Kontakte, die über diesen Kanal eingehen, werden automatisch in das Zoho CRM-Kontaktmodul übertragen. Die an Zoho übertragenen Kontakte aktivieren Zoho-Widgets.",
            zohoChannelRequiredTitle: "Zoho CRM-Kanal erforderlich",
            zohoChannelRequiredContent: "Sie haben keinen Zoho CRM-Kanal. Klicken Sie hier, um sofort einen hinzuzufügen.",
            okText: "Zoho CRM-Kanal hinzufügen",
            cancelText: "Abbrechen",
            forceQueueForNoOwnerContacts: "Sahiplose Kontakte zwingen, in der Warteschlange zu warten",
            forceQueueDescription: "Nur besessene Kontakte werden automatisch zugewiesen, wodurch besitzlose Kontakte gezwungen werden, in der Warteschlange zu warten.",
            showNoOwnerContactsToAdmins: "Besitzlose Kontakte nur für Administratoren anzeigen",
            showNoOwnerContactsDescription: "Besitzlose Kontakte sind nur für Administratoren sichtbar.",
            autoAssignOwner: "Automatische Kontaktzuweisung",
            autoAssignOwnerDescription: "Wenn der Chat automatisch einem Vertreter zugewiesen wird, wird er auch als Eigentümer zugewiesen.",
            creator: "Ersteller",
            hideShow: "Ausblenden / Anzeigen",
            url: "URL",
            cannedMessages: "Vorgefertigte Nachrichten",
            templateMessages: "Vorlagen Nachrichten",
            chatbots: "Chatbots",
            noCannedMessages: "Keine vorgefertigten Nachrichten gefunden",
            filterToFindMore: "Sie können weitere vorgefertigte Nachrichten finden, indem Sie Ihre Filter ändern.",
            runPrompt: "Prompt Ausführen",
            noLeadsFound: "Keine Leads für diese Person gefunden",
            deals: "Deals",
            noDealsFound: "Keine Deals für diese Person gefunden",
            loadingDeals: "Deals werden geladen",
            zohoCRM: "Zoho CRM",
            viewContact: "Kontakt anzeigen",
            noNotesAdded: "Noch keine Notizen hinzugefügt",
            attachments: "Anhänge",
            addNewNote: "Neue Notiz hinzufügen",
            savingg: "Speichern...",
            warningFillFields: "Bitte füllen Sie die Felder Titel und Inhalt aus.",
            successNoteAdded: "Notiz erfolgreich hinzugefügt.",
            errorAddingNote: "Beim Hinzufügen der Notiz ist ein Fehler aufgetreten.",
            noteTitle: "Notiz Titel",
            noteContent: "Notiz Inhalt",
            selectPreferredAgent: "Wählen Sie den bevorzugten Agenten aus, den Sie dem Besucher zuweisen möchten.",
            postOperations: "Post-Operationen",
            loadingPostOperations: "Post-Operationen werden geladen",
            noPostOperations: "Keine Post-Operationen für diese Person gefunden",
            postOperationDetails: "Details zu Post-Operationen",
            noMediaDocuments: "Keine Medien oder Dokumente für diese Person verfügbar.",
            selectionLimitError: "Sie können maximal 30 Elemente auswählen.",
            showNote: "Notiz für alle anzeigen",
            hideNote: "Notiz ausblenden",
            updateNote: "Notiz aktualisieren",
            addUserNote: "Eine Notiz über den Benutzer hinzufügen",
            privateNote: "Private Notiz",
            metaReferrals: "Meta Empfehlungen",
            noMetaReferrals: "Keine Meta-Werbeinteraktionen gefunden.",
            searchPrompt: "Nach etwas suchen.",
            noRecentResults: "Keine aktuellen Ergebnisse gefunden.",
            contactInfo: "Kontaktinformationen",
            noPropertiesAdded: "Noch keine Eigenschaften hinzugefügt.",
            propertyAddedUpdated: "Eigenschaft erfolgreich hinzugefügt/aktualisiert.",
            propertyError: "Beim Hinzufügen/Aktualisieren der Eigenschaft ist ein Fehler aufgetreten.",
            propertyDeleted: "Eigenschaft erfolgreich gelöscht.",
            propertyDeleteError: "Beim Löschen der Eigenschaft ist ein Fehler aufgetreten.",
            zohoSynchronization: "Zoho-Synchronisierung",
            zohoSyncConfirmation: "Möchten Sie Änderungen an der Person in Zoho vornehmen?",
            hideOtherInfo: "Andere Informationen ausblenden",
            showOtherInfo: "Andere Informationen anzeigen",
            whatsappChatStart: "WhatsApp-Chat starten",
            ownership: "Kundenbesitz",
            countryAndLanguage: "Land, Sprache",
            calendarEvent: "Kalenderevent",
            contact: "Kontakt",
            user: "Benutzer",
            customerOwnership: "Kundenbesitz",
            ownerless: "Besitzlos",
            preferredDepartment: "Bevorzugte Abteilung",
            flowluTransfer: "Übertragung an Flowlu",
            mergeSuccess: "Zusammenführungsoperation erfolgreich abgeschlossen.",
            visitorOwnershipWarning: "Dieser Besucher gehört einem anderen Benutzer.",
            newAutomation: "Neue Automatisierung",
            automations: "Automatisierungen",
            createProfileAutomation: "Profilautomatisierung erstellen",
            profileButtonClicked: "Profilknopf wurde gedrückt",
            profileButtonDescription: "Diese Automatisierung wird ausgelöst, wenn ein Profilknopf gedrückt wird.",
            automationName: "Automatisierungsname",
            create: "Erstellen",
            dayRange: "Tagesbereich",
            hourRange: "Stundenbereich",
            last24Hours: "Letzte 24 Stunden",
            today: "Heute",
            yesterday: "Gestern",
            thisWeek: "Diese Woche",
            lastWeek: "Letzte Woche",
            last7Days: "Letzte 7 Tage",
            last30Days: "Letzte 30 Tage",
            thisMonth: "Diesen Monat",
            lastMonth: "Letzter Monat",
            startDateTime: "Startdatum und Uhrzeit",
            endDateTime: "Enddatum und Uhrzeit",
            complaint: "Beschwerde",
            opens: "Öffnungen",
            clicks: "Klicks",
            mockData: "(Testdaten)",
            forwardToDepartment: "An Abteilung weiterleiten",
            toMobileAgents: "Mobile Agenten",
            noMediaAndDocuments: "Dieser Benutzer hat keine Medien oder Dokumente",
            reportBug: "Fehler melden",
            waitingForReply: "Warten auf Antwort",
            memorySize: "Speichergröße",
            usedMemory: "Verwendeter Speicher",
            availableMemory: "Verfügbarer Speicher",
            memoryLimit: "Speicherlimit",
            memoryLimitPrice: "Preis für zusätzlichen Speicher",
            telegramBotIsReachable: "Telegram-Bot-Dienst erreichbar",
            telegramBotIsHealthy: "Telegram-Bot-Dienst funktioniert einwandfrei",
            telegramBotIsUnhealthy: "Telegram-Bot-Dienst hat einen Fehler",
            pieView: "Kreisdiagramm",
            chartView: "Diagrammansicht",
            tableView: "Tabellenansicht",
            lastUpdate: "letzte Aktualisierung",
            Aufgabe: "Aufgabe",
            filterBy: "Nach Filter",
            watchAllLive: "Alle Liveübertragungen ansehen",
            sessionsUnique: "Sitzungen (Einzigartige Benutzer)",
            sessionsAll: "Sitzungen (Alle Benutzer)",
            moreFeaturesDesc: "Mehr Funktionen, mehr Integrationen, mehr Agenten! Ergreifen Sie jetzt Maßnahmen, um Ihr Team besser zu verwalten und Ihr Unternehmen auf sein maximales Potenzial zu bringen!",
            metaLeadForms: "Meta-Lead-Formulare",
            metaLeadsConnectedSucs: "Meta Leads erfolgreich verbunden",
            failedToConnectMetaLeads: "Verbindung zu Meta Leads fehlgeschlagen",
            forbiddenChannel: "Verbotener Kanal",
            forbiddenChannelDesc: "Sie sind nicht berechtigt, diesen Kanal zu sehen",
            firstContact: "Erster Kontakt",
            needsAnalysis: "Bedürfnisanalyse",
            offerSent: "Gesendetes Angebot",
            offerReview: "Angebotsüberprüfung",
            decisionPhase: "Entscheidungsphase",
            personDeleted: "Gelöschte Person",
            metaLeadsIntegration: "Meta Leads Integration",
            phoneNumberIsInvalid: "Telefonnummer ungültig",
            addAnItem: "Artikel hinzufügen",
            saveItem: "Artikel speichern",
            customItem: "Benutzerdefiniertes Element",
            backgroundPhoto: "Hintergrundbild",
            whenYouActivateFeature: "Wenn Sie diese Funktion aktivieren, wird sie nicht auf der Buchungsseite angezeigt",
            logo: "Logo",
            noLogo: "Kein Logo",
            addTeamMember: "Teammitglied hinzufügen",
            timezone: "Zeitzone",
            selectDayys: "Tag(e) auswählen",
            selectStartHour: "Startzeit auswählen",
            selectEndHour: "Endzeit auswählen",
            moveLeft: "Nach links bewegen",
            moveRight: "Nach rechts verschieben",
            reply: "Antwort",
            replyToAll: "Antwort an alle",
            deleteThreadMessage: "Nachricht zum Thema löschen",
            totalEmailsBounced: "Gesamtzahl der zurückgeschickten E-Mails",
            totalEmailsComplained: "Gesamtzahl der beanstandeten E-Mails",
            untilNowTotalEmailOpens: "Gesamtzahl der bisher geöffneten E-Mails",
            untilNowTotalEmailLinkClicks: "Gesamtzahl der bisherigen Klicks auf E-Mail-Links",
            uniqueClicks: "Einzigartige Klicks",
            untilNowTotalUniqueEmail: "Gesamtzahl der bisherigen eindeutigen Klicks auf E-Mail-Links (pro Empfänger)",
            emailCampaignTimeline: "Zeitleiste der E-Mail-Kampagne",
            receivedBroadcasts: "Empfangene Broadcasts",
            groupDeletedSuccessfully: "Gruppe erfolgreich gelöscht",
            verify: "Überprüfen",
            done: "Erledigt",
            pleaseSelectAnEmailAddress: "Bitte wählen Sie eine E-Mail-Adresse aus.",
            goBack: "Zurückgehen",
            show: "Anzeigen",
            vueEmailEditor: "Vue E-Mail-Editor (Demo)",
            saveDesign: "Entwurf speichern",
            exportHTML: "HTML exportieren",
            saveAsEmailCustomerGroup: "Als E-Mail-Kundengruppe speichern",
            saveAsWhatsappCustomerGroup: "Als Whatsapp-Kundengruppe speichern",
            deleteModalFormDesc: "Wenn Sie dieses Formular löschen, werden alle Daten des Formulars dauerhaft gelöscht. Sind Sie sicher, dass Sie fortfahren möchten?",
            todo: "Zu erledigende Dinge",
            inProgress: "In Bearbeitung",
            approval: "Genehmigung",
            transactionType: "Vorgangsart",
            previousBalance: "Vorheriger Saldo",
            nextBalance: "Nächster Saldo",
            amount: "Betrag",
            wpIntegrationChannelRequired: "Whatsapp Web-Integrationskanal erforderlich",
            wpIntegrationChannelRequiredDesc: "Chatbot + Whatsapp Web Integration erfordert Whatsapp Web Channel. Bitte erstellen Sie einen neuen Kanal.",
            wabaIntegrationChannelRequired: "WhatsApp-Business-Integrationskanal erforderlich.",
            wabaIntegrationChannelRequiredDesc: "Chatbot + WhatsApp Business API erfordert einen WhatsApp-Business-Kanal. Bitte erstellen Sie einen neuen Kanal.",
            instaIntegrationChannelRequired: "Instagram-Integrationskanal erforderlich.",
            instaIntegrationChannelRequiredDesc: "Chatbot + Instagram-Integration erfordert Instagram-Kanal. Bitte erstellen Sie einen neuen Kanal.",
            createWpChannel: "Whatsapp Web-Kanal erstellen",
            createWabaChannel: "Whatsapp Business API-Kanal erstellen",
            createInstaChannel: "Instagram-Kanal erstellen",
            failedToDeleteGroup: "Gruppe konnte nicht gelöscht werden",
            failedToDeleteGroups: "Gruppen konnten nicht gelöscht werden",
            failedToFetchGroupContacts: "Gruppenkontakte konnten nicht abgerufen werden",
            mailAddressDeletedSuccessfully: "Mail-Adresse erfolgreich gelöscht",
            defaultMailAddressChangedSuccessfully: "Standard-E-Mail-Adresse erfolgreich geändert",
            mailAddressAlreadyRegistered: "Die Mailadresse darf nicht bereits registriert oder leer sein.",
            pleaseVerifyByClicking: "Bitte verifizieren Sie sich, indem Sie auf den an Ihre E-Mail-Adresse gesendeten Link klicken.",
            signSucsRegistered: "Signatur erfolgreich registriert",
            myContacts: "Meine Kontakte",
            unanswered: "Verpasst",
            emailBroadcasts: "E-Mail-Rundrufe",
            monthlyLimit: "Monatliches Limit",
            totalShipments: "Gesamte Sendungen",
            shippingStatus: "Versandstatus",
            lastAction: "Letzte Aktion",
            receiver: "Empfänger",
            delivered: "Ausgeliefert",
            opened: "Geöffnet",
            clicked: "Angeklickt",
            bounced: "Er ist zurück",
            clickedLinks: "Angeklickte Links",
            reason: "Grund",
            timer: "Zeitgeber",
            implemented: "Implementiert?",
            module: "Modul",
            excelDownload: "Excel-Download",
            serviceFeatures: "Dienstmerkmale",
            mailAddressDeletedSucs: "Mail-Adresse erfolgreich gelöscht",
            inputSearchText: "Suchtext eingeben",
            createRecord: "Datensatz erstellen",
            separatorCharacter: "Trennzeichen",
            exampleResultPreview: "Beispiel Ergebnisvorschau",
            importRecords: "Datensätze importieren",
            equals: "Gleich",
            notEquals: "Nicht gleich",
            startsWith: "Beginnt mit",
            endsWith: "Endet mit",
            greaterThan: "Mehr",
            lessThan: "Weniger als",
            before: "Vorher",
            after: "Nach",
            is: "Ist",
            isNot: "Nicht",
            empty: "Leer",
            notEmpty: "Nicht leer",
            isOneOff: "Einmalig",
            field: "Feld",
            records: "Datensatz",
            addIntegration: "Integration hinzufügen",
            chatbotScenarioReleased: "Chatbot-Szenario freigegeben",
            chatbotScenarioHasBeenCancelled: "Chatbot-Szenario wurde abgebrochen",
            titleAndDesc: "Titel und Beschreibung",
            templateAndMailSelection: "Vorlage & E-Mail-Auswahl",
            peopleToSend: "Zu versendende Personen",
            submissionPlans: "Übermittlungsplan",
            summary: "Zusammenfassung",
            broadcastTitle: "Titel der Sendung",
            sentByEmail: "Gesendete E-Mail",
            emailTemplate: "E-Mail-Vorlage",
            onlyPeopleWithEmail: "Nur Personen mit einer E-Mail-Adresse sind für den Versand gültig",
            sendNow: "Jetzt senden",
            plan: "Plan",
            senderEmail: "Absender-E-Mail",
            totalBuyer: "Gesamtkäufer",
            estimatedDuration: "Geschätzte Dauer",
            person: "Person",
            shippingIsNowComplete: "Der Versand ist abgeschlossen!",
            back: "Zurück",
            customerName: "Kundenname",
            customerEmail: "E-Mail des Kunden",
            customValue: "Benutzerdefinierter Wert",
            selectMailTemplate: "Sie müssen eine E-Mail-Vorlage auswählen.",
            youMustSelectSendingMailAddress: "Sie müssen die Absender-E-Mail-Adresse auswählen.",
            youMustSelectCustomerGroupSend: "Sie müssen die Kundengruppe auswählen, an die gesendet werden soll.",
            createBroadcast: "Rundruf erstellen",
            broadcastDetails: "Details zur Sendung",
            youCanCheckYourEmailStatus: "Sie können Ihren E-Mail-Status überprüfen, indem Sie Ihren Tarif aktualisieren. Sie können Ihren E-Mail-Status überprüfen, indem Sie Ihren Tarif aufrüsten.",
            sentDetails: "Gesendete Details",
            total: "Gesamt",
            totalEmailsProcessed: "Insgesamt verarbeitete E-Mails",
            totalEmailsDelivered: "Insgesamt gesendete E-Mails",
            toAvailableAgents: "Für verfügbare Agenten",
            toAvailableDepartments: "Für verfügbare Abteilungen",
            toWithAgentAndDepartment: "Mit Agent und Abteilung",
            toMobilAgents: "An mobile Vertreter",
            toPreferredAgents: "An bevorzugte Agenten",
            searchAgent: "Suchagent",
            searchDepartment: "Abteilung suchen",
            searchMobileAgent: "Mobiler Agent suchen",
            searchAgentOrDepartment: "Suchagent oder Abteilung",
            searchPreferredAgent: "Suche nach dem bevorzugten Agenten",
            noAgentsAvailableToForward: "Keine Agenten zum Weiterleiten verfügbar",
            noDepartmentsAvailableToForward: "Keine Abteilungen zur Weiterleitung verfügbar",
            checkChannelVisibilityTitle: "Überprüfen Sie Ihre Kanalsichtbarkeitseinstellungen",
            checkChannelVisibilityDescription: "Wenn Sie einige Abteilungen nicht sehen können, überprüfen Sie Ihre Kanalsichtbarkeitseinstellungen",
            goToChannelSettings: "Zu Kanaleinstellungen gehen",
            noMobileAgentsAvailableToForward: "Keine mobilen Agenten zur Weiterleitung verfügbar",
            noPreferredAgentsAvailableToForward: "Keine bevorzugten Agenten zur Weiterleitung verfügbar",
            ifYouSendThisConversationToTheQueue: "Wenn Sie diese Unterhaltung an die Warteschlange senden, werden Sie aus dem Chat entfernt und die Unterhaltung wird in die Warteschlange gestellt. Wenn die automatische Chat-Zuweisung aktiviert ist, wird die Unterhaltung einem geeigneten Agenten zugewiesen und kann an Sie zurückgegeben werden.",
            ifAutomaticChatAssignmentIsDisabled: "Wenn die automatische Chat-Zuweisung deaktiviert ist, bleibt das Gespräch in der Warteschlange. Autorisierte Mitarbeiter können den Anruf aus der Warteschlange heraus annehmen.",
            sendQueue: "An Warteschlange senden",
            agentName: "Name des Agenten",
            departmentName: "Name der Abteilung",
            anWarteschlange: "Warteschlange",
            mobile: "Mobil",
            noGrouping: "Keine Gruppierung",
            groupByThis: "Nach diesem gruppieren",
            selectGroupingCriteria: "Gruppierungskriterien auswählen",
            activeUsers: "Aktive Benutzer",
            passiveUsers: "Passive Benutzer",
            noPlatform: "Keine Plattform angegeben",
            noRole: "Rolle nicht spezifiziert",
            noDepartment: "Keine Abteilung angegeben",
            noLanguage: "Keine Sprache angegeben",
            group2: "Gruppe",
            groupedByStatus: "Gruppiert nach Status",
            grouping: "Gruppierung",
            activeSubjects: "Aktive Fächer",
            passiveSubjects: "Passive Subjekte",
            groupSubjects: "Gruppenfächer",
            showAll: "Alle anzeigen",
            onlyActive: "Nur Aktive",
            onlyPassive: "Nur die passiven",
            selectTimezone: "Zeitzone auswählen",
            userFilter: "Benutzerfilter",
            confidenceScore: "Vertrauenswert",
            chatbotLanguage: "Chatbot-Sprache",
            botScenerio: "Bot-Szenario",
            selectTemplate: "Vorlage auswählen",
            importFromReadyTemplates: "Aus fertigen Vorlagen importieren",
            classification: "Klassifizierung",
            addClassification: "Klassifizierung hinzufügen",
            expressionClassified: "Zu klassifizierender Ausdruck",
            zohoModuleName: "Name des Zoho-Moduls",
            selectModule: "Modul auswählen",
            standardFields: "Standardfelder",
            selectStandardField: "Standardfeld auswählen",
            customFields: "Benutzerdefinierte Felder",
            selectCustomFields: "Benutzerdefiniertes Feld auswählen",
            aiFunction: "Funktion der Künstlichen Intelligenz",
            aiFunctionDesc: "Funktion der künstlichen Intelligenz zur Durchführung von Aktionen auf der Grundlage von Benutzereingaben",
            functionName: "Funktionsname",
            functionDesc: "Funktionsbeschreibung",
            addParameter: "Parameter hinzufügen",
            chooseAiStory: "Wählen Sie eine KI-Geschichte",
            chatbotAiPromptDesc: "Künstliche Intelligenz lernt und bestimmt, wie sie sich verhalten soll, indem sie mit Hilfe der 'Prompt'-Funktion Anweisungen zu einer bestimmten Aufgabe oder einem Problem erhält.",
            enterPrompt: "Eingabeaufforderung.",
            aiParameterTunings: "KI-Parameter-Abstimmungen",
            aiParameterTuningsDesc: "Sie können die KI-Parameter einstellen, um die KI reaktionsschneller und genauer zu machen. Diese Parameter werden verwendet, um das Verhalten der KI zu steuern und wie sie auf Benutzereingaben reagiert.",
            temperature: "Temperatur",
            temperatureDesc: "Welche Sampling-Temperatur verwendet werden soll, zwischen 0 und 2. Höhere Werte wie 0,8 machen die Ausgabe zufälliger, während niedrigere Werte wie 0,2 sie fokussierter und deterministischer machen.",
            topDesc: "Als Alternative zum Sampling nach Temperatur, dem sogenannten Kernel Sampling, berücksichtigt das Modell die Ergebnisse von Token mit der Wahrscheinlichkeitsmasse top_p. 0,1 bedeutet also, dass nur Token mit der obersten 10%igen Wahrscheinlichkeitsmasse berücksichtigt werden. Wir empfehlen in der Regel, dies oder die Temperatur zu ändern, aber nicht beides.",
            toolChoices: "Werkzeugoptionen",
            noneDesc: "None bedeutet, dass das Modell kein Werkzeug aufruft und stattdessen eine Meldung generiert.",
            autoDesc: "Der automatische Modus ist der Standardwert und bedeutet, dass das Modell zwischen der Generierung einer Nachricht oder dem Aufruf eines oder mehrerer Agenten wählen kann.",
            requiredDesc: "Der Modus 'Required' bedeutet, dass das Modell einen oder mehrere Agenten aufrufen muss, bevor es dem Benutzer antwortet.",
            createArticles: "Artikel erstellen",
            createArticlesDesc: "Erstellen Sie Artikel, die Ihren Nutzern helfen, Antworten auf ihre Fragen zu finden.",
            articlesTitle: "Artikel-Titel",
            articlesContent: "Artikelinhalt",
            createFaq: "Erstellen Sie eine häufig gestellte Frage (FAQ)",
            createFaqDesc: "Erstellen Sie eine neue FAQ für Ihren Chatbot. Dies wird Ihrem Chatbot helfen, die Fragen des Benutzers zu beantworten.",
            question: "Frage",
            saveAndClose: "Speichern und schließen",
            contentPreview: "Inhaltsvorschau",
            upgradePackageTitle: "Aktualisieren Sie Ihr Paket und vermeiden Sie Einschränkungen",
            upgradePackageDescription: "Mehr Funktionen, mehr Integrationen, mehr Agenten! Werden Sie jetzt aktiv, um Ihr Team besser zu verwalten und Ihr Geschäftspotenzial zu maximieren!",
            upgradePackage: "Upgrade",
            deleteSelected: "Ausgewählte Dateien löschen",
            newFolder: "Neuer Ordner",
            newFile: "Neue Datei",
            noFilesFound: "Es wurden keine Dateien in diesem Ordner gefunden",
            uploadFile: "Datei hochladen",
            enterFolderName: "Bitte Ordnernamen eingeben",
            folderName: "Ordnername",
            dropFileHere: "Dateien hier ablegen",
            createFolder: "Ordner erstellen",
            fileUploadingError: "Beim Hochladen einer Datei ist ein Fehler aufgetreten",
            fileUploadingSucs: "Ordner erfolgreich erstellt",
            folderNameNotEmpty: "Ordnername darf nicht leer sein",
            deleteFolder: "Ordner löschen",
            sureDeleteFolder: "Sind Sie sicher, dass Sie diesen Ordner und alle darin enthaltenen Dateien löschen wollen?",
            deletionSucs: "Löschung erfolgreich",
            deleteFile: "Datei löschen",
            sureDeleteFile: "Sind Sie sicher, dass Sie diese Datei löschen wollen?",
            deletionError: "Während des Löschvorgangs ist ein Fehler aufgetreten",
            selectFile: "Datei auswählen",
            moreThanOneSelect: "Sie können mehr als eine Datei auswählen",
            selectAnFile: "Wählen Sie eine Datei aus",
            bulkSms: "Bulk SMS",
            sendBulkSmsCustomers: "Senden Sie Massen-SMS an Ihre Kunden",
            writeYourMessage: "Schreiben Sie Ihre Nachricht hier.",
            sendSms: "SMS senden",
            sendSmsYourCustomers: "Senden Sie SMS an Ihre Kunden",
            manageChannelDetail: "Kanalinformationen verwalten",
            details: "Einzelheiten",
            teamGramChannels: "TeamGram-Kanäle",
            newTeamGramIntegration: "Neue TeamGram-Integration",
            teamGramIntegration: "TeamGram-Integration",
            notMoreThanOneTeamGramChannels: "Sie können nicht mehr als einen TeamGram-Kanal erstellen",
            teamGramDetail: "TeamGram Detail",
            manageYourTeamGramIntegration: "Verwalten Sie Ihre TeamGram-Integration",
            trendyolChannels: "Trendyol-Kanäle",
            trendyolStoreIntegration: "Trendyol Store-Integration",
            trenyolStoreConnection: "Verbinden Sie Ihren Trendyol-Store",
            deleteTrendyolIntegration: "Trendyol-Integration löschen",
            sureDeleteTrendyolIntegration: "Sind Sie sicher, dass Sie die Trendyol-Integration löschen möchten? Diese Aktion ist nicht umkehrbar.",
            trendyolStoreChannel: "Trendyol Store-Kanal",
            deleteTrendyolChannel: "Trendyol-Kanal löschen",
            channelUpdatedSucs: "Kanal erfolgreich aktualisiert",
            failedUpdateChannel: "Kanal konnte nicht aktualisiert werden.",
            trendyolStoreIntegrationDetail: "Trendyol Store Integration Detail",
            configureTrendyolStoreIntegrationDetail: "Konfigurieren Sie Ihre Trendyol Store Integration",
            trenyolStoreProductQuestManage: "Trendyol Store - Produktsuchverwaltung",
            trendyolStoreDesc: "Sie können die folgenden Einstellungen verwenden, um Anfragen zu Trendyol Store-Produkten zu verwalten.",
            zohoCrmChannels: "Zoho CRM-Kanäle",
            zohoPersonalChannel: "Zoho Personal-Kanäle",
            connectZoho: "Mit Zoho CRM verbinden",
            updateChannelDesc5: "Zoho CRM-Kanal aktualisieren",
            zohoCrmIntegration: "Zoho CRM Integration",
            sureDeleteZohoChannel: "Sind Sie sicher, dass Sie den Zoho CRM-Kanal löschen möchten?",
            createNotMoreThanOneZohoChannels: "Sie können nicht mehr als einen Zoho-Kanal erstellen",
            removeZohoLink: "Zoho Link entfernen",
            connectToZoho: "Mit Zoho verbinden",
            chatClosed: "Chat geschlossen",
            scoreChat: "Chat erzielt",
            createdTicket: "Ticket erstellt",
            updatedTicket: "Ticket aktualisiert",
            newUserCreated: "Neuer Benutzer erstellt",
            updateUser: "Aktualisierter Benutzer",
            deleteUsers: "Benutzer gelöscht",
            changeStatusRepresent: "Status des Vertreters hat sich geändert",
            incomingMessage: "Eingehende Nachricht",
            outgoingMessage: "Ausgehende Nachricht",
            createdNewTicket: "Neues Ticket erstellt",
            bitrix24Channels: "Bitrix24-Kanäle",
            sureDeleteBitrixChannel: "Sind Sie sicher, dass Sie den Bitrix24-Kanal löschen wollen?",
            bitrix24Integrations: "Bitrix24 Integration",
            notCreateMoreThenOneChannel: "Sie können nicht mehr als einen Ideasoft-Kanal erstellen",
            connectToBitrix24: "Mit Bitrix24 verbinden",
            connectToBitrix24Api: "Mit Bitrix24 Api verbinden",
            updateChannel: "Kanal aktualisieren",
            updateChannelDesc: "Bitrix24 Api Kanal aktualisieren",
            yourBitrix24Domain: "Ihr Bitrix24 Domain Name",
            bitrix24ConnectedSucs: "Bitrix24 erfolgreich verbunden",
            failedToConnectBitrix24: "Verbindung zu Bitrix24 fehlgeschlagen",
            channelCreatedSuccessfully: "Kanal erfolgreich erstellt",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            holidayPlusChannels: "Urlaub+ Kanäle",
            newHolidayPlusIntegration: "Neue Holiday+ Integration",
            holidayPlusIntegrations: "Holiday+ Integration",
            notCreateMoreThanOneHolidayChannel: "Sie können nicht mehr als einen Holiday+ Kanal erstellen",
            holidayPlusDetail: "Urlaub+ Detail",
            manageHolidayPlusIntegration: "Verwalten Sie Ihre Holiday+ Integration",
            ideasoftChannels: "Ideasoft-Kanäle",
            connectToIdeasoft: "Mit Ideasoft verbinden",
            connectToIdeasoftApi: "Mit der Ideasoft-Api verbinden",
            updateChannelDesc2: "Whatsapp Business api Kanal aktualisieren",
            ideasoftIntegration: "Ideasoft-Integration",
            sureDeleteIdeasoftChannel: "Sind Sie sicher, dass Sie den Ideasoft-Kanal löschen wollen?",
            moreThanOneChannelError: "Sie können nicht mehr als einen Ideasoft-Kanal erstellen",
            websiteAddress: "Website-Adresse",
            ideasoftConnectedSucs: "Ideasoft wurde erfolgreich verbunden",
            failedToConnectIdeasoft: "Es konnte keine Verbindung zu Ideasoft hergestellt werden",
            redirectURLcopiedToClipboard: "Umleitungs-URL in die Zwischenablage kopiert",
            openAIChannels: "ÖffneAI-Kanäle",
            newOpenAiChannel: "Neuer OpenAI-Kanal",
            createNewChannelOpenAi: "Erstelle einen neuen Kanal für OpenAI",
            updateChannelDesc3: "Whatsapp business api Kanal aktualisieren",
            openAiIntegration: "OpenAI-Integration",
            sureDeleteOpenAiChannel: "Sind Sie sicher, dass Sie den OpenAI-Kanal löschen wollen?",
            createMoreThenOneOpenAiChannel: "Sie können nicht mehr als einen OpenAI-Kanal erstellen",
            postaCellChannels: "PostaCell-Kanäle",
            newPostaCellChannel: "Neue PostaCell-Kanäle",
            createNewPostaCellChannel: "Neuen Kanal für PostaCell SMS-Anbieter erstellen",
            updateChannelDesc4: "Whatsapp Business API Kanal aktualisieren",
            leads: "Leads",
            ensureFacebookAccount: "Stellen Sie sicher, dass Sie ein Facebook-Konto und eine Facebook-Seite haben",
            ensureAdAccount: "Stellen Sie sicher, dass es ein Werbekonto gibt",
            page: "Seite",
            leadCount: "Anzahl der Leads",
            showLeads: "Leads anzeigen",
            syncLeeds: "Leads synchronisieren",
            wpStartChat: "Whatsapp-Chat-Startprogramm",
            archivedIn: "Archiviert?",
            makeSelect: "Auswahl treffen",
            newLead: "Neuer Lead",
            initalContact: "Erster Kontakt",
            needsAssessnment: "Bedürfnisanalyse",
            proposalSent: "Angebot gesendet",
            proposalReview: "Vorschlagsüberprüfung",
            negotiation: "Verhandlung",
            decisionStage: "Entscheidungsphase",
            closure: "Abschluss",
            followUp: "Folgen",
            campagin: "Kampagne",
            adSet: "Anzeigensatz",
            ad: "Anzeige",
            inArchived: "Archiviert",
            deletedSelectedPerson: "Ausgewählte Personen löschen",
            sureDelSelectedPerson: "Sind Sie sicher, dass Sie die ausgewählten Personen löschen möchten?",
            deletePerson: "Person löschen",
            sureDeletePerson: "Sind Sie sicher, dass Sie die Person löschen wollen?",
            phoneNumberNotAvailable: "Rufnummer nicht verfügbar",
            statusSucsUpdated: "Status erfolgreich aktualisiert",
            statusUpdatedFailed: "Beim Aktualisieren des Status ist ein Fehler aufgetreten",
            archivedContact: "Kontakt archivieren",
            sureWantArchivePerson: "Sind Sie sicher, dass Sie diese Person archivieren wollen?",
            personArchived: "Person archiviert",
            personArchivedHead: "Archivierungsvorgang fehlgeschlagen",
            metaLeadChannels: "Meta-Lead-Kanäle",
            wpStartSpeech: "Whatsapp-Sprachstarter",
            pleaseSelectStartChat: "Bitte wählen Sie den Kanal, auf dem Sie den Chat starten möchten:",
            phoneNumber: "Telefonnummer",
            phoneNumberDesc: "Landesvorwahl mit nur Zahlen ohne Leerzeichen",
            channelDesc: "Auf welchem Kanal möchten Sie den Chat beginnen",
            pleaseSelectStartChatOn: "Bitte wählen Sie den Kanal, auf dem Sie den Chat beginnen möchten",
            notAuthorisedChannel: "Sie sind nicht berechtigt, auf diesen Kanal zuzugreifen",
            phoneNumberError: "Telefonnummer nicht korrekt",
            chatStartError: "Es ist ein Fehler beim Starten des Chats aufgetreten. Bitte versuchen Sie es erneut.",
            noRecordFailed: "Kein Datensatz gefunden",
            metaLeadsChannel: "Meta Leads Kanal",
            mlChannelDetails: "Meta Leads Kanal Details",
            manageMlChannel: "Verwalten Sie Ihre Meta Leads",
            deleteMetaLeadsChannelInfo: "Sind Sie sicher, dass Sie den Meta Leads-Kanal löschen möchten?",
            contactPage: "Kontaktseite",
            addRouted: "Geführt hinzufügen",
            otherEmailProviders: "Andere E-Mail-Anbieter",
            visitorScreenNaming: "Benennung des Besucherbildschirms",
            enterCatalogTitle: "Katalogtitel eingeben...",
            passwordUpdate: "Kennwort aktualisieren",
            showCenterScreen: "Anzeige in der Mitte des Bildschirms",
            skipNow: "Jetzt überspringen",
            confirm: "Bestätigen Sie",
            newTable: "Neue Tabelle",
            actions: "Transaktionen",
            integrationsTrendyol: "Verbinden Sie Ihren Trendyol-Shop und beantworten Sie automatisch die Anfragen Ihrer Kunden.",
            integrationsHoliday: "Integrieren Sie Holiday+, um Hotels und Zimmer über den Chatbot bereitzustellen!",
            integrationsTeamgram: "Übertragen Sie Ihre Kunden von Supsis zu Teamgram, um Ihr Kundenmanagement zu optimieren!",
            integrationsTicimax: "Senden Sie eine automatische Nachricht an segmentierte Ticimax-Mitglieder.",
            integrationsBitrix24: "Aktivieren Sie die Bitrix24-API für ein verbessertes Chatbot-Erlebnis für Ihre Kunden.",
            integrationsIdeasoft: "Aktivieren Sie die Ideasoft-API für ein verbessertes Chatbot-Erlebnis für Ihre Kunden.",
            integrationsOpenAI: "OpenAI-Dienste aktivieren, Chatbot-AI-Antwort, KI-Assistent CoPilot, Chatbot-AI-Wissensdatenbank.",
            integrationsSMSPostacell: "Aktivieren Sie das Senden von SMS über den PostaCELL SMS-Anbieter.",
            integrationsMetaLeads: "Verwalten Sie Ihre Meta-Leads über Supsis. Verbinden Sie Leads mit Tickets, Chatbot oder Live-Support.",
            integrationsZoho: "Integrieren Sie Ihre Geschäftsprozesse in Zoho CRM mit Supsis.",
            forward: "weiter",
            packUpRequired: "Paket-Upgrade erforderlich",
            upgradePack: "Upgrade-Paket",
            supsisMobilApp: "SUPSIS MOBIL APP",
            supsisMobilAppDesc: "IOS und Android App auf dem Markt!",
            sendEmail: "E-Mail senden",
            jumpToMessage: "Klicken Sie hier, um zur Nachricht zu springen",
            doesntMatter: "Spielt keine Rolle",
            events: "Kalender Ereignisse",
            reservations: "Buchungen",
            designer: "Designer",
            targetContacts: "Zielkontakte",
            scheduler: "Planer",
            planAndTask: "Plan & Aufgaben",
            insights: "Einblicke",
            createRole: "Rolle erstellen",
            createSubject: "Thema erstellen",
            createUser: "Benutzer erstellen",
            blockManuel: "Block Manuel",
            showHide: "anzeigen/ausblenden",
            contactSearch: "Kontakt Suche",
            favorites: "Favoriten",
            downloadAllData: "alle Daten herunterladen",
            downloadThePage: "Download der Seite",
            choosePoints: "Punkte auswählen",
            channel: "Kanal",
            createdAt: "Erstellt am",
            action: "Aktion",
            searchChannel: "Kanäle suchen",
            activeChannels: "Aktive Kanäle",
            deleteChannels: "Gelöschte Kanäle",
            selectChannel: "Kanal auswählen",
            channelFilter: "Kanalfilter",
            noConversationDesc: "Hier können Sie aktive Chats und Ihnen zugewiesene Chats sehen.",
            forMe: "Für mich",
            unAssigned: "Nicht zugewiesen",
            agentDetails: "Agentendetails",
            contactProperties: "Kontaktinformationen",
            goToProfile: "Zum Profil gehen",
            addNote: "Notiz hinzufügen",
            noPreferredAgent: "Noch kein bevorzugter Agent",
            toPrefer: "Bevorzugen",
            inChat: "Im Chat",
            watching: "Schaut zu",
            chatsTitle: "Chats",
            dealyTimeMaxValueError: "Die Verzögerungszeit kann maximal 15 betragen",
            dealyTimeTypeError: "Verzögerungszeitwert muss eine Zahl sein",
            passedTimeHm: "{hour} Stunden {min} Minuten",
            passedTimeMs: "{min} Minuten {sec} Sekunden",
            passedTimeSc: "{sec} Sekunden",
            translateMessage: "Ihre Nachricht wurde durch künstliche Intelligenz übersetzt.",
            toneChanged: "Nachrichtenton auf {tone} geändert",
            aiResponseAdded: "KI-Antwort zur Nachricht hinzugefügt",
            messageLonger: "Nachricht verlängert",
            grammarFixed: "Grammatik korrigiert",
            aiTranslate: "Übersetzung",
            other: "Andere",
            yourLanguage: "Ihre Sprache",
            contactLanguage: "Kundensprache",
            myLanguage: "Meine Sprache",
            forwardToChatbot: "An Chatbot Weiterleiten",
            friendly: "Freundlich",
            confident: "Selbstbewusst",
            straightForward: "Geradlinig",
            casual: "Lässig",
            professional: "Professionell",
            longSentence: "Langer Satz",
            changeTone: "Ton Ändern",
            fixGrammar: "Grammatik Korrigieren",
            aiResponse: "KI-Antwort",
            templateButtonNote: "Um den Kontakt zu sperren, verwenden Sie bitte die folgenden Texte auf der Sperrtaste. Unabhängig von Groß- oder Kleinbuchstaben",
            templateButtonTags: "#Nachricht senden# | #Abbestellen# | #Sperren# | #Blockieren# ",
            dashboard: "Dashboard",
            adminReports: "Admin-Berichte",
            calendarModule: "Kalendermodul",
            taskModule: "Aufgabenverwaltungsmodul",
            maxUrlButtonMessage: "Sie können maximal 2 URL-Schaltflächen hinzufügen.",
            noPreferredDepartment: "Keine bevorzugte Abteilung vorhanden",
            searchForDepartment: "Nach Abteilung suchen",
            departmentAssignedToTheVisitor: "Wählen Sie die Abteilung aus, die Sie dem Besucher zuweisen möchten.",
            assignPreferredDepartment: "Bevorzugte Abteilung zuweisen",
            smsChannel: "SMS-Kanal: ",
            whatsappv2Channel: "Whatsapp V2-Kanal: ",
            whatsappv1Channel: "Whatsapp V1-Kanal: ",
            wBChannel: "Whatsapp Business-Kanal: ",
            messengerChannel: "Messenger-Kanal: ",
            instagramChannel: "Instagram-Kanal: ",
            allPlatforms: "Alle Plattformen",
            cbStartMessage: "Chatbot-Startnachricht",
            cbStartMessageDesc: "Die erste vom Benutzer eingegebene Nachricht wird automatisch vom Chatbot verarbeitet und an die entsprechende Adresse weitergeleitet.",
            messengerUserProfile: "Messenger Benutzerprofil",
            instagramUserProfile: "Instagram Benutzerprofil",
            noEventFound: "Kein Ereignis gefunden",
            visitorMails: "Besucher-E-Mails",
            visitorActions: "Besucheraktionen",
            notVerified: "Nicht überprüft",
            visitorEvents: "Besucherereignisse",
            assignedTasks: "Zugewiesene Aufgaben",
            mails: "Mails",
            prefferedAgents: "Bevorzugte Agenten",
            createEvent: "Ereignis erstellen",
            blockManagement: "Blockmanagement",
            deleteUser: "Benutzer löschen",
            blocked: "Blockiert",
            profiles: "Profile",
            similiarProfiles: "Ähnliche Profile gefunden",
            ReplyAsAPm: "Als Privatnachricht antworten und schließen",
            replyAsAComment: "Als Kommentar antworten und schließen",
            messengerAddDesc: "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddPrivacyCheckDesc: "Ich habe die {Privacy} und {Terms and Conditions} gelesen und stimme ihnen zu",
            instaAddDesc5: "Klicken Sie unten auf die Schaltfläche Verbinden und melden Sie sich bei Ihrem Facebook-Konto an.",
            instaAddDesc4: "Registrieren Sie sich als Facebook-Entwickler",
            instaAddDesc3: "Stellen Sie sicher, dass der <b>'Zugriff auf Nachrichten erlauben'</b>-Schalter aktiviert ist",
            instaAddDesc2: "Stellen Sie sicher, dass Ihr Instagram-Profikonto mit Ihrer Facebook-Seite verbunden ist",
            instaAddDesc1: "Stellen Sie sicher, dass Ihr Instagram-Konto ein professionelles Instagram-Konto (Geschäftskonto) ist.",
            selectedDepartment: "Ausgewählte Abteilung",
            departmentForwardEnable: "Abteilungsweiterleitung aktiviert",
            departmentForwardRule: "Abteilungsweiterleitungsregel",
            departmentForwardDesc: "Wählen Sie aus, an welche Abteilung eingehende Chats im Kanal weitergeleitet werden sollen.",
            channelName: "Kanalname",
            forwardToLiveAgents: "👉 An Live-Agenten weiterleiten",
            manageIgChannel: "Verwalten Sie Ihren Instagram-Kanal",
            igDetail: "Instagram-Detail",
            manageVisibilityDesc: "Verwalten, wer diesen Kanal sehen kann",
            selectAnIgAccount: "Wählen Sie ein Instagram-Konto aus",
            connectToInsta: "Mit Instagram verbinden",
            connectToMetaLeads: "Mit Meta Leads verbinden",
            deleteInstaChannelInfo: "Möchten Sie den Instagram-Kanal wirklich löschen?",
            instagramChannels: "Instagram-Kanäle",
            suspendedDescription: "Ihr Konto wurde aufgrund unbezahlter Rechnungen gesperrt",
            onlyChatbot: "Nur Chatbot",
            onlyAgents: "Nur Agenten",
            checkboxWarning: "Dieses Feld muss angekreuzt werden",
            sendingAllow: "Senden",
            receiving: "Empfang",
            platform: "Plattform",
            banModalTitle: "Besucher-Sperrbildschirm",
            selectDepartmentDesc: "Wählen Sie die Abteilungen aus, für die Sie die Sichtbarkeit ändern möchten",
            selectAgentDesc: "Wählen Sie die Agenten aus, für die Sie die Sichtbarkeit ändern möchten",
            selectDepartment: "Abteilung auswählen",
            selectAgent: "Agent auswählen",
            visibleDepartments: "Sichtbare Abteilungen",
            visibleAgents: "Sichtbare Agenten",
            visibilityInfoCont: "Alle Agenten und Abteilungen können diesen Kanal sehen",
            editDepartmentVisibility: "Abteilungssichtbarkeit bearbeiten",
            editAgentVisibility: "Agentensichtbarkeit bearbeiten",
            typeSTToSearch: "Geben Sie etwas ein, um nach Benutzern zu suchen",
            exportToCSV: "Als CSV exportieren",
            clear: "Löschen",
            usedSessionCount: "Verwendete Sitzungsanzahl",
            maxSessionCount: "Maximale Sitzungsanzahl",
            leftSessionCount: "Verbleibende Sitzungsanzahl",
            planManagement: "Planverwaltung",
            maxAutomationTask: "Maximale Automatisierungsaufgaben",
            teamChat: "Team-Chat",
            templateNameIsNotValid: "Vorlagenname ist ungültig",
            relatedAdvertisement: "Entsprechende Werbung",
            whatsappNumber: "WhatsApp-Nummer",
            integrationsWhatsappV1: "Für reibungslose Kommunikation zwischen Supsis und WhatsApp ist ein WhatsApp-Plan erforderlich.",
            integrationsWhatsappV2: "Sie können Chat-Informationen leicht zwischen Supsis und WhatsApp übertragen.",
            integrationsWhatsappBusiness: "Sie können Chat-Informationen schnell und bequem zwischen Supsis und WhatsApp übermitteln.",
            selectDays: "Tage auswählen",
            addTime: "Zeit hinzufügen",
            instagramContactList: "Instagram Kontaktliste",
            archiveAllRated: "Alle Konversationen mit Bewertungen abrufen.",
            allChannels: "alle Kanäle",
            comment: "Kommentar",
            news: "Was gibt es Neues?",
            conversation: "Teamgespräch",
            speechTermination: "Gespräch beenden",
            noSystemMessage: "Es sind noch keine Nachrichten im System!",
            supsisCustomerService: "Kundenservice von Supsis,",
            supsisClickExperience: "Sie können das Erlebnis ausprobieren, indem Sie darauf klicken.",
            customerPage: "Gehen Sie zur Kundenseite",
            buttonTitle: "Schaltflächentitel",
            buttonType: "Schaltflächentyp",
            buttonSendMessage: "Nachricht senden",
            buttonGoToBlock: "Zum Block gehen",
            buttonOpenUrl: "Öffne URL",
            buttonPhoneCall: "Anruf",
            buttonOpenMoment: "Offener Augenblick",
            buttonCloseChat: "Chat schließen",
            buttonTransferChat: "Chat übertragen",
            buttonCreateTicket: "Ticket erstellen",
            deleteVisitor: "Möchten Sie den Benutzer wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
            userProfile: "Profil",
            addCalendarEvent: "Veranstaltung +",
            you: "Du",
            and: "und",
            dndBlocked: "Dateisendeneinstellungen sind geschlossen.",
            tokenCopied: "Der Zugang wurde an Token kopiert.",
            apiIntegration: "Entwickler",
            generateToken: "Token erzeugen",
            copyToken: "Token kopieren",
            labels: "Etiketten",
            noData: "Kein Inhalt",
            color: "Farbe",
            titleColor: "Titelfarbe",
            secondTitleColor: "Farbe des zweiten Titels",
            tag_name_indicator: "Verlinke den Namen",
            sendMessage: "Nachricht senden",
            removeFromG: "Aus der Gruppe entfernen",
            delChannel: "Möchten Sie diesen Kanal wirklich löschen?",
            new_name: "Neuer Name",
            set_group_info: "Gruppeninformationen bearbeiten",
            shortcut_desc_num: "Wechseln Sie zwischen aktiven Gesprächen mit numerischen Ziffern",
            copilot_desc_num: "Ermöglicht Ihnen, Copilot auf dem Chat-Bildschirm zu öffnen",
            typing_w_chat: "schreibt...",
            edit_group_info: "Gruppeninformationen bearbeiten",
            notif_sound: "Benachrichtigungstöne aktivieren",
            notif_mute: "Benachrichtigungen stummschalten",
            leave: "Verlassen",
            group: "Gruppe",
            updateTag: "Tag aktualisieren",
            ordered_desc: "Weist Chats in der Reihenfolge den Mitarbeitern zu.",
            random_desc: "Weist Chats zufällig den Mitarbeitern zu.",
            Rrobin_desc: "Weist Chats den Mitarbeitern im Round-Robin-Verfahren zu. (Bevorzugt die am wenigsten beschäftigten Mitarbeiter)",
            RrobinRev_desc: "Weist Chats den Mitarbeitern im umgekehrten Round-Robin-Verfahren zu. (Bevorzugt die am meisten beschäftigten Mitarbeiter)",
            algo_desc: "Wählen Sie den Algorithmus für die automatische Chat-Zuweisung aus",
            algorithm: "Algorithmus",
            os_browser: "Betriebssystem und Browser",
            CHAT: "Plaudern",
            addTag: "Etikett hinzufügen",
            tags: "Etiketten",
            searchRepresentative: "Vertreter suchen",
            preferredRepresentative: "Vertreter",
            voting: "Abstimmung",
            chatWidget: "SUPSIS -Chat -Ballon",
            webhooks: "Webhaken",
            selectHooks: "Wählen Sie Webhaken",
            planRequired: "{integratable} Plan ist erforderlich.",
            allIntegrations: "Alle Integrationen",
            disableAgentSystemMessages: "Repräsentative Systemnachrichten verbergen",
            disableAgentSystemMessagesDesc: "Agentensystemnachrichten ausblenden.",
            disableAutoTranslate: "Automatische Übersetzung",
            disableAutoTranslateDesc: "Übersetzt automatisch Nachrichten aus verschiedenen Sprachen. So können Sie einfacher mit Ihren Kunden kommunizieren.",
            shouldAddMethod: "Sie müssen das Feld Zahlungsmethode und Rechnungsadresse ausfüllen!",
            approveSelection: "Bestätigen Sie Ihre Wahl",
            trialDaysEndSelectPlan: "Bestätigen Sie die Planauswahl",
            trialDaysEndSelectPlanDesc: "Ihre Testversion ist vorbei. Sie müssen bestätigen, indem Sie den folgenden Plan auswählen.",
            infinitePlay: "Spielen Sie die ganze Zeit",
            hideBubbleOnMobile: "Verstecken Sie sich auf dem Handy",
            deleteSystemLanguage: "{code} Aus dem System löscht die Sprache",
            assignedChat: "Zugewiesener Chat",
            check: "Bestätigungsbox",
            systemStatus: "Systemstatus",
            chatAssignedToUser: "Neues Chat wurde ernannt",
            inactiveThresholdTime: "Passive Chat -Zeit (Minuten)",
            tippyInactiveThresholdTime: "Wenn innerhalb der in der Rede angegebenen Zeit keine Nachricht gesendet wird, wird die Rede als passiv angesehen. Geben Sie den Wert ein (Minuten). Mindestens 1 Minuten sollten höchstens 120 Minuten betragen.",
            inactiveTerminateTime: "Passive Chat Schließzeit (Minuten)",
            tippyInactiveTerminateTime: "Das Gespräch wird nach der angegebenen Zeit geschlossen. Geben Sie den Wert ein (Minuten). Es sollte mindestens 0 in den meisten 120 Minuten sein.",
            removePendingMessage: "Stornierung",
            disconnected: "Nicht verbunden",
            visitorWriteEmptyChatTippy: "Der Kunde kann schreiben, bevor der Vertreter mit dem Sprechen verbunden ist.",
            visitorWriteEmptyChat: "Der Kunde kann schreiben, ohne den Vertreter zu verbinden.",
            visitorConnectionEventSystemMessageEnabled: "Der Verbindungsstatus des Besuchers aktiviert Systemmeldungen.",
            visitorConnectionEventSystemMessageEnabledTippy: "Der Besucher links und der Besucher kam zurück und zeigte die Systemmeldungen.",
            openBubble: "Sprechen Ballloom offen",
            showHeaderImage: "Kopfbild anzeigen",
            changeLogo: "Ändern Sie das Logo",
            changePhoto: "Foto ändern",
            addPhoto: "Ein Foto hinzufügen",
            seePhoto: "Siehe das Foto",
            deletePhoto: "Das Foto löschen",
            askQuestion: "Frage stellen",
            locationPermsNeeded: "Die Standortgenehmigung für die Verwendung dieser Funktion erforderlich",
            useMyLocation: "Verwenden Sie meinen Standort",
            acceptingChat: "Der Chat -Kauf ist geöffnet",
            notAcceptingChat: "Chat -Einnahme geschlossen",
            websiteChatWidgetIntegration: "Website -Chat -Ballonintegration",
            loggedOut: "Offline",
            listStatuses: "Situationen",
            hideInactiveAgents: "Passive Vertreter verbergen",
            hideMinorValues: "Kleine Werte verbergen",
            agentActivities: "Repräsentative Aktivitäten",
            newHASHContent: "#Hashtag hinzufügen",
            hash: "Hashtag",
            languageRemovalQuestion: "Sie sind kurz davor, die {code} Sprache aus dem System zu löschen!",
            blockBy: "Vertreter",
            hashText: "Hashtag",
            exampleHash: "Bestellverfolgung",
            notValidHash: "Sollte keinen Lückencharakter enthalten",
            videoCallEnabledDesc: "Aktivieren Sie, um die Videoanruffunktion zu aktivieren",
            videoCallEnabled: "Videoanruffunktion",
            audioCallDesc: "Aktivieren Sie, um die Sprachanruffunktion zu aktivieren",
            audioCallEnabled: "Sprachanruffunktion",
            assignPreferredAgent: "Bevorzugter Vertreter",
            representativeAssignedToTheVisitor: "Wählen Sie den bevorzugten Agenten aus, den Sie dem Besucher zuweisen möchten.",
            agentFileSendEnabledDesc: "Aktiviert die Dateiversenden der Vertreterfunktionen",
            agentFileSendEnabled: "Vertreter können Dateien senden",
            visitorFileSendEnabledDesc: "Mit den Besuchern können Sie die Funktion zum Senden von Dateien öffnen und ausschalten",
            visitorFileSendEnabled: "Besucher können Dateien senden",
            visitorAutoLogin: "Besucher automatisch Anmeldung",
            visitorAutoLoginDesc: "Besucherballonklicks klicken, sobald Sie auf die Konversation klicken",
            agentVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Vertreter",
            agentVoiceRecordEnabled: "Vertreter können Ton aufnehmen",
            visitorVoiceRecordEnabledDesc: "Ermöglicht die Soundaufzeichnungsfunktion der Besucher",
            visitorVoiceRecordEnabled: "Besucher können Sound aufnehmen",
            startVideoCall: "Videoanruf",
            startAudioCall: "Sprachanruf",
            visitorGDPRDeleteEnabledDesc: "Mit den Besuchern können Sie alle Informationen öffnen und ausschalten",
            visitorGDPRDeleteEnabled: "Besucher können alle Informationen löschen",
            visitorLocationEnabled: "Besucher können den Standort teilen",
            visitorLocationEnabledDesc: "Ermöglicht den Besuchern, die Freigabe der Standort zu öffnen oder zu schließen",
            customerLocationEnabled: "Vertreter können den Standort teilen",
            customerAutoMergeEnabled: "Verschmilzt automatisch die gleichen Personen",
            customerAutoMergeEnabledDesc: "Diese Funktion führt eine automatische Zusammenführung durch, um Daten effektiv von denselben Personen zu sammeln. Dadurch werden Benutzer mit ähnlichen Profilen in Datenbeständen konsistenter und geordneter repräsentiert.",
            chatAiCopilot: "Chat KI Copilot",
            chatAiCopilotDesc: "Beantworten Sie automatisch die Fragen Ihrer Kunden mit dem Chat KI Copilot",
            customerLocationEnabledDesc: "Ermöglicht den Vertretern, die Standortfreigabe zu öffnen oder zu schließen",
            thoesNotOwners: "Nicht-Besitzer in der Warteschlange halten",
            thoesNotOwnersDesc: "Sie aktivieren diese Funktion, um Personen, die nicht Eigentümer der Unterhaltung sind, in der Warteschlange zu halten.",
            hideContactInfo: "Kontaktinformationen ausblenden",
            hideContactInfoDesc: "Wenn Sie diese Funktion aktivieren, werden die Nummern und E-Mails Ihrer Kunden vor Agenten verborgen.",
            triggerAlreadyExists: "Es gibt bereits einen Auslöser für diesen Zustand.",
            ticketStatusForm: "Ticketstatusformular",
            statusFormTitle: "Ticketstatentitel",
            allStatus: "Alle Situationen",
            triggers: "Löst aus",
            trigger: "Abzug",
            noTrigger: "Sie haben noch keinen Auslöser hinzugefügt",
            triggerSkipLoginForm: "Anmeldeformular",
            triggerSkipLoginFormTrue: "Anmeldeformular anzeigen",
            triggerSkipLoginFormFalse: "Anmeldeformular überspringen und direkt zur Nachricht wechseln",
            noContent: "Kein Inhalt",
            toCreate: "Erschaffen",
            clickTheButton: "Drück den Knopf",
            triggerContent: "Schreiben Sie die Beschreibung, die Sie im Fenster sehen möchten, das sich öffnet. Schreiben Sie einfach in einer Sprache aus, um automatisch in andere Sprachen zu übersetzen.",
            triggerDrag: "Sie können die Nachrichtenzeit durch Ziehen oder Klicken auf die Leiste festlegen.",
            triggerNewCondition: "Sie können einen neuen Zustand mit Taste hinzufügen.",
            triggerNoConditionDescription1: "Sie können die gewünschten Bedingungen aus den Optionen erstellen. Wenn Sie keine Bedingungen für einen Auslöser erstellen, ist der Abzug in erster Linie aktiv.",
            triggerNoConditionDescription2: "Auf der Besucherseite ist nur einer der Auslöser mit den gleichen Bedingungen aktiv sichtbar.",
            triggerShowAndHide: "Sie können die Trigger zeigen oder verbergen, wenn Sie zeigen möchten.",
            countryLanguage: "Land/Sprache",
            addTrigger: "Trigger hinzufügen",
            yesPlease: "Ja bitte!",
            noThanks: "Nein danke.",
            firstAnswer: "Frage Dialog positive Antwort",
            secondAnswer: "Frage Dialog negative Antwort",
            noTitle: "Kein Titel",
            sumChat_MediaFile: "Medien und Dokumente",
            importantWarning: "WICHTIGE WARNUNG!",
            images: "Bilder",
            URLS: "Links",
            files: "Dateien",
            warning: "WARNUNG!",
            noCondition: "Nicht nötig! Sie können einen Zustand hinzufügen, indem Sie auf das Plus -Symbol klicken.",
            showTriggers: "Klicken Sie hier, um die Trigger anzuzeigen",
            showThisTrigger: "Klicken Sie hier, um diesen Auslöser anzuzeigen",
            hideTriggers: "Klicken Sie hier, um die Trigger auszublenden",
            hideThisTrigger: "Klicken Sie hier, um diesen Auslöser auszublenden",
            updateTrigger: "Aktualisieren Sie den Auslöser",
            conditions: "Bedingungen",
            messageDurationPerRow: "Nachrichtenzeit für jede Zeile",
            dayTime: "Stunde",
            weekDay: "Wochentag",
            spendTimePage: "Zeit auf der Seite verbracht",
            spendTimeSite: "Zeit auf der Website verbracht",
            pageUrl: "URL",
            pageTitle: "Seitentitel",
            equal: "Gleich",
            not_equal: "Nicht gleich",
            less_than: "Kleiner als",
            greater_than: "Größer als",
            less_than_or_equal: "Kleiner oder gleich",
            greater_than_or_equal: "Größer oder gleich",
            visitorName: "Besuchername",
            seconds10: "10 Sekunden",
            seconds30: "30 Sekunden",
            minute1: "1 Minute",
            minutes5: "5 Minuten",
            minutes10: "10 Minuten",
            minutes30: "30 Minuten",
            hour1: "1 Stunde",
            hours2: "2 Stunden",
            hours4: "4 Stunden",
            hours8: "8 Stunden",
            hours12: "12 Stunden",
            hours24: "24 Stunden",
            maxCondition: "Maximale Situation",
            doYouWishToDeleteTrigger: "Möchten Sie den Abzug löschen?",
            contains: "Enthält",
            not_contains: "Enthält nicht",
            chatLanguage: "Sprechsprache",
            translating: "Übersetzung",
            liveSupportStartingWait: "Live -Unterstützung wird begonnen, bitte warten Sie",
            noConnection: "Keine Verbindung!",
            buyWhatsapp: "Kaufen Sie WhatsApp",
            integrations: "Integrationen",
            refundInvoiceSure: "Sind Sie sicher, dass Sie die Rechnung zurückgeben möchten?",
            invoiceMarkedAsPaidSuccess: "Die Rechnung wurde als bezahlt gekennzeichnet.",
            invoiceMarkedAsPaidError: "Der Fehler konnte nicht gekennzeichnet werden, da die Rechnung bezahlt wurde.",
            deleteConfirm: "Möchten Sie dieses {Objekt} wirklich löschen?",
            markPaidConfirm: "Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?",
            startChatDesc: "Sprache starten",
            addLink: "Verbindung",
            selectStep: "Wählen Sie einen Schritt aus:",
            addGOTO: "Gehen",
            sendFastLink: "Senden Sie den Anmeldelink ohne Passwort",
            or: "Oder",
            allTags: "Alle Tags",
            showDetail: "Detail anzeigen",
            hideDetail: "Detail ausblenden",
            weLlSendPhone: "Senden wir es an Ihr Telefon",
            weLlSendEmail: "Senden wir eine E-Mail",
            linkSentToPhone: "Der Link wurde als SMS gesendet",
            offerlinkSendToPhone: "Senden wir den Download -Link unserer Bewerbung mit SMS an Sie.",
            offerlinkSendToMail: "Senden wir den Download -Link unserer Bewerbung per Post an Sie.",
            theEmail: "Registrierte Email",
            differentEmail: "Andere E-Mails",
            linkSentToMailBox: "Link an Ihre Mail -Adresse gesendet",
            errorOccurred: "Ein Fehler ist aufgetreten !",
            clickStoreIcon: "Sie können die mobile Anwendung erreichen, indem Sie auf das Symbol klicken, das zu Ihrem Telefon passt",
            meetWithSupsis: "Möchten Sie unsere mobile SUPSIS -Anwendung treffen?",
            downloadMobileApps: "Laden Sie die mobile Anwendung herunter",
            getApps: "Bewerbungen erhalten",
            info: "Information",
            conversationHistory: "Sprachgeschichte",
            planInfoHeader: "Informationen planen",
            planInformation: "Ihr Plan {selectedPlan} Plan ({detailMaxagentCount} Repräsentant) ({freeAgent} Free Agent)",
            creditAvailable: "Ihr repräsentatives Darlehen in Ihrem Plan:",
            upDownGradePlan: "Wenn Sie Ihren Plan erhöhen/reduzieren möchten, bitte",
            click: "KLICKEN",
            all: "Alle",
            allDepartments: "Alle Abteilungen",
            preferredLanguage: "Bevorzugte Sprache",
            kmkAutoDepartmentBind: "KMK Automatische Abteilungsfindung",
            kmkAutoDepartmentBindDesc: "KMK findet den automatischen Speichernamen auf Kundenseiten und setzt ihn auf das Anmeldformular",
            visitorEmailUpdated: "Besucher -E -Mail -Adresse aktualisiert",
            visitorEmailIsNotValid: "Sie haben die E -Mail -Adresse eingegeben, ist nicht korrekt",
            visitorNameUpdated: "Name des Besuchers aktualisiert",
            clickToEdit: "Zum Bearbeiten anklicken",
            addEmail: "+ Fügen Sie die E -Mail -Adresse hinzu",
            addFullname: "+ Name hinzufügen",
            partner: "Ref?",
            isIntegrated: "Integration?",
            agentCount: "Anzahl der Vertreter",
            autoStartChat: "Automatischer Chat -Start",
            bubbleColor: "Chat -Ballonfarbe",
            openFolder: "Ordner öffnen",
            preDefined: "Themen",
            customIcon: "Installieren Sie es von Ihrem Computer aus",
            theme: "Thema",
            themeSettings: "Themen Einstellungen",
            chatThemeSettings: "Chat Designeinstellungen",
            bubbleSettings: "Chat -Balloneinstellungen",
            inputHeightOfBubble: "Ballongröße",
            inputPixelsOfChatBubble: "Klicken Sie hier, um die Entfernung des Chat -Ballons an den Rändern zu regulieren",
            modalTitleIsMarginAsPixelInfo: "Die Entfernung des Chat -Ballons zu den Rändern:",
            inputPxOfXaxis: "Horizontale Lage",
            inputPxOfYaxis: "Vertikale Lage",
            inputPxOfMobileXaxis: "(Mobiler) horizontaler Standort",
            inputPxOfMobileYaxis: "(Mobiler) vertikaler Standort",
            animations: "Animationen",
            preferredAnimation: "Bevorzugte Animation",
            selectAnAnimation: "Wählen Sie eine Animation",
            inputOfBubbleMessage: "Fügen Sie Inhalte zu riesigen Chat-Blasen hinzu.\n{contentOfChatBubble} ",
            showChatBubbleOnlyLoggedUserToolTip: "Der Chat -Ballon ist die Versteck, abhängig vom Anmeldung der Protokollierung.",
            showChatBubbleOnlyLoggedUser: "Zeigen Sie den Ballon nur dem Benutzer, der sich angemeldet hat. (Ideenoft)",
            helloDoUNeedHelp: "Hallo, ich kann helfen!",
            bubbleIcon: "Chat -Ballonbild",
            overrideMargins: "Passen Sie die Kantenlücken an",
            autoHideBubble: "Verstecke deinen Chat -Ballon",
            vtippyAutoHideBubble: "Vertreter verstecken den Chat -Ballon, während sie online sind",
            hideBubble: "Chatblase ausblenden",
            vtippyHideBubble: "Blendet die Chatblase aus.",
            overrideMobileMargin: "Passen Sie Mobile -Versionslücken an",
            vtippyMobileMargin: "Passen Sie den Chat -Ballon -Edge -Rand für mobile Version an",
            vtippyHideBubbleOnMobile: "Der Chat -Ballon ist in Besuchern mit Mobilgeräten versteckt.",
            isFabsActive: "Offene Menüs zeigen",
            isAlwaysActive: "Menü ist immer geöffnet",
            isAlwaysActiveDesc: "Möchten Sie, dass das Chatblasen-Menü in der Webansicht immer geöffnet bleibt?",
            bubbleOpenableMenu: "Der Chat -Ballon öffnet das Menü",
            vtippyIsFabsActive: "Es ist die Einstellung von Öffnungsmenüs / Verstecktätigkeiten",
            vtippyIsFabsAsIcon: "Einstellung, ob die Symbole in den Pop-up-Menüs angezeigt werden.",
            vtippyTranslateButton: "Umwandle die ausgewählte Sprache in andere Sprachen.",
            vtippyTranslateClearButton: "Reinigt die Inhalte in anderen Sprachen.",
            vtippySelectnotification: "Sie können Benachrichtigungsklang auswählen.",
            vtippyVoiceLevel: "Sie können die Audioebene festlegen.",
            vtippyStartVoice: "Hören",
            vtippyInfiniteNotification: "Die neu angekommenen Chats werden weiter spielen, wenn Sie im Panel nicht aktiv sind. Sie können Active-Passive bearbeiten, indem Sie klicken.",
            vtippyNewVisitorNotification: "Sprachbenachrichtigungseinstellungen für Besucher Ihrer Website.",
            vtippyNewChatNotification: "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der zum System kommt.",
            vtippyNewConversationNotification: "Sprachbenachrichtigungseinstellungen für jeden neuen Chat, der Ihnen zugewiesen ist.",
            vtippyNewMessageNotification: "Nachrichtenbenachrichtigungseinstellungen aus den Ihnen zugewiesenen Chats.",
            vtippyPrivateMessageNotification: "Sprachbenachrichtigungseinstellungen für Nachrichten aus der Teamrede.",
            isFabsAsIcon: "Menüsymbole anzeigen.",
            setMarginAsPixel: "Pixel einstellen",
            returnDefaultMargins: "Standardkante Gap -Einstellungen",
            closePreviewColors: "Schließen Sie die Vorschau",
            previewColors: "Öffnen Sie die Vorschau",
            videoCalls: "Videointerviews",
            filterLost: "Entkommene Gespräche",
            vtipyCustomLogin: "Wenn Sie Ihre Besucher mit dem System anschließen, können Sie die Informationen hier im Eingabeformular anpassen.",
            vtipyLoginlessChat: "Das Anmeldeformular wird nicht angezeigt, wenn Sie Ihre Besucher mit dem System verbinden. Vertreter werden verwendet, indem sie nach den persönlichen Informationen der Besucher fragen.",
            loginlessChat: "Besucheranmeldeformular",
            imageUrl: "Bild",
            replied: "ANTWORTETE",
            solved: "Gelöst",
            openImage: "Bild öffnen",
            writeFeedback: "Hier können Sie Ihr Feedback zu Supsis schreiben.",
            feedbackFailed: "Während des Feedback -Senders gab es einen Fehler.",
            feedbackSuccessful: "Das Feedback -Senden ist erfolgreich.",
            sendFeedback: "Feedback abschicken",
            errorReport: "Sie können uns Feedback zu den Problemen geben, die Sie mit Supsis haben.",
            sendErrorFeedBack: "Geben Sie uns Feedback zu Ihrem Problem.",
            successImgUpload: "Ihr Bild wurde erfolgreich hochgeladen.",
            successImgDelete: "Bild wurde erfolgreich gelöscht.",
            errorImgUpload: "Beim Hochladen Ihres Bildes trat ein Fehler auf",
            errorImgDelete: "Beim Löschen des Bildes ist ein Fehler aufgetreten",
            chatBotEndStatics: "Chatbot Sprachabschlussrate",
            videoCallDist: "Videointerviewverteilung",
            deleteSite: "{sitename} kann gelöscht werden?",
            deleteThisSite: "Löschen Sie diese Seite",
            departmentInfo: "Abteilungsinformationen",
            infoAboutDepartment: "Kurze Informationen über die Abteilung",
            deleteDepartmentQuestion: "Möchten Sie diese Abteilung wirklich löschen?",
            departmentDeleted: "Die Abteilung wurde gelöscht",
            departmentTitle: "Abteilungstitel",
            updateDepartmentForm: "Abteilungs -Update -Formular",
            updateCompleted: "Update abgeschlossen",
            CatalogUpdatedSuccessfully: "Erfolgreich aktualisiert",
            integrateSupsiswithIntegratable: "Leicht die Chat Informationen zwischen SUPSIS und {integratable} leiten.",
            installationOK: "Geladen",
            newDepartmentForm: "Neue Abteilungsregistrierungsformular",
            newDepartment: "Neue Abteilung",
            departmentSaved: "Abteilung gespeichert",
            selectAll: "Alle auswählen",
            collapseAll: "Alle einklappen",
            expandAll: "Alle erweitern",
            addUsersToDepartment: "Benutzer zur Abteilung hinzufügen",
            removeFromDepartment: "Aus Abteilung entfernen",
            moveToDepartment: "In andere Abteilung verschieben",
            noUsersInDepartment: "Keine Benutzer in dieser Abteilung",
            selectAtLeastOneUser: "Wählen Sie mindestens einen Benutzer",
            departmentUsersUpdated: "Benutzer aktualisiert",
            copyToDepartment: "Auch zur Abteilung hinzufügen",
            userAlreadyInDepartment: "Benutzer ist bereits in dieser Abteilung",
            removeUserFromDepartmentConfirm: "Möchten Sie diesen Benutzer wirklich aus der Abteilung entfernen?",
            bulkUpdateProgress: "Massenaktualisierung",
            usersUpdated: "aktualisiert",
            moveToAllDepartments: "In alle Abteilungen verschieben",
            copyToAllDepartments: "Auch zu allen Abteilungen hinzufügen",
            deselectAll: "Alle abwählen",
            sameDepartment: "Es gibt eine Abteilung mit demselben Namen",
            sameValue: "Es gibt einen Wert mit demselben Namen!",
            sameTag: "Es gibt ein Tag mit diesem Namen!",
            departments: "Abteilungen",
            department: "Abteilung",
            announcements: "Ankündigungen",
            announcement: "Bekanntmachung",
            newAnnouncement: "Neue Ankündigung",
            announcementInfo: "Ankündigungsinformationen",
            infoAboutAnnouncement: "Kurze Informationen über die Ankündigung",
            deleteAnnouncementQuestion: "Möchten Sie diese Ankündigung wirklich löschen?",
            announcementDeleted: "Die Ankündigung wurde gelöscht",
            announcementTitle: "Ankündigungstitel",
            updateAnnouncementForm: "Ankündigungs -Update -Formular",
            newAnnouncementForm: "Neues Ankündigungsformular",
            announcementSaved: "Ankündigung aufgezeichnet.",
            chatTimingSettings: "Chat -Zeiteinstellungen",
            assetOversize: "Die Größe der Datei, die Sie senden möchten, sollte nicht größer als 10 MB sein.",
            assetOversizeMB: "Die Größe der Datei, die Sie senden möchten, sollte {mb} MB nicht überschreiten.",
            assetOversizeWithExt: "Die Dateigröße sollte kleiner als 10 MB und PNG, JPG -Format sein.",
            messageDeleted: "Diese Nachricht wurde gelöscht",
            filterVideoCall: "Zeigt Videogespräche",
            filterLostChat: "Filter für verlorene Chats",
            filterClosedByAgent: "Vom Vertreter geschlossene Chats",
            notificationText: "Damit SUPSIS -Benachrichtigungen korrekt arbeiten können",
            notificationTitle: "Benachrichtigungen aus",
            deniedText: "Ihre Benachrichtigungen sind geschlossen, Sie müssen Ihre Benachrichtigungen öffnen, um Ihre Kunden nicht zu verpassen.",
            deniedTitle: "Klicken Sie hier, um Ihre Benachrichtigungen zu öffnen!",
            deniedHeader: "Um Ihre Kunden nicht zu verpassen, müssen Sie Ihre Benachrichtigungen aktivieren!",
            showNotificationGuide: "Für Einzelheiten anklicken",
            howToEnableNotification: "Wie kann ich Benachrichtigungen aktivieren?",
            notificationOK: "OK",
            notificationUnderstood: "Verstanden!",
            notificationCancel: "Stornieren",
            howToEnableNotificationInstruction1: "Klicken Sie in der Adressleiste des Browsers auf das Symbol für Sperre",
            howToEnableNotificationInstruction2: "Aktivieren Sie, wenn \"Benachrichtigungen\" im Abschnitt Genehmigungen passiv zu sein scheinen",
            howToEnableNotificationInstruction3: "Wenn \"Benachrichtigungen\" im Abschnitt Genehmigungen nicht angezeigt werden, klicken Sie auf \"Site -Einstellungen\".",
            howToEnableNotificationInstruction4: "Öffnen Sie die Berechtigung \"Benachrichtigungen\" aus dem Abschnitt \"Genehmigungen\" auf der Seite \"Site -Einstellungen",
            checkPaymentMethod: "Bitte überprüfen Sie Ihre Zahlungsmethode",
            pushNotificationEnabled: "Großartige Benachrichtigungssendung ist aktiv.",
            pushNotificationDenied: "Sie haben die Benachrichtigungsgenehmigungen abgelehnt",
            suspendedMessage: "Ihr Konto wurde gesperrt",
            enableNotification: "Öffnen Sie Ihre Benachrichtigungen.",
            languageSettings: "Sprechsprache",
            problemsSound: "Wenn Sie Probleme mit den Benachrichtigungen haben, klicken Sie auf das Sperrsymbol der Adressleiste Ihres Browsers (im Bild angezeigt) und klicken Sie auf das Feld \"Site -Einstellungen\" und ändern Sie die \"Audio\" aus dem geöffneten Abschnitt.",
            betweenRepresentative: "Die neue Nachricht eines Vertreters.",
            desktopNotifications: "Benachrichtigungen",
            notificationDisable: "Sie können die Desktop -Benachrichtigungen aus den repräsentativen Einstellungen schließen.",
            notificationEnabled: "SUPSIS -Benachrichtigungen sind aktiv.",
            newMessageAlert: "Du hast eine neue Nachricht.",
            newConversationAlert: "Sie haben ein neues Gespräch.",
            chatBot: "Chatbot",
            ticketResponse: "Ticket-Antwort:",
            archived: "Mit Archiven",
            chatbotChatCount: "Chatbot",
            closeChat: "Beende die Nachrichten",
            formStep: "Formschritt",
            menuStep: "Menüschritt",
            contentStep: "Inhaltsschritt",
            menuTitle: "Menükopf",
            messageContent: "Nachrichteninhalt",
            goToLive: "Übertragung zum Vertreter",
            prevStep: "Kehren Sie zu meinem vorherigen Schritt zurück",
            button: "Taste",
            addImage: "Bild",
            addText: "Text",
            stepTitle: "Schritt Titel",
            addTicket: "Ticket",
            formDescription: "Frage",
            addInput: "Frage",
            addRandomText: "Zufälliger Text",
            changeTitle: "Ändern Sie den Titel",
            changeVisitorTitle: "Besuchertitel ändern",
            catalog: "Katalogentitel",
            openTheCatalog: "Öffnen Sie den Katalog",
            catalogNotOpen: "Die Katalogfunktion ist deaktiviert. Sie können die Catalok -Funktion öffnen, um Ihren Kunden vorbereitete Inhalte zu unterstützen.",
            showCatalogCategories: "Ändern Sie den Status des Erscheinens im Chat -Ballon des Katalogmenüs.",
            showChatBot: "Ändern Sie den Zustand des Erscheinens im Chat -Ballon des Chatbot -Menüs.",
            openCatalog: "Katalog",
            unreadMessages: "Ungelesene Beiträge",
            personalFirstMsg: "Repräsentant erster Reaktionszeitdurchschnitt (SN)",
            personalRating: "Personalbewertung",
            soundSettings: "Benachrichtigungseinstellungen",
            newPrivateMessage: "Private Nachricht",
            addNewGroup: "Eine neue Gruppe erstellen",
            newMessage: "Neue Nachricht",
            newConversation: "Neuer Chat",
            newVisitor: "Neuer Besucher",
            chatPosition: "Chat -Standort",
            bottomLeftCorner: "untere linke Ecke",
            leftDocked: "links angedockt",
            bottomRightCorner: "untere rechte Ecke",
            rightDocked: "rechts angedockt",
            chatPositionSelect: "Ort auswählen",
            teamChatGroup: "Gruppennachrichten",
            teamChatDepartment: "Nachrichten der Abteilung",
            teamChatTeam: "Team-Nachrichten",
            teamChatDm: "DM Nachrichten",
            bottomLeft: "Unten links",
            left: "Links",
            bottomRight: "Rechts unten",
            right: "Rechts",
            mailorname: "E-Mail oder Name",
            breaksByTime: "Pausenzahlen",
            clPlaceholder: "Der Name erscheint in Kundenform",
            fieldName: "Schlüsselname",
            value: "Wert",
            addSetting: "Fügen Sie eine neue Einstellung hinzu",
            globalSettings: "Allgemeine Einstellungen",
            target: "Lasttest",
            duration: "Lasttestdauer (Sek.)",
            arrivalCount: "Anzahl der Bots (Stück)",
            bootMaxLife: "Standzeit eines Bots (SN)",
            startLoadTest: "Starten Sie den Lasttest",
            noClusterInstanceFound: "Server nicht gefunden",
            stopLoadTest: "Beenden Sie den Lasttest",
            integrationDesc: "Fügen Sie einfach den folgenden Codes für einen Zeilen hinzu.",
            integrationDemoCode: "Beispielintegration Demo Code",
            integrationWindow: "Wie integriere ich meine Website?",
            notIntegrated: "Integration",
            help: "Hilfe",
            notIntegratedDesc: "Wir haben festgestellt, dass Sie das Chat -System nicht zu Ihrer Website hinzugefügt haben. Wenn Sie sich in Ihre Website integrieren und das erste Interview starten, haben Sie die Integration abgeschlossen. Klicken Sie auf den Integrationscode",
            backToLogin: "Nochmal anmelden",
            passwordlessLoginUnsuccessful: "Eintrag fehlgeschlagen.",
            passwordlessLogin: "Eindringung des Eintritts",
            loginWithEmail: "Melden Sie sich mit E -Mail an",
            loginWithPassword: "Melden Sie sich mit Passwort an",
            enteringPasswordless: "Der Eintrag erfolgt ohne Passwort ...",
            toMainPath: "Richtung zur Homepage",
            userRoleChanged: "Ihr Benutzergenehmigungen haben sich geändert. Sie werden auf die Hauptseite verwiesen, um fortzufahren.",
            passwordChangeSuccess: "Ihr Kennwortänderungsprozess ist erfolgreich ...",
            feedback: "Rückmeldung",
            showFeedbackHistory: "Feedback Senden Nachrichten anzeigen.",
            newSelfServiceSite: "Neue Self -Service -Site",
            subdomain: "Sub -Domain -Name",
            rootUserEmail: "Benutzer Email",
            rootUserName: "Ihren Namen",
            newVersion: "Neue Version verfügbar",
            closeLiveSupport: "Schließende Live -Unterstützung",
            newVersionShort: "Neue Version",
            bannedWordRestrict: "Verbotenes Wort Blockieren",
            ticketShow: "Erlauben Sie Kunden, Tickets zu erstellen",
            ticketShowDesc: "Aktivieren Sie die Option zur Ticketerstellung im Chat-Menü",
            autoLoadIframe: "Live -Verkehr",
            autoLoadIframeDesc: "Iframe lädt automatisch den gesamten Besucherverkehr",
            bannedWordRestrictDesc: "Wenn das verbotene Wortblockieren geöffnet ist, wird der Vertreter daran gehindert, den Besuchern verbotene Wörter zu schreiben.",
            agentDown: "Vertreter fiel",
            delayChat: "Verzögerte Konversation",
            tableSettingTippy: "Sie können die Informationen in der Tabelle von hier aus ändern.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsInfo: "Sie können die Informationen in der Tabelle von hier aus ändern. Sie können bis zu 7 Spalten auswählen",
            privateParametry: "Benutzerdefinierte Benutzerparameter",
            systemOperetor: "Systeminformationen",
            cityAndDistrict: "Stadtteil",
            general: "Allgemein",
            availability: "Repräsentative Arbeitszeit",
            home: "Startseite",
            successful: "Erfolgreich",
            forgetPasswordSent: "Das Passwort Reset Mail wurde gesendet. Überprüfen Sie Ihre E-Mail.",
            saturday: "Samstag",
            friday: "Freitag",
            thursday: "Donnerstag",
            wednesday: "Mittwoch",
            tuesday: "Dienstag",
            monday: "Montag",
            sunday: "Sonntag",
            download: "Laden Sie die Datei herunter",
            calendarPassedTimeHour: "{hour} clock {name}",
            calendarPassedTime: "{hour} clock {min} min {name}",
            calendarPassedTimeMinSec: "{min} min {sec} sec {name}",
            calendarPassedTimeMin: "{value} dk {name}",
            calendarPassedTimeSec: "{hour} clock {min} min {sec} sn {name}",
            workScheduleOneDay: "{name} 'S {sDate} Day Work Calender",
            workSchedule: "{name} namens {sdate} - {edate}",
            noRating: "Es wurde keine Wertung erzielt",
            rateDist: "Bewertungsverteilung",
            distConversation: "Redeverteilung durch Vertreter",
            distributionConversa: "Punkteverteilung",
            distChatbotAgent: "Kommunikationskanäle",
            distAgent: "Chatbot & Agent",
            distFugitive: "Verpasste Rede und empfangene Rede",
            distLive: "Live-Chat",
            distChatbot: "Chatbot",
            distComplex: "Chatbot & Live-Chat",
            distHandled: "Chat beantwortet",
            distMissed: "unbeantworteter Chat",
            distWeb: "Webseite",
            distWhatsapp: "Whatsapp",
            distTelegram: "Telegram",
            distInstagram: "Instagram",
            totalWhatsappChatCount: "WhatsApp -Anzahl der Chats",
            statsByTime: "Anzahl der spricht rechtzeitig",
            selectRep: "Wählen Sie einen Vertreter",
            allRepresentatives: "Alle Vertreter",
            avgRating: "Punktverteilung ({punkt}) ({count} Evaluation)",
            avgFirstMessageTime: "Die durchschnittliche erste Zeit",
            totalBreakTime: "System Break -Zeit",
            totalBreakNum: "Anzahl der Molain",
            averageConTime: "Durchschnittliche Sprachzeit",
            multiWpReportTitle: "Mehrere WhatsApp-Konversationsnummern",
            multiWpReport: "Anzahl mehrerer WhatsApp-Chats",
            multiWpReportExplanation: "Sie können die Chat-Anzahl Ihrer Multi-WhatsApp-Kanäle sehen.",
            longestConTime: "Längste Gesprächszeit",
            shortestConTime: "Kürzeste Sprachzeit",
            refresh: "Aktualisierung",
            waitingReply: "Auf eine Antwort warten",
            organizationName: "Organisationsname",
            companySlogan: "Langer Name der Organisation",
            messageSentErr: "Keine Nachricht konnte nicht gesendet werden, versuchen Sie es erneut.",
            messageSent: "Die Nachricht wurde gesendet.",
            openPrivateChat: "Öffnen Sie das Gespräch zwischen Vertretern",
            escKey: "Aktive Konversation verbergen",
            archiveChatKey: "Ermöglicht es Ihnen, am Chat unten auf der Archivseite teilzunehmen.",
            chatCopilot: "Aktiviert Chat CoPilot",
            privateChat: "Konversationspanel zwischen Vertretern",
            multiModeAlertDesc: "SUPSIS ist in einem anderen Fenster geöffnet. Klicken Sie in diesem Fenster auf \"Verwenden Sie hier\", um SUPSIS zu verwenden.",
            useHereText: "Verwenden Sie es hier",
            brandVisibility: "SUPSIS -Brand -Label erscheint im Chat -Ballon",
            focusInput: "Konzentrieren Sie sich auf das Schreibfeld der Active Rede von Cursor",
            send: "Schicken",
            notYet: "Noch nicht",
            sending: "Gesendet",
            onlyRepresentative: "Ihre Nachricht wird nur von Vertretern gesehen.",
            yourMessage: "Ihre Nachricht",
            liveFabListDescription: "Live Support",
            messengerIntegrationDesc: "Chatten Sie mit Ihren Kunden über die Facebook-Seite, senden Sie automatisierte Nachrichten mit Chatbot.",
            checkDepartmentToAgent: "Abteilung auf Online-Agenten überprüfen",
            ifAllOfflineStory: "Story zur Weiterleitung, wenn alle offline sind",
            AssignMessagesToAgents: "Alle Nachrichten den Agenten zuweisen",
            firstChatbotAndAssign: "Zuerst antwortet der Chatbot und weist dann einem Agenten zu",
            hybridAssign: "Das System überprüft die Abteilung, um zu sehen, ob ein Online-Agent vorhanden ist, und weist es bei fehlendem Online-Agenten dem Chatbot zu.",
            ticketFabListDescription: "Tick",
            whatsappFabListDescription: "WhatsApp",
            phoneFabListDescription: "Telefon",
            emailFabListDescription: "Email",
            facebookFabListDescription: "Facebook",
            twitterFabListDescription: "Twitter",
            instagramFabListDescription: "Instagram",
            youtubeFabListDescription: "Youtube",
            linkedinFabListDescription: "Linkedin",
            telegramFabListDescription: "Telegram",
            typeYourChannelLink: "Sie können den Link Ihres {channelLink} -Kanals auf diesem Feld einsetzen.",
            typeYourAccountLink: "Sie können den Link Ihres {accountLink} -Konto in diesem Feld einfügen.",
            typeYourMessage: "Schreibe deine Nachricht hier",
            typeYourMessageMail: "Die in diesem Feld eingegebene Nachricht wird als erste Nachricht an die oben genannte E -Mail -Adresse gesendet.",
            typeYourMessageDesc: "Die in diesem Feld eingegebene Nachricht wird vom Kunden als erste Nachricht an die oben genannte Telefonnummer gesendet.",
            sendNumber: "Telefonnummer zum Senden der Nachricht: {path}",
            callNumber: "Telefonnummer zu Ihrem Kundenanruf: {phoneNumber}",
            numberIsNotCorrect: "Die fehlende Nummer wurde eingegeben !!",
            emailIsNotCorrect: "E-Mail ist falsch!",
            selectFab: "Wählen Sie eine Fabrik",
            notValid: "Sie können nur den Brief (ein Zeichen) eingeben. E, d, f, z, a, x, c, v, w, t, n Buchstaben sind ungültig",
            forMacUsers: "Mac -Benutzer können den Schlüsselsteuerschlüssel verwenden",
            basePriceValue: "Minimaler Preis",
            basePriceDiscount: "Rabatt",
            basePriceCurrency: "Währung",
            customerDBEnabled: "Datenbankauswahl: Verwenden Sie den eigenen Datenbankserver des Kunden",
            customerDBDisabled: "Datenbankauswahl: Verwenden Sie die SUPSIS -Datenbank Sucunus",
            mongoConnectionString: "Mongo -Verbindung",
            whatsappBasePriceValue: "WhatsApp -Grundpreis",
            whatsappPlusBasePriceValue: "WhatsApp plus Grundpreis",
            instagramBasePriceValue: "Instagram -Grundpreis",
            instagramPlusBasePriceValue: "Instagram plus Grundpreis",
            clientAddress: "Kundenadresse",
            customerClientAddress: "Kundenkundenadresse",
            apiAddress: "API -Adresse",
            socketAddress: "Sockeladresse",
            backendAddress: "Backend -Adresse",
            panelLogoUrl: "Panel -Logo -Adresse",
            panelCustomCssUrl: "Spezialpanel CSS -Adresse",
            customerLogoUrl: "Kundenlogo -Adresse",
            customerCssUrl: "Kunden -CSS -Adresse",
            siteAlias: "Standortname",
            language: "Sprache",
            features: "Merkmale",
            interactionPopularity: "Popularität von Interaktionen",
            interactionCount: "Anzahl der Interaktionen",
            uniqueUserCount: "Anzahl der eindeutigen Benutzer",
            allUserPercentage: "(%) Prozent aller Benutzer",
            represantativeSettings: "Repräsentative Einstellungen",
            documentTitle: "Dokumentenformular",
            supsisDocument: "Supsis-Dokument",
            ApiDoc: "API-Dokumentation",
            chatBalloonTehemeSettings: "Chat -Ballon- und Themeneinstellungen",
            customLoginFormSettingsTitle: "Passen Sie das Besucheranmeldeformular an",
            addNewField: "Neues Feld hinzufügen",
            editField: "Bearbeitungsfeld",
            typeHere: "Geben Sie hier ein",
            pco: "PCO",
            perPage: "/Buchseite",
            perPageInFilter: "Stück",
            noUserInfoFound: "Keine Benutzerinformationen gefunden",
            startFilter: "Fang an zu suchen",
            showMyChats: "Zeigen Sie mir die zugewiesenen",
            showOnlineAgents: "Nur online zeigen",
            showWaitingChats: "Repräsentative zeigen diejenigen, die erwarten",
            addNewStatus: "Status hinzufügen",
            newTitleContent: "Titel hinzufügen",
            roleName: "Rollenname",
            error: "Fehler",
            contentType: "Inhaltstyp",
            contentTitle: "Inhaltstitel",
            newSiteForm: "Neues Standortregistrierungsformular",
            updateSiteForm: "Site -Update -Formular",
            newBannedWordForm: "Neues Registrierungsformular für verbotenes Wort",
            updateBannedWordForm: "Formular für verbotenes Wort Update",
            newWelcomeMessageForm: "Neues Begrüßungsmeldungsformular",
            updateWelcomeMessageForm: "Formular zur Systemmeldung Aktualisierung",
            newDefaultContentForm: "Neues Bereitschafts -Inhaltsregistrierungsformular",
            updateDefaultContentForm: "Formular für das Ready Content -Update",
            newSubjectForm: "Neues Fachregistrierungsformular",
            updateSubjectForm: "Formular des Betreff -Update",
            showIntro: "Einführung zeigen",
            showChatColorMeaning: "Chatfarben",
            options: "Optionen",
            resetPassword: "Aktualisieren Sie das Passwort",
            audioLevel: "Sprachwarnschall Level",
            privateChatNotificationSound: "Benachrichtigungston",
            continue: "Weitermachen",
            newRoleForm: "Neues Rollenregistrierungsformular",
            updateRoleForm: "Rollen -Update -Formular",
            newUserForm: "Neues Benutzerregistrierungsformular",
            updateUserForm: "Benutzer aktualisieren",
            changeOSRForm: "Ändern Sie die Offline -Nachricht",
            tooltipOSRForm: "Sie können die Offline -Nachricht ändern.",
            newOSRForm: "Offline -Support -Formular",
            newOSRMessages: "Fügen Sie Offline -Post hinzu",
            newOsrMessageTitle: "Offline -Nachrichtentitel",
            updateOSRForm: "Offline -Update -Formular",
            osrTitle: "Titel",
            osrTitleDescription: "Sie können den Titel des Offline -Support -Formulars hinzufügen",
            osrContent: "Inhalt",
            osrContentDescription: "Sie können nicht -Online -Support -Formularinhalte hinzufügen",
            hello: "Hallo Welt",
            date: "Geschichte",
            startDate: "Anfangsdatum",
            finish: "Beenden",
            start: "Anfang",
            endDate: "Endtermin",
            representative: "Vertreter",
            representative_: "Vertreter",
            star: "Stern",
            filter: "Filter",
            reset: "ZURÜCKSETZEN",
            dailyChatList: "Tägliche Sprachliste",
            dailyChatDuration: "Tägliche Sprachzeit",
            chatDuration: "Sprachzeit",
            dailyChatGraph: "Tägliche Gesprächsgrafik",
            ok: "OK",
            chatCount: "Anzahl der Reden",
            shortest: "Kürzeste",
            longest: "Die längste",
            average: "Durchschnitt",
            count: "Stück",
            averagePoint: "Durchschnittliche Punktzahl",
            pointDist: "Bewertungsverteilung",
            point: "Punkt",
            filters: "Filter",
            totalCustomer: "Totaler Kunde",
            avResponseTime: "Abdeckung. Die erste Interventionszeit",
            breakDuration: "Pause",
            breakCount: "Bruch",
            active: "Aktiv",
            passive: "Passiv",
            userForm: "Benutzerform",
            startChat: "Chat beginnen",
            sender: "Absender",
            profile: "Profil",
            name: "Name",
            number: "Nummer",
            username: "Nutzername",
            updateUserName: "Benutzername aktualisieren",
            password: "Passwort",
            oldPassword: "Altes Passwort",
            newPassword: "Neues Kennwort",
            passwordAtLeast: "Passwort (mindestens {num} Zeichen)",
            passwordRepeat: "Passwort erneut",
            changePassword: "Kennwort ändern",
            status: "Situation",
            enableState: "Aktiv?",
            douYouWishToDeleteUser: "Möchten Sie diesen Benutzer wirklich löschen?",
            douYouWishToDeleteAnnouncement: "Möchten Sie diese Ankündigung wirklich löschen?",
            userDeleted: "Benutzer gelöscht",
            userSaved: "Benutzer gespeichert.",
            oldPasswordError: "Das alte Passwort ist falsch. Bitte überprüfen Sie.",
            chooseAnOption: "Bitte wählen Sie Ihren bevorzugten Benachrichtigungs -Sound aus.",
            userVolumeUpdated: "Die Schallanpassung wurde aktualisiert.",
            addNewMenu: "Neues Menü hinzufügen",
            addNewContent: "Neue Inhalte hinzufügen",
            pleaseTitleEnter: "Bitte geben Sie den Titel ein",
            like: "Anerkennung",
            disLike: "Ungnade",
            users: "Benutzer",
            visitor: "Besucher",
            allContacts: "Alle Links",
            allUsers: "Alle Vertreter",
            allSites: "Alle Standorte",
            newUser: "Neuer Benutzer",
            noNewUser: "Es gibt noch keinen Benutzer.",
            noNewAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            noNewAnnouncement: "Es gibt noch keine Ankündigung.",
            noRoleFound: "Es gibt noch keine Rolle.",
            noBannedWordFound: "Es gibt noch kein Verbot.",
            noWelcomeMessageFound: "Noch keine Systemnachricht.",
            noSubjectFound: "Es gibt noch kein Thema.",
            noVisitorFound: "Der Besucher wurde nicht gefunden.",
            noContactFound: "Der Leitfaden wurde nicht gefunden.",
            sendResponse: "Antwort schreiben",
            delete: "Löschen",
            duplicate: "Kopieren",
            makeDefault: "Machen Sie den Standard",
            checkMore: "Mehr",
            useReadyTemplates: "Verwenden Sie Bereitschaftsvorlagen",
            noRePresentativeFound: "Der Vertreter wurde nicht gefunden.",
            noLiveSupportFound: "Es gibt noch keine Live -Support -Aufzeichnungen.",
            noLiveSupportFoundWithDepartment: "Es gibt keine Chat -Aufzeichnung der Abteilung",
            noBannedVisitorFound: "Es gibt noch keine verbotenen Besucher.",
            removeBanDescription: "Das Verbot entfernen",
            editThisItem: "Aktualisieren Sie diesen Datensatz",
            removeThisItem: "Löschen Sie diesen Datensatz",
            role: "Rolle",
            newRolePlaceHolder: "Klicken Sie hier, um eine neue Rolle hinzuzufügen ...",
            autoChatAssignLimit: "Automatische Sprachzuweisungsgrenze",
            chatAssignInfo: "-1 = Systemannahme, 0 = kein Termin erfolgt,> 0 = Zuweisung ist bis zum angegebenen Wert bestanden.",
            relatedDepartments: "Die zuständigen Abteilungen",
            subjectInfo: "Alle Probleme sind zulässig, wenn das Thema nicht ausgewählt ist.",
            archive: "Archiv",
            offlineSupportRequests: "Offline -Unterstützung",
            offlineModeMessage: "Offline -Nachricht",
            offlineMode: "Offline-Modus",
            first: "Erste",
            last: "Ende",
            query: "Fang an zu suchen",
            clean: "Sauber",
            loading: "Wird geladen",
            loadMore: "Lade mehr hoch",
            noMessage: "Es gibt keine Nachricht ...",
            selectChat: "Wählen Sie Sprache",
            noMessageInChat: "In dieser Rede wurde keine Nachricht gefunden",
            noMediaToShow: "Keine Medien zu zeigen",
            firstSeen: "Zum ersten Mal gesehen",
            userInfo: "Nutzerinformation",
            chatId: "Sprachausweise",
            visitorId: "Besucher-ID",
            visitingPage: "Besuchte Seite",
            osAndBrowser: "Betriebssystem und Browser",
            customerClientVersion: "Kundenversion",
            visitorFeedback: "Kundenbewertung",
            notes: "Notizen",
            nameSurname: "Vorname Familienname",
            chats: "Reden",
            bannedVisitors: "Verbotte Besucher",
            country: "Land",
            city: "Stadt",
            cityDistrict: "Provinzbezirk",
            browser: "Scanner",
            os: "Betriebssystem",
            ipAddress: "IP Adresse",
            connectionDate: "Verbindungszeit",
            transaction: "Verfahren",
            banRemoved: "Die Blockierung wurde entfernt.",
            bannedWords: "Verbotene Worte",
            newBannedWord: "Neues verbotenes Wort",
            noBannedWord: "Es gibt noch kein Wort mit Behinderungen.",
            bannedWordForm: "Verbotene Wortform",
            word: "Wort",
            bannedWordAndWordGroup: "Verbotte Wort / Wortgruppe",
            doYouWishToDeleteBannedWord: "Möchten Sie dieses verbotene Wort wirklich löschen?",
            doYouWishToOfflineSupportRequest: "Möchten Sie diese Nachricht löschen?",
            bannedWordSaved: "Verbotenes Wort aufgezeichnet",
            deletedSuccessfully: "Erfolgt gelöscht",
            deleteErrorMsg: "Das Löschen des Prozesses konnte nicht realisiert werden, versuchen Sie es erneut",
            socketError: "Sochete Connection Problem. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut",
            socketConnecting: "Die Verbindung wird mit dem Server hergestellt",
            offlineModeDescription: "Das System ist geschlossen, Kunden können nicht auf Live -Support zugreifen.",
            offlineModeSettingsDescription: "Überprüfen Sie im Menü Einstellungen die Funktion \"Offline -Modus\".",
            offlineModeUser: "Das System muss mindestens ein Online -Vertreter sein.",
            adminCannotConnectSocket: "Administratoren können nicht mit der Steckdose verbunden werden.",
            liveSupport: "Live Support",
            siteVisitors: "Site -Besucher",
            visitors: "Besucher",
            thoseConnectedToLiveSupport: "Diejenigen, die mit Live -Unterstützung verbunden sind",
            visitorHistory: "Besuchergeschichte",
            visitorHistoryDescription: "Sie können den Besucher-Chat-Verlauf anzeigen und herunterladen.",
            privateMessage: "Private Nachricht",
            addRepresentative: "Vertreter hinzufügen",
            forwardRepresentative: "Anweisung zum Vertreter",
            keyboardShortcuts: "Tastatürkürzel",
            chatColorMeanings: "Sprachfarbe Bedeutungen",
            connLostCheckInternet: "Ihre Verbindung ist gebrochen. Bitte stellen Sie sicher, dass Sie eine Internetverbindung haben.",
            wishToEndThisChat: "Möchten Sie dieses Treffen beenden?",
            defaultContents: "Bereites Inhalt",
            contents: "Inhalt",
            newDefaultContent: "Neue Bereitschaftsinhalte",
            newCTRLContent: "Fügen Sie Strg -Inhalt hinzu",
            newALTContent: "Fügen Sie den Sub -Conontent hinzu",
            newTABContent: "Registerkarte Inhalt hinzufügen",
            shortcutChar: "Verknüpfungscharakter",
            pickOne: "Wähle eins",
            writeSomething: "Schreiben Sie einen Charakter (a-z | 0-9)",
            letterSequence: "Briefreihe",
            exampleText: "Beispiel: fut -> Fußball",
            anyChar: "Jeder Charakter",
            shorcutKey: "Tastenkürzel",
            content: "Inhalt",
            shortcutName: "Verknüpfungsname",
            type: "Medizin",
            shortcut: "Abkürzung",
            deleteContentQuestion: "Möchten Sie diesen in den Bereit sich hergestellten Inhalt wirklich löschen?",
            defaultContentDeleted: "Bereites Inhalt wurde gelöscht.",
            defaultContentSaved: "Ready -hergestellte Inhalte aufgezeichnet.",
            defaultContentForm: "Bereitete Inhaltsform",
            titleContentForm: "Title in Content",
            contentMoved: "Der Inhalt wurde verschoben.",
            cannotMoveFullParent: "Sie können dieses Element nicht tragen",
            yourEmail: "E-Mail-Addresse",
            yourName: "Ihr Name und Nachname",
            lostPassword: "Ich habe mein Passwort vergessen",
            login: "Eingang",
            forgotPassword: "Ich habe mein Passwort vergessen",
            multipleSession: "Sie haben sich irgendwo anders angemeldet.",
            notAuthorizedToDisplayPage: "Sie haben keine Erlaubnis, diese Seite anzuzeigen!",
            permissions: "Genehmigung",
            newPermission: "Neuer Urlaub",
            permissionForm: "Erlaubnis von",
            displayTitle: "Bildgebungstitel",
            key: "Taste",
            keyToUseInSystem: "Der Schlüsselwert, der im System verwendet werden soll",
            deletePermissionQuestion: "Möchten Sie diese Erlaubnis wirklich löschen?",
            permissionDeleted: "Die Erlaubnis wurde gelöscht.",
            permissionSaved: "Erlaubnis wurde aufgezeichnet.",
            newRole: "Neue Rolle",
            selectARole: "Wählen Sie eine Rolle",
            yes: "Ja",
            no: "NEIN",
            fullAuth: "Volle Autorität",
            roleDeleted: "Die Rolle wurde gelöscht.",
            roleForm: "Rollenform",
            roles: "Rollen",
            settings: "Einstellungen",
            selectTopic: "Abteilungsauswahl",
            autoCallTransfer: "Automatische Interviewübertragung",
            customerTyping: "Benutzer schreiben",
            typing: "Er schreibt",
            agentTyping: "Vertreter schreibt",
            disconnectTime: "Kündigungszeit (SN)",
            tippyDissconnectTime: "Passt das Gespräch in der immer noch Situation nach wie vielen Sekunden an, die geschlossen werden wird",
            queueNumberVisibleFeature: "Zeigen Sie die Anzahl der Personen, die im Einklang mit dem Besucher warten",
            privateChatEnabled: "Chat zwischen Vertretern zeigen",
            delayedTalkTime: "Verzögerungszeit (SN)",
            employeeAverageChatCount: "Durchschnittliche Anzahl von Reden für das Personal -Chat -Verhältnis",
            customerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            autoAssignLimit: "Automatische Zuordnungsgrenze",
            wasted: "V Verschwendung Zeit (SN)",
            settingsSaved: "Einstellungen aufgezeichnet.",
            settingsCannotSaved: "Einstellungen können nicht gespeichert werden",
            noAuthorization: "Keine Berechtigung",
            warningBadInput: "Es wird empfohlen, eine Zahl zwischen 0 und 70 einzugeben.",
            warningBadInputMarginY: "Warnung vor dem Auftritt der vertikalen Seitenhauptstadt ⚠️",
            warningBadInputMarginX: "Warnung vor dem Eingang des horizonalen Kapitals ⚠️",
            warningBadInputBubbleSize: "Warnung vor Ballongrößeneintrag ⚠️",
            settingFormWrong: "Die Daten, die Sie eingeben, sind falsch, überprüfen und versuchen Sie es erneut",
            delayTime: "Zeitverzögerungszeit (Mr.)",
            sites: "Standorte",
            newSite: "Neue Seite",
            noSiteYet: "Es gibt noch keine Website.",
            siteAddress: "Website-Adresse",
            turnBack: "Zurückdrehen",
            customerRepLimit: "Kundenvertreterlimit",
            siteSaved: "Die Seite wurde gerettet.",
            siteSaveError: "Es gab einen Fehler beim Erstellen einer Website.",
            subjects: "Themen",
            newSubject: "Neues Thema",
            noSubject: "Es gibt noch kein Thema.",
            subject: "Thema",
            subjectTitle: "Thementitel",
            infoAboutSubject: "Kurze Informationen zum Thema",
            deleteSubjectQuestion: "Möchten Sie dieses Thema wirklich löschen?",
            subjectDeleted: "Das Thema wurde gelöscht",
            subjectSaved: "Das Thema wurde gerettet.",
            osrFromMessageSaved: "Offline -Nachricht aufgezeichnet.",
            welcomeMessages: "Systemmeldungen",
            newWelcomeMessages: "Neue Begrüßungsnachricht",
            noWelcomeMessage: "Noch keine Systemnachricht.",
            welcomeMessageContent: "Systemnachrichteninhalt",
            makeChoice: "Entscheide dich ...",
            welcomeMessage: "Willkommensnachricht",
            repLoggedIn: "Vertreter unterzeichnet",
            loginMessage: "Signiernachricht",
            message: "Nachricht",
            deleteWelcomeMessageQuestion: "Möchten Sie diese Systemnachricht wirklich löschen?",
            welcomeMessageDeleted: "Systemnachricht gelöscht",
            welcomeMessageSaved: "Die Systemmeldung wurde aufgezeichnet.",
            welcomeMessageForm: "Systemnachrichtenformular",
            noRep: "Es gibt noch keinen Vertreter.",
            addChat: "Fügen Sie das Interview hinzu",
            forwardChat: "Leiten Sie das Interview",
            ago: "Vor",
            repName: "Repräsentativer Name",
            lastOnline: "Letzte Verbindung/Online -Zeit",
            lastStatusChange: "Letzte Falländerung",
            activeChat: "Aktive Rede",
            userMaxCapacity: "Max Chat -Kapazität",
            noActiveChat: "Keine aktive Rede.",
            watch: "BETRACHTEN",
            join: "VERBINDEN",
            open: "Öffne das Gespräch",
            directMessage: "PRIVATE NACHRICHT",
            block: "BLOCK",
            transactions: "Transaktionen",
            informations: "Informationen",
            visitStart: "Beginn des Besuchs",
            fullName: "Name und Nachname",
            waitChatTime: "Wartezeit/Chatzeit",
            blockUserConfirm: "Möchten Sie diese Person wirklich verhindern?",
            messaging: "Nachrichten",
            hideChat: "Verstecke das Gespräch",
            block_: "Block",
            privateMessage_: "Geheime Botschaft",
            assignRep: "Repräsentant ATA",
            joinChat: "Einbeziehung im Gespräch",
            forwardRep: "Orientierungshilfe",
            leaveChat: "Verlassen Sie das Interview",
            endChat: "Beenden Sie das Treffen",
            translatedTextDescription: "Amazon hat diese Nachricht {from} -> {to} übersetzt.",
            autoTranslate: "Automatische Übersetzung",
            translateThisMessage: "Drehen Sie diese Nachricht",
            autoTranslateDetectedDesc: "Besucher sprechen in {visitorLanguage}. Klicken Sie hier, um die automatische Übersetzung zu aktivieren",
            on: "Offen",
            off: "Geschlossen",
            prevChats: "Vorherige Reden",
            noShortCut: "Keine Verknüpfung",
            leaveChartConfirm: "Bist du sicher, dass du gehen willst, ohne zu reden?",
            endChatConfirm: "Möchten Sie dieses Treffen beenden?",
            chatBar: "Sprachanzeige",
            endConversation: "Beenden Sie das Treffen",
            onlyOneRep: "Sie sind der einzige Vertreter in diesem Gespräch!",
            chatList: "Sprachliste",
            unreadTitle: "Ungelesen",
            visitorLeftTitle: "Besucherausgabe",
            activeChatTitle: "Aktive Rede",
            autoAssignedTitle: "Automatisch zugewiesen",
            watchModeTitle: "Überwachungsmodus",
            lostChat: "Repräsentative Verbindung gebrochen",
            repLostConn: "Wenn der Vertreter aus der Rede ausbrach, wird das Gespräch rosa.",
            chatWidthDelay: "Verzögerung des Chats",
            repChatWidthDelay: "Wenn es keinen aktiven Vertreter im System gibt oder dass Besucher aufgrund der Dichte nicht genommen werden, ist der Hintergrund grün.",
            unreadMsg: "Wenn es eine ungelesene Nachricht gibt, wird der Hintergrund hellblau.",
            visitorLeftChat: "Wenn der Besucher die Rede verließ, wird der Hintergrund dunkelgrau.",
            activeChatMsg: "Wenn die Rede aktiv ist, wird der Hintergrund grün",
            autoAssignMsg: "Wenn er mit automatischer Aufgabe ernannt wurde und das Gespräch nicht betrachtet wurde, wird der Hintergrund Senf",
            watchModeMsg: "Wenn im Überwachungsmodus geöffnet wird, wird der Hintergrund rot",
            online: "Online",
            beRightBack: "Ich komme gleich wieder",
            away: "Ich komme gleich wieder",
            busy: "Beschäftigt",
            offline: "Offline",
            logout: "Ausloggen",
            forWindows: "Für Windows",
            forMac: "Für Mac",
            nextChatFromActive: "Gehen Sie zum nächsten Gespräch ohne aktive Gespräch",
            previousChatFromActive: "Übergeben Sie das vorherige Gespräch ohne aktive Rede",
            hideActiveChat: "Aktive Konversation verbergen",
            closeActiveChat: "Beenden Sie aktive Gespräche",
            firsthiddenChat: "Stellen Sie eine Verbindung zur Rede des am meisten gewarteten Kunden her",
            firstChatWaiting: "Wechseln Sie zur Sprache, die auf eine Antwort wartet",
            previousOpenedChat: "Wechseln Sie zu dem Gespräch, das zuvor geöffnet wurde",
            hashHintMessage: "Sie können schnell die Hashtag -Verknüpfungen eingeben",
            pmHintMessage: "Sie können eine geheime Nachricht mit (Beispiel PM: HI) senden",
            vtippyTicketNotification: "Benachrichtigungseinstellungen für jedes neue Ticket, das zu Ihnen kommt",
            newTicketSound: "Neues Ticket",
            vtippyDepartmentNotification: "Benachrichtigungseinstellungen für Nachrichten aus der Abteilungskonversation",
            vtippyGroupNotification: "Benachrichtigungseinstellungen für Nachrichten aus erstellten Gruppen",
            vtippyAnnouncemenNotification: "Benachrichtigungseinstellungen für neue Ankündigungen",
            languageSelection: "Sprachauswahl",
            shortcutHintMessage: "Sie wissen, dass Sie schnellere Nachrichten mit Abkürzungsnachrichten senden können.",
            switchBetweenConversations: "Wissen Sie, dass Sie schnell zwischen Verknüpfungen und Chats umschalten können?",
            atNameHintMessage: "Wissen Sie, dass Sie den Namen des Besuchers schnell schreiben können?",
            dndHintMessage: "Sie können die Datei mit Drag & Drop hochladen.",
            pasteFile: "Sie können Dateien mit senden.",
            atEmailHintMessage: "Wissen Sie, dass der Besucher die E-Mail schnell schreiben kann?",
            pastePlainText: "Es klebt den Ausdruck, den Sie als direkter Text ohne Stil kopieren.",
            pressAndTalk: "Press and talk",
            historyDetails: "Vergangene Details",
            chat: "Rede",
            chatNotFound: "Keine Sprache gefunden.",
            dataNotFound: "Daten nicht gefunden.",
            visitorInfo: "Besucherinformationen",
            timeSpent: "Die Zeit",
            noActiveVisitors: "Keine aktiven Besucher",
            select: "Öffnen Sie das Menü",
            fullname: "Vollständiger Name",
            text: "Text",
            numeric: "Digital",
            phone: "Telefon",
            optionsPlaceholder: "Optionswert",
            selectField: "Klicken Sie auf, wenn Sie ein Pop -up -Menü hinzufügen möchten",
            fullnameField: "Klicken Sie, wenn Sie einen vollständigen Namensraum hinzufügen möchten.",
            textField: "Klicken Sie, wenn Sie ein Textfeld hinzufügen möchten.",
            labelField: "Wenn Sie das Feld Beschreibung hinzufügen möchten, klicken Sie auf.",
            numericField: "Wenn Sie einen numerischen Bereich hinzufügen möchten, klicken Sie auf.",
            phoneField: "Klicken Sie, wenn Sie ein Telefonfeld hinzufügen möchten.",
            departmentField: "Klicken Sie auf, wenn Sie einen Abschnitt hinzufügen möchten",
            emailField: "Wenn Sie den E -Mail -Bereich hinzufügen möchten, klicken Sie auf.",
            visible: "Sichtbar",
            required: "Schwierigkeit",
            label: "Erläuterung",
            totalConnected: "Anzahl der Reden",
            missedChat: "Anzahl der Reden entkommen",
            workTime: "Arbeitszeit",
            closedChatCount: "Geschlossene Gespräche",
            activeConvo: "Aktiv gesprochen",
            notAnswered: "Noch nicht beantwortet",
            delayedConvo: "Verzögerte Gespräche",
            leavingRep: "Abfahrtsvertreter",
            staffRate: "Personal Arbeitsrate",
            customLoginAlert: "Es muss mindestens 1 sichtbarer Bereich in Ihrer Form sein.",
            atLeastOneLanguage: "Muss mindestens eine Sprache der Sprache sein.",
            requiredField: "Dieser Bereich ist obligatorisch.",
            notRequiredField: "Dieser Bereich ist nicht obligatorisch.",
            visibleField: "Dieses Feld erscheint in der Form.",
            notVisibleField: "Dieses Feld erscheint nicht in der Form.",
            connectServer: "Sie sind mit dem Server verbunden",
            disconnectServer: "Ihre Verbindung mit dem Server wurde abgeschnitten",
            liveChatOff: "Live -Unterstützung aus",
            visitorScreen: "Besucherbildschirm",
            viewOnTheSite: "Ansicht auf der Seite",
            viewOnTheSiteTippy: "Klicken Sie hier, um zu sehen, wie Ihre Änderungen stoppen.",
            showHint: "Tipp zeigen",
            dontShowHint: "Tipp zeigt",
            liveChatOn: "Live -Unterstützung ist offen",
            nightModeOff: "Nachtmodus aus",
            nightModeOn: "Der Nachtmodus ist offen",
            deleteField: "Löschen",
            arrow_upward: "Stromaufwärts",
            arrow_downward: "Stromabwärts",
            doubleClickEdit: "Klicken Sie zweimal, um die Schaltfläche Bearbeiten zu bearbeiten oder zu drücken.",
            newCatalogCategory: "Neue Katalogkategorie",
            childCreate: "Klicken Sie hier, um Sub -Incontent zu erstellen",
            updateCatalogCategoryFrom: "Katalogkategorie -Aktualisierungsformular",
            newCatalogCategoryFrom: "Neue Formular der Katalogkatalog",
            catalogMenu: "Speisekarte",
            catalogContent: "Inhalt",
            catalogCategoryName: "Katalogkategorie Name",
            newCatalogContentFrom: "Neues Kataloginhaltsformular",
            catalogContentName: "Kataloginhaltsname",
            catalogCategorySaved: "Katalogkategorie aufgezeichnet",
            catalogCategoryDeleted: "Die Katalogkategorie wurde gelöscht.",
            catalogCategoryRate: "Content Score",
            catalogContentFeature: "Katalogfunktion",
            vtipyAudioLevel: "Es wird verwendet, um Benachrichtigungsgeräusche zu schneiden oder zu öffnen.",
            vtipyOrganizationName: "Sie können den Organisationsnamen ändern und aktualisieren.",
            vtipyBrandVisibility: "Das SUPSIS -Tag ist die Einstellung, ob es im Chat -Ballon angezeigt wird.",
            vtipyBrandVisibilityForced: "Nur Proplan kann Benutzer ändern !!",
            vtipyClientDefault: "Sie können die repräsentative Seitensprache hier ändern.",
            vtipyCustomerClientDefault: "Hier können Sie die Sprache der Kundenseite (CHAT) ändern.",
            vtipyVisitorPreferredLang: "Sie können die Sprachsprache auf der Seite Kunden (CHAT) auswählen.",
            vtipyCustomerClientLanguageDetect: "Sie können automatisch die Sprache der Seite der Kunden (CHAT) erkennen.",
            vtipySelectTopic: "Nach den von den Kunden ausgewählten Themen müssen die Abteilungen (Fächer) geleitet werden.",
            vtipyAutoCallTransfer: "Es weist die Warteverträge automatisch den verfügbaren Vertretern zu.",
            vtipyCustomerTyping: "Sie können den Kunden auf dem Chat -Bildschirm auf dem Chat -Bildschirm sehen.",
            vtipyAgentTyping: "Der Vertreter zeigt den Schreibstatus beim Kundenballon.",
            vtipyQueueNumberVisibleFeature: "Es zeigt, was für Kunden, die sich verbinden möchten, wenn Vertreter intensiv sind.",
            vtipyPrivateChatEnabled: "Zeigt das Sprachgremium zwischen Vertretern.",
            vtipyDelayedTalkTime: "Während dieser Zeit ist kein Vertreter mit dem Sprechen als \"verzögerte Rede\" verbunden.",
            vtipyOfflineMode: "Mit dem System können Sie offline -Mode kaufen.",
            vtipyAutoAssignLimit: "Es bestimmt, wie viele Kundenterminer an den Vertreter vereinbart werden.",
            vtipyCustomerDownTimeWhenRepExit: "Als der Vertreter ausgeht, verschwendete der Kunde Zeit (Mr.)",
            tippyDisconnectTime: "Nachdem die Kundenverbindung unterbrochen wurde, ist die Schließzeit (SN).",
            changeSettings: "Ändern Sie die globale Einstellung",
            totalBg: "Gesamtzahl der Chats",
            activeBg: "Aktive Chats",
            watchBg: "Verfolgung",
            waitingBg: "Ausstehende Chats",
            lateBg: "vorbeiziehende Gespräche",
            freeBg: "Leerlauf",
            maxCapacityBg: "Max",
            addNewSettings: "Fügen Sie eine neue globale Einstellung hinzu",
            darkMode: "NACHT-MODUS",
            clientDefault: "Panel Standardsprache",
            customerClientDefault: "Kundenteil ist die Standardsprache",
            customerClientLanguageDetect: "Kundenteil der Sprache erkennt automatisch",
            visitorPreferredLang: "Kunde Wählen Sie die Sprachsprache",
            preferredThemeColor: "Sprachbildschirm -Themenpräferenz",
            detail: "Prüfen",
            langSetting: "Die Spracheinstellung",
            supportUs: "Kontaktieren Sie uns (Live -Unterstützung)",
            changeLang: "Sprache ändern",
            fontSizeSetting: "Einstellung der Bildschirmvergrößerung",
            changeLangDesc: "Legt die Anwendungssprache auf {code} fest.",
            trLang: "Türkisch",
            enLang: "Englisch",
            fieldRequired: "{field} Feld ist erforderlich.",
            selectALanguage: "Wählen Sie eine Sprache",
            selectATheme: "Wähle ein Thema",
            responseForm: "Antwortformular",
            clientRequestInfo: "Kundenbedarfsinformationen",
            createdDate: "Erstellungsdatum",
            descMessage: "Nachricht",
            new: "Neu",
            lastLoginPlatform: "Plattform",
            requiredFieldField: "Dieser Bereich ist obligatorisch",
            catalogCategoryMenu: "Fügen Sie das Katalogkategoriemenü hinzu",
            catalogCategoryLeaf: "Katalogkategorie Sub -Menu",
            selectAllPermission: "Wählen Sie Alle",
            catalogCategories: "Katalog",
            copiedClipboard: "In die Tafel kopiert",
            organizationLogo: "Firmenlogo",
            changePlan: "Plan ändern",
            close: "Schließen",
            vtipyUploadLogo: "Sie können Ihr eigenes Logo auf Customer Mails und Kundenseite verwenden, indem Sie Ihr Firmenlogo aus diesem Bereich installieren.",
            tagName: "Verlinke den Namen",
            tagDescription: "Etikettenbeschreibung",
            tagColor: "Etikettenfarbe",
            userInformations: "Nutzerinformation",
            incomingChat: "Eingehender Chat",
            support: "Unterstützung",
            team: "Satz",
            groups: "Gruppen",
            newConversationStarted: "Neues Gespräch begonnen",
            allHistoryLoaded: "Der gesamte Verlauf wurde hochgeladen",
            chatCreator: "Chat-Ersteller",
            enterGroupTitle: "Geben Sie den Gruppentitel ein",
            requiredTitle: "Sie können das Titelfeld nicht leer lassen",
            requiredChannel: "Der Kanalname darf nicht leer sein",
            next: "Bestätigen",
            selectPeople: "Wählen Sie Personen aus",
            textLimitAlertMessage: "Die Zeichenbeschränkung in WhatsApp beträgt 19 Zeichen und darüber hinaus wird es nicht angezeigt. Im Web werden jedoch Texte, die die 19-Zeichen-Grenze überschreiten, automatisch in die nächste Zeile verschoben und angezeigt.",
            artificialIntelligence: "Künstliche Intelligenz",
            channelSettings: "Kanaleinstellungen",
            apiKeyMode: "API-Schlüssel-Modus",
            byokTitle: "Eigenen API-Schlüssel verwenden (BYOK)",
            byokDesc: "API-Schlüssel aus Ihrem OpenRouter-Konto verwenden",
            supsisKeyTitle: "Supsis KI stellt API-Schlüssel bereit",
            supsisKeyDesc: "Von Supsis bereitgestellten API-Schlüssel verwenden",
            openrouterApiKey: "OpenRouter API-Schlüssel",
            openrouterApiKeyHint: "API-Schlüssel erhalten Sie im OpenRouter-Dashboard.",
            noChannels: "Noch keine Kanäle",
            createFirstChannel: "Klicken Sie auf „Kanal hinzufügen“, um Ihren ersten Kanal zu erstellen.",
            createChannel: "Kanal erstellen",
            providerInfo: "Anbieterinformationen",
            channels: "Kanäle",
            channelUpdatedSuccessfully: "Kanal erfolgreich aktualisiert",
            channelDeletedSuccessfully: "Kanal erfolgreich gelöscht",
            failedToSaveChannel: "Kanal konnte nicht gespeichert werden",
            failedToDeleteChannel: "Kanal konnte nicht gelöscht werden",
            apiKeyRequired: "API-Schlüssel ist erforderlich",
            deleteChannelConfirm: "Sind Sie sicher, dass Sie diesen Kanal löschen möchten?",
            copiedToClipboard: "In Zwischenablage kopiert",
            showMore: "Mehr anzeigen",
            showLess: "Weniger anzeigen",
            autoForwardToOwnerForce: "Kontakte mit Besitzer immer an Besitzer weiterleiten (auch bei aktivem Chatbot)",
            dropdown: "Auswählbar",
            selectRepresentativeChatbot: "Vertreter/Chatbot auswählen",
            selectDomain: "Domain auswählen",
            salesOrders: "Verkaufsbestellungen",
            noSalesOrdersFound: "Für diese Person wurden keine Verkaufsbestellungen gefunden",
            loadingSalesOrders: "Verkaufsbestellungen werden geladen",
            contacts: "Kontakte",
            noContactsFound: "Für diese Telefonnummer wurden keine Kontakte gefunden",
            loadingContacts: "Kontakte werden geladen",
            task: "Aufgabe",
            isOneOf: "Eines von",
            between: "Zwischen",
            chatbotScenarioHasBeenCanceled: "Chatbot-Szenario wurde abgebrochen",
            toQueue: "Warteschlange",
            aiClassificationTextMode: "Textklassifizierung",
            aiClassificationImageMode: "Bildklassifizierung",
            aiClassificationImageUrlLabel: "Zu klassifizierendes Bild (URL)",
            aiClassificationImageUrlPlaceholder: "Bild-URL eingeben (z. B. https://...)",
            updateChannelDesc6: "WhatsApp-Business-API-Kanal aktualisieren",
            newWabaChannel: "Neuer WhatsApp-Business-Kanal",
            newWabaChannelDesc: "Neuen Kanal für WhatsApp Business API erstellen",
            deleteFiles: "Dateien löschen",
            sureDeleteMultipleFiles: "Sind Sie sicher, dass Sie die ausgewählten Dateien löschen möchten?",
            cancelSelection: "Auswahl aufheben",
            accessControl: "Zugangskontrolle",
            questions: "Fragen",
            notAuthorizedChannel: "Sie sind nicht berechtigt, auf diesen Kanal zuzugreifen.",
            integrationsYouTubeComments: "Manage YouTube comments from a single panel and engage with your customers.",
            integrationsGoogleBusinessReviews: "Manage Google Business reviews from a single panel and engage with your customers.",
            integrationsGooglePlayReviews: "Manage Google Play Store app reviews from a single panel and engage with your users.",
            integrationsAppStoreReviews: "Manage App Store app reviews from a single panel and engage with your users.",
            integrationsGoogleDrive: "Manage your Google Drive files within Supsis and share them in conversations.",
            integrationsPage: {
                compare: "Vergleichen",
                dead: "Deaktiviert",
                whatsappV2Web: "WhatsApp V2 (Web)",
                whatsappV3QR: "WhatsApp V3 (QR Code)",
                whatsappBusinessAPI: "WhatsApp Business API",
                whatsappBusinessAPIv2: "WhatsApp Business API v2",
                instagram: "Instagram",
                instagramV2: "Instagram V2",
                instagramV2Desc: "Direkte Verbindung mit Instagram Login. Kein Facebook-Konto erforderlich.",
                messenger: "Messenger",
                linkedin: "LinkedIn",
                telegramQR: "Telegram (QR Code)",
                telegramBotFather: "Telegram (Bot Father)",
                youtubeComments: "YouTube-Kommentare",
                googleBusinessReviews: "Google Business Bewertungen",
                googlePlayReviews: "Google Play Bewertungen",
                appStoreReviews: "App Store Bewertungen",
                googleDrive: "Google Drive",
                webTabs: "Web-Tabs",
                webTabsDesc: "Externe Apps in Supsis öffnen durch benutzerdefinierte Tabs in der Sidebar",
                webApps: "Web-Apps",
                webAppsDesc: "Eigene Webanwendungen hochladen und verwalten",
                mail: "Mail",
                smsPostacell: "SMS - Postacell",
                zohoCRM: "Zoho CRM",
                teamgram: "Teamgram",
                ideasoft: "Ideasoft",
                ticimax: "Ticimax",
                ticimaxV2: "Ticimax-V2",
                ticimaxV2Desc: "Ticimax-Shop einfach verwalten und Kunden in Echtzeit über Supsis antworten.",
                tsoft: "T-SOFT",
                tsoftDesc: "T-SOFT-Bestellungen und Versand einfach mit SUPSIS AI verwalten.",
                ikas: "IKAS",
                ikasDesc: "Ikas-Shop-Bestellungen und Versand einfach mit SUPSIS AI verwalten.",
                cacheManager: "Cache-Verwaltung",
                cacheManagerDesc: "Cache-Verwaltung für Datenaustausch zwischen Automatisierung und Chatbots",
                openai: "OpenAI",
                slack: "Slack",
                pushover: "Pushover",
                metaLeads: "Meta Leads",
                voice: "Stimme",
                webphoneRedsantral: "Webphone (Red Central)",
                webphoneRedsantralDesc: "Web-basierte Telefonsystem-Integration",
                webphoneTelnyx: "Webphone (Telnyx)",
                webphoneTelnyxDesc: "Telnyx-Integration für weltweite Anrufe",
                webphoneNetgsm: "Webphone (NetGSM)",
                webphoneNetgsmDesc: "Web-basierte Telefon-Integration mit NetGSM-Vermittlung",
                aiVoiceAgent: "KI-Sprachagent",
                aiVoiceAgentDesc: "Verwalten Sie Ihre Telefone mit KI-Sprachassistent. Sie können auch Sprachassistent in Ihre Website integrieren.",
                artificialIntelligenceFallback: "Künstliche Intelligenz",
                openRouter: "OpenRouter",
                openRouterDesc: "Zugriff auf alle LLM-Modelle über eine einzige API",
                openAIDesc: "GPT-4-, GPT-4o- und ChatGPT-Modelle",
                googleAIStudio: "Google AI Studio",
                googleAIStudioDesc: "Gemini-Modelle",
                anthropic: "Anthropic",
                anthropicDesc: "Claude 3.5 Sonnet und Claude Modelle",
                mistral: "Mistral",
                mistralDesc: "Mistral Large und andere Modelle",
                microsoftAzure: "Microsoft Azure",
                microsoftAzureDesc: "Azure OpenAI-Dienste",
                amazonBedrock: "Amazon Bedrock",
                amazonBedrockDesc: "AWS-LLM-Plattform",
                cohere: "Cohere",
                cohereDesc: "Command R+ und NLP-Modelle",
                xai: "xAI",
                xaiDesc: "Grok-Modelle",
                deepInfra: "DeepInfra",
                deepInfraDesc: "LLM-Inferenz-Infrastruktur",
                together: "Together",
                togetherDesc: "Open-Source-LLM-Dienste",
                fireworks: "Fireworks",
                fireworksDesc: "Schnelle LLM-Inferenz",
                siliconFlow: "SiliconFlow",
                siliconFlowDesc: "KI-Modell-Plattform",
                parasail: "Parasail",
                parasailDesc: "LLM-API-Dienst",
                nebius: "Nebius",
                nebiusDesc: "Cloud-KI-Infrastruktur",
                alibabaCloud: "Alibaba Cloud",
                alibabaCloudDesc: "Qwen-Modelle",
                xiaomi: "Xiaomi",
                xiaomiDesc: "MiLM-Modelle",
                sambaNova: "SambaNova",
                sambaNovaDesc: "KI-Hardware und -Software",
                moonshotAI: "Moonshot AI",
                moonshotAIDesc: "Kimi-Modelle",
                minimax: "Minimax",
                minimaxDesc: "Abab-Modelle",
                nvidia: "NVIDIA",
                nvidiaDesc: "NVIDIA NIM-Modelle",
                whatsappComparisonTitle: "WhatsApp-Lösungen Vergleich",
            },
            trendyol: "Trendyol",
            addUserToRole: "Benutzer zu Rolle hinzufügen",
            moveToRole: "In Rolle verschieben",
            noUsersInRole: "Keine Benutzer in dieser Rolle",
            removeUserFromRole: "Benutzer aus Rolle entfernen",
            removeUserFromRoleConfirm: "Sind Sie sicher, dass Sie diesen Benutzer aus der Rolle entfernen möchten?",
            selectNewRole: "Neue Rolle auswählen",
            selectRole: "Rolle auswählen",
            roleUsersUpdated: "Benutzer aktualisiert",
            userNotFound: "Benutzer nicht gefunden",
            unnamed: "Unbenannt",
            whatsappv3Channel: "WhatsApp-V3-Kanal: ",
            linkedinChannel: "LinkedIn-Kanal: ",
            telegramChannel: "Telegram-Kanal: ",
            linkedinUserProfile: "LinkedIn-Benutzerprofil",
            telegramUserProfile: "Telegram-Benutzerprofil",
            createTask: "Aufgabe erstellen",
            integrationsInstagram: "Verwalten Sie Ihre Instagram-Nachrichten in einem Panel, sorgen Sie für nahtlose Kundenkommunikation in den sozialen Medien.",
            integrationsLinkedin: "Verwalten Sie LinkedIn-Nachrichten und -Kommentare, ermöglichen Sie schnelle Kundeninteraktion mit automatischen Antworten.",
            integrationsTelegram: "Verwalten Sie Ihren Telegram-Kanal von einer Plattform aus und behalten Sie alle Nachrichten im Blick.",
            integrationsWebchat: "Aktiver Chatbot auf Ihrer Website, FAQ-Antworten und Lead-Nachverfolgung für mehr Conversion.",
            deleteThread: "Sind Sie sicher, dass Sie alle E-Mails löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            deleteMail: "Sind Sie sicher, dass Sie die E-Mail löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.",
            cardInfos: "Karteninformationen",
            saveSystemCardInfo: "Ihre Karte wird in unserem System gespeichert und am Fälligkeitsdatum automatisch belastet.",
            cardNumber: "Kartennummer",
            cardType: "Kartentyp",
            skt: "Gültig bis",
            cvv: "CVV",
            saveCard: "Karte speichern",
            cardNameSurname: "Name und Nachname des Karteninhabers",
            confidentialityAgreementCheck: "Ich akzeptiere die Vertraulichkeitsvereinbarung",
            confidentialityAgreement: "Vertraulichkeitsvereinbarung",
            ticket: "Ticket",
            calendar: "Kalender",
            useAITemplates: "GPT-4-KI-Vorlagen verwenden",
            mail: "E-Mails",
            sameRole: "Es gibt bereits eine Rolle mit diesem Namen!",
            messageTitle: "Titel",
            billingAddress: "Rechnungsadresse",
            addNewAddress: "Neue Adresse hinzufügen",
            adressTitle: "Adressbezeichnung",
            address: "Adresse",
            contactUs: "Kontakt",
            ImportFromReadyTemplates: "Aus Vorlagen importieren",
            KeepUsingFeatures: "Um Ihre Funktionen weiter nutzen zu können",
            aprobado: "Genehmigt",
            beginsWith: "Beginnt mit",
            campaign: "Kampagne",
            cantProceedPayment: "Zahlung konnte nicht durchgeführt werden",
            chatbotTickets: "Chatbot-Tickets",
            completado: "Abgeschlossen",
            configureTrendyolStoreStoreIntegrationDetail: "Trendyol-Shop-Integration einrichten",
            connectZohoZoho: "Mit Zoho CRM verbinden",
            createMoreThanOneOpenAiChannel: "Sie können nicht mehr als einen OpenAI-Kanal erstellen",
            deleteModalModalFormDesc: "Wenn Sie dieses Formular löschen, werden alle Formulardaten endgültig gelöscht. Sind Sie sicher, dass Sie fortfahren möchten?",
            deleteZohoLinkbulkSms: "Massen-SMS",
            failToDeleteGroup: "Gruppe konnte nicht gelöscht werden",
            failToDeleteGroups: "Gruppen konnten nicht gelöscht werden",
            failToFetchGroupContacts: "Gruppenkontakte konnten nicht geladen werden",
            favorite: "Favoriten",
            featureIsNotAvailable: "Funktion nicht verfügbar.",
            ifYouSendThisConversationToTheQue: "Wenn Sie dieses Gespräch in die Warteschlange senden, werden Sie aus dem Chat entfernt und das Gespräch kommt in die Warteschlange. Bei aktivierter automatischer Chatzuweisung wird es einem Agenten zugewiesen und kann Ihnen wieder zugewiesen werden.",
            initialContact: "Erstkontakt",
            manageYourYourTeamGramIntegration: "TeamGram-Integration verwalten",
            needsAssessment: "Bedarfsanalyse",
            notCreateMoreThanOneChannel: "Sie können nicht mehr als einen Ideasoft-Kanal erstellen",
            offlineTickets: "Offline-Tickets",
            payNow: "JETZT BEZAHLEN",
            removeZohoLinkbulkSms: "Massen-SMS senden",
            saveAsAsEmailCustomerGroup: "Als E-Mail-Kundengruppe speichern",
            saveAsAsWhatsAppCustomerGroup: "Als WhatsApp-Kundengruppe speichern",
            saving: "Wird gespeichert...",
            sendBulkBulkSmsCustomers: "Massen-SMS an Ihre Kunden senden",
            supprimerZohoLinkbulkSms: "Massen-SMS",
            sureDeleteDeleteZohoChannel: "Sind Sie sicher, dass Sie den Zoho-CRM-Kanal löschen möchten?",
            suspendedPlan: "Funktionen sind eingeschränkt",
            temperatura: "Temperatur",
            ticketSettings: "Ticket-Einstellungen",
            trendyolStoreConnection: "Verbinden Sie Ihren Trendyol-Shop",
            usageLimitExceeded: "Nutzungslimit überschritten",
            visitorScreenLabel: "Bezeichnung Besucherbildschirm"
        },
        shouldAddMethod: "Sie müssen das Feld Zahlungsmethode & Rechnungsadresse ausfüllen!\nEs wird kein Geld von Ihrem Konto abgebucht..\nAm Ende des Monats wird eine Rechnung entsprechend Ihrer Nutzungsmenge erstellt.",
        telegram: {
            typeInTelegramToken: "Geben Sie Telegram Token ein",
            token: "Zeichen",
            telegramTokenTitle: "Telegram Supsis Integration",
            telegramAlertForm: "Sie können Telegram Bot Token von erhalten",
            telegramAlertTitle: "Möchten Sie das Token wirklich löschen?",
            telegramAlertText: "Der Token geht dauerhaft verloren!",
            telegram: "Telegram"
        },
        wp: {
            sendingStatus: "In der Sendung",
            sent: "Gesendet",
            allErrors: "Alle Fehler",
            inProcess: "In Bearbeitung",
            sendingStatuses: "Sendestatus",
            downloadCSV: "CSV herunterladen",
            errorMessage: "Fehlermeldung",
            noNumbersAdded: "Keine Nummern hinzugefügt",
            downloadDetails: "Details herunterladen",
            broadcastFound: "{count} Übertragung(en) gefunden",
            resendForFailedNumbersTooltip: "Erneutes Senden für verbleibende Empfänger starten",
            date: "Datum",
            walletBalanceInsufficient: "Unzureichender Wallet-Saldo.",
            broadcastCreatedSuccess: "Übertragung erfolgreich erstellt.",
            broadcastCreateFailed: "Übertragung konnte nicht erstellt werden.",
            resendTitlePrefix: "Erneut senden ({count} Empfänger): ",
            duplicateTitlePrefix: "Duplikat: ",
            broadcastClonedSuccess: "Übertragung erfolgreich geklont.",
            broadcastCloneFailed: "Übertragung konnte nicht geklont werden.",
            broadcastCancelRequestSent: "Übertragungsabbruch angefordert. Bitte warten...",
            broadcastCancelledSuccess: "Übertragung wurde erfolgreich abgebrochen.",
            downloadError: "Beim Herunterladen ist ein Fehler aufgetreten!",
            progressTooltipFormat: "{percent}% ({sent} gesendet/{total} Kontakte)",
            successRatioTooltipFormat: "Gesendete Nachrichten = {total} \n Erfolgreiche Nachrichten = {success} \n Fehlgeschlagene Nachrichten = {failed}",
            notAvailable: "N/V",
            fieldRequired: "{field} Feld ist erforderlich.",
            defaultBroadcastMessageText: "Hallo {{name}}, danke dass Sie uns gewählt haben.",
            sendAgain: "Erneut senden",
            shippingDetails: "Versanddetails",
            whatsapp: "WhatsApp",
            importContactsFromFile: "Kontakte aus Datei importieren",
            chatStartingWait: "Die Rede beginnt, bitte warten",
            chatStarted: "Die Sprache begann",
            chatNotStarted: "Sprache konnte nicht gestartet werden",
            contactSelected: "Die Person wurde ausgewählt",
            startChatWithAnyNo: "Chatten Sie mit einer beliebigen Zahl",
            toLittleChar: "Die fehlende Nummer wurde eingegeben!",
            typeInANumberDesc: "Schreiben Sie die Nummer, um einen Chat zu starten",
            wpPlusAndLicenceRequired: "WhatsApp Plus -Plan und Lizenz sind erforderlich.",
            wpPlusAndLicenceRequiredDesc: "Sie sollten Ihren WhatsApp -Plan erhöhen und eine Lizenz erhalten, damit Sie mit dem Chatten nach Nummern beginnen können, die nicht in Ihrem Leitfaden registriert sind.",
            agreement: "Vereinbarung",
            purchase: "Besorgen",
            activating: "WhatsApp -Dienst aktiviert",
            authenticating: "QR -Codeüberprüfung",
            ready: "Vollständig",
            activationTitle: "Aktivieren Sie die WhatsApp -Integration auf SUPSIS:",
            wpIntegrationInstruction1: "Öffnen Sie WhatsApp auf Ihrem Telefon",
            wpIntegrationInstruction2: "Wählen Sie Menü oder Einstellungen und klicken Sie auf Geräte.",
            wpIntegrationInstruction3: "Führen Sie Ihr Telefon auf diesem Bildschirm aus, um den Code zu scannen",
            qrGeneratingWait: "Der QR -Code wird erstellt, bitte warten ...",
            pleaseContinueToWaitUntilCompleted: "Nachdem der QR -Code überprüft wurde, wechselt er automatisch in den ausgefüllten Bereich. Warten Sie mal...",
            authenticatingWait: "Es loggt sich an, bitte warte ...",
            enableFeature: "Aktivieren Sie die WhatsApp -Funktion",
            unsubscribeWpInetgration: "WhatsApp -Integration beendet sein Abonnement",
            unsubscribeIGIntegration: "Beendigung von Instagram -Integration -Abonnements",
            wpBack: "Zurück",
            terminatelWpInetgration: "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre WhatsApp -Integration beendet.",
            cancelWpInetgration: "Möchten Sie WhatsApp -Integration stornieren?",
            terminatelIGIntegration: "Wenn Sie auf die Abonnementschaltfläche klicken, wird Ihre Instagram -Integration beendet.",
            cancelIGIntgeration: "Möchten Sie die Instagram -Integration stornieren?",
            startChatWp: "Chat beginnen",
            readAndAgree: "Ich habe es gelesen, ich stimmte zu",
            subscribe: "Abonnieren",
            subscribed: "Gezeichnet",
            toEnableWpDescription: "Klicken Sie auf die Schaltfläche unten, um WhatsApp -Funktionen zu aktivieren.",
            waitForWpActivationDescription: "Der WhatsApp -Account -Service wird aktiv. Warten Sie mal. Es dauert ungefähr 30 Sekunden.",
            greatWpActivatedDescription: "WhatsApp -Kontodienst wurde aktiviert.",
            unsubscribe: "Aus dem Abonnement herauskommen",
            planDetails: "Merkmale",
            sendReceiveMessage: "Senden von Nachrichten und Empfangen",
            sendReceiveImage: "Bilder senden und empfangen",
            sendReceiveAudio: "Senden von Audioaufzeichnungen und Empfangen",
            sendReceiveGif: "GIF -Senden & Empfangen",
            startChat: "Chat beginnend in SUPSIS",
            supsisFunctionality: "Nützliche SUPSIS -Chat -Funktion",
            onePhoneMultiAgent: "Mehr als ein Vertreter mit einem einzelnen Telefon",
            basicIntegration: "Einfache Integration",
            purchaseHeader: "SUPSiS-WhatsApp-Integration Einkauf",
            wpServices: "WhatsApp -Service",
            wpServicesIntegrationCompleted: "WhatsApp -Integration ist abgeschlossen. Sie können es jetzt verwenden.",
            purchasePaymentDescription: "WhatsApp -Feature ist von Monat zu Monat in Rechnung gestellt. Nach der Annahme des Abonnements wird Ihr WhatsApp -Dienst aktiviert.",
            wpIntegrationFeatures: "WhatsApp -Integrationsfunktionen",
            saveChanges: "Änderungen speichern",
            contactList: "Personliste",
            broadcast: {
                broadcast: "Kollektive Nachricht",
                detail: "Detail",
                customer: "Kunde",
                phoneNumbers: "Kontaktnummern",
                showMore: "Zeig mehr",
                showLess: "Zeige weniger",
                groupName: "Gruppenname",
                messages: "Mitteilungen",
                status: "Situation",
                usageCost: "Nutzungskosten",
                sendingTime: "Zeit zu senden",
                progress: "Fortschritt",
                groupDetail: "Gruppendetail",
                messagesPerContact: "Anzahl der Nachrichten pro Kopf",
                successRatio: "Erfolgsrate",
                message: "Nachricht"
            },
            messages: "Mitteilungen",
            broadcastRequests: "Kollektive Nachrichtenanfragen",
            customerGroups: "Kundengruppen",
            messageTemplates: "Nachrichtenvorlagen",
            plans: "Pläne",
            wpIntegrationRequired: "WhatsApp -Integration erforderlich",
            wpRequiredIntegrationDescription: "Entschuldigung, die Seite, die Sie besuchen, wird aktiviert, wenn Sie Ihre WhatsApp integrieren.",
            integrateWp: "Komm schon, integrieren Sie WhatsApp",
            active: "Aktiv",
            archived: "Archiviert",
            createBroadcastMessage: "Erstellen Sie eine kollektive Nachricht",
            title: "Titel",
            description: "Erläuterung",
            createdAt: "Erstellungsdatum",
            numbers: "Zahlen",
            actions: "Bewegungen",
            action: "Aktion",
            createCustomerGroup: "Erstellen Sie eine spezielle Kundengruppe",
            search: "Forderung",
            name: "NAME",
            contacts: "Personen",
            noContactFound: "Die Person nicht gefunden",
            broadcastTitle: "Schreiben Sie einen Titel in Ihre kollektive Nachricht.",
            recipients: "Käufer",
            selectRecipients: "Wählen Sie Käufer",
            writeYourMessage: "Schreibe deine Nachricht.",
            schedule: "Mit Plan",
            scheduleNowOrLater: "Planen Sie jetzt oder später.",
            summary: "Zusammenfassung",
            cancel: "Stornieren",
            send: "Schicken",
            sending: "Gesendet",
            deleteCustomerGroup: "Sind Sie sicher, dass Sie diese Kundengruppe löschen möchten? {Name}",
            customerGroupDeleting: "Die Kundengruppe wird gelöscht ...",
            customerGroupDeletingSuccess: "Kundengruppe erfolgreich gelöscht",
            customerGroupDeletingError: "Die Kundengruppe ist beim Löschen aufgetreten",
            wpPlusRequired: "WhatsApp Plus -Plan ist erforderlich.",
            broadcastMessageArchived: "Archivarchive",
            broadcastMessageNotArchived: "Die Bulk Message Group wurde nicht archiviert",
            groupNameSearch: "Schreiben Sie den Kundengruppennamen",
            groupNameDesc: "Kundengruppenname Definieren Sie Ihre Kundengruppen",
            save: "Speichern",
            number: "NUMMER",
            addColumn: "Spalte hinzufügen",
            addColumnDesc: "Fügen Sie der Tabelle eine Spalte hinzu",
            addNewContact: "Neue Person hinzufügen",
            addNewContactDesc: "Person zur Tabelle hinzufügen",
            importFile: "Aus der Datei einführen",
            importFileDesc: "Befragte Personen aus der Excel- oder CSV -Datei",
            contactAdded: "Person hinzugefügt",
            updateCustomerGroup: "Die Kundengruppe wird aktualisiert ...",
            updateCustomerGroupSuccess: "Die Kundengruppe hat erfolgreich aktualisiert",
            sendBroadcastMessage: "Senden Sie eine kollektive Nachricht",
            columnName: "Spaltenname",
            columnType: "Spalte",
            defaultValue: "Standardwert",
            setDefaultValue: "Setzen Sie den Standardwert auf vorhandene Personen",
            age: "Alter",
            location: "Standort",
            gender: "Geschlecht",
            selectContactFile: "Wählen Sie die Datei mit Personen aus",
            selectContactCsvOrExcel: "Wählen Sie eine CSV- oder Excel -Datei aus.",
            importConfiguration: "Verbessern Sie Ihre Datei",
            customizeFile: "Bearbeiten Sie die Personen, die Sie hinzufügen.",
            sendMessageTo: "Wen möchten Sie die Nachricht senden?",
            allContact: "Alle Leute",
            messageTypes: "Nachrichtentypen",
            whenSendMessage: "Wann möchten Sie die Nachricht senden?",
            instantlyRightNow: "Im Augenblick",
            completed: "Vollendet",
            scheduleFuture: "Timing für ein zukünftiges Datum",
            messageDesc: "Ihre Nachricht wird sofort an alle Käufer gesendet",
            messageSendAt: "Es wird an alle Käufer unter Ihrer Nachrichtenadresse weitergeleitet:",
            estimatedPrice: "Schätzpreis",
            estimatedTime: "Geschätzte Zeit",
            now: "Jetzt",
            tenMinute: "10 Minuten",
            cancelled: "Es wird abgesagt",
            failed: "Erfolglos",
            running: "Geht weiter",
            queued: "Aufgereiht",
            scheduled: "Geplant",
            noNumberAdded: "Nummer nicht hinzugefügt",
            csvOrExcelFile: "CSV- oder Excel -Datei",
            broadcastMessagesToContactFile: "Senden von kollektiven Nachrichten an die Personliste",
            broadcastMessageTemplates: "Kollektive Nachrichtenvorlagen",
            messageFlow: "Nachrichtenfluss",
            textMessageSupport: "SMS -Unterstützung",
            imageMessageSupport: "Unterstützung bei Bildnachrichten",
            spamPreventions: "Spam -Nachrichtenprävention",
            includesAllBasicPlans: "Enthält alle Funktionen im WhatsApp -Paket",
            chatbotIntegration: "Chatbot -Integration",
            messageToNewNumbers: "Senden von Nachrichten an neue Zahlen",
            broadcastMessageToEveryone: "Senden einer kollektiven Nachricht an alle",
            personalizedBroadcastMessage: "Persönliche Massennachrichten",
            customerGroupSegmentation: "Kundengruppensegmentierung",
            scheduleBroadcastMessage: "Bulk -Nachrichtenplanung",
            locationMessageSupport: "Standortmeldungsunterstützung",
            advancedSpamPreventions: "Erweiterte Spam -Nachrichtenprävention",
            whatsappPlans: "WhatsApp -Pläne",
            selectBestPlan: "Wählen Sie den entsprechenden Plan für Sie",
            comingSoon: "Sehr bald...",
            selectFile: "Wähle eine Datei",
            created: "Erstellt",
            message: "Nachricht",
            uploadFromComputer: "Vom Computer hochladen",
            cancelIGIntegration: "Möchten Sie die Instagram-Integration wirklich beenden?"
        },
        ig: {
            instagram: "Instagram"
        },
        ticket: {
            trendyolQandA: "Trendyol Fragen und Antworten",
            instagramComments: "Instagram Kommentare",
            messengerComments: "Messenger Kommentare",
            trendyolComments: "Trendyol Kommentare",
            facebookComments: "Facebook-Kommentare",
            offlineTickets: "Offline-Tickets",
            chatbotTickets: "Chatbot-Tickets",
            ticketSettings: "Ticket-Einstellungen",
            ticketSelection: "Ticket ausgewählt",
            bulkClose: "Massenabschluss",
            igComment: "Instagram-Kommentar",
            igMentioned: "Instagram-Erwähnungen",
            incomingReqChatbot: "Eingehende Anfragen mit Chatbot",
            incomingReqWebForm: "Anfragen von Web-Formular",
            incomingReqAutomation: "Anfragen von der Automatisierung",
            thisPersonEmailAnswered: "Diese Person möchte per E-Mail beantwortet werden",
            thisPersonWpAnswered: "Diese Person wartet auf eine Antwort über WhatsApp.",
            clickStartWpChat: "Klicken Sie, um einen WhatsApp-Chat zu starten",
            requestProgress: "Fortschritt anfordern",
            requestMessage: "Nachricht anfordern",
            clickAddMailAddress: "Klicken Sie, um eine Mailadresse hinzuzufügen",
            sendReplyCloseTicket: "Antwort senden und Ticket schließen",
            closeTicket: "Ticket schließen",
            selectEmailSender: "E-Mail-Absender auswählen",
            withEmailWillNotRecievice: "Sie können keine Antworten auf die E-Mail erhalten, wenn Sie mit dieser E-Mail-Adresse senden!",
            deleteCommentAndClose: "Kommentar löschen und schließen",
            sendReplyAndClose: "Antwort senden und schließen",
            startChatWp: "WhatsApp-Chat starten",
            sureWantToDeleteTicket: "Sind Sie sicher, dass Sie ein Ticket löschen wollen?",
            bulkDeleteConfirmation: "Massenlöschbestätigung",
            selectedTicketSucsDelete: "Ausgewählte Tickets wurden erfolgreich gelöscht.",
            thereErrorDeletingTicket: "Beim Löschen von Tickets ist ein Fehler aufgetreten.",
            deleteConfirm: "Löschung bestätigen",
            sureDeleteTicket: "Sind Sie sicher, dass Sie dieses Ticket löschen möchten?",
            ticketSucsDelete: "Ticket erfolgreich gelöscht.",
            represantiveSucsAppoint: "Der Bearbeiter wurde erfolgreich ernannt.",
            ticketClosedSucs: "Ticket erfolgreich geschlossen",
            ticketCloureFailed: "Ticketschließung fehlgeschlagen.",
            unprocessed: "Unverarbeitet",
            pleaseSelectValidStatus: "Bitte wählen Sie einen gültigen Status aus.",
            ticketStatusBeenUpdatd: "Der Ticketstatus wurde aktualisiert.",
            doYouWantCloseTicket: "Möchten Sie das Ticket schließen?",
            ticketWillMarkedClosed: "Das Ticket wird als geschlossen markiert und archiviert.",
            errorUpdatingTicketFailed: "Beim Aktualisieren des Ticketstatus ist ein Fehler aufgetreten.",
            igCommentDeleteIgPost: "Der Instagram-Kommentar wurde aus Ihrem IG-Post gelöscht.",
            igCommentHideChange: "Der Status des Ausblendens von Instagram-Kommentaren wurde geändert.",
            pleaseChooseRepresent: "Bitte wählen Sie einen Vertreter aus.",
            selectedTicketSucsDelegated: "Ausgewählte Tickets wurden erfolgreich delegiert.",
            errorOccuredDuringDelegation: "Während des Delegierungsvorgangs ist ein Fehler aufgetreten.",
            bulkTicketClosing: "Massenhaftes Schließen von Tickets",
            sureWantCloseTicket: "Sind Sie sicher, dass Sie das Ticket schließen möchten?",
            selectedTicketSucsClosed: "Die ausgewählten Tickets wurden erfolgreich geschlossen.",
            thereErrorClosingTicket: "Beim Schließen von Tickets ist ein Fehler aufgetreten.",
            changeFilterTicketPage: "Ändern Sie die Filter auf der Seite 'Tickets'",
            nameOfFilter: "Name des Filters.",
            filterValue: "Wert des Filters",
            deletesSelectedTickets: "Löscht die ausgewählten Tickets",
            idTicketBeDelete: "Die IDs der zu löschenden Tickets (ausgewählte Ticket-IDs oder alle aufgelisteten Ticket-IDs)",
            assignsAgentSelectedTickets: "Weist einem Vertreter die ausgewählten Tickets zu",
            idTicketBeAssigned: "Die IDs der Tickets, die zugewiesen werden sollen (IDs der ausgewählten Tickets oder IDs aller aufgeführten Tickets)",
            idAgentAssigned: "ID des Vertreters, der zugewiesen werden soll",
            changesStatusSelectedTicket: "Ändert den Status der ausgewählten Tickets",
            idTicketWhoseStatus: "Die IDs der Tickets, deren Status geändert werden soll (IDs der ausgewählten Tickets oder IDs aller aufgeführten Tickets)",
            newStatus: "Neuer Status",
            selectedTicketsSucsUpdated: "Der Status der ausgewählten Tickets wurde erfolgreich aktualisiert.",
            errorWhileChangingStatus: "Beim Ändern des Status der Tickets ist ein Fehler aufgetreten.",
            thisPageVoiceAssistant: "Diese Seite hat einen Sprachassistenten",
            hello: "Hallo!",
            voiceAssistantContent: "Wusstest du, dass es einen <strong>KI-Assistenten</strong> gibt, der dir auf dieser Seite hilft?\n                Du kannst die folgenden Methoden ausprobieren, um den Assistenten zu verwenden:",
            commandHoldingDownTheKey: "Du kannst einen Befehl geben, indem du die Tastenkombination gedrückt hältst und sprichst.",
            topRightContent: "obere rechte Ecke",
            clickOnTheIcon: "Du kannst den Assistenten starten, indem du auf das Symbol klickst.",
            sampleVoiceCommands: "Beispiele für Sprachbefehle:",
            showMyTickets: "Zeige meine Tickets",
            showMeZeynepsOpenTicket: "Zeige Zeyneps offene Tickets für heute",
            deleteTicketsScreen: "Tickets auf dem Bildschirm löschen",
            assigntLastTicketAli: "Weisen Sie Ali das letzte Ticket zu",
            changeStatusAllTicket: "Ändere den Status aller Tickets auf erledigt",
            setStatusTicketsScreen: "Setze den Status der Tickets auf dem Bildschirm auf .......",
            assigntUserTicketScreen: "Weisen Sie die Tickets auf dem Bildschirm dem Benutzer ..... zu",
            assigntFirstTicket: "Weisen Sie mir das erste Ticket zu.",
            showIgTickets: "Zeige die Instagram-Tickets des letzten Monats.",
            makeChoice: "Auswahl treffen",
            makeAssignment: "Zuweisung vornehmen",
            tickets: "Fahrkarten",
            instagramTickets: "Instagram-Tickets",
            facebookTickets: "Facebook-Tickets",
            trendyolTickets: "Trendyol-Tickets",
            automationTickets: "Automatisierungs-Tickets",
            supsisFormTickets: "Supsis-Formular-Tickets",
            columnSettings: "Spalteneinstellungen",
            ticketField: "Ticket-Bereich",
            contactPropertyFields: "Erreichen von Eigentumsbereichen",
            ticketFilterList: {
                archivedRequests: "Archivierte Anfragen",
                comingFromFacebook: "Von Facebook kommend",
                comingFromInstagram: "Von İnstagram kommend",
                unassignedOpenRequests: "Nicht zugewiesene offene Anträge",
                openRequests: "Offene Anfragen",
                requestsOpenedThisWeek: "Diese Woche eröffnete Anfragen",
                specialList: "Besondere Liste",
                creationDate: "Datum der Erstellung",
                supsisFromTheForm: "Supsis From The Form",
                fromTrendyol: "Von Trendyol",
                comesWithAutomation: "Kommt von der Automatisierung",
                label: "Etikett",
                status: "Status",
                subject: "Thema",
                email: "E-Mail",
                name: "Name",
                phone: "Telefon",
                type: "Typ",
                assignedUser: "Zugewiesener Benutzer"
            },
            appointingRepresentative: "Ernennen Sie einen Vertreter",
            ticketTagFilter: "Ticketfilter -Tag",
            ticketEmails: "E-Mail-Liste zu direkter",
            save: "Speichern",
            delete: "Löschen",
            transactions: "Transaktionen",
            noEmailTicketNotifications: "TES Ticket Eposta Verwandte Registrierung COYPENTIENT",
            emailIsNotValid: "Die e-mail Adresse ist ungültig",
            emailNotificationDeleted: "Ticket -Routing -Datensatz gelöscht",
            emailNotificationDeleteError: "Ticket -Routing -Datensatz konnte nicht gelöscht werden !!",
            tagFilterRequired: "Ticket -Betrefffilter -Tag ist erforderlich. Sie können das * (Wildcard) -Tag für alle Tickets verwenden!",
            emailsRequired: "Mindestens 1 E -Mail -Adresse sollte für die Ticketausrichtung eingegeben werden",
            emailNotificationCreated: "Ticket -Routing -Datensatz erstellt",
            emailNotificationCreateError: "Ticket -Routing -Datensatz konnte nicht erstellt werden !!",
            ticketForwarding: "Ticket -E -Mail -Anleitung",
            ticketTagFilterDesc: "Um ein Ticket zu filtern, verwendet der Chatbot die Tickets, die Sie im Design verwenden. Sie können ein anderes Etikett schreiben und die Eingabetaste drücken und hinzufügen. Wenn Sie das Tag '*' auswählen, wählen Sie alle Tickets aus",
            ticketEmailsDesc: "Die E -Mail -Liste wird durch Tickets gerichtet. Sie können die Adressen der Vertreter im System hinzufügen, indem Sie die Adressen auswählen. Sie können auch nicht -System -E -Mail/s hinzufügen.",
            ticketList: "Ticket -Routing -Regeln",
            ticketTagFilterPlaceHolder: "Ticketfilter, für alle * auswählen *",
            ticketEmailsPlaceHolder: "Routing -E -Mail -Liste",
            assignFirstTicket: "Weise mir das erste Ticket zu.",
            assignLastTicketAli: "Weise Ali das letzte Ticket zu.",
            assignUserTicketScreen: "Weise die Tickets auf dem Bildschirm dem Benutzer ..... zu.",
            placeholders: "Platzhalter",
            ticketStatusBeenUpdated: "Ticketstatus wurde aktualisiert."
        },
        theme: {
            headerColor1: "Titel (links)",
            headerColor1A: "Titelteilfarbe/Transparenz",
            headerColor2: "Titel (rechts)",
            headerColor2A: "Titelteil 2. Farbe/Transparenz",
            backgroundColor: "Hintergrund (links)",
            backgroundColorA: "Hintergrund 1. Farbe/Transparenz",
            backgroundColor2: "Hintergrund (rechts)",
            backgroundColor2A: "Hintergrund 2. Farbe/Transparenz",
            opacity: "Transparenz",
            textColor: "Allgemeine Textfarbe",
            errorTheme: "Fehlerfarbe",
            bubbleBackground: "Repräsentative Ballonfarbe",
            bubbleVisitorBackground: "Kundenballonfarbe",
            bubbleBackgroundA: "Repräsentative Ballontransparenz",
            bubbleVisitorBackgroundA: "Kundenballontransparenz",
            bubbleText: "Repräsentative Sprachfarbe",
            bubbleVisitorText: "Kundensprachfarbe",
            textFormColor: "Farbe bilden",
            selectCustom: "Wählen Sie ein besonderes Thema",
            headerColorSecond: "Kopffarbe oben",
            headerColorFirst: "Farbe des Titelbodens",
            backgroundColorFirst: "Hintergrundfarbe oben",
            formColor: "Formulartextfarbe",
            buttonColor: "Knopffarbe",
            backgroundColorSecond: "Hintergrundfarbe unten",
            chatBotButtonText: "Chatbot-Schriftfarbe",
            chatBotButtonColor: "Farbe der Chatbot-Schaltfläche",
            font: "Font"
        },
        billing: {
            paymentId: "Zahlungs-ID",
            billType: "Rechnungstyp",
            invoiceId: "Rechnungsnummer",
            invoiceAmount: "Rechnungsbetrag",
            invoiceDate: "Rechnungsdatum",
            invoiceStatus: "Rechnungsstatus",
            invalidBill: "Ungültige Rechnung",
            invalidBillNotPossible: "Diese Rechnung wurde noch nicht erstellt, daher kann sie nicht als ungültig markiert werden.",
            myInvoices: "Meine Rechnungen",
            allInvoices: "Alle Rechnungen",
            manualInvoices: "Manuelle Rechnungen",
            endOfPeriodInvoices: "Ende des Zeitraums Rechnungen",
            purchaseInvoices: "Kauf Rechnungen",
            paidInvoices: "Bezahlte Rechnungen",
            unpaidInvoices: "Unbezahlte Rechnungen",
            walletDeposit: "Geldschein einzahlen",
            updateBillingInfo: "Rechnungsadresse aktualisieren",
            notFoundSavedBillingAddress: "Keine gespeicherte Rechnungsadresse gefunden",
            notFoundSavedCard: "Keine gespeicherte Karte gefunden",
            cardInfoIsStoredSecurelyByIyzico: "Kartendaten werden von Iyzico in einer sicheren Weise gespeichert.",
            paymentMethodAndInvoiceAddress: "Zahlungsmethode und Rechnungsadresse",
            unpaidInvoiceBannerMessage: "Sie haben eine unbezahlte Rechnung. Bitte zahlen Sie Ihre Rechnung, um eine Dienstunterbrechung zu vermeiden.",
            unpaidInvoiceBannerMessageWithDate: "Sie haben eine unbezahlte Rechnung. Wenn Sie nicht vor dem {date} zahlen, wird Ihr Konto gesperrt.",
            clickToPay: "Zur Zahlungsseite gehen",
            packageDescriptions: {
                whatsapp: "Integrieren Sie Ihr reguläres WhatsApp-Konto, um Kunden über alle Kanäle zu erreichen.",
                whatsappBusiness: "Integrieren Sie Ihr WhatsApp Business-Konto, um Kunden über alle Kanäle zu erreichen.",
                supsis: "Mit mehr Vertretern können Sie Ihre Kunden schneller und effizienter betreuen.",
                chatbot: "Die Integration eines Chatbots ermöglicht es Ihnen, Ihre Kunden rund um die Uhr zu bedienen.",
                instagram: "Integrieren Sie Ihr Instagram-Konto, um Kunden über alle Kanäle zu erreichen.",
                telegram: "Integrieren Sie Ihr Telegram-Konto, um Kunden über alle Kanäle zu erreichen.",
                custom: "Wählen Sie einen unserer individuellen Pläne, um maßgeschneiderte Lösungen für Ihr Unternehmen zu erhalten.",
                messenger: "Integrieren Sie Ihr Messenger-Konto, um Kunden über alle Kanäle zu erreichen.",
                trendyol: "Integrieren Sie Ihr Trendyol-Konto, um Kundenanfragen schnell zu beantworten.",
                metaLead: "Integrieren Sie Ihr Meta Lead-Konto, um Leads direkt über das Dashboard zu verwalten.",
                customerTables: "Erstellen Sie dynamische Tabellen, um Kundendaten, Bestellungen und mehr zu verwalten.",
                form: "Erstellen Sie Formulare, um Informationen von Ihren Kunden zu sammeln und zu analysieren.",
                automation: "Richten Sie Automatisierungen ein, um Arbeitsprozesse zu optimieren und Ihren Service zu verbessern.",
                mail: "Die E-Mail-Integration ermöglicht Ihnen das Senden und Empfangen von E-Mails mit Ihren Kunden.",
                tasks: "Erstellen Sie Aufgaben, um Ihre Arbeitsabläufe zu planen und zu verwalten.",
                artificialIntelligence: "Die Integration künstlicher Intelligenz hilft Ihnen, schneller und effizienter auf Kundenanfragen zu reagieren.",
                webhook: "Integrieren Sie Ihre Anwendungen mit Supsis über Webhooks.",
                default: "Entdecken Sie unsere Pakete für weitere Details."
            },
            autoRenew: "Automatische Erneuerung",
            purchased: "Gekauft",
            currentPlans: "Meine Pläne",
            individual: "Einzelperson",
            expirationDate: "Ablaufdatum",
            yourNameSurname: "Ihr Vor- und Nachname",
            editCardInformation: "Kartendaten bearbeiten",
            billingContactInfo: "Rechnungskontaktinformationen erfolgreich aktualisiert.",
            defaultRootEmail: "Standard: Basis-E-Mail",
            invoiceEmailAddress: "Rechnungs-E-Mail-Adresse",
            invoiceSettings: "Einstellungen für Rechnungen",
            updateChannelDesc6: "Whatsapp Business Api-Kanal aktualisieren",
            newWabaChannel: "Neuer Whatsapp-Business-Kanal",
            newWabaChannelDesc: "Neuen Kanal für Whatsapp business api erstellen",
            popular: "Beliebt",
            selectedPlan: "Ausgewählter Plan",
            editPlan: "Plan bearbeiten",
            removePlan: "Plan entfernen",
            showPlan: "Plan anzeigen",
            hiddenPlan: "Plan ausblenden",
            contactSales: "Vertrieb kontaktieren",
            showLess: "Weniger anzeigen",
            more: "Mehr",
            selectTransactionType: "Transaktionstyp",
            walletLogs: "Wallet-Protokolle",
            addBalance: "Saldo hinzufügen",
            availableBalance: "Verfügbarer Saldo",
            walletTransactions: "Wallet-Transaktionen",
            autoReload: "Automatisches Aufladen",
            transactionTypes: "Transaktionstypen:",
            transactionTypesHint: "(Klicken für Einzelauswahl, Strg+Klick für Mehrfachauswahl)",
            importantInfo: "Wichtige Informationen",
            walletImportantPoint1: "Wenn die Zahlung von Ihrer Karte nicht durchgeführt werden kann, wird das System automatisch deaktiviert; Sie müssen es selbst aktivieren.",
            walletImportantPoint2: "Nur 1 Aufladung alle 10 Minuten. Halten Sie den Zielsaldo für intensive Nutzung hoch.",
            walletImportantPoint3: "Sie können weitere Benachrichtigungen in den Benachrichtigungseinstellungen aktivieren.",
            walletImportantPoint3Before: "Sie können weitere Benachrichtigungen in ",
            walletImportantPoint3After: " aktivieren.",
            walletImportantPoint4: "Sie können automatische Aufladungen in der Registerkarte \"Wallet-Transaktionen\" einsehen.",
            walletImportantPoint5: "Es gibt keine Begrenzung für Anzahl oder Betrag der Aufladungen; stellen Sie sicher, dass Sie die richtigen Einstellungen eingeben.",
            autoBalanceReload: "Automatische Saldoaufladung",
            autoBalanceReloadDesc: "Lädt automatisch Saldo auf, wenn Ihr Wallet-Saldo unter den von Ihnen festgelegten Schwellenwert fällt.",
            autoReloadToggle: "Automatisches Aufladen",
            autoReloadToggleDesc: "Sie können diese Funktion aktivieren/deaktivieren",
            disabledDueToFailure: "Aufgrund eines Fehlers deaktiviert",
            thresholdValue: "Schwellenwert (TL)",
            thresholdValueDesc: "Automatische Aufladung erfolgt, wenn der Saldo unter diesen Wert fällt",
            reloadMode: "Auflademodus",
            reloadModeDesc: "Was soll passieren, wenn der Saldo unter den Schwellenwert fällt?",
            addFixedAmount: "Festen Betrag hinzufügen",
            fixBalance: "Saldo festlegen",
            modeAddDesc: "Wenn der Saldo unter den Schwellenwert fällt, wird der festgelegte Betrag hinzugefügt. Z.B.: Schwellenwert 50 TL, Saldo 30 TL → 200 TL hinzugefügt → Saldo wird 230 TL.",
            modeFixedDesc: "Wenn der Saldo unter den Schwellenwert fällt, wird der Saldo auf den festgelegten Betrag aufgefüllt. Z.B.: Schwellenwert 50 TL, Saldo 30 TL → 170 TL hinzugefügt → Saldo wird 200 TL.",
            amountToAdd: "Hinzuzufügender Betrag (TL)",
            targetBalance: "Zielsaldo (TL)",
            amountToAddDesc: "Dieser Betrag wird hinzugefügt, wenn der Saldo unter den Schwellenwert fällt",
            targetBalanceDesc: "Der Saldo wird auf diesen Betrag aufgefüllt, wenn er unter den Schwellenwert fällt (muss größer als Schwellenwert sein)",
            panelNotifications: "Panel-Benachrichtigungen",
            panelNotificationsDesc: "In welchen Fällen möchten Sie Benachrichtigungen erhalten?",
            notifyOnRecharge: "Benachrichtigung bei erfolgreicher Aufladung",
            notifyOnFailure: "Benachrichtigung bei Fehler",
            notifyOnDisabled: "Benachrichtigung bei Deaktivierung",
            emailNotifications: "E-Mail-Benachrichtigungen",
            emailNotificationsDesc: "Wer soll E-Mail-Benachrichtigungen erhalten (optional)",
            emailPlaceholder: "E-Mail-Adressen eingeben (mit Komma trennen)",
            emailHint: "Wenn leer gelassen, wird die E-Mail nur an den Site-Inhaber gesendet",
            lastTrigger: "Letzte Auslösung:",
            neverTriggered: "Noch nicht ausgelöst",
            failedAttempt: "Fehlgeschlagener Versuch:",
            saveSettings: "Einstellungen speichern",
            tabAll: "Alle",
            tabAiUsage: "KI-Nutzung",
            tabVoiceAgent: "Voice Agent",
            tabAutomation: "Automatisierung",
            balanceAddedSuccess: "{price}TL wurde Ihrem WhatsApp-Konto gutgeschrieben",
            balanceAddFailed: "Saldo konnte Ihrem Konto nicht hinzugefügt werden.",
            autoRebalanceLoadError: "Einstellungen für automatische Aufladung konnten nicht geladen werden",
            thresholdMinError: "Schwellenwert muss 0 oder größer sein",
            targetBalanceMinError: "Zielsaldo muss größer als 0 sein",
            targetBalanceThresholdError: "Zielsaldo muss größer als Schwellenwert sein",
            autoRebalanceSaveSuccess: "Einstellungen für automatische Aufladung erfolgreich gespeichert",
            settingsSaveFailed: "Einstellungen konnten nicht gespeichert werden",
            testFailed: "Test fehlgeschlagen",
            creditCardRequiredForAutoReload: "Sie müssen zuerst Ihre Kreditkarteninformationen hinzufügen für automatische Aufladung",
            notificationSettings: "Benachrichtigungseinstellungen",
            appsumoPack: "Appsumo Pack",
            updatePlan: "Plan aktualisieren",
            createPlan: "Plan erstellen",
            freePack: "Kostenloses Paket",
            instantFee: "Es wird eine Sofortgebühr erhoben",
            planSequence: "Plansequenz",
            requiredCodes: "Anzahl der erforderlichen Codes",
            subHeading: "Unterüberschrift",
            featureKey: "Schlüssel des Merkmals",
            customerKey: "Kundenschlüssel",
            monthlyPrice: "Monatlicher Preis",
            monthlyNonDiscounted: "Monatlicher nicht rabattierter Preis (nicht-funktionale Anzeige)",
            twoYearDiscount: "2-Jahres-Rabatt",
            yearDisccount: "Jahresrabatt",
            sixMonthDiscount: "6 Monate",
            threeMonthDiscount: "3 Monate",
            features: "Eigenschaften",
            sessionCount: "Anzahl der Sitzungen",
            subType: "Abonnement-Typ",
            skipTrialVersion: "Testversion überspringen",
            skipTrialVersionDesc: "Sie können die Testversion überspringen und mit der Auswahl des entsprechenden Pakets für Ihr Unternehmen fortfahren. Wenn Sie die Testversion überspringen, kann diese Aktion nicht rückgängig gemacht werden.",
            skipStep: "Diesen Schritt überspringen",
            switchToPay: "Zum Bezahlen wechseln",
            forward: "Weiter",
            pleaseFillInCard: "Bitte geben Sie die Kartendaten ein!",
            fillInTheBillingAddress: "Bitte geben Sie die Rechnungsadresse ein!",
            cardNumberWrong: "Die Kartennummer ist falsch!",
            pleaseConfirmTheUser: "Bitte bestätigen Sie die Benutzervereinbarung.",
            pleaseCheckYourCard: "Bitte überprüfen Sie Ihre Karte und Ihre Angaben.",
            site: "Site",
            period: "Zeitraum",
            billStatus: "Rechnungsstatus",
            totalPrice: "Gesamtpreis + MwSt.",
            depotMoneyWallet: "Einzahlung auf das Wallet",
            threeMonthly: "Alle 3 Monate",
            sixMonthly: "Alle 6 Monate",
            twoYearly: "2 Jahre",
            forever: "Für immer",
            extraPackage: "Extra-Paket",
            teamPackage: "Team-Pakete",
            adventPackage: "Vorteilspakete",
            cupponError: "Der Gutscheincode ist falsch oder abgelaufen.",
            enterYourCard: "Bitte geben Sie Ihre Kreditkarte ein.",
            invalidCard: "Ungültige Kreditkarte, Zahlung nicht erhalten.",
            calculateThis: "Berechnen Sie für:",
            adventageousPackage: "Vorteilhafte Paketrabatte!",
            cuponApplied: "Coupon erfolgreich angewendet",
            subStart: "Abonnement initiiert",
            subSuccessStart: "Ihr Abonnement wurde erfolgreich gestartet.",
            success: "Erfolgreich",
            succesDesc: "Erfolgreich erstelltes Abonnement.",
            successDesc: "Ihre Funktion wurde erfolgreich aktiviert.",
            maxNumber: "Maximale Anzahl von Vertretern, die das Wort ergreifen",
            currentAmountDetails: "Details zum aktuellen Betrag",
            endOfMonthForecastDetails: "Details der Monatsendprognose",
            totalAmount: "Gesamtbetrag",
            vatAmount: "Mehrwertsteuer-Betrag (20%)",
            totalAmountIncludingVAT: "Gesamtbetrag einschließlich Mehrwertsteuer",
            hideDetails: "Details ausblenden",
            createInvoice: "Rechnung erstellen",
            reimbursementMade: "Erstattete Erstattung",
            invalidInvoice: "Ungültige Rechnung",
            balanceTopUp: "WhatsApp-Guthabenaufladung",
            paidSuccesfully: "Die Rechnung wurde erfolgreich bezahlt.",
            paymentFailed: "Der Zahlungsvorgang der Rechnung ist fehlgeschlagen.",
            areYouSurePaid: "Sind Sie sicher, dass Sie diese Rechnung als bezahlt markieren möchten?",
            invoiceMarkedPaid: "Die Rechnung wurde als bezahlt markiert.",
            invoiceMarkedFailed: "Es ist ein Fehler aufgetreten, und die Rechnung konnte nicht als bezahlt markiert werden.",
            areYouSoreRefundInvoice: "Sind Sie sicher, dass Sie eine Erstattung für diese Rechnung vornehmen möchten?",
            copied: "Kopiert",
            copiedToClipboard: "Inhalt in die Zwischenablage kopiert.",
            copyFailed: "Kopiervorgang fehlgeschlagen.",
            invoiceGenerated: "Rechnung erstellt",
            invoiceNotGenerated: "Rechnung nicht erstellt",
            notAvailable: "N/V",
            estimated: "Geschätzt",
            dueDate: "Fälligkeitsdatum",
            markAsPaid: "Als bezahlt markieren",
            refundPayment: "Rückerstattung durchführen",
            editInvoice: "Rechnung bearbeiten",
            deleteInvoice: "Rechnung löschen",
            adminGroup: "Admin",
            billTypeNone: "Keine",
            billTypeManual: "Manuell",
            billTypeMonthly3: "3 Monate",
            billTypeMonthly6: "6 Monate",
            billTypeAnnual: "Jährlich",
            billTypeAnnual2: "2 Jahre",
            billTypeEducation: "Bildung",
            billTypeConsultancy: "Beratung",
            billTypeInstallation: "Installation",
            billTypeOther: "Sonstige",
            paymentNotPossible: "Zahlung nicht möglich",
            saveCardFirst: "Bitte speichern Sie zuerst Ihre Kreditkarte, um eine Zahlung durchzuführen.",
            youMustFillInEmpty: "Sie müssen alle Leerstellen ausfüllen.",
            createdNewInvoice: "Eine neue Rechnung wurde erfolgreich erstellt.",
            createdNewInvoiceFailed: "Beim Erstellen der Rechnung ist ein Fehler aufgetreten.",
            invoiceUpdated: "Der Rechnungsbetrag wurde erfolgreich aktualisiert...",
            invoiceUpdatedFailed: "Beim Aktualisieren der Rechnung ist ein Problem aufgetreten.",
            plans: "Pläne",
            companyName: "Name des Unternehmens",
            compony: "Unternehmen",
            person: "Person",
            invoiceAddressInfo: "Informationen zur Rechnungsadresse",
            idNo: "Türkische ID",
            taxOffice: "Finanzamt",
            taxNumber: "Steuernummer",
            packageCanNotDownSupsis: "Ihr Paket kann nicht herabgestuft werden. Bitte entfernen oder deaktivieren Sie mehrere Ihrer Agenten, um Ihr Paket herabzustufen.",
            packageCanNotDownWp: "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie mehrere Ihrer Whatsapp-Kanäle, um Ihr Paket herabzustufen.",
            packageCanNotDownWPBussiness: "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie mehrere Ihrer Whatsapp-Geschäftskanäle, um Ihren Paketstatus herabzustufen.",
            chooseYourPlan: "Wählen Sie Ihren Plan.",
            numberOfRepresentatives: "Anzahl der Repräsentanten",
            numberOfChannels: "Anzahl der Kanäle",
            wpNumberOfChannels: "Anzahl der Whatsapp-Kanäle",
            igNumberOfChannels: "Anzahl der Instagram-Kanäle",
            msNumberOfChannels: "Anzahl der Messenger-Kanäle",
            cancelIt: "Abbrechen",
            activePlan: "Aktiver Plan",
            activate: "Aktivieren",
            noTransition: "Kein Übergang",
            daysLater: "Tage später",
            payBack: "Zurückzahlen",
            paid: "Bezahlt",
            unPaid: "Unbezahlt",
            editPrice: "Preis bearbeiten",
            payNow: "jetzt bezahlen",
            youAreCurrentlyOnTrial: "Sie befinden sich derzeit im Probebetrieb. Sie können die Probezeit jetzt überspringen, um exklusive Pakete zu sehen.",
            youAreCurrentlyLimited: "Sie sind derzeit vom System eingeschränkt, weil Ihre Pakete nicht den Bedingungen entsprechen.",
            youHaveOneRepresentative: "Sie haben einen Vertreter.",
            deactivateOrDeleteYourPiece: "Deaktivieren oder löschen Sie Ihren Piece Representative oder kaufen Sie einen Vertreter.",
            youHaveOneWhatsappQRChannel: "Sie haben einen Whatsapp-QR-Kanal.",
            deleteYourWhatsAppQR: "Löschen Sie Ihren Whatsapp-QR-Kanal oder kaufen Sie einen Kanal.",
            youHaveAWhatsappBusiness: "Sie haben einen Whatsapp Business-Kanal.",
            deleteYourWhatsapp: "Löschen Sie Ihren Whatsapp Business-Kanal oder kaufen Sie einen Kanal.",
            youHaveAnInstagram: "Sie haben einen Instagram-Kanal.",
            deleteYourInstagram: "Löschen Sie Ihren Instagram-Kanal oder kaufen Sie einen Kanal.",
            youHaveAMessenger: "Sie haben einen Messenger-Kanal.",
            deleteYourMessenger: "Löschen Sie Ihren Messenger-Kanal oder kaufen Sie einen Kanal.",
            additionalPackages: "Zusätzliche Pakete",
            availablePackages: "Verfügbare Pakete",
            buyNow: "Jetzt kaufen",
            invoiceInformation: "Rechnungsinformationen",
            invoiceAddress: "Rechnungsadresse",
            invoiceType: "Rechnungstyp",
            review: "Überprüfung",
            viewDetails: "Details anzeigen",
            addNewAddress: "Neue Adresse hinzufügen",
            enterYourBillingAddress: "Geben Sie Ihre Rechnungsadresse ein",
            selectPlan: "Plan auswählen",
            paymentStatus: "Zahlungsstatus",
            amount: "Betrag",
            invoiceID: "Rechnungs-ID",
            expected: "Erwartet..",
            currentAmount: "Aktueller Betrag",
            monthlyEstimatedAmount: "Monatlicher geschätzter Betrag",
            creationDate: "Erstellungsdatum",
            invoicePeriod: "Rechnungszeitraum",
            newPaymentMethod: "Neue Zahlungsmethode",
            channelCount: "Kanalanzahl",
            remainingTime: "Verbleibende Zeit",
            chatbotLimit: "Chatbot-Limit",
            free: "Kostenlos",
            maxChatbotSession: "Maximale Chatbot-Sitzungen",
            buyIt: "Kaufen",
            renewalDate: "Verlängerungsdatum",
            monthly: "Monatlich",
            yearly: "Jährlich",
            packagePeriod: "Paketperiode",
            packageType: "Pakettyp",
            packageManagement: "Paketverwaltung",
            invoiceManagement: "Rechnungsmanagement",
            futureInvoice: "Zukünftige Rechnung",
            pastInvoices: "Vergangene Rechnungen",
            creditCard: "Kreditkarte",
            invoice: "Rechnung",
            mustBeUpgradePlanForChatBot: "Sie müssen zum Pro -Plan wechseln, um die Chatbot -Funktion zu aktivieren!",
            cardInfo: "Karteninformationen",
            billingDetails: "Rechnungs-Details",
            addCardIyzico: "Sie haben keine registrierte Karte. Sie müssen Karten hinzufügen, um Ihre monatlichen Gebührengebühren zu bezahlen.",
            billingPlanSettings: "Rechnungsmethode und Zahlungsmethode",
            paymentMethod: "Bezahlverfahren",
            billingDate: "Rechnungsdatum",
            isPaid: "Wird es bezahlt?",
            markPaid: "Als bezahlt festgelegt",
            paymentDate: "Zahlungsdatum",
            pay: "Die Rechnung bezahlen",
            newInvoice: "Rechnung erstellen",
            updateBilling: "Ändern Sie Ihre Rechnungsadresse",
            updateCard: "Ändern Sie Ihre Kreditkarte",
            paymentBilling: "Zahlungsmethode und Rechnungsadresse",
            price: "Rechnungsbetrag",
            billingAddress: "Offene Adresse",
            billingCity: "Stadt",
            billingCountry: "Land",
            contactName: "Rechnungsname",
            expireMonth: "Ende verwenden Sie T. Ay",
            expireYear: "Ablauf T. Jahr",
            expireDate: "Ablaufdatum",
            cardNumber: "Kartennummer",
            cardHolderName: "Nennen Sie den Nachnamen auf der Karte",
            cardAlias: "Kartenstopfenname",
            identityNumber: "ID/Steuernummer",
            name: "Name",
            surname: "Nachname",
            email: "Email",
            addCard: "Karte hinzufügen",
            update: "Aktualisieren",
            cancel: "aufgeben",
            save: "Speichern",
            saving: "Gerettet",
            noInvoiceFound: "Rechnungsaufzeichnung nicht gefunden",
            year: "Jahr",
            updating: "Aktualisierung",
            newInvoiceForm: "Neue Rechnung erstellen Form",
            error: "Fehler",
            transactions: "Transaktionen",
            paymentMethodAdded: "Zahlungsmethode erfolgreich hinzugefügt",
            paymentMethodAddError: "Die Zahlungsmethode konnte nicht hinzugefügt werden, ein Fehler trat auf",
            creditCardChanged: "Ihre Kreditkarte wurde geändert",
            errorOccurred: "Es gab einen Fehler, versuchen Sie es erneut.",
            billingDetailUpdated: "Ihre Rechnungsinformationen wurden aktualisiert",
            invoiceCreated: "Rechnungsregistrierungserfolg erstellt",
            paymentSuccess: "Ihre Rechnung wurde erfolgreich bezahlt, danke",
            paymentFail: "Wenn Ihre Rechnung bezahlt wird, trat der Fehler auf und versuchen Sie es erneut.",
            startWith: "{cardFamily} Karte beginnend mit {binNumber}",
            billingAddressChanged: "Rechnungsinformationen aktualisiert",
            hidePlan: "Den Plan verstecken",
            informationShopping: "Ihre Zahlungsinformationen, Rechnungsinformationen und Kreditkarteninformationen werden von Shopify überprüft.",
            trialTimeInformation: "{dayCount} hat die Testversion verlassen. Wenn Sie die Zahlungsmethode erst Ende dieses Zeitpunkts eingeben, wechselt das System automatisch zum freien Plan.",
            trialTimeInformationShort: "Last {dayCount} Tag",
            currentPlanLabel: "Aktueller Plan: {planName} Plan ({agentCount} Repräsentant)",
            changeCancelPlan: "Den Plan ändern/stornieren",
            oneAgent: "Vertreter",
            agent: "Vertreter",
            yourCurrentPlan: "Bestehender Plan",
            month: "Mond",
            billedMonthToMonth: "(Monatliche Abrechnung)",
            selectAgentCount: "Wählen Sie die Anzahl der Vertreter aus",
            selectFreePlan: "Wählen Sie kostenlosen Plan",
            planDetails: "Planen Sie Details",
            multiAgent: "(Sehr repräsentativ)",
            selectProPlan: "Wählen Sie den Pro -Plan",
            foreverFree: "Unbestimmt frei",
            websiteIntegration: "Website -Integration",
            websiteIntegrationUnlimited: "Website -Integration",
            ChatBotUnlimited: "Chatbot",
            videoCallUnlimited: "Videosuche",
            multiAgentUpTo: "Mehrere Vertreter ({agentCount} zu Repräsentant)",
            audioCallUnlimited: "Sprachanruf",
            screenSharingUnlimited: "Bildschirm teilen",
            fileTransferUnlimited: "Datenaustausch",
            autoChatAssignerUnlimited: "Automatische Chatzuweisung",
            multiLanguageTranslationUnlimited: "Automatischer Sprachwandler",
            detailedReporting: "Berichterstattung",
            days30TrialsAvailable: "30-tägige kostenlose Testversion",
            limitedArchiveLookupLastMo: "Limited Archivsuche (letztes {monatCount} -ay)",
            fullCustomizationUnlimited: "Anpassen",
            planUpdated: "Ihr Plan wurde erfolgreich aktualisiert.",
            planUpdating: "Ihr Plan aktualisiert ...",
            planUpdatingDescription: "Bitte warten Sie während des Update!",
            done: "Vollendet",
            freePlanUpdated: "Ihr Plan wurde als kostenloser Plan aktualisiert. (Maximale Anzahl von Vertretern: 1)",
            proPlanUpdated: "Ihr Plan wurde als Pro -Plan aktualisiert. (Maximale Anzahl von Vertretern: {proPlanUpdated})",
            canNotDwnGrade: "Ihr Plan kann nicht von PRO {agentCountFirst} Agents auf {valNewPlnToUppr} {agentCountSecond} heruntergestuft werden!. Ihre Agenten-Credits werden verwendet.",
            deleteWarning: "{valdif} Sie müssen den Vertreter löschen.",
            warnMessage: "Der ausgewählte Plan sollte sich vom aktuellen Plan unterscheiden",
            add: "Hinzufügen",
            cancelYourPlan: "Stornieren Sie Ihren Plan",
            upgradeYourPlan: "Aktualisieren Sie Ihren Plan",
            downgradeYourPlan: "Reduzieren Sie Ihren Plan",
            agree: "GIB ES ZU",
            disagree: "AUFGEBEN",
            invoices: "Rechnungen",
            priceIntervals: "Betragsbereich",
            selectSiteAlias: "Geben Sie den Site -Namen ein oder wählen Sie",
            selectPriceInterval: "Geben Sie den Betragbereich ein oder wählen Sie den Betragsbereich aus",
            isRefunded: "Wurde erstattet?",
            siteId: "Standort Nr",
            createdDate: "Das Datum des Seins",
            failCount: "Fehlgeschlagener Schießversuch",
            failDate: "Zahlungsdatum, der nicht erfolgt ist",
            Dashboard: "Armaturenbrett",
            Agents: "Vertreter",
            Integration: "Integration",
            Settings: "Einstellungen",
            Contacts: "Links",
            Domain: "Domain",
            lastActivity: "Letzte Aktivität",
            basePrice: "Minimaler Preis",
            packagePrice: "Paketpreis",
            whatsappPrice: "WhatsApp -Preis",
            realtimeVisitorCount: "Sofortiger Besucher",
            suspend: "Verdächtig",
            partner: "Partner",
            plan: "Planen",
            trialDay: "Probetag",
            mobile: "Handy, Mobiltelefon",
            webSite: "Webseite",
            websiteOrigins: "Website -Quelle",
            ownerName: "Der Name des Besitzers",
            ownerEmailAddress: "Die E -Mail des Besitzers",
            discount: "Rabatt",
            daysLeft: "Der verbleibende Tag",
            newTrialPopUp: "Wie viele Tage wird die neue Testzeit sein",
            newWpPricePopUp: "Wie viel kostet die neue WhatsApp -Gebühr?",
            newIGPricePopUp: "Wie viel kostet die neue Instagram -Gebühr?",
            newBasePricePopUp: "Wie viel kostet der neue SUPSIS -Grundpreis?",
            siteInfoUpdated: "Standortinformationen aktualisiert",
            siteInfoNotUpdated: "Standortinformationen nicht aktualisiert",
            siteInfoNotUpdatedErr: "Ein Fehler ist aufgetreten! Site -Informationen wurden nicht aktualisiert.",
            depositMoneyWallet: "Guthaben aufladen",
            couponError: "Gutscheincode ist ungültig oder abgelaufen.",
            cupponApplied: "Gutschein erfolgreich angewendet",
            paidSuccessfully: "Rechnung erfolgreich bezahlt.",
            areYouSureRefundInvoice: "Sind Sie sicher, dass Sie diese Rechnung erstatten möchten?",
            company: "Unternehmen",
            incorrect: "Falsch",
            firstPreferredCard: "Als Standardkarte festlegen",
            primary: "Standard",
            billingHistory: "Rechnungsverlauf",
            deleteYourWhatsApp: "WhatsApp-Business-Kanal löschen oder weiteren Kanal hinzufügen.",
            packageCanotDownSupsis: "Ihr Paket kann nicht herabgestuft werden. Bitte entfernen oder deaktivieren Sie einige Ihrer Agenten.",
            packageCanotDownWPBussiness: "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie einen Ihrer WhatsApp-Business-Kanäle.",
            packageCanotDownWp: "Ihr Paket kann nicht herabgestuft werden. Bitte löschen Sie einen Ihrer WhatsApp-Kanäle.",
            planes: "Pläne",
            sito: "Website",
            yearDiscount: "Jahresrabatt",
            youHaveAWhatsAppBusiness: "Sie haben einen WhatsApp-Business-Kanal.",
            youHaveOneWhatsAppQRChannel: "Sie haben einen WhatsApp-QR-Kanal."
        },
        tour: {
            representativeTab: "Vertreter",
            stats: "Statistisches Panel",
            chats: "Chat -Panel",
            settings: "EINSTELLUNGEN",
            status: "SITUATION",
            prevStep: "Vorheriger Schritt",
            nextStep: "Nächster Schritt",
            finish: "Beende es",
            skip: "Springen",
            skip2: "Ich kenne das System, zeige nicht wieder",
            startTour: "Beginnen Sie die Tour",
            firstTimeIntro: "Ich entdeckte, dass es zum ersten Mal in das System eingegeben wurde.",
            hi: "Hallo",
            welcomeTo: "Willkommen bei Supsis Live Support",
            statsPanel: "Es ist die Statusleiste, die die gesamten aktiven Chat -Nummern zeigt, die sofort mit dem System warten.",
            sidebarMenu: "Speisekarte",
            sidebarMenuContent: "Hier können Sie Übergänge zwischen den Seiten durchführen.",
            representativePrivateMessage: "Konversationspanel zwischen Vertretern",
            representativePrivateMessageContent: "Hier sehen Sie spezielle Gespräche zwischen Vertretern.",
            helpMenu: "Hilfsmenü",
            helpMenuContent: "Hier finden Sie die Hilfeinformationen zum System.",
            settingsMenu: "Einstellungsmenü",
            settingsMenuContent: "Sie können die Schritte für Sprache, Nachtmodus und Bildschirmvergrößerung hier ausführen.",
            startChat: "Chat beginnen",
            profileMenu: "Profilmenü",
            profileMenuContent: "Sie können Ihren verfügbaren Status ändern und Ihre repräsentativen Einstellungen hier vornehmen.",
            visitorsTab: "Besucher",
            visitorsTabContent: "Hier können Sie Besucher sehen.",
            visitorTabHistory: "Besuchergeschichte",
            visitorTabHistoryContent: "Sie können die Besuchergeschichte hier sehen.",
            representativ_eTab: "Vertreter",
            representativeTabContent: "Sie können die Vertreter hier sehen.",
            liveSupport: "Live Support",
            liveSupportContent: "Sie können die Anzahl der Kunden sehen, die hier Live -Support erhalten.",
            siteVisitors: "Site -Besucher",
            siteVisitorsContent: "Sie können die Anzahl der Besucher hier sehen.",
            tableSettings: "Tisch Einstellungen",
            tableSettingsContent: "In der Tabelle können Sie hier eine Spalte anzeigen oder ausblenden.",
            watchModeButton: "Publikumsknopf",
            watchModeContent: "Sie können dem Publikum als Modus beitreten und zeigen nur, was geschrieben ist.",
            popoverInfo: "Besucherdetail",
            popoverInfoContent: "Gibt Informationen über den Besucher.",
            popoverButton: "Erweiterte Spracheinstellungen",
            popoverButtonContent: "Sie können ein Gespräch öffnen, eine direkte Nachricht an den Vertreter senden oder den Besucher blockieren.",
            openChat: "Sprachschaltfläche anschließen",
            openChatContent: "Sie können das Gespräch hier öffnen",
            pagination: "Paging -Menü.",
            paginationContent: "Sie können die Anzahl der Seiten hier erhöhen.",
            chatwindow: {
                chatWindowSettingsButtons: "Sprachfenstereinstellungen Schaltfläche",
                chatWindowActionButtons: "Sprachfenster allgemeiner Prozessschaltfläche",
                chatPanelActions: "Sprachpanel Verfahren",
                otherPanels: "Andere Panels",
                settingsButton: "Sie können Sprachblockierung, Anleitung, geheime Nachrichten und Vertretern zuweisen.",
                chatColorButton: "Sie können lernen, welche Farbe im Gespräch Ballons hier bedeutet",
                keyboardShortcutButton: "Sie finden die Abkürzungen von Funktionen, die während der Korrespondenz oder anderer Funktionen, die Sie hier verwenden, Komfort bieten.",
                hideButton: "Es reduziert das offene Gespräch darunter weiterhin offen im Hintergrund",
                closeButton: "Beendet die offene Rede und geht ohne das Gespräch",
                ellipsisButton: "Hier finden Sie weitere Vorgänge. Operationen wie das Senden von privaten Nachrichten, das Ziyaratci -Verbot, die repräsentative Ernennung finden Sie hier.",
                userInfoWidget: "Detaillierte Informationen zum Besucher werden hier enthalten sein",
                preparedContentWidget: "Hier gibt es bereit -hergestellte Inhaltsvorlagen. Sie können schnell referenzierte Inhalte hinzufügen, indem Sie im Feld Schreibfeld auf die Verknüpfung klicken, indem Sie auf den Sprachbildschirm klicken.",
                chatHistoryWidget: "Dies wird hier aufgeführt, wenn der Besucher frühere Gespräche führt. Sie können die alten Sprachdetails hier untersuchen",
                chatBarButton: "Sie können hier aktive Gespräche verhindern, eine geheime Nachricht an den Vertreter senden und das Interview verlassen."
            },
            selectColumnsToDisplay: "Anzuzeigende Spalten auswählen",
            selectAll: "Alle auswählen",
            deselectAll: "Alle abwählen",
            resetToDefault: "Auf Standard zurücksetzen",
            settingsSaved: "Einstellungen gespeichert",
            changeLang: "Systemsprache kann geändert werden",
            changeStatus: "Verfügbarkeitsstatus kann geändert werden",
            changeTheme: "Zwischen dunklem und hellem Design wechseln",
            closeChat: "Chat schließen",
            contentStep: "Inhaltsschritt",
            formStep: "Formularschritt",
            goToLive: "Mit Vertreter verbinden",
            logout: "Hier können Sie sich abmelden",
            menuStep: "Menüschritt",
            menuTitle: "Menütitel",
            messageContent: "Nachrichteninhalt",
            ticket: "Ticket"
        },
        adminUser: {
            newAdminUserForm: "Neues Administratorregistrierungsformular",
            updateAdminUserForm: "Administrator -Benutzer -Aktualisierungsformular",
            adminUsers: "Administrator Benutzer",
            newAdminUser: "Neuer Administrator Benutzer",
            noAdminUser: "Es gibt noch keinen Administratorbenutzer.",
            adminUserName: "Administratorbenutzername"
        },
        report: {
            channel: "Kanal",
            channelType: "Kanaltyp",
            contactCount: "Anzahl der Kontakte",
            tag: "Tag",
            owner: "Besitzer",
            email: "E-Mail",
            language: "Sprache",
            approvalCount: "Anzahl der Genehmigungen",
            adTitle: "Anzeigentitel",
            sourceType: "Quelltyp",
            contactDistributions: "Kontaktverteilungen",
            mostUsedTag: "Meistgenutzter Tag",
            leastUsedTag: "Am wenigsten genutzter Tag",
            timeDistribution: "Kontaktverteilung nach Zeit",
            channelDistribution: "Kontaktverteilung nach Kanal",
            tagDistribution: "Kontaktverteilung nach Tags",
            platformDistribution: "Kontaktverteilung nach Plattform",
            ownerDistribution: "Kontaktverteilung nach Besitzer",
            languageDistribution: "Kontaktverteilung nach Sprache",
            adsDistribution: "Kontaktverteilung nach Werbung",
            contactPropertyDistribution: "Kontaktverteilung nach Kontakteigenschaften",
            totalPersonCount: "Gesamtanzahl der Kontakte",
            averagePersonCount: "Durchschnittliche Kontaktanzahl",
            personCount: "Kontaktanzahl",
            person: "Kontakt",
            mostEffectiveAd: "Effektivste Werbung",
            leastEffectiveAd: "Am wenigsten effektive Werbung",
            mostUsedChannel: "Meistgenutzter Kanal",
            leastUsedChannel: "Am wenigsten genutzter Kanal",
            columnChart: "Säulendiagramm",
            pieChart: "Kreisdiagramm",
            mostUsed: "Am meisten verwendet",
            leastUsed: "Am wenigsten verwendet",
            mostUsedLanguage: "Meistgenutzte Sprache",
            leastUsedLanguage: "Am wenigsten genutzte Sprache",
            mostAssigned: "Am häufigsten zugewiesen",
            leastAssigned: "Am wenigsten zugewiesen",
            mostUsedPlatform: "Meistgenutzte Plattform",
            leastUsedPlatform: "Am wenigsten genutzte Plattform",
            commentAnalysis: "Kommentaranalyse",
            whatsappChannelDistribution: "Chat-Verteilung nach WhatsApp-Kanälen",
            instagramChannelDistribution: "Chat-Verteilung nach Instagram-Kanälen",
            messengerChannelDistribution: "Chat-Verteilung nach Messenger-Kanälen",
            trendyolChannelDistribution: "Chat-Verteilung nach Trendyol-Kanälen",
            metaLeadsChannelDistribution: "Chat-Verteilung nach Meta Leads-Kanälen",
            chatDistributionByTelegramChannels: "Chat-Verteilung nach Telegram-Kanälen",
            chatDistributionByLinkedinChannels: "Chat-Verteilung nach Linkedin-Kanälen",
            channelTimeseries: "Kanal-Zeitverlauf",
            channelPies2: "Kanalverteilung",
            date: "Datum",
            incomingMessages: "Eingehende Nachrichten",
            outgoingMessages: "Ausgehende Nachrichten",
            customerCount: "Kundenzahl",
            mailCount: "Anzahl der Mails",
            answered: "Antwortet",
            unanswered: "Unbeantwortet",
            selectaChannel: "einen Kanal auswählen",
            sentMails: "Gesendete Mails",
            sentMailCount: "Anzahl der gesendeten Mails",
            eventCount: "Anzahl der Ereignisse",
            ticketDistribution: "Ticket-Verteilung",
            selectWorkflow: "Wählen Sie Ihren Workflow",
            distributionOfTasks: "Verteilung der Aufgaben",
            mostMissioned: "Meist bearbeitete Aufgabe",
            leastTask: "Am wenigsten bearbeitete Aufgaben",
            totalNumberTasks: "Gesamtzahl der Aufgaben",
            errorFetchingTask: "Fehler beim Empfangen von Aufgabendaten:",
            pipelinePhase: "Pipeline-Phase",
            status: "Status",
            numberOfTasks: "Anzahl der Aufgaben",
            insufficientData: "Nicht genügend Daten",
            hourly: "(Stündlich)",
            hourlyAverage: "Stündlicher Durchschnitt",
            hourlyMax: "Stündliches Maximum",
            hourlyMin: "Stündliches Minimum",
            totalAmount: "Gesamtbetrag",
            averageAmount: "Durchschnittsbetrag",
            minAmount: "Mindestbetrag",
            maxAmount: "Höchstbetrag",
            siteCount: "site Count",
            agentCount: "Agent Count",
            channelsTimeSeries: "Kanäle Zeitreihen",
            channelPies: "Kanal-Torten",
            pieView: "Kreisdiagramm",
            topVisitorCountry: "Top-Besucherland",
            websiteTrafficByCountry: "Website-Traffic nach Ländern",
            visitorCount: "Besucheranzahl",
            websiteVisitorTraffic: "Website-Besuchertraffic",
            websiteTraffic: "Website-Traffic",
            author: "Autor",
            topWorstComments: "Top Schlechteste Kommentare",
            topBestComments: "Top Beste Kommentare",
            topComments: "Top-Kommentare",
            noComment: "Noch keine Kommentare",
            minWaitingTime: "Minimale Wartezeit",
            maxWaitingTime: "Maximale Wartezeit",
            averageWaitTime: "Durchschnittliche Wartezeit",
            waitTime: "Wartezeit (Sekunden)",
            agentWaitDurationTitle: "Wartezeitdiagramm des Agents",
            incomingMessage: "Eingehende Nachricht(en)",
            outgoingMessage: "Ausgehende Nachricht(en)",
            totalSpent: "Gesamtausgaben",
            avgSpent: "Durchschnittsausgaben",
            totalPayment: "Gesamtzahlung",
            walletStatus: "Wallet-Status",
            walletBalanceStatus: "Wallet-Saldo-Status",
            messageTraffic: "Nachrichtenverkehr",
            breakCount: "Pausenanzahl",
            agentBreakTime: "Anzahl der Pausen der Agenten ☕",
            agentStatusHour: "Agentenstatus Stunde",
            agentWorkTimeCalendar: "Kalender für die Arbeitszeit des Agenten",
            agentActivity: "Aktivität des Agenten",
            noEnoughtData: "Nicht genug Daten",
            averageFirstResponse: "Durchschnittliche Erstantwortzeit",
            slowestResponser: "Langsamster Responder",
            fastestResponder: "Schnellster Responder",
            firstAnswerTimeSec: "Erstnachrichtenzeit (in Sekunden)",
            firstAnswerByAgent: "Erstnachrichtenzeit durch Agent",
            averageSolutionTime: "Durchschnittliche Lösungszeit",
            slowestSolver: "Langsamster Löser",
            fastestSolver: "Schnellster Löser",
            averageChat: "Durchschnittlicher Chat",
            leastChatReceiver: "Am wenigsten aktiver Chat-Empfänger",
            mostChatRecipients: "Meiste Chat-Empfänger",
            averageTicket: "Average Ticket",
            leastTicketReceiver: "Least Ticket Least",
            mostTicketRecipients: "Most Ticket Recipients",
            resolveTime: "Auflösungszeit (Min)",
            resolveTimeByUser: "Chat-Auflösungszeit nach Benutzer (in Minuten)",
            chatResolveTimeByAgent: "Chat-Auflösungszeit nach Agenten",
            chatDistByHandleType: "Chat-Verteilung nach Handler",
            chatDistByHandDesc: "Wie viele Chats wurden von Agenten, Chatbots und Hybrid bearbeitet?",
            chatCountsByHandleType: "Chatanzahl nach Bearbeitungstyp",
            missed: "Verpasst",
            chatDistByAnsDesc: "Wie viele Chats wurden beantwortet oder verpasst?",
            chatCountsByAns: "Chatanzahl nach Antwort",
            chatCountByPlatform: "Chatanzahl nach Plattform",
            chatDistByPDesc: "Wie viele Chats kamen auf welche Plattform?",
            chatDistByPlatform: "Chat-Verteilung nach Plattform",
            ticketCountByUser: "Anzahl der Tickets nach Agenten",
            ticketCountByStatus: "Anzahl der Tickets nach Antwortstatus",
            user: "Benutzer",
            saveAsImage: "Als Bild speichern",
            fullScreen: "Vollbild",
            download: "Herunterladen",
            tableView: "Tabellenansicht",
            chartView: "Diagrammansicht",
            chatDistByUsers: "Chat-Verteilung nach Benutzern",
            chatCountsByUsers: "Chatanzahl nach Benutzern",
            minDuration: "Mindestdauer",
            maxDuration: "Maximaldauer",
            totalDurationByAgent: "Gesamtdauer der Sitzung nach Agent",
            averageDurationByAgent: "Durchschnittliche Dauer der Sitzung nach Agent",
            totalDurationByCB: "Gesamtdauer der Sitzung nach Chatbot",
            averageDurationByCB: "Durchschnittliche Dauer der Sitzung nach Chatbot",
            viewUnitAs: "Einheit anzeigen als",
            hybrid: "Hybrid",
            handledBy: "Bearbeitet von",
            sessionDurationOverall: "Gesamte Sitzungsdauer",
            allChannels: "Alle Kanäle",
            sessionsDurationOverall: "Gesamtdauer der Sitzungen",
            sessionsOverall: "Gesamtsitzungen",
            sessionsOverallDesc: "Total chat session count in the selected period",
            ratingOverallDesc: "Distribution of customer satisfaction scores",
            sessionDurationOverallDesc: "Average and total session durations",
            totalSessionCountDesc: "Total number of sessions in the selected period",
            averageSessionCountDesc: "Average session count per time unit",
            maxSessionCountDesc: "Highest session count in a single time unit",
            minSessionCountDesc: "Lowest session count in a single time unit",
            totalSessionDurationDesc: "Sum of all session durations",
            averageSessionDurationDesc: "Average duration per session",
            totalDurationByCBDesc: "Total duration handled by chatbot",
            averageDurationByCBDesc: "Average chatbot session duration",
            totalDurationByAgentDesc: "Total duration handled by agents",
            averageDurationByAgentDesc: "Average agent session duration",
            maxDurationDesc: "Longest session in the selected period",
            minDurationDesc: "Shortest session in the selected period",
            totalRatingCountDesc: "Total number of ratings received",
            averageRatingDesc: "Average score of all ratings",
            weightedAverageRatingDesc: "Weighted average based on score distribution",
            chatDistByUsersDesc: "Chat session distribution by agent",
            chatDistByAnsDesc: "Ratio of answered vs missed sessions",
            chatDistByPlatformDesc: "Chat sessions by platform source",
            chatDistByHandleTypeDesc: "Session distribution between chatbot and live agent",
            resolveTimeByUserDesc: "Average resolve time per agent",
            firstAnswerByAgentDesc: "Average first response time per agent",
            agentWaitDurationDesc: "Customer wait time for agent response",
            topCommentsDesc: "Best and worst customer feedback comments",
            websiteTrafficDesc: "Website visitor traffic over time",
            websiteTrafficByCountryDesc: "Website visitor distribution by country",
            channelBreakdownDesc: "Session counts and distribution by channel",
            wabaMessageTrafficDesc: "WhatsApp message traffic (incoming/outgoing)",
            walletStatusDesc: "Balance transactions and wallet status",
            calendarEventsDesc: "Calendar event count time series",
            reservationEventsDesc: "Reservation event count time series",
            mailInboxDesc: "Incoming email count time series",
            mailSendDesc: "Sent email count time series",
            ticketTimeSeriesDesc: "Support ticket time series",
            ticketByStatusDesc: "Support ticket distribution by status",
            ticketByUserDesc: "Support ticket distribution by agent",
            taskOverallDesc: "Task status and pipeline stage distribution",
            contactTimeDistDesc: "Contact distribution over time",
            contactChannelDistDesc: "Contact distribution by channel",
            contactTagDistDesc: "Contact distribution by tag",
            contactPlatformDistDesc: "Contact distribution by platform",
            contactOwnerDistDesc: "Contact distribution by agent",
            contactLanguageDistDesc: "Contact distribution by language",
            contactAdDistDesc: "Contact distribution by advertisement",
            contactPropertyDistDesc: "Contact distribution by contact properties",
            agentActivitiesDesc: "Daily agent activity summary",
            agentPerformanceDesc: "Agent performance metrics",
            agentWorktimeDesc: "Agent work and break durations",
            breakCountDesc: "Break count and duration distribution",
            calendarEvents: "Kalenderereignisse",
            reservationEvents: "Reservierungsereignisse",
            incomingMails: "Eingehende E-Mails",
            incomingMailCount: "Anzahl eingehender E-Mails",
            reservation: "Reservierung",
            event: "Veranstaltung",
            reservationEventCount: "Anzahl der Reservierungsereignisse",
            channelBreakdown: "Kanalübersicht",
            websiteAnalysis: "Website-Analyse",
            customerSatisfaction: "Kundenzufriedenheit",
            teamBreakAnalysis: "Team-Break-Analyse",
            dailyAgentActivity: "Tägliche Agentenaktivität",
            agentPerformance: "Agentenleistung",
            chatDistributions: "Chat-Verteilung",
            users: "Benutzer",
            segmentTimeseries: "Segment-Zeitreihe",
            segmentsOverall: "Gesamtsegmente",
            unmatchRatio: "Nichtübereinstimmungsverhältnis",
            totalMatchCount: "Gesamtanzahl der Übereinstimmungen",
            totalUnmatchCount: "Gesamtanzahl der Nichtübereinstimmungen",
            matchRatio: "Übereinstimmungsverhältnis",
            matched: "Übereinstimmend",
            trainingOverall: "Gesamtschulung",
            trainingStatusTimeseries: "Schulungsstatus-Zeitreihe",
            duration: "Dauer",
            totalSessionDuration: "Gesamtdauer der Sitzung",
            averageSessionDuration: "Durchschnittliche Sitzungsdauer",
            second: "Sekunde",
            minute: "Minute",
            hour: "Stunde",
            aggregateAs: "Aggregieren als",
            chatbotSessionDurationOverall: "Gesamtdauer der Chatbot-Sitzung",
            ratingTimeSeries: "Bewertungszeitreihe",
            chatCountTimeseries: "Chat-Zählzeitreihe",
            notRated: "Nicht bewertet",
            totalRatingCount: "Gesamtanzahl der Bewertungen",
            averageRating: "Durchschnittliche Bewertung",
            weightedAverageRating: "Gewichteter Durchschnitt der Bewertung",
            rate: "Bewerten",
            ratingOverall: "Kundenbewertungen insgesamt",
            session: "Sitzung",
            total: "Gesamt",
            average: "Durchschnitt",
            max: "Maximal",
            min: "Minimal",
            sessionCount: "Sitzungszähler",
            uniqueUsers: "Eindeutige Benutzer",
            viewAs: "Anzeigen als:",
            overall: "Insgesamt",
            detailReport: "Ausführlicher Bericht",
            dailyReports: "Tagesberichte",
            pointBasedReports: "Punktbasierte Berichte",
            personDateBasedPointReport: "Person und täglicher Punktbericht",
            personDateBasedReport: "Person und Tagesbericht",
            personBasedReport: "Personenbasierte Berichte",
            personAndDateBasedGraph: "Person und tägliche Grafik",
            noReport: "Kein Bericht",
            reports: "Berichte",
            totalBar: "Gesamt",
            ticketCount: "Ticket Count",
            adNameDistribution: "Contact Distribution by Ad Name",
            adsetDistribution: "Contact Distribution by Ad Set Name",
            campaignDistribution: "Contact Distribution by Campaign Name",
            selectChannel: "Kanal auswählen",
            leastTasked: "Am wenigsten bearbeitet",
            dailyAverage: "Tagesdurchschnitt",
            dailyMax: "Tagesmaximum",
            dalyMin: "Tagesminimum",
            topBestWorstComments: "Beste/Schlechteste Bewertungen",
            erorFetchingTask: "Fehler beim Laden der Aufgabendaten:"
        },
        announcements: {
            menu: "Ankündigungen",
            newAnnouncementForm: "Neues Ankündigungsformular",
            updateAnnouncementForm: "Ankündigungs -Update -Formular"
        },
        stats: {
            total: "Die Anzahl der aktiven Gespräche im System.",
            active: "Es ist die Anzahl der aktiven Gespräche, die Ihnen gehören.",
            waiting: "Der Vertreter ist die Anzahl der neuen aktiven Reden, die darauf warten, ernannt zu werden.",
            late: "Es ist die Anzahl der neuen Reden, die für einen bestimmten Zeitraum verabschiedet wurden und darauf warten, zum Vertreter ernannt zu werden.",
            free: "Der Vertreter ist die Anzahl der Reden, die darauf warten, nach der Veröffentlichung einen neuen Vertreter zu ernennen.",
            pco: "[Personal Arbeitsverhältnis]: Dies ist die Belegungsrate der Anzahl der Reden, in denen die Online -Vertreter im System erhalten können.",
            maxCapacity: "Ist die maximale Anzahl von Chats, die das System einen Vertreter ernennen kann, ohne zu warten",
            chatbot: "Chatbots aktive Reden Nummer"
        },
        time: {
            lastYear: "Letztes Jahr",
            thisYear: "Dieses Jahr",
            last3Months: "Letzte 3 Monate",
            last7: "Letzte 7 Tage",
            today: "Heute",
            yesterday: "Gestern",
            lastWeek: "Letzte Woche",
            currentWeek: "Diese Woche",
            currentMonth: "Diesen Monat",
            lastMonth: "Im vergangenen Monat",
            last30Day: "Letzte 30 Tage",
            allTime: "Jederzeit",
            custom: "Eine andere Zeit"
        },
        fastWizard: {
            generalColors: "Allgemeine Farben",
            tellUsMore: "Geben Sie uns mehr Informationen, damit wir Ihre Erfahrungen personalisieren können",
            moreInfo: "Allgemeine Einstellungen",
            display: "Themen Einstellungen",
            availability: "Repräsentative Arbeitszeit",
            preview: "Vorschau",
            installCode: "Aufstellen",
            previous: "Vorheriger Schritt",
            setupSupsisLiveChat: "SUPSIS Live Fast Setting",
            continue: "Nächster Schritt",
            completeInitialize: "Führen Sie die schnelle Installation ab",
            completedMessage: "Supsis Live Quick Installation wurde erfolgreich durchgeführt.",
            websiteIntegration: "Adresse Ihrer Website für die Live -Integration von Supsis",
            customizeLiveChat: "Passen Sie Ihren Live -Chat an",
            createBrandedExperience: "Erstellen Sie ein Marken -Chat -Erlebnis für Ihre Besucher.",
            chatColor: "Chatfarbe",
            chooseChatColor: "Wähle eine Farbe.",
            chatBubble: "Chat -Ballon",
            selectBubble: "Wählen Sie einen Chat -Ballon",
            chatBubbleColor: "Chat -Ballonfarbe",
            selectChatBubbleColor: "Wählen Sie die Chat -Ballonfarbe",
            customSelection: "Besondere Wahl:",
            onlineSupportVisitorTime: "In welchen Zeitintervallen bieten Sie Ihren Besuchern an?",
            channelAvailability: "Zykluszeitpunkt",
            availability724: "7/24 kontinuierlicher Service",
            basedOnTeam: "Vertreter innerhalb der Arbeitszeiten",
            basedOnTeamExplanation: "Wenn es mindestens 1 Vertreter online gibt, erscheint der Chat online. Wenn es keinen Online -Vertreter gibt, erscheint es als offline",
            customHours: "Besondere Arbeitszeiten",
            customHoursExplanation: "Bestimmen Sie Ihre eigenen Arbeitszeiten",
            customHoursTimezone: "Regionale Zeitzone:",
            customHoursFrom: "Anfang:",
            customHoursTo: "Beenden:",
            customHoursAddHours: "+Uhr hinzufügen",
            previewDesktop: "Desktop",
            previewIpad: "Tablette",
            installationAndInstructions: "Installationsanleitung",
            installationTrackingCode: "Laden Sie die Tracking -Nummer auf Ihre Website hoch",
            installationTrackingCodePlease: "Bitte fügen Sie den Code gemäß den folgenden Anweisungen kurz vor dem Ende des {bodyTag} -Tags auf einer beliebigen Seite ein, die SUPSıs Live -Chat aktivieren möchten.",
            installationInstructionsJavascript: "Fügen Sie den oben genannten Integrationscode kurz vor dem Schließen im {bodyTag} -Label ein.",
            installationInstructionsShopify1: "1. Melden Sie sich bei Ihrem Shopify -Panel an",
            installationInstructionsCopy: "Kopieren",
            installationInstructionsCoppyMessage: "Integrationsbefehle an die Karte kopiert",
            installationInstructionsShopify2: "2. Gehen Sie zum Online -Shop> Themen> Aktionen im POP -UP -Menü unter dem aktuellen Thema> Code bearbeiten> thema.liquid",
            installationInstructionsShopify3: "3. Platzieren Sie den Integrationscode vor dem {bodyTag} -Label am Ende von Theme.liquid Skript.",
            installationInstructionsIdeaSoft1: "1. Melden Sie sich bei Ihrem Händlerpanel an.",
            installationInstructionsIdeaSoft2: "2. Einstellungen -> SEO -> Befolgen Sie den Schritt der Suchmaschinendienste.",
            installationInstructionsIdeaSoft3: "3. Platzieren Sie den oben angegebenen Integrationscode direkt vor dem {bodyTag} Tag am Ende des theme.liquid-Skripts.",
            installationInstructionsIdeaSoft4: "4. Kopieren Sie den oben genannten Integrationscode in das geöffnete Feld.",
            installationInstructionsIdeaSoft5: "5. Einstellungen -> Optimierungen -> Drücken Sie die Taste \"Davtur\". Die Integration wurde abgeschlossen.",
            installationInstructionsWordPress1: "1. Melden Sie sich in Ihrem WordPress Admin -Bereich an",
            installationInstructionsWordPress2: "2. anzeigen> gehen zum Thema redaktionell",
            installationInstructionsWordPress3: "3. Suchen und wählen Sie den Footprint (footer.php) unter den Themendateien (rechts) (rechts).",
            installationInstructionsWordPress4: "4. Fügen Sie den obigen Integrationscode vor dem {bodyTag} -Tag unten ein.",
            installationInstructionsWordPress5: "5. Aktualisieren Sie die Datei, um Änderungen zu speichern. Klicken Sie auf",
            installationInstructionsOpenCart1: "1. Melden Sie sich in Ihrem OpenCart -Administratorfeld an",
            installationInstructionsOpenCart2: "2. Design> Gehen Sie zu Tema Editorial",
            installationInstructionsOpenCart3: "3. Wählen Sie den Ordner \"Common\" aus und öffnen Sie die Datei \"Header.twig\" darin.",
            installationInstructionsOpenCart4: "4. Fügen Sie den obigen Integrationscode vor dem {headtag} -Tag unten ein.",
            installationInstructionsOpenCart5: "5. Klicken Sie auf die Schaltfläche Speichern",
            installationInstructionsTicimax1: "1. Melden Sie sich in Ihrem Ticimax -Management -Panel an",
            installationInstructionsTicimax2: "2. Design> Konstruktionseinstellungen> Headerfußzeile Design Open",
            installationInstructionsTicimax3: "3. Klicken Sie im Abschnitt Logo -Design auf 'Source'Buton.",
            installationInstructionsTicimax4: "4. Fügen Sie den obigen Integrationscode unter den HTML -Code ein.",
            installationInstructionsEticaretteyim1: "1. Melden Sie sich bei Ihrem E-Commerce-Administrationsbereich an",
            installationInstructionsEticaretteyim2: "2. Benennen Sie einfach SUPSIS aus Plugins > HTML generieren > und kopieren Sie den Code.",
            installationInstructions: "Anweisungen",
            installationVerify: "Überprüfen Sie die SUPSIS -Installation Ihrer Website",
            installationVerifyChecking: "Kontrolliert",
            installationVerifyCheck: "prüfen Sie",
            installationVerifyCheckingStatus: "Der SUPSIS -Integrationsstatus von {website} prüft",
            installationCheckingStatusMessageYes: "SUPSıs Live wurde in {website} integriert.",
            installationCheckingStatusMessageNo: "SUPSIS ist derzeit nicht mit der Website {website} integriert. Sie können Ihren Integrationsprozess jetzt oder später abschließen.",
            vtippyPreferredLanguage: "Bevorzugte Sprache",
            chatAvailability: "Chat Availability"
        },
        akinon: {
            typeOrSelectSKU: "Schreiben oder wählen Sie SKU",
            akinonUserId: "Akinon User ID",
            userEmail: "Benutzer Email",
            userEmailDesc: "Schreiben oder wählen Sie die Benutzer -E -Mail ...",
            send: "Schicken",
            selectCity: "Wählen Sie den Distrikt",
            city: "Bezirk",
            selectState: "Wählen Sie Ihre Provinz",
            state: "Provinz",
            useMap: "Verwenden Sie die Karte",
            chooseAddress: "Adresse auswählen",
            selectCountry: "Land auswählen",
            country: "Land",
            productIdDesc: "Schreiben oder wählen Sie das Produkt ...",
            productId: "Produkt ID",
            userIdDesc: "Schreiben Sie die Akinon -Benutzer -ID ...",
            productSKU: "Produkt SKU",
            latitudeDesc: "Schreiben oder wählen Sie den Zielort der Zielort ...",
            longitudeDesc: "Schreiben oder wählen Sie die Länge der Zielposition ...",
            orderNumber: "Ihre Auftragsnummer",
            orderDesc: "Schreiben Sie die Bestellnummer ...",
            longitude: "Längengrad",
            latitude: "Breite"
        },
        probel: {
            branchCode: "Branchencode",
            branchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            hospitalBranchCode: "Branchencode",
            hospitalBranchCodeDesc: "Schreiben oder wählen Sie den Zweig -Code ...",
            clinicCode: "Polyclinic Code",
            clinicCodeDesc: "Schreiben oder wählen Sie den Polyclinic Code ...",
            date: "Termin",
            dateDesc: "Geben Sie das Datum des Termins ein oder wählen Sie ...",
            patientToken: "Patient Token",
            patientTokenDesc: "Schreiben oder wählen Sie das Patient -Token ...",
            appointmentId: "Termin -ID",
            appointmentIdDesc: "Schreiben oder wählen Sie die Termin -ID ...",
            identityType: "Identitätstyp",
            identityNumber: "Identifikationsnummer",
            name: "Patientenname",
            surname: "Nachname des Patienten",
            gender: "Kranker Sex",
            birthDay: "Patientendatum der Geburtsdatum",
            phoneNumber: "Patientennummer",
            identityTypeDesc: "Schreiben oder wählen Sie die Art der Identität ...",
            identityNumberDesc: "Schreiben oder wählen Sie die ID -Nummer ...",
            nameDesc: "Schreiben oder wählen Sie den Patientennamen ...",
            surnameDesc: "Schreiben oder wählen Sie den Nachnamen des Patienten ...",
            genderDesc: "Schreiben oder wählen Sie Patientensex ...",
            birthDayDesc: "Schreiben oder wählen Sie das Geburtsdatum ...",
            phoneNumberDesc: "Geben Sie die Patientennummer ein oder wählen Sie die Patientennummer ..."
        },
        headBar: {
            source: "Quelle",
            label: "Etikett",
            completed: "Abgeschlossen?",
            email: "Email",
            phone: "Telefon",
            name: "Name",
            date: "Geschichte",
            subject: "Thema",
            situation: "Situation",
            representative: "Vertreter",
            transactions: "Transaktionen",
            channel: "Kontaktkanal",
            Email: "E-mail"
        },
        login: {
            loginTitle1: "Willkommen bei",
            loginTitle2: "Supsis AI",
            email: "Deine E-Mail Adresse",
            emailPlaceholder: "Geben Sie bitte Ihre Email-Adresse ein.",
            emailError: "Bitte eine gültige E-Mail-Adresse eintragen",
            password: "Ihr Passwort",
            passwordLogin: "Passwortfreies Login",
            passwordAndLogin: "Login mit Passwort",
            passwordNew: "Setze mein Passwort zurück",
            loginAnd: "Oder",
            passwordPlaceholder: "Bitte geben Sie Ihr Passwort ein.",
            loginMemory: "erinnern Sie sich an dieses Gerät",
            passwordForget: "Ich habe mein Passwort vergessen",
            passwordNewAgain: "Neues Kennwort",
            passwordNewAgainTwo: "Neues Passwort wiederholen",
            passwordNewAgainPlaceholder: "Bitte geben Sie Ihr neues Passwort ein.",
            passwordNewAgainPlaceholderTwo: "Bitte geben Sie Ihr neues Passwort erneut ein.",
            login: "Anmeldung",
            loginFooter: "Oder melden Sie sich mit E-Mail an",
            emailLogin: "Melden Sie sich mit E-Mail an",
            welcomeTitle: "Willkommen",
            welcomeMorning: "Guten Morgen",
            welcomeAfternoon: "Guten Tag",
            welcomeEvening: "Guten Abend",
            welcomeNight: "Gute Nacht"
        },
        settings: {
            ipWhitelist: "IP-Zugangsliste",
            loadMore: "Mehr laden...",
            detectIpAddress: "Meine IP-Adresse erkennen",
            addWighteListAddress: "IP-Adresse zur Whitelist hinzufügen",
            accessControlSubTitles: "Die Zugangskontrolle bietet eine zusätzliche Sicherheitsebene, die nur autorisierten IPs den Systemzugriff ermöglicht",
            companyInformation: "Unternehmensinformationen",
            ipAddress: "Meine IP-Adresse",
            whiteList: "Sichere IP-Liste",
            whiteListAdd: "Zugangskontrolle hinzufügen",
            whiteListDeletedSuccessfully: "Zugangskontrolle erfolgreich gelöscht",
            whiteListDeletedFailed: "Zugangskontrolle nicht gelöscht",
            whiteListAddedSuccessfully: "Zugangskontrolle erfolgreich hinzugefügt",
            whiteListAddedFailed: "Zugangskontrolle nicht hinzugefügt",
            deleteWhiteListTitle: "Sind Sie sicher, dass Sie diesen Whitelist löschen möchten?",
            talkSettings: "Spracheinstellungen",
            talkSubtitles: "Verwalten Ihrer Spracheinstellungen",
            changeSettings: "Einstellungen für die automatische Chat-Zuweisung ändern",
            dateAndTime: "Datum und Uhrzeit",
            actor: "Akteur",
            event: "Ereignis",
            accessControl: "Zugangskontrolle",
            rulesGroup: "Regeln",
            organizationLongName: "Langer Name der Organisation",
            visitorNewDesc: "Sie können die neue Version des Besucherthemas verwenden.",
            transactionType: "Transaktionsart",
            priorBalance: "Vorheriger Saldo",
            nextBalance: "Nächster Saldo",
            amount: "Betrag",
            phoneNumber: "Telefonnummer",
            profileInfoRemoved: "Profilinformationen entfernt",
            newValueUpdated: "Neuer Wert aktualisiert.",
            balanceToTransferred: "Zu übertragendes Guthaben",
            availableBalance: "Verfügbarer Saldo",
            balanceReceived: "Empfangener Saldo",
            totalBalance: "Gesamtsaldo",
            paymentCard: "Zahlungskarte",
            wpPhoneNumber: "Whatsapp-Telefonnummer",
            wpSendingMessage: "Whatsapp sendet erste Nachricht",
            auditlogs: "Prüfprotokolle",
            myaccount: "Mein Konto",
            notifications: "Benachrichtigungen",
            company: "Firma",
            features: "Eigenschaften",
            general: "Allgemeines",
            chat: "Plaudern",
            wallet: "Brieftasche",
            timings: "Zeitmessung",
            language: "Sprache",
            "bubble-settings": "Blaseneinstellungen",
            "bubble-actions": "Blasenaktionen",
            "theme-settings": "Thema Einstellungen",
            visitorLoginForm: "Besucher Login Formular",
            visitorAttribute: "Informationen zum Besucherprofil",
            timing_settings: "Chat Timing Einstellungen",
            auto_assign: "Auto Assign",
            availability: "Verfügbarkeit",
            "website-integration": "Website Integration",
            General: "Allgemeines",
            Chat: "Plaudern",
            Timings: "Zeitmessung",
            Integration: "Integration",
            developer: "Entwickler",
            visitorNew: "Neuer Besucher",
            companySubtitles: "Verwalten Sie Ihre Unternehmensinformationen.",
            featuresSubtitles: "Verwalten Sie Ihre Funktionen.",
            languageSubtitles: "Legen Sie die bevorzugte Sprache und Zeitzone Ihres Unternehmens fest.",
            bubbleSettings: "Blaseneinstellungen",
            bubbleSettingsSubtitles: "Verwalten Sie Ihre Blaseneinstellungen.",
            bubbleActionsSubtitles: "Verwalten Sie Ihre Blasenaktionen.",
            chatThemeSettingsSubtitles: "Verwalten Sie Ihre Chat -Thema -Einstellungen.",
            visitorLoginFormSubtitles: "Verwalten Sie Ihre Besucher -Login -Formular -Einstellungen.",
            chatTimingSettingsSubtitles: "Verwalten Sie Ihre Chat -Timing -Einstellungen.",
            webSiteIntegrationSubtitles: "Verwalten Sie Ihre Website -Integration.",
            apiAccessTitle: "API Zugriff",
            apiAccessSubtitles: "Verwalten Sie Ihre API -Zugriff.",
            youTubeActionForm: "Fügen Sie Ihren YouTube -Kanal hinzu",
            linkedinActionForm: "Fügen Sie Ihr LinkedIn-Konto hinzu",
            telegramActionForm: "Telegram-Konto hinzufügen",
            facebookActionForm: "Fügen Sie Ihre Facebook -Seite hinzu",
            tiwitterActionForm: "Fügen Sie Ihren Twitter -Kanal hinzu",
            instagramActionForm: "Fügen Sie Ihren Instagram -Kanal hinzu",
            liveSupportDescription: "Aktivieren Sie den Live -Support -Modus, um Ihre Besucher zu unterstützen.",
            ticketDescription: "Aktivieren Sie den Ticket -Modus, um Ihre Besucher zu unterstützen.",
            whatsappDescription: "Aktivieren Sie den Whatsapp -Modus, um Ihre Besucher zu unterstützen.",
            phoneDescription: "Aktivieren Sie den Telefon -Modus, um Ihre Besucher zu unterstützen.",
            emailDescription: "Aktivieren Sie den E-Mail -Modus, um Ihre Besucher zu unterstützen.",
            facebookDescription: "Aktivieren Sie den Facebook -Modus, um Ihre Besucher zu unterstützen.",
            twitterDescription: "Aktivieren Sie den Twitter -Modus, um Ihre Besucher zu unterstützen.",
            instagramDescription: "Aktivieren Sie den Instagram -Modus, um Ihre Besucher zu unterstützen.",
            youtubeDescription: "Aktivieren Sie den Youtube -Modus, um Ihre Besucher zu unterstützen.",
            linkedinDescription: "Ermöglichen Sie Ihren Kunden, Sie mit LinkedIn zu erreichen",
            telegramDescription: "Lassen Sie Ihre Kunden mit Telegram an Größe gewinnen",
            whatsappModalTitle: "WhatsApp-Transaktionsformular",
            whatsappModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr WhatsApp-Konto zu verbinden.",
            phoneModalTitle: "Telefontransaktionsformular",
            phoneModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Telefonkonto zu verbinden.",
            emailModalTitle: "E-Mail Transaktionsformular",
            emailModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr E-Mail-Konto zu verbinden.",
            facebookModalTitle: "Facebook Transaktionsformular",
            facebookModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Facebook-Konto zu verbinden.",
            twitterModalTitle: "Twitter-Transaktionsformular",
            twitterModalDescription: "Bitte füllen Sie das untenstehende Formular aus, um Ihr Twitter-Konto zu verbinden.",
            instagramModalTitle: "Instagram-Transaktionsformular",
            instagramModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Instagram-Konto zu verbinden.",
            youtubeModalTitle: "Youtube Transaktionsformular",
            youtubeModalDescription: "Bitte füllen Sie das Formular unten aus, um Ihr Youtube-Konto zu verbinden.",
            linkedinModalTitle: "LinkeIn-Transaktionsformular",
            linkedinModalDescription: "Bitte füllen Sie das untenstehende Formular aus, um Ihr LinkedIn-Konto zu verknüpfen.",
            telegramModalTitle: "Telegram-Transaktionsformular",
            telegramModalDescription: "Geben Sie Ihren Telegram-Profillink in das untenstehende Formular ein, um Ihr Telegram-Konto zu verknüpfen",
            instagramAlertTitle: "Instagram-Integration erforderlich",
            instagramAlertDesc: "Entschuldigung, die von Ihnen besuchte Seite wird aktiviert, wenn Sie Ihr Instagram integrieren.",
            instagramActivateText: "Los geht's, integriere Instagram",
            remove: "Entfernen",
            edit: "Bearbeiten",
            connected: "Verbunden",
            add: "Hinzufügen",
            themeDescription: "Wählen Sie ein Thema für Ihren Chat aus.",
            fontDescription: "Wählen Sie eine Schriftart für Ihren Chat aus.",
            isFabsAsIcon: "Menüsymboltexte anzeigen.",
            chatBubbleTextSetting: "Chat-Blasentext-Einstellung",
            textOnChatBubble: "Sie können die Texteinstellungen anpassen, die in der Chat-Blase angezeigt werden.",
            textToAppearOnChatBubble: "Text, der in der Chat-Blase angezeigt wird",
            newVisitorProfileInformation: "Neue Besucherprofilinformationen",
            newVisitorProfileInformationDescription: "Fügt den Besucherprofilinformationen einen neuen Wert hinzu",
            create: "Erstellen",
            newAdd: "Neue hinzufügen",
            toInform: "Informieren",
            toInformDescription: "Sie können die Werte, die Sie auf dieser Seite hinzufügen, mit dem Besucher-Anmeldeformular abgleichen.",
            showVisitor: "Besucher anzeigen",
            label: "Fahrkarte",
            text: "Schreiben",
            email: "Email",
            phone: "Telefon",
            number: "Nummer",
            url: "URL",
            date: "Zeit",
            dropdown: "wählbar",
            languageTimeZone: "Sprache und Region",
            timeZoneTitle: "Region und Zeitzone",
            timeZoneDescription: "Regions- und Zeitzoneneinstellungen",
            ballanceToTransferred: "Aktarılıcak Bakiye",
            integration: "Entegrasyon",
            emailTitle: "E-Posta Adresinizi Giriniz",
            emailMessage: "E-posta İlk Gönderim Mesajı",
            advertising: "Pubblicità",
            ballanceToTransfer: "Solde à transférer",
            crm: "CRM",
            ecommerce: "E-commerce",
            sms: "SMS",
            socialMedia: "Social Media",
            utilities: "Utilità",
            web: "Web"
        },
        sessions: {
            mySessions: "Meine Sitzungen",
            mySessionsDesc: "Anzeigen und Verwalten Ihrer aktiven Sitzungen.",
            allSessions: "Alle Sitzungen",
            sessionManagement: "Sitzungsverwaltung",
            allSessionsDesc: "Anzeigen und Verwalten aller aktiven Sitzungen im System.",
            noActiveSessions: "Keine aktiven Sitzungen gefunden",
            currentSession: "Aktuelle Sitzung",
            lastAccess: "Letzter Zugriff",
            createdAt: "Erstellt",
            revoke: "Widerrufen",
            revokeConfirm: "Sind Sie sicher, dass Sie diese Sitzung widerrufen möchten?",
            revokeAllConfirm: "Sind Sie sicher, dass Sie alle anderen Sitzungen widerrufen möchten?",
            revokeSuccess: "Sitzung erfolgreich widerrufen",
            revokeAllSuccess: "Alle Sitzungen erfolgreich widerrufen",
            revokeFailed: "Sitzung konnte nicht widerrufen werden",
            revokeAllOther: "Alle anderen Sitzungen widerrufen",
            unknownLocation: "Unbekannter Standort",
            unknownDevice: "Unbekanntes Gerät",
            filterByUser: "Nach Benutzer filtern",
            mobile: "Mobil",
            supsisMobileApp: "Supsis Mobile App",
            httpClient: "HTTP-Client",
            unknown: "Unbekannt",
            ios: "iOS",
            android: "Android"
        },
        contactModuleRules: {
            title: "Kontaktmodul-Regeln",
            description: "Definieren Sie automatische Aktionen bei Erstellung einer Kundenkarte oder Öffnung eines Chats",
            active: "Aktiv",
            passive: "Passiv",
            when: "Wann:",
            conditions: "Bedingungen:",
            actions: "Aktionen:",
            elseTitle: "Sonst (wenn keine Regel passt)",
            noActionsDefined: "Keine Aktionen definiert",
            addNewRule: "Neue Regel hinzufügen",
            rulesDisabled: "Kontaktmodul-Regeln deaktiviert",
            enableHint: "Schalten Sie den Schalter oben ein, um automatische Aktionen zu aktivieren",
            rulesEnabledSuccess: "Kontaktmodul-Regeln aktiviert",
            rulesDisabledSuccess: "Kontaktmodul-Regeln deaktiviert",
            ruleEnabledSuccess: "Regel aktiviert",
            ruleDisabledSuccess: "Regel deaktiviert",
            ruleUpdateError: "Fehler beim Aktualisieren der Regel",
            orderUpdatedSuccess: "Regelreihenfolge aktualisiert",
            orderUpdateError: "Fehler beim Aktualisieren der Reihenfolge",
            ruleNameTemplate: "Regel {n}",
            ruleSavedSuccess: "Regel gespeichert",
            ruleSaveError: "Fehler beim Speichern der Regel",
            deleteRuleTitle: "Regel löschen",
            deleteRuleConfirm: "Sind Sie sicher, dass Sie die Regel \"{name}\" löschen möchten?",
            delete: "Löschen",
            ruleDeletedSuccess: "Regel gelöscht",
            ruleDeleteError: "Fehler beim Löschen der Regel",
            elseActionsSavedSuccess: "Sonst-Aktionen gespeichert",
            actionsSaveError: "Fehler beim Speichern der Aktionen",
            whenContactCreated: "Wenn Kundenkarte erstellt",
            whenChatOpened: "Wenn Chat geöffnet",
            noCondition: "Keine Bedingung",
            and: "und",
            or: "oder",
            AND: "UND",
            OR: "ODER",
            fieldNotSelected: "Feld nicht ausgewählt",
            noAction: "Keine Aktion",
            doNothing: "Nichts tun",
            assignToOwnerless: "unzugewiesen",
            assignOwnerlessAction: "Als <strong>{ownerless}</strong> zuweisen",
            assignTo: "zuweisen an",
            assignToUser: "Zuweisen an <strong>{name}</strong>",
            unknown: "Unbekannt",
            leastContact: "Weniger Gespräche",
            roundRobin: "Round Robin",
            today: "heute",
            last7Days: "letzte 7 Tage",
            last30Days: "letzte 30 Tage",
            channelAccessUsers: "Benutzer mit Kanalzugang",
            usersCount: "{n} Benutzer",
            allUsers: "alle Benutzer",
            random: "Zufällig",
            algorithmic: "Algorithmisch",
            addTagNotSelected: "Tag hinzufügen (nicht ausgewählt)",
            tagsLabel: "Tags",
            tagLabel: "Tag",
            addDepartmentNotSelected: "Abteilung hinzufügen (nicht ausgewählt)",
            addDepartmentTo: "Abteilung",
            applyToConversation: "(auch auf Konversation anwenden)",
            updatePropertyNotSelected: "Eigenschaft aktualisieren (nicht ausgewählt)",
            changeOwner: "Besitzer ändern",
            addTag: "Tag hinzufügen",
            addDepartment: "Abteilung hinzufügen",
            updateProperty: "Eigenschaft aktualisieren",
            yes: "Ja",
            no: "Nein",
            fields: {
                fullname: "Name",
                email: "E-Mail",
                phone: "Telefon",
                whatsappNumber: "WhatsApp",
                whatsappCountry: "WhatsApp-Land",
                platform: "Plattform",
                ownerExists: "Besitzer",
                ownerIsOnline: "Besitzer online",
                ownerStatus: "Besitzerstatus",
                uptime: "Alter (Min)",
                tags: "Tags",
                channel: "Kanal",
                preferredDepartment: "Abteilung",
                hour: "Stunde",
                day: "Tag",
                conversationStatus: "Chat-Status",
                conversationSubject: "Chat-Abteilung"
            },
            operators: {
                equals: "gleich",
                not_equals: "ungleich",
                contains: "enthält",
                not_contains: "enthält nicht",
                gt: "größer als",
                gte: "≥",
                lt: "kleiner als",
                lte: "≤",
                in: "enthält",
                not_in: "enthält nicht",
                exists: "existiert",
                not_exists: "existiert nicht"
            },
            ruleEditor: {
                editTitle: "Regel bearbeiten",
                createTitle: "Neue Regel erstellen",
                stepWhen: "Wann?",
                stepConditions: "Bedingungen",
                stepActions: "Aktionen",
                whenQuestion: "Wann soll die Regel ausgeführt werden?",
                ruleName: "Regelname",
                ruleNamePlaceholder: "Name für die Regel eingeben",
                contactCreatedTitle: "Wenn Kundenkarte erstellt",
                contactCreatedDesc: "Wird ausgeführt, wenn ein neuer Kunden-Datensatz erstellt wird",
                chatOpenedTitle: "Wenn Chat geöffnet",
                chatOpenedDesc: "Wird ausgeführt, wenn der Kunde eine neue Konversation startet",
                conditionsQuestion: "Welche Bedingungen müssen erfüllt sein?",
                actionsQuestion: "Welche Aktionen sollen ausgeführt werden?",
                back: "Zurück",
                cancel: "Abbrechen",
                next: "Weiter",
                save: "Speichern",
                newRule: "Neue Regel"
            },
            elseEditor: {
                title: "Sonst-Aktionen bearbeiten",
                description: "Standardaktionen definieren, wenn keine Regel passt"
            },
            ruleTester: {
                title: "Regel testen",
                description: "Sie können testen, wie viele Kontakte Ihre Regel abgleicht",
                selectRule: "Regel auswählen",
                selectRulePlaceholder: "Zu testende Regel auswählen",
                test: "Testen",
                ruleInfo: "Regelinformationen",
                conditionCount: "Anzahl Bedingungen:",
                actionCount: "Anzahl Aktionen:",
                ruleNotFound: "Regel nicht gefunden",
                testComingSoon: "Testfunktion kommt bald.",
                testError: "Fehler beim Testen"
            },
            filterBuilder: {
                noConditions: "Noch keine Bedingungen hinzugefügt",
                addFirstCondition: "Erste Bedingung hinzufügen",
                groupTitle: "Gruppe {n}",
                deleteGroup: "Gruppe löschen",
                if: "Wenn",
                selectField: "Feld auswählen",
                operator: "Operator",
                select: "auswählen",
                selectValue: "Wert auswählen",
                enterValue: "Wert eingeben",
                addCondition: "Bedingung hinzufügen",
                addFilterGroup: "Filtergruppe hinzufügen",
                andOption: "und",
                orOption: "oder",
                fieldLabels: {
                    fullname: "Kontaktname",
                    email: "Kontakt-E-Mail",
                    phone: "Kontakt-Telefon",
                    whatsappNumber: "WhatsApp-Nummer",
                    whatsappCountry: "WhatsApp-Land",
                    platform: "Kontaktplattform",
                    ownerExists: "Kontakt hat Besitzer",
                    ownerIsOnline: "Besitzer online",
                    ownerStatus: "Besitzerstatus",
                    uptime: "Kontaktalter (Min)",
                    tags: "Kontakt-Tags",
                    channel: "Kontaktkanal",
                    preferredDepartment: "Bevorzugte Abteilung",
                    hour: "Aktuelle Stunde",
                    day: "Aktueller Tag",
                    conversationStatus: "Konversationsstatus",
                    conversationSubject: "Konversationsabteilung"
                },
                operators: {
                    equals: "gleich",
                    not_equals: "ungleich",
                    contains: "enthält",
                    not_contains: "enthält nicht",
                    gt: "größer als",
                    gte: "größer oder gleich",
                    lt: "kleiner als",
                    lte: "kleiner oder gleich",
                    between: "zwischen",
                    exists: "existiert",
                    not_exists: "existiert nicht",
                    in: "enthält",
                    not_in: "enthält nicht"
                }
            },
            actionsEditor: {
                noActions: "Noch keine Aktionen hinzugefügt",
                addFirstAction: "Erste Aktion hinzufügen",
                actionNumber: "Aktion {n}",
                actionType: "Aktionstyp",
                addAction: "Aktion hinzufügen"
            },
            changeOwnerConfig: {
                method: "Zuweisungsmethode",
                static: "Statisch",
                algorithmic: "Algorithmisch",
                random: "Zufällig",
                userSelect: "Benutzerauswahl",
                assignOwnerless: "Als unzugewiesen zuweisen",
                selectUser: "Benutzer auswählen",
                userList: "Benutzerliste",
                channelAccessUsers: "Alle Benutzer mit Kanalzugang",
                selectUsers: "Benutzer auswählen",
                algorithm: "Algorithmus",
                leastContact: "Weniger Gespräche",
                roundRobin: "Round Robin",
                dateRange: "Datumsbereich",
                today: "Heute",
                last7Days: "Letzte 7 Tage",
                last30Days: "Letzte 30 Tage",
                onlyOnline: "Nur Online-Benutzer einbeziehen"
            },
            addTagConfig: {
                tagsToAdd: "Hinzuzufügende Tags",
                selectTag: "Tag auswählen",
                selectedTagsHint: "Ausgewählte Tags werden dem Kontakt hinzugefügt"
            },
            addDepartmentConfig: {
                departmentSelect: "Abteilungsauswahl",
                selectDepartment: "Abteilung auswählen",
                departmentHint: "Ausgewählte Abteilung wird zur Abteilungsliste des Kontakts hinzugefügt",
                applyToConversation: "Auch auf Konversation anwenden",
                applyToConversationHint: "Wenn aktiviert, wird auch die Abteilung der geöffneten Konversation gesetzt"
            },
            upsertContactPropertyConfig: {
                propertySelect: "Eigenschaftsauswahl",
                selectProperty: "Eigenschaft auswählen",
                propertyHint: "Zu aktualisierende oder zu erstellende Eigenschaft",
                value: "Wert",
                valuePlaceholder: "Eigenschaftswert eingeben",
                valueHint: "Dieser Wert wird der Eigenschaft zugewiesen"
            }
        },
        taskModuleRules: {
            title: "Aufgabenmodul-Regeln",
            description: "Definieren Sie automatische Aktionen bei Erstellung, Aktualisierung einer Aufgabe oder Hinzufügen eines Kommentars",
            settingsTitle: "Aufgabenmodul-Regeln",
            settingsDescription: "Definieren Sie automatische Aufgabenregeln für jeden Workflow",
            selectWorkflow: "Workflow auswählen",
            selectWorkflowPlaceholder: "Workflow auswählen",
            selectWorkflowHint: "Wählen Sie einen Workflow zum Bearbeiten der Aufgabenmodul-Regeln",
            active: "Aktiv",
            passive: "Passiv",
            when: "Wann:",
            conditions: "Bedingungen:",
            actions: "Aktionen:",
            elseTitle: "Sonst (wenn keine Regel passt)",
            noActionsDefined: "Keine Aktionen definiert",
            addNewRule: "Neue Regel hinzufügen",
            rulesDisabled: "Aufgabenmodul-Regeln deaktiviert",
            enableHint: "Schalten Sie den Schalter oben ein, um automatische Aktionen zu aktivieren",
            rulesEnabledSuccess: "Aufgabenmodul-Regeln aktiviert",
            rulesDisabledSuccess: "Aufgabenmodul-Regeln deaktiviert",
            ruleEnabledSuccess: "Regel aktiviert",
            ruleDisabledSuccess: "Regel deaktiviert",
            ruleUpdateError: "Fehler während des Vorgangs",
            orderUpdatedSuccess: "Regelreihenfolge aktualisiert",
            orderUpdateError: "Fehler beim Aktualisieren der Reihenfolge",
            ruleNameTemplate: "Regel {n}",
            ruleSavedSuccess: "Regel gespeichert",
            ruleSaveError: "Fehler beim Speichern der Regel",
            deleteRuleTitle: "Regel löschen",
            deleteRuleConfirm: "Sind Sie sicher, dass Sie die Regel \"{name}\" löschen möchten?",
            delete: "Löschen",
            ruleDeletedSuccess: "Regel gelöscht",
            ruleDeleteError: "Fehler beim Löschen der Regel",
            elseActionsSavedSuccess: "Sonst-Aktionen gespeichert",
            actionsSaveError: "Fehler beim Speichern der Aktionen",
            noCondition: "Keine Bedingung",
            and: "und",
            or: "oder",
            AND: "UND",
            OR: "ODER",
            fieldNotSelected: "Feld nicht ausgewählt",
            noAction: "Keine Aktion",
            chainBadge: "Verkettung",
            chainBadgeTooltip: "Diese Regel kann andere Regeln auslösen",
            automationOffBadge: "Automatisierung aus",
            automationOffTooltip: "Nicht an Supsis Automations gemeldet",
            yes: "Ja",
            no: "Nein",
            unknown: "Unbekannt",
            cancel: "Abbrechen"
        },
        userInfoWidget: {
            zohoInfo: "Zoho-Informationen",
            messageSearch: "Nachricht suchen",
            userInformation: "Nutzerinformation",
            fullName: "Name und Nachname",
            newValue: "Neuer Wert",
            newProfileInfo: "Neue Profilinformationen",
            affiliatedRepresentatives: "Vertreter",
            preferredAgents: "Bevorzugter Agent",
            labels: "Etiketten",
            agentNotes: "Agentennotizen",
            newNote: "Neue Notiz",
            note: "Notiz",
            available: "Es sind Notizen vorhanden.",
            systemInformation: "System Information",
            speechID: "Sprach-ID",
            customerVersion: "Kundenversion",
            IPAddress: "IP Adresse",
            pageVisited: "Seite besucht",
            systemAndBrowser: "Betriebssystem und Browser",
            countryAndLanguage: "Land und Sprache",
            clickToEdit: "Bearbeiten Klicken Sie in den Beitrag",
            adsYouAreInterestedIn: "Anzeigen, an denen Sie interessiert sind",
            detail: "Detail",
            adsTitle: "Titel",
            adUrl: "Anzeigen-URL",
            sourceID: "Quell-ID",
            resourceType: "Ressourcentyp",
            adsBody: "Inhalt",
            adsCreateDate: "Erstellungsdatum",
            adsUpdateDate: "Aktualisierungsdatum"
        },
        newWizartV2: {
            generalSettings: "Allgemeine Einstellungen",
            themeSettings: "Themen Einstellungen",
            representativeWorkingHours: "Repräsentative Arbeitszeiten",
            preview: "Repräsentative Arbeitszeiten",
            setup: "Aufstellen",
            formStepTitle: "Geben Sie uns weitere Informationen, damit wir Ihr Erlebnis individuell gestalten können",
            supsisEntergation: "Wo werden Sie Supsis auf Ihrer Website verwenden?:",
            goToNextStep: "Machen Sie den nächsten Schritt",
            readytemplate: "Verwenden Sie eine fertige Farbvorlage",
            customSettings: "Benutzerdefinierte Einstellungen",
            customerMessageView: "Kundennachrichtenansicht",
            backcgroundColor: "Hintergrundfarbe",
            textColor: "Schriftfarbe",
            agentMessageView: "Agentennachrichtenansicht",
            workingHours: "In welchen Zeitabständen bieten Sie Ihren Besuchern Dienstleistungen an?",
            continuousService: "Kontinuierlicher Service",
            continuousServiceDescription: "Die Chat-Blase ist immer aktiv. Auch wenn Sie nicht im System sind.",
            vote: "Treffen Sie Ihre Wahl",
            representativeWorking: "Repräsentative Arbeitszeiten",
            representativeWorkingDescription: "Der Chat erscheint online, wenn mindestens 1 Agent online ist. Wenn kein Online-Vertreter vorhanden ist, wird er als offline angezeigt.",
            computer: "Computer",
            tablet: "Tablette",
            uploadTrackingCodeToYourWebsite: "Laden Sie den Tracking-Code auf Ihre Website hoch",
            password: "Neues Passwort festlegen"
        },
        whatsappChannel: {
            whatsappTitleV1: "Whatsapp V1 Kanäle (QR)",
            whatsappTitleV2: "Whatsapp V2 Kanäle (QR)",
            channelName: "Channel",
            phoneNumber: "Telefonnummer",
            forwardToChatbot: "An Chatbot weiterleiten",
            forwardingChatbotOrLiveAgent: "Weiterleitung (Chatbot oder Live-Agent)",
            addChannel: "Kanal hinzufügen",
            newWhatsappChannel: "Neuer WhatsApp-Kanal",
            newWhatsappChannelDescription: "Erstellen Sie einen neuen WhatsApp-Kanal, indem Sie den QR-Code scannen",
            editWhatsappChannel: "WhatsApp-Kanal bearbeiten",
            editWhatsappChannelDescription: "WhatsApp-Kanal bearbeiten",
            whatsappChannel: "WhatsApp-Kanal",
            deleteWhatsappChannelDescription: "Sind Sie sicher, dass Sie diesen Kanal löschen möchten?",
            whatsappIntegration: "WhatsApp-Integration",
            deleteChannel: "Kanal löschen",
            restartChannel: "Kanal neu starten",
            wantRestartChannel: "Möchten Sie den Kanal neu starten?",
            deleteSMSChannelDescription: "Sind Sie sicher, dass Sie den SMS-Kanal löschen möchten?",
            smsChannel: "SMS-Kanal",
            maxChannelCount: "Sie können nicht mehr als einen SMS-Kanal erstellen!",
            smsModalText: "Unsere Integration mit modernen Kommunikationslösungen bietet Ihnen die Möglichkeit, SMS einfach und effektiv zu versenden. Beseitigen Sie Grenzen in der Kommunikation, treten Sie direkt mit Ihren Kunden in Kontakt!",
            smsModalBtn: "Klicken Sie hier, um den SMS-Kanal zu öffnen...",
            postaCellDetail: "PostaCell-Kanaldetails",
            phoneNummer: "Telefon Numarası"
        },
        noPermission: "Sie haben keine Berechtigung, diese Aktion auszuführen.",
        mail_integration_detail: {
            title: "E-Mail-Detail",
            integration: "Integration",
            sender: "Absender-E-Mail",
            signature: "Unterschrift",
            inbox: "Posteingang",
            medias: "Medien",
            visibility: "Sichtbarkeit",
            settings_group: "Einstellungen",
            contacts: "Kontakte"
        },
        whatsapp_business_api: {
            userVisibility: "Benutzer-Sichtbarkeit",
            userVisibilityDesc: "Die Kanäle, auf die Benutzer zugreifen können, hängen von ihrer Rolle und den Sichtbarkeitseinstellungen des Kanals ab. Benutzer mit der Rolle Full Admin oder root können alle Channels sehen. Wenn die Sichtbarkeitseinstellungen eines Channels leer sind, ist der Channel öffentlich. Wenn der Channel jedoch für bestimmte Benutzer oder Abteilungen definiert ist, können nur diese Benutzer oder Abteilungsmitglieder den Channel sehen.",
            searchTemplate: "Suchvorlage...",
            forwardToChatbot: "Weiterleitung an Chatbot",
            forwarding: "Weiterleitung (Chatbot oder Live-Agent)",
            forwardLiveAgents: "👉 Weiterleitung an Live-Support",
            forwardingToDepartment: "Weiterleitung an Abteilung",
            selectDepartment: "Abteilung auswählen",
            createWbChannel: "Um einen Whatsapp Business-Kanal zu erstellen, müssen Sie ein Whatsapp Business-Paket erwerben. Sie können sofort auf günstige Pakete zugreifen.",
            wbCreateChannelMax: "Sie haben das Limit für die Erstellung von Whatsapp Business-Kanälen erreicht. Maximun",
            wbContinue: "Sie können einen Whatsapp Business Channel erstellen. Um fortzufahren, aktualisieren Sie Ihr Paket oder löschen Sie einige Ihrer Whatsapp Business Channels.",
            chatInitiatorTemplate: "Chatinitiator-Vorlage",
            selectChatInitiatorTemplate: "Wählen Sie Ihre Chatinitiator-Vorlage aus.",
            dailyUsageReport: "Täglicher Nutzungsbericht",
            metaInsightsTitle: "Meta Insights",
            metaInsightsSubtitle: "WhatsApp Business API-Statistiken anzeigen",
            metaInsightsDateRange: "Datumsbereich",
            metaInsightsDateStart: "Start",
            metaInsightsDateEnd: "Ende",
            metaInsightsGranularity: "Granularität",
            metaInsightsGranularityDay: "Täglich",
            metaInsightsGranularityMonth: "Monatlich",
            metaInsightsGranularityHalfHour: "Halbe Stunde",
            metaInsightsRefresh: "Aktualisieren",
            metaInsightsTabMessaging: "Messaging-Analytik",
            metaInsightsTabConversation: "Conversation-Analytik",
            metaInsightsTabPricing: "Pricing-Analytik",
            metaInsightsTabTemplate: "Template-Analytik",
            metaInsightsTabTemplateGroup: "Template-Gruppen-Analytik",
            metaInsightsErrorMessaging: "Messaging-Analytikdaten konnten nicht geladen werden",
            metaInsightsErrorConversation: "Conversation-Analytikdaten konnten nicht geladen werden",
            metaInsightsErrorPricing: "Pricing-Analytikdaten konnten nicht geladen werden",
            metaInsightsErrorTemplate: "Template-Analytikdaten konnten nicht geladen werden",
            metaInsightsErrorTemplateGroup: "Template-Gruppen-Analytikdaten konnten nicht geladen werden",
            metaInsightsViewChart: "Diagrammansicht",
            metaInsightsViewTable: "Tabellenansicht",
            metaInsightsDownloadExcel: "Excel herunterladen",
            metaInsightsTotalSent: "Gesendet gesamt",
            metaInsightsTotalDelivered: "Zugestellt gesamt",
            metaInsightsDeliveryRate: "Zustellrate",
            metaInsightsUnitMessage: "Nachrichten",
            metaInsightsMessageStats: "Nachrichtenstatistik",
            metaInsightsSent: "Gesendet",
            metaInsightsDelivered: "Zugestellt",
            metaInsightsDateColumn: "Datum",
            metaInsightsCountryBreakdown: "Aufschlüsselung nach Land",
            metaInsightsNoData: "Keine Daten gefunden. Bitte überprüfen Sie den Datumsbereich.",
            metaInsightsPieChart: "Kreisdiagramm",
            metaInsightsTotalConversations: "Gesamt Konversationen",
            metaInsightsTotalCost: "Gesamtkosten",
            metaInsightsAvgCost: "Durchschnittskosten",
            metaInsightsUnitConversation: "Konversationen",
            metaInsightsCostPerConversation: "$/Konversation",
            metaInsightsCategoryBreakdown: "Aufschlüsselung nach Kategorie",
            metaInsightsConversationStats: "Konversationsstatistik",
            metaInsightsCategoryDistribution: "Kategorieverteilung",
            metaInsightsConversationCount: "Anzahl Konversationen",
            metaInsightsCost: "Kosten",
            metaInsightsCategory: "Kategorie",
            metaInsightsType: "Typ",
            metaInsightsConversationCategoryAuth: "Authentifizierung",
            metaInsightsConversationCategoryMarketing: "Marketing",
            metaInsightsConversationCategoryService: "Service",
            metaInsightsConversationCategoryUtility: "Utility",
            metaInsightsConversationCategoryOther: "Sonstige",
            metaInsightsConversationDistribution: "Konversationsverteilung",
            metaInsightsTotalVolume: "Gesamtvolumen",
            metaInsightsAvgUnitCost: "Durchschnittliche Stückkosten",
            metaInsightsCostPerMessage: "$/Nachricht",
            metaInsightsPricingCategoryBreakdown: "Aufschlüsselung nach Preiskategorie",
            metaInsightsPricingTypeBreakdown: "Aufschlüsselung nach Preistyp",
            metaInsightsPricingStats: "Preisstatistik",
            metaInsightsCostDistribution: "Kostenverteilung",
            metaInsightsCountry: "Land",
            metaInsightsVolume: "Volumen",
            metaInsightsTier: "Tier",
            metaInsightsPricingCategoryAuth: "Authentifizierung",
            metaInsightsPricingCategoryAuthInternational: "Internationale Authentifizierung",
            metaInsightsPricingCategoryMarketing: "Marketing",
            metaInsightsPricingCategoryService: "Service",
            metaInsightsPricingCategoryUtility: "Utility",
            metaInsightsPricingCategoryReferral: "Referral-Konvertierung",
            metaInsightsPricingTypeRegular: "Regulär",
            metaInsightsPricingTypeFreeCustomerService: "Kostenloser Kundenservice",
            metaInsightsPricingTypeFreeEntryPoint: "Kostenloser Einstiegspunkt",
            metaInsightsTemplateAboutTitle: "Über Template-Analytik",
            metaInsightsTemplateAboutDesc: "Für die Template-Analytik müssen Sie Vorlagen auswählen. Sie können bis zu 10 Vorlagen auswählen. Die Analysedaten werden mit Tagesgranularität zurückgegeben und Sie können auf 90 Tage Verlaufsdaten zugreifen.",
            metaInsightsTemplateSelectLabel: "Vorlagen auswählen (max. 10)",
            metaInsightsTemplateSelectPlaceholder: "Vorlagen auswählen...",
            metaInsightsFetchData: "Daten abrufen",
            metaInsightsTotalRead: "Gesamt gelesen",
            metaInsightsReadRate: "Lesequote",
            metaInsightsRead: "Gelesen",
            metaInsightsTemplatePerformance: "Vorlagen-Performance",
            metaInsightsCostInfo: "Kosteninformationen",
            metaInsightsTotalSpent: "Gesamt ausgegeben",
            metaInsightsCostPerDelivered: "Kosten pro Zustellung",
            metaInsightsClickInfo: "Klickinformationen",
            metaInsightsClickInfoDesc: "URL- und Quick-Reply-Button-Klicks sind nur für Vorlagen in den Kategorien MARKETING und UTILITY verfügbar.",
            metaInsightsTemplateNoData: "Keine Template-Analytikdaten gefunden. Sie können Daten abrufen, indem Sie Template-IDs auswählen.",
            metaInsightsTemplateId: "Template-ID",
            metaInsightsTemplateGroupAboutTitle: "Über Template-Gruppen-Analytik",
            metaInsightsTemplateGroupAboutDesc: "Für die Template-Gruppen-Analytik müssen Sie in Meta erstellte Template-Gruppen-IDs eingeben. Sie können bis zu 10 Gruppen eingeben. Die Analysedaten werden mit Tagesgranularität zurückgegeben und Sie können auf 90 Tage Verlaufsdaten zugreifen.",
            metaInsightsTemplateGroupIdsLabel: "Template-Gruppen-IDs (kommagetrennt, max. 10)",
            metaInsightsTemplateGroupIdsPlaceholder: "z. B.: 1044106240855852, 1044106240855853",
            metaInsightsTemplateGroupPerformance: "Template-Gruppen-Performance",
            metaInsightsGroupBreakdownTitle: "Performance nach Gruppe",
            metaInsightsGroupLabel: "Gruppe",
            metaInsightsTemplateGroupNoData: "Keine Template-Gruppen-Analytikdaten gefunden. Sie können Daten abrufen, indem Sie Template-Gruppen-IDs eingeben.",
            metaInsightsGroupId: "Gruppen-ID",
            capiStatus: "CAPI-Status",
            capiActive: "Aktiv",
            capiPassive: "Inaktiv",
            capiConnectionMethod: "Verbindungsmethode",
            capiConnectThroughMeta: "Über Meta verbinden",
            capiWithDatasetAndToken: "Mit Dataset und Token",
            capiOauthInfoDesc: "Sie müssen sich erneut autorisieren, um über Meta eine Verbindung herzustellen. Dies beeinträchtigt Ihren bestehenden Kanal nicht, es werden nur zusätzliche Berechtigungen hinzugefügt.",
            capiConnecting: "Verbinde...",
            capiConnectWithMeta: "Mit Meta verbinden",
            capiDatasetSelection: "Dataset-Auswahl",
            capiSelectDataset: "Dataset auswählen",
            capiCreating: "Erstelle...",
            capiCreateNewDataset: "Neues Dataset erstellen",
            capiDatasetId: "Dataset-ID",
            capiEnterDatasetId: "Dataset-ID eingeben",
            capiAccessToken: "Access Token",
            capiEnterAccessToken: "Access Token eingeben",
            capiTesting: "Teste...",
            capiTestConnection: "Verbindung testen",
            capiConnectionSuccess: "Verbindung erfolgreich",
            capiConnectionFailed: "Verbindung fehlgeschlagen",
            capiAutoEventSend: "Automatischer Event-Versand",
            capiEventInitiateCheckout: "Chat gestartet",
            capiEventInitiateCheckoutDesc: "Wenn eine neue Konversation erstellt wird",
            capiEventPurchase: "Kauf",
            capiEventPurchaseDesc: "Wenn der Kauf abgeschlossen ist",
            capiEventAppointmentBooked: "Termin gebucht",
            capiEventAppointmentBookedDesc: "Wenn ein Termin reserviert wird",
            capiEventAddToCart: "In den Warenkorb",
            capiEventAddToCartDesc: "Wenn ein Produkt in den Warenkorb gelegt wird",
            capiEventViewContent: "Inhalt angesehen",
            capiEventViewContentDesc: "Wenn eine Seite oder ein Produkt angesehen wird",
            capiEventOrderCreated: "Bestellung erstellt",
            capiEventOrderCreatedDesc: "Wenn die Bestellung erfolgreich erstellt wurde",
            capiEventOrderShipped: "Bestellung versendet",
            capiEventOrderShippedDesc: "Wenn die Bestellung versendet wird",
            capiMetaConnectionSuccess: "Meta-Verbindung erfolgreich",
            capiMetaConnectionFailed: "Meta-Verbindung fehlgeschlagen",
            capiDatasetsLoadError: "Datasets konnten nicht geladen werden",
            capiDatasetCreated: "Neues Dataset erstellt",
            capiDatasetCreateError: "Dataset konnte nicht erstellt werden",
            capiConnectionTestSuccess: "CAPI-Verbindung erfolgreich!",
            capiConnectionTestFailed: "CAPI-Verbindung fehlgeschlagen",
            capiConnectionTestError: "Verbindungstest konnte nicht durchgeführt werden",
            wabaMovementsTitle: "Webhook-Aktivitäten",
            wabaMovementsSubtitle: "WhatsApp Business API Kanalaktivitäten verfolgen",
            wabaMovementsTotalActivity: "Aktivitäten gesamt",
            wabaMovementsEmailNotifications: "E-Mail-Benachrichtigungen",
            wabaMovementsActive: "Aktiv",
            wabaMovementsOff: "Aus",
            wabaMovementsEmailSettingTitle: "Kontobenachrichtigungen per E-Mail erhalten",
            wabaMovementsEmailSettingDesc: "E-Mail-Benachrichtigungen für Webhook-Aktivitäten senden",
            wabaMovementsEmailListHeader: "E-Mail-Adressen für Benachrichtigungen",
            wabaMovementsEmailPlaceholder: "E-Mail-Adresse eingeben",
            wabaMovementsNoEmailsYet: "Noch keine E-Mail-Adressen hinzugefügt",
            wabaMovementsActivityLoadError: "Fehler beim Laden der Aktivitätsprotokolle",
            wabaMovementsNotificationsOn: "E-Mail-Benachrichtigungen aktiviert",
            wabaMovementsNotificationsOff: "E-Mail-Benachrichtigungen deaktiviert",
            wabaMovementsUpdateError: "Fehler bei der Aktualisierung",
            wabaMovementsEmailAlreadyAdded: "Diese E-Mail-Adresse ist bereits hinzugefügt",
            wabaMovementsEmailAdded: "E-Mail-Adresse hinzugefügt",
            wabaMovementsEmailAddError: "Fehler beim Hinzufügen der E-Mail",
            wabaMovementsEmailRemoved: "E-Mail-Adresse entfernt",
            wabaMovementsEmailRemoveError: "Fehler beim Entfernen der E-Mail",
            freeChat: "Kostenloser Chat",
            paidChat: "Bezahlter Chat",
            templateMessage: "Vorlage Nachricht",
            outgoingSession: "Ausgehende Sitzung",
            incomingSession: "Kommende Sitzung",
            totalCost: "Gesamtkosten",
            allOptNumbers: "Alle Opt-in-Nummern",
            startChat: "Chat starten",
            lastMessageDate: "Datum der letzten Nachricht",
            sureDeleteTemplate: "Sind Sie sicher, dass Sie diese Vorlage löschen wollen?",
            manageWhoChannelChat: "Verwalten, wer diese Channel-Chats sehen kann",
            profileImageDesc: "Dies wird als Profilbild Ihres Unternehmens in WhatsApp angezeigt",
            businessDescription: "Unternehmensbeschreibung",
            descOfWork: "Description of your business in a few words (maximum 512 characters)",
            accountStatus: "Account Status",
            dockerStatus: "Docker Status",
            phoneQuality: "Phone Quality",
            customersOrDay: "Customers/Day",
            messagingLimit: "Messaging Limit",
            canSendMessage: "Message Can Be Sent",
            officialDetails: "Official Details",
            officialDetailsDesc: "These addresses will always be shown in the profile section to users who chat with you on WhatsApp. After editing, we will send them to WhatsApp for approval.",
            addressLine: "Address Line",
            stateIfApplicable: "State (if applicable)",
            zipCodeOrPostCode: "Zip Code/Postal Code",
            selectCountry: "Select Country",
            selectBusinessVertical: "Select Business Area",
            saveInfo: "Informationen speichern",
            active: "Active",
            banned: "Banned",
            low: "Low",
            medium: "Medium",
            high: "High",
            connected: "Connected",
            disConnected: "Disconnected",
            flagged: "Flagged",
            pending: "Pending",
            restricted: "Restricted",
            unknown: "Unknown",
            available: "Available",
            limited: "Limited",
            blocked: "Blocked",
            loadingProfile: "Profilinformationen werden geladen...",
            businessProfileTitle: "Unternehmensprofil",
            lastUpdate: "Letzte Aktualisierung:",
            updateFromMeta: "Von Meta aktualisieren",
            waitSeconds: "{n}s warten",
            wabaInfoTitle: "WhatsApp Business Account Informationen",
            phoneInfo: "Telefoninformationen",
            verifiedNameLabel: "Verifizierter Name:",
            phoneNumberLabel: "Telefonnummer:",
            codeVerificationLabel: "Code-Verifizierung:",
            platformSettings: "Plattformeinstellungen",
            platformTypeLabel: "Plattformtyp:",
            throughputLevelLabel: "Durchsatzstufe:",
            twoFaPinLabel: "2FA-PIN:",
            enabled: "Aktiviert",
            disabled: "Deaktiviert",
            dailyLimit: "Tageslimit",
            messageSending: "Nachrichtenversand",
            businessInfoTitle: "Unternehmensinformationen",
            profilePhoto: "Profilfoto",
            change: "Ändern",
            profilePhotoNote: "JPG oder PNG (max. 5MB, empfohlen: 640x640px)",
            aboutText: "Über-Text",
            aboutPlaceholder: "Schreiben Sie eine kurze Beschreibung Ihres Unternehmens...",
            aboutHint: "Kurze Beschreibung auf Ihrem WhatsApp-Profil (max. 139 Zeichen)",
            businessDescriptionLabel: "Unternehmensbeschreibung",
            businessDescriptionPlaceholder: "Schreiben Sie Ihre detaillierte Unternehmensbeschreibung...",
            descriptionHint: "Ihre detaillierte Unternehmensbeschreibung",
            contactEmail: "Kontakt-E-Mail",
            emailPlaceholder: "beispiel@firma.com",
            businessAddress: "Geschäftsadresse",
            addressPlaceholder: "Vollständige Adresse",
            website1: "Website 1",
            website2: "Website 2",
            website1Placeholder: "https://www.firma.com",
            website2Placeholder: "https://www.facebook.com/firma",
            businessCategory: "Unternehmenskategorie",
            selectBusinessCategory: "Unternehmenskategorie auswählen",
            categoryHint: "Wählen Sie Ihren Geschäftsbereich",
            revertChanges: "Änderungen rückgängig machen",
            updateButton: "Aktualisieren",
            accountModeLabel: "Kontomodus:",
            na: "N/V",
            verticalOther: "Sonstige",
            verticalAuto: "Automobil",
            verticalBeauty: "Schönheit, Spa und Salon",
            verticalApparel: "Kleidung und Bekleidung",
            verticalEdu: "Bildung",
            verticalEntertain: "Unterhaltung",
            verticalEventPlan: "Eventplanung und Service",
            verticalFinance: "Finanzen und Banking",
            verticalGrocery: "Lebensmittel und Lebensmittelgeschäft",
            verticalGovt: "Öffentlicher Dienst",
            verticalHotel: "Hotel und Unterkunft",
            verticalHealth: "Medizin und Gesundheit",
            verticalNonprofit: "Gemeinnützig",
            verticalProfServices: "Professionelle Dienstleistungen",
            verticalRetail: "Einkaufen und Einzelhandel",
            verticalTravel: "Reisen und Transport",
            verticalRestaurant: "Restaurant",
            verticalAlcohol: "Alkohol",
            verticalOnlineGambling: "Online-Glücksspiel",
            verticalPhysicalGambling: "Physisches Glücksspiel",
            verticalOtcDrugs: "Rezeptfreie Medikamente",
            verticalMatrimonyService: "Heiratsvermittlung",
            success: "Success",
            successDesc: "Your profile information was successfully updated.",
            wabaOverview: "WABA Health Overview",
            manageChannelDetail: "Manage your channel information",
            wpBussChannelDetail: "WhatsApp Business Channel Detail",
            manageWpBussChannel: "Manage your WhatsApp business channel",
            channelName: "Channel Name",
            phoneNumberE164: "Phone Number",
            phoneNumberE164Place: "Phone Number e.g. 908501234455",
            channelUpdatedSucs: "Channel updated successfully",
            failedUpdateChannel: "Failed to update channel",
            title: "Whatsapp Business API Kanäle",
            integration: "Integration",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            templates: "Alle Vorlagen-Nachrichten",
            settings_group: "Einstellung",
            template_message_group: "Vorlagen-Nachrichten",
            chat_initiator_template: "Chat-Initiierungsvorlage",
            contacts: "Kontakte",
            numbers: "Zahlen",
            all_contacts: "Alle Kontakte",
            new_template: "Neue Vorlage erstellen",
            broadcast_group: "Rundsendung",
            broadcast_requests: "Rundsende-Anfragen",
            customer_groups: "Kundengruppen",
            businessChannelDetail: "Whatsapp Business Kanaldetails",
            wallet: "Wallet",
            postacellMessage: "SMS senden",
            postacellAllMessage: "Massen-SMS senden",
            message_group: "Nachricht",
            createNewTemplate: "Neue Vorlagennachricht erstellen",
            templateName: "Vorlagenname",
            templateNameDesc: "Geben Sie Ihrem Nachrichtenvorlagen einen Namen.",
            templateInfo: "Informationen zur Vorlage",
            viewTemplates: "Vorlagen anzeigen",
            templateListTitle: "Nachrichtenvorlagen",
            templateListShownTotal: "{shown} Vorlagen angezeigt (Gesamt: {total})",
            templateListCreateButton: "Vorlage erstellen",
            templateListSearchPlaceholder: "Vorlagen suchen...",
            templateListAllCategories: "Alle Kategorien",
            templateListAllStatus: "Alle Status",
            templateListStatusApproved: "Genehmigt",
            templateListStatusPending: "In Überprüfung",
            templateListStatusRejected: "Abgelehnt",
            templateListRefresh: "Aktualisieren",
            templateListTotalTemplates: "Gesamt {count} Vorlagen",
            templateListCopied: "Kopiert!",
            templateListCopy: "Kopieren",
            templateListIdLabel: "ID:",
            templateListPreview: "Vorschau",
            templateListEdit: "Bearbeiten",
            templateListDelete: "Löschen",
            templateListPreviewTitle: "Vorlagenvorschau",
            templateListNameLabel: "Name:",
            templateListCategoryLabel: "Kategorie:",
            templateListLanguageLabel: "Sprache:",
            templateListStatusLabel: "Status:",
            templateListReasonLabel: "Grund:",
            templateListRecommendationLabel: "Empfehlung:",
            templateListColumnName: "VORLAGENNAME",
            templateListColumnCategory: "KATEGORIE",
            templateListColumnStatus: "STATUS",
            templateListColumnLastEdited: "ZULETZT BEARBEITET",
            templateListStatusActive: "Aktiv",
            templateListStatusInReview: "In Überprüfung",
            templateListStatusRejected: "Abgelehnt",
            templateListStatusFailed: "Fehlgeschlagen",
            templateListQualityHigh: "Hohe Qualität",
            templateListQualityMedium: "Mittlere Qualität",
            templateListQualityLow: "Niedrige Qualität",
            templateListDeleteConfirmTitle: "Vorlage löschen",
            templateListDeleteConfirmContent: "Möchten Sie \"{{name}}\" wirklich löschen?",
            templateListDeleteConfirmOk: "Löschen",
            templateListDeleteConfirmCancel: "Abbrechen",
            templateListCopyIdError: "Beim Kopieren der ID ist ein Fehler aufgetreten",
            templateListDeletedSuccess: "{{name}} wurde erfolgreich gelöscht.",
            templateListDeleteFailed: "Vorlage konnte nicht gelöscht werden.",
            templateNameRules: "Der Vorlagenname darf nur Kleinbuchstaben, Zahlen und Unterstriche enthalten.",
            category: "Kategorie",
            categoryDesc: "Wählen Sie aus, welche Art von Vorlage Sie erstellen möchten",
            categoryUtility: "Dienstprogramm",
            categoryUtilityDesc: "Senden Sie nützliche Informationen wie Kontoupdates, Bestellupdates, Warnungen und mehr.",
            categoryMarketing: "Marketing",
            categoryMarketingDesc: "Senden Sie Werbeangebote, Produktangebote und mehr, um die Aufmerksamkeit und Interaktion zu erhöhen.",
            categoryAuth: "Authentifizierung",
            categoryAuthDesc: "Senden Sie Codes, damit Ihre Kunden auf ihre Konten zugreifen können.",
            optional: "Optional",
            languageDesc: "Wählen Sie die Sprache aus, in der Ihre Vorlagennachricht gesendet wird",
            header: "Header",
            headerRules: "Fügen Sie Ihrer Nachricht einen 60 Zeichen langen Header hinzu. Im Header wird nur eine Variable unterstützt.",
            headerOptionMedia: "Medien",
            headerOptionText: "Text",
            none: "Keiner",
            headerType: "Headertyp",
            headerText: "Headertext",
            body: "Körper",
            bodyRules: "Geben Sie den Text in der von Ihnen für Ihre Nachricht ausgewählten Sprache ein",
            addVariable: "Variable hinzufügen",
            variables: "Variablen",
            variable: "Variable",
            defaultVariableName: "Standardvariablenname",
            defaultVariableToolTip: "Ihre Variable erscheint im Template mit diesem Namen. <br><br> Darüber hinaus wird dieser Wert als Standardwert gesendet, falls andere Situationen auftreten.",
            selectATemplate: "Wählen Sie eine Nachrichtenvorlage",
            variableSettings: "Variablen-Einstellungen",
            example: "Beispiel",
            footer: "Fußzeile",
            footerDesc: "Fügen Sie Ihrer Nachricht eine Fußzeile mit 60 Zeichen hinzu. Variablen werden in der Fußzeile nicht unterstützt.",
            buttons: "Schaltflächen",
            buttonType: "Schaltflächentyp",
            buttonTypeReply: "Antworten",
            submit: "Speichern",
            submitting: "Wird übermittelt",
            addButton: "Schaltfläche hinzufügen",
            rejectWhatsapp: "Von Whatsapp abgelehnt.",
            approvedWhatsapp: "Von Whatsapp genehmigt.",
            pendingWhatsapp: "Ausstehende Genehmigung",
            daily_usages: "Tägliche Verbräuche",
            bussinesDesciption: "Bussines Açıklama ",
            stateIfApplic: "State (if applicable)",
            selectBussVertical: "Select business area",
            succesDesc: "Profil bilgileriniz başarılı bir şekilde güncellendi.",
            faieldUpdateChannel: "Failed to update channel",
            completeSetup: "Einrichtung abschließen",
            completeSetupDescription:
                "Um die WhatsApp Business API-Einrichtung abzuschließen, klicken Sie bitte auf die Schaltfläche unten, um zur Verbindungsseite zu gelangen.",
            connectWhatsAppBusinessAccount: "WhatsApp Business-Konto verbinden",
            infoLabel: "Information",
            onboardingInfoDescription:
                "Ihr Facebook Business-Konto und Ihre WhatsApp-Nummer müssen für die WhatsApp Business API-Einrichtung bereit sein.",
            businessId: "Business-ID",
            phoneNumberId: "Telefonnummer-ID",
            wabaId: "WABA-ID",
            verifiedNameLabel: "Verifizierter Name",
            userAccessibility: "Benutzerzugriff",
            userAccessibilityDesc:
                "Die unten angegebenen Personen können Kontakte und Chats in diesem Kanal sehen (kein Zugriff bei gesetzter Inhaberschaft). Diese Einstellung wird verwendet in: <ul><li><strong>Automatische Chat-Zuweisung:</strong> Eingehende Kunden werden nach Sichtbarkeit zugewiesen; Chats werden nicht an Personen ohne Zugriff vergeben</li><li><strong>Weiterleitung:</strong> Weiterleitung eines Chats oder Hinzufügen eines weiteren Agenten muss mit diesen Einstellungen übereinstimmen; Weiterleitung an Unbefugte ist nicht erlaubt</li><li><strong>Kontakt-/Kundenlisten:</strong> Die angezeigten Listen basieren auf dieser Einstellung</li><li><strong>Inhaberschaft:</strong> Sie können einen Kunden einem Agenten innerhalb dieser Einstellung zuweisen</li></ul>",
            makePublicButton: "Öffentlich machen",
            channelOwners: "Kanalinhaber",
            channelOwnersDesc:
                "Kanalinhaber dürfen alle Unterhaltungen in diesem Kanal einsehen. Sie können alle Nachrichten unabhängig von den Sichtbarkeitseinstellungen lesen.",
            editChannelOwners: "Kanalinhaber bearbeiten",
            selectChannelOwner: "Kanalinhaber auswählen",
            selectChannelOwnerDesc: "Wählen Sie die Agenten, die diesen Kanal besitzen sollen",
            makePublicConfirmTitle: "Möchten Sie diesen Kanal wirklich öffentlich machen?",
            makePublicConfirmContent: "Nach dieser Aktion können alle Agenten die Unterhaltungen in diesem Kanal einsehen.",
            makePublicConfirmOk: "Ja, öffentlich machen",
            makePublicSuccessMessage: "Der Kanal wurde öffentlich gemacht",
            stepSetupTemplate: "Vorlage einrichten",
            stepEditTemplate: "Vorlage bearbeiten",
            stepSubmitReview: "Zur Überprüfung einreichen",
            templateNameAndLanguage: "Vorlagenname und Sprache",
            editModeNoticeText: "Im Bearbeitungsmodus können Vorlagenname und Sprache nicht geändert werden. Nur Kategorie (wenn nicht genehmigt), Komponenten und Time-to-Live sind bearbeitbar.",
            nameYourTemplate: "Geben Sie Ihrer Vorlage einen Namen",
            enterTemplateNamePlaceholder: "Vorlagenname eingeben",
            selectLanguage: "Sprache auswählen",
            content: "Inhalt",
            footerOptional: "Fußzeile • Optional",
            enterTextPlaceholder: "Text eingeben",
            bodyLabel: "Body",
            bodyPlaceholder: "Geben Sie Ihren Nachrichtentext ein",
            bold: "Fett",
            italic: "Kursiv",
            strikethrough: "Durchgestrichen",
            headerLabelRecommended: "Empfohlen",
            headerLabelOptionalTextOnly: "Optional (nur Text)",
            headerLabelRequiredProduct: "Erforderlich (Produkt)",
            headerLabelOptional: "Optional",
            headerNone: "Keine",
            headerTextOption: "Text",
            headerDocument: "Dokument",
            headerProduct: "Produkt",
            productHeaderAutoSet: "Produktkopf wird automatisch bei Produktvorlagen gesetzt.",
            headerTextPlaceholder: "Fügen Sie eine kurze Textzeile zur Kopfzeile Ihrer Nachricht hinzu",
            mediaHintNote: "Hinweis:",
            mediaHintIntro: "Folgende Dateiformate und -größen werden akzeptiert:",
            mediaHintImage: "Bild: JPEG, PNG (Max. 5 MB)",
            mediaHintVideo: "Video: MP4 (Max. 16 MB)",
            mediaHintDocument: "Dokument: PDF (Max. 100 MB)",
            productHeaderAutoInfo: "Produktkopf wird automatisch aus Ihrem Katalog hinzugefügt.",
            carouselContentDescription: "Erstellen Sie zwei Nachrichten: zuerst den allgemeinen Text (Body), dann die Karussell-Karten. Jede Karte kann eigenen Body-Text (optional) und Buttons (mind. 1) haben.",
            contentDescriptionProduct: "Fügen Sie Body-Text für Ihre Produktnachrichtenvorlage hinzu. Produktkopf wird aus dem Katalog hinzugefügt.",
            contentDescriptionLTO: "Fügen Sie Kopf und Body für Ihre zeitlich begrenzte Angebotsvorlage hinzu. Fußzeile wird bei diesem Typ nicht unterstützt.",
            contentDescriptionCarousel: "Fügen Sie allgemeinen Body-Text und Karussell-Karten hinzu. Jede Karte hat eigenen Kopf, optionalen Body und Buttons.",
            contentDescriptionDefault: "Fügen Sie Kopf, Body und Fußzeile für Ihre Vorlage hinzu.",
            readyToSubmit: "Bereit zum Einreichen",
            submitReviewDescription: "Ihre Vorlage wird zur Meta-Überprüfung eingereicht. Dauert in der Regel Minuten, bis zu 24 Stunden.",
            bodyContentAdded: "Body-Inhalt hinzugefügt",
            buttonsAddedCount: "{count} Buttons hinzugefügt",
            previous: "Zurück",
            discard: "Verwerfen",
            next: "Weiter",
            submitForReview: "Zur Überprüfung einreichen",
            updateTemplate: "Vorlage aktualisieren",
            cannotProceed: "Fortfahren nicht möglich",
            noChangesReason: "Es wurden keine Änderungen an der Vorlage vorgenommen. Bitte mindestens eine Änderung vornehmen.",
            categoryCannotChangeWarning: "Die Kategorie genehmigter Vorlagen kann nicht geändert werden.",
            setupYourTemplate: "Richten Sie Ihre Vorlage ein",
            setupDescription: "Wählen Sie die Kategorie, die Ihre Nachrichtenvorlage am besten beschreibt. Dann den Nachrichtentyp.",
            learnMoreCategories: "Mehr zu Kategorien.",
            marketing: "Marketing",
            utility: "Utility",
            authentication: "Authentifizierung",
            categoryCannotChangeApproved: "Kategorie kann bei genehmigten Vorlagen nicht geändert werden",
            categoryCannotEditApproved: "Kategorie kann bei genehmigten Vorlagen nicht bearbeitet werden. Nur Komponenten und Time-to-Live.",
            notSupported: "Nicht unterstützt",
            selectProductMessageType: "Produktnachrichtentyp auswählen",
            selectOtpAutofillType: "OTP-Autofill-Typ auswählen",
            templatePreview: "Vorlagenvorschau",
            previewAlt: "Vorschau",
            previewAltCallPermission: "Anruferlaubnis anfordern",
            previewSampleCard: "Beispielkarte",
            previewCardPreview: "Kartenvorschau",
            previewBodyMarketingDefault: "Hallo! Entdecken Sie unsere frischen Lebensmittel! Nutzen Sie den Code HEALTH für 10 % Rabatt.",
            previewBodyCarouselStep0: "Entdecken Sie unsere Produkte! Wischen Sie für tolle Angebote.",
            previewSpecialOffer: "Sonderangebot",
            previewEndsIn2Days: "Endet in 2 Tagen",
            previewExpiresLabel: "Läuft ab: ",
            previewSeeAllOptions: "Alle Optionen anzeigen",
            previewBodyLto: "Jetzt! 2 kaufen, 1 gratis bei unserer neuen Seifenkollektion.",
            previewWinterSaleHeader: "Unser Winterschlussverkauf läuft!",
            previewBodyCoupon: "Shoppen Sie bis Ende Dezember und nutzen Sie den Code WINTER25 für 25 % Rabatt!",
            previewViewBizCatalog: "{BIZ_NAME}s Katalog auf WhatsApp ansehen",
            previewBrowseCatalogueDetails: "Bilder und Details der Angebote durchsuchen.",
            previewBodyCatalogue: "Jetzt Ihre Lieblingsprodukte auf WhatsApp kaufen! Katalog durchstöbern.",
            previewBodyCatalogueSingle: "Entdecken Sie dieses Produkt! Perfekt für Ihre Bedürfnisse.",
            previewBodyCatalogueMulti: "Etwas vergessen? Diese Artikel haben Sie im Warenkorb gelassen.",
            previewBodyCatalogueCarousel: "Entdecken Sie unsere neuesten Produkte! Katalog durchsuchen.",
            previewBodyUtility: "Gute Nachricht! Ihre Bestellung 23KFEJJ2312 wurde versendet! Sendungsverfolgung unten.",
            previewBodyAuth: "123456 ist Ihr Bestätigungscode. Teilen Sie diesen Code aus Sicherheitsgründen nicht.",
            previewBodyPlaceholder: "Ihr Nachrichtentext erscheint hier",
            previewBodyCarouselPlaceholder: "Ihr Karussell-Nachrichtentext erscheint hier",
            previewButtonN: "Button {n}",
            previewProductNDescription: "Produkt {n} Beschreibung",
            previewTemplateGoodFor: "Diese Vorlage eignet sich für",
            previewTemplateAreasCustomise: "Anpassbare Vorlagenbereiche",
            previewDescCatalogue: "Produkt-/Service-Entdeckung, Verkauf, Angebote, gezieltes Marketing",
            previewDescCoupon: "Aktionscodes mit Kopier-Button senden. Nur ein Kopier-Button.",
            previewDescCarousel: "Mehrere Produkte oder Dienstleistungen in scrollbarer Ansicht. Jede Karte mit Bild, Text und Buttons.",
            previewDescMarketing: "Willkommensnachrichten, Aktionen, Gutscheine, Newsletter",
            previewDescUtility: "Bestellbestätigungen, Kontoupdates, Belege, Erinnerungen",
            previewDescAuth: "Einmalpasswort, Kontowiederherstellung, Verifizierung",
            previewCustomisableCallPermission: "Kopfzeile, Text, Fußzeile",
            previewCustomisableCoupon: "Kopfzeile (Text), Text, Button (außer Kopier-Text)",
            previewCustomisableCarousel: "Allgemeiner Text, Karussell-Karten",
            previewCustomisableMarketing: "Medien, Kopfzeile, Text, Fußzeile, Button",
            previewCustomisableUtility: "Kopfzeile, Text, Fußzeile",
            previewCustomisableAuth: "Text",
            productMessage: "Produktnachricht",
            callUs: "Rufen Sie uns an",
            unsubscribe: "Abmelden",
            trackShipment: "Sendung verfolgen",
            choosePreference: "Präferenz wählen",
            autoVerify: "Auto-Verifizierung",
            yourTemplateNamePlaceholder: "ihr_vorlagenname",
            templateNameLabel: "Vorlagenname",
            categoryLabel: "Kategorie",
            languageLabel: "Sprache",
            templateCreatedSuccess: "Vorlage erfolgreich erstellt und zur Überprüfung eingereicht!",
            templateUpdatedSuccess: "Vorlage erfolgreich aktualisiert!",
            mediaUploadedSuccess: "Medien erfolgreich hochgeladen",
            mediaUploadFailedPrefix: "Medien-Upload fehlgeschlagen: ",
            nameRequired: "Vorlagenname ist erforderlich",
            nameInvalidChars: "Nur Kleinbuchstaben, Zahlen und Unterstriche sind erlaubt",
            nameMaxLength: "Vorlagenname darf maximal 512 Zeichen haben",
            bodyRequired: "Body-Inhalt ist erforderlich",
            ltoRequiresOneButton: "Zeitlich begrenztes Angebot erfordert mindestens einen Button",
            ltoRequiresUrlButton: "Zeitlich begrenztes Angebot erfordert einen URL-Button",
            carouselRequiresOneCard: "Karussell-Vorlage erfordert mindestens eine Karte",
            cardMustHaveButton: "Karte {index} muss mindestens einen Button haben",
            cardMustHaveHeaderMedia: "Karte {index} muss ein Kopfbild oder -video haben",
            ltoUrlButtonCannotRemove: "Zeitlich begrenztes Angebot erfordert mindestens einen URL-Button, der nicht entfernt werden kann",
            ltoRequiresOneButtonWarning: "Zeitlich begrenztes Angebot erfordert mindestens einen Button",
            copyCodeButtonRequired: "Code-kopieren-Button ist für Gutschein-Vorlagen erforderlich und kann nicht entfernt werden",
            carouselCardMustHaveButton: "Jede Karussell-Karte muss mindestens einen Button haben",
            imageMaxSize: "Bild muss kleiner als 5 MB sein",
            videoMaxSize: "Video muss kleiner als 16 MB sein",
            documentMaxSize: "Dokument muss kleiner als 100 MB sein",
            fileUploadFailed: "Datei-Upload fehlgeschlagen",
            uploadFileLoading: "Datei wird hochgeladen...",
            templateTypeDefault: "Standard",
            templateTypeDefaultDesc: "Senden Sie Nachrichten mit Medien und angepassten Buttons, um Kunden zu erreichen.",
            templateTypeLimitedTimeOffer: "Zeitlich begrenztes Angebot",
            templateTypeLimitedTimeOfferDesc: "Erzeugen Sie Dringlichkeit mit zeitlich begrenzten Aktionen und Angebotscodes.",
            templateTypeCarousel: "Karussell",
            templateTypeCarouselDesc: "Senden Sie ein Karussell von Karten mit Bildern und Buttons für mehrere Produkte oder Angebote.",
            templateTypeProductMessage: "Produktnachricht",
            templateTypeProductMessageDesc: "Senden Sie Nachrichten, die Verkäufe fördern, indem Sie Ihren Produktkatalog verbinden.",
            templateTypeCallPermission: "Anruferlaubnis anfragen",
            templateTypeCallPermissionDesc: "Fragen Sie Kunden, ob Sie sie auf WhatsApp anrufen dürfen.",
            templateTypeCouponCode: "Gutscheincode",
            templateTypeCouponCodeDesc: "Senden Sie Aktionscodes mit Kopier-Button zur einfachen Einlösung.",
            templateTypeUtilityDefault: "Standard",
            templateTypeUtilityDefaultDesc: "Senden Sie Nachrichten zu bestehender Bestellung oder Konto.",
            templateTypeOtp: "Einmalpasswort",
            templateTypeOtpDesc: "Senden Sie Codes zur Verifizierung einer Transaktion oder Anmeldung.",
            catalogueSubtypeCatalogue: "Katalognachricht",
            catalogueSubtypeCatalogueDesc: "Zeigen Sie Ihren vollständigen Produktkatalog mit Katalog-Button.",
            catalogueSubtypeMultiProduct: "Multi-Produkt-Nachricht",
            catalogueSubtypeMultiProductDesc: "Zeigen Sie bis zu 30 Produkte aus Ihrem Katalog in einer Nachricht.",
            catalogueSubtypeSingleProduct: "Einzelprodukt-Nachricht",
            catalogueSubtypeSingleProductDesc: "Heben Sie ein Produkt mit Details und Call-to-Action-Button hervor.",
            catalogueSubtypeProductCardCarousel: "Produktkarten-Karussell",
            catalogueSubtypeProductCardCarouselDesc: "Zeigen Sie bis zu 10 Produktkarten im Karussell.",
            catalogueSubtypeDisabledReason: "Derzeit nicht unterstützt. Dieser Vorlagentyp erfordert eine Produktkatalog-Integration.",
            authSubtypeCopyCode: "Code kopieren",
            authSubtypeCopyCodeDesc: "Der Benutzer kopiert den Code manuell (Standard-OTP).",
            authSubtypeOneTap: "One Tap",
            authSubtypeOneTapDesc: "Code mit einem Tippen auf unterstützten Android-Geräten automatisch ausfüllen.",
            authSubtypeZeroTap: "Zero Tap",
            authSubtypeZeroTapDesc: "Code automatisch ohne Benutzerinteraktion ausfüllen (erfordert Benutzereinwilligung).",
            viewCatalog: "Katalog anzeigen",
            viewProduct: "Produkt anzeigen",
            viewProducts: "Produkte anzeigen",
            view: "Anzeigen",
            copyOfferCode: "Angebotscode kopieren",
            oneTapAutofill: "One Tap Autofill",
            zeroTapAutofill: "Zero Tap Autofill",
            shopNow: "Jetzt einkaufen",
            viewItems: "Artikel anzeigen",
            autofill: "Autofill",
            messageTtlOptional: "Nachrichten-Time-to-Live (TTL) • Optional",
            selectTtlPlaceholder: "TTL wählen oder Standard belassen",
            ttlDescMarketing: "Wenn wir Ihre Marketingnachricht nicht zustellen können, versuchen wir es für die angegebene Dauer erneut.",
            ttlDescUtility: "Legen Sie fest, wie lange wir Utility-Nachrichten (z. B. Bestellbestätigungen) zustellen.",
            ttlDescAuthentication: "Definieren Sie, wie lange Authentifizierungscodes für die Zustellung gültig sind.",
            ttlInfoMarketing: "Marketing-Vorlagen: 12 Stunden bis 30 Tage. Standard systemdefiniert.",
            ttlInfoUtility: "Utility-Vorlagen: 30 Sekunden bis 12 Stunden oder -1 für 30 Tage. Standard systemdefiniert.",
            ttlInfoAuthentication: "Authentifizierungsvorlagen: 30 Sekunden bis 15 Minuten oder -1 für 30 Tage. Standard systemdefiniert.",
            ttlOption12Hours: "12 Stunden (43.200 Sekunden)",
            ttlOption1Day: "1 Tag (86.400 Sekunden)",
            ttlOption3Days: "3 Tage (259.200 Sekunden)",
            ttlOption7Days: "7 Tage (604.800 Sekunden)",
            ttlOption15Days: "15 Tage (1.296.000 Sekunden)",
            ttlOption30Days: "30 Tage (2.592.000 Sekunden)",
            ttlOption30Seconds: "30 Sekunden",
            ttlOption1Minute: "1 Minute (60 Sekunden)",
            ttlOption2Minutes: "2 Minuten (120 Sekunden)",
            ttlOption3Minutes: "3 Minuten (180 Sekunden)",
            ttlOption5Minutes: "5 Minuten (300 Sekunden)",
            ttlOption10Minutes: "10 Minuten (600 Sekunden)",
            ttlOption15Minutes: "15 Minuten (900 Sekunden)",
            ttlOption30Minutes: "30 Minuten (1.800 Sekunden)",
            ttlOption1Hour: "1 Stunde (3.600 Sekunden)",
            ttlOption2Hours: "2 Stunden (7.200 Sekunden)",
            ttlOption4Hours: "4 Stunden (14.400 Sekunden)",
            ttlOption6Hours: "6 Stunden (21.600 Sekunden)",
            ttlOption30DaysSpecial: "30 Tage (Sonderwert: -1)",
            authSettings: "Authentifizierungseinstellungen",
            addSecurityRecommendation: "Sicherheitshinweis hinzufügen",
            securityRecommendationHint: "Fügt die Meldung „Teilen Sie diesen Code aus Sicherheitsgründen nicht“ hinzu.",
            authMessageTtlHint: "Zeitlimit für die Nachrichtenzustellung (60-600 Sekunden). Leer lassen für Standard.",
            authTtlPlaceholder: "60-600",
            authCodeExpPlaceholder: "1-90",
            authPackagePlaceholder: "com.example.app",
            authSignatureHash: "Signatur-Hash",
            messageTtlSecondsOptional: "Nachrichten-TTL (Sekunden) • Optional",
            codeExpirationOptional: "Codeablauf (Minuten) • Optional",
            codeExpirationHint: "Wie lange der OTP-Code gültig ist. Wird in der Fußzeile angezeigt.",
            zeroTapTerms: "Ich akzeptiere die Zero-Tap-Bedingungen",
            zeroTapTermsHint: "Erforderlich für Zero-Tap-Autofill.",
            supportedAndroidAppsOptional: "Unterstützte Android-Apps • Optional",
            addApp: "App hinzufügen",
            limitedTimeOfferLabel: "Zeitlich begrenztes Angebot",
            ltoDescription: "Fügen Sie Text hinzu, der Dringlichkeit erzeugt. Ablaufzeit wird beim Senden gesetzt.",
            ltoPlaceholder: "z. B. Angebot läuft ab!, Flash-Verkauf!",
            showExpirationTimer: "Ablauf-Timer anzeigen",
            ltoExpirationHint: "Wenn aktiviert, zeigt WhatsApp einen Countdown basierend auf dem Sendezeitpunkt.",
            carouselCards: "Karussell-Karten",
            carouselCardsDescription: "Diese Karten erscheinen als zweite Nachricht nach dem allgemeinen Body-Text. Jede Karte muss Bild-/Video-Kopf und mindestens einen Button (bis 2) haben. Karten-Body ist optional und unterstützt Variablen. Bis zu 10 Karten.",
            carouselCardN: "Karte {n}",
            carouselButtonsLabel: "Buttons * (mind. 1, max. 2)",
            cardHeaderRequired: "Kartenkopf",
            cardBodyOptional: "Kartenbody • Optional",
            cardBodyPlaceholder: "Kartenbody-Text eingeben (optional)",
            image: "Bild",
            video: "Video",
            moveUp: "Nach oben",
            moveDown: "Nach unten",
            remove: "Entfernen",
            dragDropUpload: "Zum Hochladen ziehen und ablegen",
            orChooseFiles: "Oder Dateien auf dem Gerät auswählen",
            uploadingToMeta: "Wird zu Meta hochgeladen...",
            uploadedSuccessfully: "Erfolgreich hochgeladen",
            addQuickReplyButton: "Schnellantwort-Button hinzufügen",
            addCtaButton: "CTA-Button hinzufügen",
            urlButtonRequiredLto: "URL-Button ist für zeitlich begrenztes Angebot erforderlich",
            copyCodeButtonFixed: "Button-Text „Code kopieren“ kann bei Gutscheinvorlagen nicht angepasst werden",
            copyCode: "Code kopieren",
            fixed: "Fest",
            buttonsHeading: "Buttons",
            buttonLabelAutoAdded: "Automatisch hinzugefügt",
            buttonLabelRequiredCopyCode: "Erforderlich (1 Code kopieren + optional)",
            buttonLabelRequiredUrl: "Erforderlich (1 URL + optional)",
            buttonLabelOptional: "Optional",
            buttonDescCatalogue: "Ein Produktbutton wird automatisch hinzugefügt. Sie können den Button-Text anpassen.",
            buttonDescCallPermission: "Ein Anruferlaubnis-Button wird automatisch hinzugefügt. Keine weiteren Buttons möglich.",
            buttonDescAuth: "Ein Authentifizierungs-Button wird automatisch hinzugefügt. Sie können den Button-Text anpassen.",
            buttonDescCoupon: "Ein Button „Code kopieren“ ist erforderlich, der Text ist nicht anpassbar. Sie können bis zu 10 Schnellantwort- oder CTA-Buttons hinzufügen.",
            buttonDescLto: "Zeitlich begrenzte Angebote erfordern mindestens einen URL-Button. Sie können weitere CTA- oder Schnellantwort-Buttons hinzufügen.",
            buttonDescDefault: "Fügen Sie Schnellantwort- oder CTA-Buttons hinzu. Maximal 10 Buttons insgesamt.",
            buttonPlaceholderText: "Button-Text",
            buttonMax10Warning: "Maximal 10 Buttons erlaubt",
            buttonCopyCodeAutoAddedWarning: "Der Button „Code kopieren“ wird automatisch hinzugefügt und kann nicht manuell hinzugefügt werden",
            exampleValuePlaceholder: "beispielwert",
            copyCodeExamplePlaceholder: "SUMMER20",
            quickReply: "Schnellantwort",
            visitWebsite: "Website besuchen",
            callPhone: "Anrufen",
            addCard: "Karte hinzufügen",
            addButton: "Button hinzufügen",
            reports: "Raporlar",
            dynamicUrlSampleNote: "Sample dynamic URL with variable (Note: Do not add the URL in your sample message body above)",
            bussinesDescription: "Business description",
            postacellMessagepostacellMessage: "Envoyer un SMS"
        },
        multi_whatsapp_api: {
            profile: "Profil",
            integration: "Integration",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            templates: "Alle Vorlagenmeldungen",
            settings_group: "Einstellung",
            template_message_group: "Vorlagennachrichten",
            new_template: "Neue Vorlage erstellen",
            broadcast_group: "Bulk-Nachricht",
            broadcast_requests: "Massenversand von Nachrichten",
            customer_groups: "Kundengruppen",
            chat_initiator_template: "Chat-Initiator-Vorlage",
            contacts: "Kontakte",
            numbers: "Nummern",
            all_contacts: "Alle Kontakte"
        },
        archive: {
            destroyedBy: {
                agent: "Vertreter",
                visitor: "Besucher",
                system: "System",
                chatbot: "Chatbot"
            }
        },
        upgradeMessages: {
            ticket: "Auch wenn Sie offline sind, werden Ihre Anfragen sofort mit künstlicher Intelligenz und Chatbot erfasst. Halten Sie Ihre Kunden immer zufrieden!",
            tasks: "Verwalten Sie Ihre Aufgaben und Projekte einfach. Arbeiten Sie mit Ihren Teammitgliedern zusammen und liefern Sie Ihre Projekte rechtzeitig!",
            calendar: "Planen Sie Ihre Termine und Besprechungen einfach. Synchronisieren Sie sich mit Ihren Teammitgliedern und nutzen Sie Ihre Zeit effizienter!",
            mail_integration: "Verwalten Sie Ihre E-Mails einfach. Stärken Sie die Kommunikation mit Ihren Kunden und steigern Sie die Zusammenarbeit!",
            team_integration: "Kommunizieren Sie schneller und effektiver mit Ihrem Team. Steigern Sie die Zusammenarbeit und liefern Sie Ihre Projekte rechtzeitig!",
            webhook_integration: "Verknüpfen Sie Ihre Anwendungen mit Webhook-Integration und erleichtern Sie den Datenaustausch!",
            whatsapp_v2: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            whatsapp: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            whatsapp_business_api: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über WhatsApp-Integration!",
            instagram: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Instagram-Integration!",
            messenger: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Messenger-Integration!",
            sms_postacell: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über SMS-Integration!",
            ready_contents: "Mit fertigen Inhalten können Sie die Kommunikation mit Ihren Kunden schneller und effektiver gestalten.",
            automation: "Automatisieren Sie Ihre Aufgaben mit Automatisierung. Verwalten Sie Ihre Arbeit schneller und effektiver!",
            form: "Formularerstellung ermöglicht eine schnellere und effektivere Kommunikation mit Ihren Kunden. Sammeln Sie mehr Informationen von Ihren Kunden und steigern Sie die Zusammenarbeit!",
            customer_tables: "Erstellen Sie mit Customer Tables Ihre eigene Tabelle und speichern und verwalten Sie Kundeninformationen schnell und einfach!",
            trendyol: "Kommunizieren Sie schneller und effektiver mit Ihren Kunden über Trendyol-Integration!",
            access_control: "Schützen Sie Ihre Daten und blockieren Sie böswillige Benutzer mit Access Control!",
            upgrade: "Mein Abonnement upgraden",
            upgradeFeature: "Zusätzliches Paket kaufen",
            featureNotAvailable: "Ihre Funktion ist nicht verfügbar.",
            usageLimitExceeded: "Nutzungsgrenze überschritten.",
            maxAgentCount: "Erweitern Sie Ihr Paket, um mehr Kunden durch zusätzliche Agenten zu betreuen.",
            maxTriggerCount: "Erweitern Sie Ihr Paket, um mehr Interaktionen durch zusätzliche Trigger zu erstellen.",
            visitorStartChat: "Erweitern Sie Ihr Paket, um Chats mit Besuchern zu starten, die zuvor nicht interagiert haben.",
            voiceCalling: "Erweitern Sie Ihr Paket, um effektiver mit Kunden per Sprachanruf zu kommunizieren.",
            videoCalling: "Erweitern Sie Ihr Paket, um effektiver mit Kunden per Videoanruf zu kommunizieren.",
            fileAndVoiceMessage: "Erweitern Sie Ihr Paket, um Dateien und Sprachnachrichten an Ihre Kunden zu senden.",
            autoTranslation: "Erweitern Sie Ihr Paket, um mit automatischer Übersetzung mehr Kunden zu erreichen.",
            telegramEntegration: "Erweitern Sie Ihr Paket, um die Telegram-Integration zu aktivieren.",
            chatCopilot: "Erweitern Sie Ihr Paket, um besseren Service mit dem KI-gestützten Chat Copilot zu bieten.",
            calenderEntegration: "Erweitern Sie Ihr Paket, um andere Anwendungen über die Kalenderintegration zu synchronisieren.",
            mailEntegration: "Erweitern Sie Ihr Paket, um E-Mails effizienter zu verwalten und die Kundenkommunikation zu verbessern.",
            smsEntegration: "Erweitern Sie Ihr Paket, um Kunden schneller über SMS zu erreichen.",
            ticketSystem: "Erweitern Sie Ihr Paket, um Kundenanfragen effizienter mit einem Ticketsystem zu verwalten.",
            taskManagementEntegration: "Erweitern Sie Ihr Paket, um Arbeitsabläufe mit Aufgabenmanagement-Integration zu optimieren.",
            webhookEntegration: "Erweitern Sie Ihr Paket, um andere Anwendungen über Webhook-Integration zu synchronisieren.",
            readyContents: "Erweitern Sie Ihr Paket, um die Kundenkommunikation mit vorgefertigten Inhalten zu verbessern.",
            automationEntegration: "Erweitern Sie Ihr Paket, um Arbeitsabläufe mit Automatisierungsintegration zu optimieren.",
            customerTablesEntegration: "Erweitern Sie Ihr Paket, um Kundendaten effizienter mit Kundentabellen zu verwalten.",
            formEntegration: "Erweitern Sie Ihr Paket, um Kundenanfragen effizienter mit Formularen zu verwalten.",
            maxFormLimit: "Erweitern Sie Ihr Paket, um mehr Formulare zu erstellen und Kundenanfragen effizienter zu verwalten.",
            maxFormFieldLimit: "Erweitern Sie Ihr Paket, um mehr Formularfelder hinzuzufügen und Kundenanfragen besser zu verwalten.",
            maxCustomerTableCount: "Erweitern Sie Ihr Paket, um mehr Kundentabellen hinzuzufügen.",
            maxCustomerTableFieldCount: "Erweitern Sie Ihr Paket, um mehr Felder in Kundentabellen hinzuzufügen.",
            maxCustomerTableViewCount: "Erweitern Sie Ihr Paket, um mehr Ansichten für Kundentabellen zu speichern.",
            maxCustomerTableRecordCount: "Erweitern Sie Ihr Paket, um mehr Einträge in Kundentabellen hinzuzufügen.",
            maxAutomationButton: "Erweitern Sie Ihr Paket, um mehr Automatisierungsblöcke hinzuzufügen.",
            automationTimerBase: "Erweitern Sie Ihr Paket, um Automatisierungstimer zu verwenden.",
            automationEventBase: "Erweitern Sie Ihr Paket, um Automatisierungsereignisse zu nutzen.",
            automationWebhookBase: "Erweitern Sie Ihr Paket, um Automatisierungs-Webhooks zu verwenden.",
            automationButtonBase: "Erweitern Sie Ihr Paket, um Automatisierungsschaltflächen zu verwenden.",
            liveScore: "Erweitern Sie Ihr Paket, um die Live-Überwachungsfunktion zu aktivieren.",
            multipleChatWindow: "Erweitern Sie Ihr Paket, um mehrere Chatfenster gleichzeitig zu öffnen.",
            maxTaskWorkflowLimit: "Erweitern Sie Ihr Paket, um mehr Aufgaben-Workflows hinzuzufügen.",
            maxTaskColumnLimit: "Erweitern Sie Ihr Paket, um mehr Aufgabenspalten hinzuzufügen.",
            maxTaskRowLimit: "Erweitern Sie Ihr Paket, um mehr Aufgabenreihen hinzuzufügen.",
            maxDepartmentLimit: "Erweitern Sie Ihr Paket, um mehr Abteilungen hinzuzufügen.",
            maxRoleLimit: "Erweitern Sie Ihr Paket, um mehr Rollen hinzuzufügen.",
            maxReadyContentsLimit: "Erweitern Sie Ihr Paket, um mehr vorgefertigte Inhalte hinzuzufügen.",
            excelDownload: "Erweitern Sie Ihr Paket, um die Excel-Download-Funktion zu aktivieren.",
            customerGroup: "Erweitern Sie Ihr Paket, um die Kundengruppen-Funktion zu nutzen.",
            maxMailCount: "Erweitern Sie Ihr Paket, um mehr E-Mails zu senden.",
            maxWhatsappChannel: "Erweitern Sie Ihr Paket, um mehr WhatsApp-Kanäle hinzuzufügen.",
            maxBusinessWhatsappChannel: "Erweitern Sie Ihr Paket, um mehr WhatsApp-Business-Kanäle hinzuzufügen.",
            maxInstagramChannel: "Erweitern Sie Ihr Paket, um mehr Instagram-Kanäle hinzuzufügen.",
            maxMessengerChannel: "Erweitern Sie Ihr Paket, um mehr Messenger-Kanäle hinzuzufügen.",
            maxTelegramChannel: "Erweitern Sie Ihr Paket, um mehr Telegram-Kanäle hinzuzufügen.",
            maxTrendyolChannel: "Erweitern Sie Ihr Paket, um mehr Trendyol-Kanäle hinzuzufügen.",
            maxMetaLeadChannel: "Erweitern Sie Ihr Paket, um mehr Meta-Lead-Kanäle hinzuzufügen."
        },
        setupWizard: {
            finishModalVideos: "Schulungsvideos",
            finishModalDoc: "Dokumentation",
            finsihModalLiveSupport: "Live-Support",
            completed: "Alles klar, verstanden",
            completedWarning: "Klicken Sie auf die Schaltfläche, um die Einrichtung abzuschließen und den Leitfaden zu beenden",
            supsisSetupGuide: "Supsis Einrichtungshandbuch",
            supsisSetupGuideDescription: "Bitte führen Sie diese Schritte aus, um Supsis vollständig zu nutzen.",
            goToSetup: "Zur Einrichtung gehen",
            completionPercentageDescription: "Sie nutzen nur % {percentage} der von Supsis angebotenen Funktionen.",
            aiChatbot: {
                title: "KI-Chatbot",
                content: "Antworten Sie automatisch, sofort und intelligent auf eingehende Nachrichten mit dem Supsis KI-Chatbot.",
                steps: {
                    step1: {
                        title: "Chatbot erstellen",
                        content: "Verwenden Sie diese Schaltfläche, um ein neues <b>Chatbot-Szenario</b> zu erstellen. Sie können entweder schnell mit einer der speziell für Sie vorbereiteten Vorlagen beginnen oder ein völlig originelles Szenario von Grund auf entwerfen, um einen Chatbot zu erstellen, der Ihren Geschäftsanforderungen vollständig entspricht."
                    },
                    step2: {
                        title: "Vorgefertigte Szenarien",
                        content: "Verstehen Sie die grundlegende Arbeitslogik des Chatbots einfach mit den <b>vorgefertigten Vorlagen</b> hier. Sparen Sie Zeit, indem Sie diese Vorlagen nach Ihren Bedürfnissen anpassen und maßgeschneiderte Lösungen entwickeln. Sie können mit einer der unten aufgeführten Vorlagen beginnen, die für verschiedene Anwendungsfälle geeignet sind."
                    },
                    step3: {
                        title: "Chatbot-Integrationen",
                        content: "Integrieren Sie Ihren vorbereiteten Chatbot mit <b>beliebten sozialen Medienplattformen wie WhatsApp, Instagram und Facebook</b>. Auf diese Weise können Sie Ihren Chatbot direkt auf den Kanälen aktivieren, die Ihre Kunden nutzen, und Ihre Erreichbarkeit und Engagement-Raten erhöhen."
                    },
                    step4: {
                        title: "Chatbot-Analysen",
                        content: "Sehen und analysieren Sie die <b>Leistung Ihres Chatbots mit detaillierten Diagrammen und Statistiken</b>. Durch Filterung nach bestimmten Zeiträumen oder den Plattformen, die Sie integriert haben, können Sie die Wirksamkeit Ihres Chatbots messen, Verbesserungsbereiche identifizieren und Ihre Strategien optimieren."
                    }
                }
            },
            aiAssistant: {
                title: "KI-Assistent",
                content: "Aktivieren Sie den digitalen Assistenten, um Ihrem Support-Team zu helfen.",
                steps: {
                    step1: {
                        title: "OpenAI-Integration",
                        content: "<p>Etablieren Sie eine <b>nahtlose Integration</b> zwischen OpenAI und Supsis KI, um Ihre Geschäftseffizienz zu steigern. Auf diese Weise wird Ihr leistungsstarker KI-Assistent aktiviert und beginnt, Ihre Prozesse zu optimieren. Um die Integration abzuschließen, müssen Sie nur Ihren OpenAI API-Schlüssel eingeben. <br> <br> <b>Um Ihren OpenAI API-Schlüssel zu erhalten, <a href='https://platform.openai.com/account/api-keys' target='_blank'>klicken Sie hier</a>.</b></p>"
                    }
                }
            },
            aiLiveSupport: {
                title: "KI Live-Support",
                content: "Aktivieren Sie das KI-gestützte Live-Chat-System.",
                steps: {
                    step1: {
                        title: "Gespräche filtern",
                        content: "Verwalten Sie <b>alle Kundengespräche</b> einfach aus diesem Bereich. Sie können Gespräche priorisieren, indem Sie sie in verschiedene Kategorien wie ungelesen, ausstehend oder solche, die mit dem Chatbot laufen, filtern und sicherstellen, dass keine Anfrage übersehen wird."
                    },
                    step2: {
                        title: "Detailliertere Ansicht",
                        content: "Verwenden Sie diese Optionen, um Kundengespräche tiefgreifender zu untersuchen. Sie können <b>detailliertere Filter</b> wie unbeantwortete Gespräche von gestern oder bestimmte Kunden, die Sie kontaktiert haben, anwenden oder Ihre eigenen benutzerdefinierten Filter erstellen, um Ihren Arbeitsablauf zu personalisieren."
                    },
                    step3: {
                        title: "Live-Support-Bildschirm",
                        content: "Wechseln Sie zu dieser Ansicht, um <b>alle Ihre Live-Support-Gespräche effizient von einem zentralisierten Bildschirm aus zu verwalten</b>. Sehen Sie alle Nachrichten, Agenten-Antworten, aktuelle Status und Datumsinformationen für jedes Gespräch an einem Ort und treffen Sie schnelle und genaue Entscheidungen."
                    },
                    step4: {
                        title: "Testseite",
                        content: "Greifen Sie auf diesen Bereich zu, um die Leistung und den Betrieb Ihres erstellten Chatbots in Echtzeit zu testen. Indem Sie Nachrichten als Besucher senden, können Sie <b>die Antworten und Verhaltensweisen Ihres Chatbots genau beobachten</b> und alle notwendigen Verbesserungen vornehmen, bevor Sie ihn den Endbenutzern präsentieren."
                    }
                }
            },
            aiAutomation: {
                title: "KI-Automatisierung",
                content: "Automatisieren Sie Ihre Support-Prozesse und sparen Sie Zeit.",
                steps: {
                    step1: {
                        title: "Neue Automatisierung erstellen",
                        content: "Verwenden Sie diese Schaltfläche, um eine neue Automatisierung zu erstellen und Ihre Geschäftsprozesse zu rationalisieren. Sie können Automatisierungen entwerfen, die ereignisbasiert (z.B. wenn eine neue Nachricht ankommt), zeitbasiert (z.B. jeden Morgen zu einer bestimmten Zeit) oder <b>Webhook-basiert</b> sind, um Ihre Arbeitsabläufe intelligenter zu gestalten."
                    },
                    step2: {
                        title: "Automatisierungskategorien",
                        content: "Wenn Sie viele Automatisierungen haben, erstellen Sie <b>Automatisierungskategorien</b> aus diesem Bereich, um die Verwaltung zu erleichtern. Die Kategorisierung hilft Ihnen, Ihre Automatisierungen organisiert zu halten und sie bei Bedarf schnell zu finden. Verwenden Sie diese Schaltfläche, um eine neue Kategorie zu erstellen."
                    },
                    step3: {
                        title: "Ausgeführte Aufgaben",
                        content: "Nachdem Sie Ihre Automatisierungen erstellt und veröffentlicht haben, können Sie <b>sofort verfolgen, wie viele Aufgaben Ihre Automatisierungen ausgeführt haben</b> aus diesem Bereich. Dies ermöglicht es Ihnen zu beobachten, wie aktiv Ihre Automatisierungen sind und welche Prozesse sie beeinflussen."
                    },
                    step4: {
                        title: "Automatisierungsstatistiken",
                        content: "Überprüfen Sie <b>umfassende Leistungsstatistiken</b> Ihrer Automatisierungen in diesem Bereich. Sehen Sie, wie oft jede Automatisierung läuft, die Anzahl erfolgreicher Aufgaben, die Erfolgsrate und eventuelle Fehlerquoten, um Ihre Automatisierungsstrategien zu optimieren."
                    }
                }
            },
            aiDynamicCrm: {
                title: "KI-CRM",
                content: "Analysieren und verwalten Sie Ihre Kundeninteraktionen mit künstlicher Intelligenz.",
                steps: {
                    step1: {
                        title: "Besucher filtern",
                        content: "Filtern Sie <b>Besucher</b> in Ihrer Kundendatenbank einfach. Sie können nach Besuchern anhand von Name, E-Mail-Adresse, Telefonnummer, Tag oder benutzerdefinierten Profilfeldern suchen. Sie können auch auf diesen Bereich für eine detailliertere Anzeige und Analyse zugreifen."
                    },
                    step2: {
                        title: "Besucher anzeigen",
                        content: "Alle Ihre Besucher sind in dieser Tabelle aufgelistet. <b>Doppelklicken Sie auf die entsprechende Zeile, um weitere Informationen zu erhalten und Aktionen für einen Besucher durchzuführen</b>. Im geöffneten Fenster können Sie auf die Kommunikationshistorie, Notizen und andere detaillierte Informationen des Besuchers zugreifen."
                    },
                    step3: {
                        title: "Manuelles Blockieren",
                        content: "Sie können <b>Besucher manuell blockieren</b>, die unerwünschtes oder unangemessenes Verhalten zeigen. Blockierte Besucher werden in einer separaten Liste angezeigt, und Sie können die Blockierung bei Bedarf aus diesem Bereich entfernen."
                    },
                    step4: {
                        title: "Tags",
                        content: "Machen Sie Ihr CRM organisierter und verwaltbarer, indem Sie <b>Ihre Besucher mit Tags kategorisieren</b>. Um Besuchern Tags zuzuweisen, müssen Sie zunächst Ihre eigenen Tags erstellen. Verwenden Sie diese Schaltfläche, um ein neues Tag zu erstellen."
                    },
                    step5: {
                        title: "Profilfelder",
                        content: "<b>Profilfelder</b> ermöglichen es Ihnen, zusätzliche Informationen über Ihre Besucher zu sammeln und diese Informationen organisiert zu verwalten. Auf diese Weise können Sie Ihre Kundensegmentierung vertiefen, personalisierten Service anbieten und Ihre Kundenbeziehungen effektiver gestalten."
                    }
                }
            },
            whatsappBusiness: {
                title: "WhatsApp Business",
                content: "Verwalten Sie Ihre Support-Nachrichten, indem Sie Ihr WhatsApp Business-Konto verbinden.",
                steps: {
                    step1: {
                        title: "WhatsApp Business-Integration",
                        content: "<p><b>Verbinden Sie Ihr WhatsApp Business-Konto mit Supsis</b> und verwalten Sie alle Ihre Kundensupport-Nachrichten von einem einzigen zentralen Panel aus. Mit dieser Integration können Sie Sofortnachrichten über WhatsApp senden, Massenmitteilungen machen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen umfassend verfolgen.</p>"
                    }
                }
            },
            whatsappWeb: {
                title: "WhatsApp Web",
                content: "Verwalten Sie über WhatsApp Web empfangene Nachrichten mit Supsis KI.",
                steps: {
                    step1: {
                        title: "WhatsApp Web-Integration",
                        content: "<p><b>Verwalten Sie nahtlos alle über WhatsApp Web empfangenen Nachrichten mit Supsis KI.</b> Mit dieser Integration können Sie Sofortnachrichten über WhatsApp senden, Massennachrichten erstellen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen einfach verfolgen. Auf diese Weise machen Sie Ihre Kundenkommunikation effizienter.</p>"
                    }
                }
            },
            instagram: {
                title: "Instagram",
                content: "Antworten Sie auf Instagram-DMs über Supsis KI.",
                steps: {
                    step1: {
                        title: "Instagram-Integration",
                        content: "<p><b>Zentralisieren Sie Ihre Kundenkommunikation, indem Sie direkt auf Instagram-DMs über Supsis KI antworten.</b> Mit dieser Integration können Sie Sofortnachrichten über Instagram senden, Massenmitteilungen machen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen umfassend verfolgen.</p>"
                    }
                }
            },
            facebook: {
                title: "Facebook",
                content: "Verwalten Sie Nachrichten von Ihrer Facebook-Seite in einem einzigen Panel.",
                steps: {
                    step1: {
                        title: "Facebook-Integration",
                        content: "<p><b>Verwalten Sie alle Nachrichten von Ihrer Facebook-Seite effektiv mit Supsis KI.</b> Mit dieser Integration können Sie Sofortnachrichten über Facebook Messenger senden, Massennachrichten erstellen, automatisierte Antworten einrichten und Ihre Kundeninteraktionen verfolgen.</p>"
                    }
                }
            },
            telegram: {
                title: "Telegram",
                content: "Integrieren Sie Telegram-Nachrichten mit Supsis KI.",
                steps: {
                    step1: {
                        title: "Telegram-Integration",
                        content: "<p><b>Integrieren Sie Telegram-Nachrichten mit Supsis KI</b> und verwalten Sie Ihre Kundenkommunikation von einem einzigen Panel aus. Mit dieser Integration können Sie Sofortnachrichten über Telegram senden, Massennachrichten erstellen, automatisierte Antworten einrichten und alle Ihre Kundeninteraktionen mühelos verfolgen.</p>"
                    }
                }
            },
            mail: {
                title: "E-Mail",
                content: "Integrieren Sie Ihre Support-E-Mails in das Supsis KI-System.",
                steps: {
                    step1: {
                        title: "Neue E-Mail erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um eine neue E-Mail zu senden. <b>Durch Ausfüllen des E-Mail-Inhalts, der Empfänger und anderer notwendiger Informationen</b> können Sie Ihre persönlichen oder Massen-E-Mails schnell versenden.</p>"
                    },
                    step2: {
                        title: "E-Mail-Vorlagen",
                        content: "<p><b>Verwalten Sie</b> Ihre E-Mail-Vorlagen aus diesem Bereich. Sie können Vorlagen bearbeiten, löschen oder neue erstellen. Durch die Verwendung vorgefertigter Vorlagen können Sie Ihre E-Mail-Versandprozesse beschleunigen und eine konsistente Kommunikation gewährleisten.</p>"
                    },
                    step3: {
                        title: "Massen-E-Mails senden",
                        content: "<p>Verwenden Sie diesen Bereich, um <b>Massen-E-Mails zu senden</b> und große Zielgruppen zu erreichen. Durch Ausfüllen der erforderlichen Felder können Sie einfach Massen-E-Mails an Ihre Kundenliste oder bestimmte Gruppen in Supsis senden.</p>"
                    },
                    step4: {
                        title: "Verwalten Sie Ihre Kundengruppen",
                        content: "<p><b>Verwalten Sie effektiv</b> Ihre Kundengruppen aus diesem Bereich. Sie können Gruppen bearbeiten, löschen oder neue erstellen. Mit diesen Gruppen können Sie gezielte E-Mail-Kampagnen organisieren und Ihre Kommunikation noch mehr personalisieren.</p>"
                    }
                }
            },
            metaLead: {
                title: "Meta Lead",
                content: "Verwalten Sie Formulare, die von Ihren Facebook- und Instagram-Anzeigen empfangen wurden.",
                steps: {
                    step1: {
                        title: "Meta Lead-Integration",
                        content: "<p>Mit der <b>Meta Lead-Integration</b> verwalten Sie potenzielle Kundenformulare, die von Ihren Facebook- und Instagram-Anzeigen empfangen wurden, direkt über Supsis. Dank dieser Integration können Sie die Leads, die Sie aus Ihren Werbekampagnen erhalten, effizienter verfolgen, Ihre Kommunikation mit potenziellen Kunden beschleunigen und Ihre Konversionsraten erhöhen.</p>"
                    }
                }
            },
            trendyol: {
                title: "Trendyol",
                content: "Verwalten Sie Ihre Trendyol-Bestellungen und Kundennachrichten.",
                steps: {
                    step1: {
                        title: "Trendyol-Integration",
                        content: "<p>Dank der <b>Trendyol-Integrationsvorgänge</b> verwalten Sie Ihre über Trendyol erhaltenen Bestellungen zentral über Supsis. Nach Abschluss dieser Integration können Sie Ihre Bestellprozesse effizienter gestalten, Ihre Kundenkommunikation erleichtern und Ihre operative Arbeitsbelastung reduzieren.</p>"
                    }
                }
            },
            formSurvey: {
                title: "Formular-Umfragen",
                content: "Erstellen Sie Formulare, um Feedback von Kunden zu sammeln.",
                steps: {
                    step1: {
                        title: "Neues Formular erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>ein neues Formular oder eine Umfrage zu erstellen</b>, um Feedback von Ihren Kunden zu sammeln. Mit den Formularen, die Sie erstellen, können Sie wertvolles Kundenfeedback sammeln und Ihre Kommunikation effizienter gestalten.</p>"
                    },
                    step2: {
                        title: "Verwalten Sie Ihre Formulare",
                        content: "<p><b>Verwalten Sie alle Ihre Formulare effektiv</b> aus diesem Bereich. Sie können Formulare bearbeiten, archivieren, löschen oder neue erstellen. Sie können auch die Leistung Ihrer veröffentlichten Formulare verfolgen, Antwortquoten anzeigen und bei Bedarf sofortige Bearbeitungen vornehmen. Mit der Formularverwaltung können Sie Kundenfeedback effektiver sammeln und analysieren.</p>"
                    }
                }
            },
            processManagement: {
                title: "Prozessmanagement",
                content: "Planen und verwalten Sie Ihre Support-Prozesse Schritt für Schritt.",
                steps: {
                    step1: {
                        title: "Verwalten Sie Ihre Geschäftsprozesse",
                        content: "<p>Dieser Bereich ermöglicht es Ihnen, alle Ihre Geschäftsprozesse effektiv zu verwalten. <b>Sie können Aufgaben erstellen, sie Ihren Teammitgliedern zuweisen und Ihre Arbeitsabläufe optimieren.</b> Auf diese Weise können Sie Ihre Prozesse effizienter gestalten, den Status von Aufgaben sofort verfolgen und die Leistung Ihres Teams steigern.</p>"
                    },
                    step2: {
                        title: "Aufgaben auflisten",
                        content: "<p><b>Zeigen Sie alle Ihre Aufgaben in einer Listenansicht</b> aus diesem Bereich an. Sie können Aufgaben filtern, löschen oder neue erstellen. Verfolgen Sie Ihre Arbeitsbelastung einfach mit einer umfassenden Listenansicht.</p>"
                    },
                    step3: {
                        title: "Aufgaben-Labels",
                        content: "<p><b>Erstellen Sie Labels</b>, um Ihre Aufgaben besser zu organisieren und zu verwalten. Durch die Verwendung dieser Labels können Sie Aufgaben einfach kategorisieren und Ihre Suchprozesse beschleunigen. Sie können diese Schaltfläche verwenden, um Labels zu erstellen.</p>"
                    },
                    step4: {
                        title: "Aufgaben archivieren",
                        content: "<p><b>Archivieren Sie abgeschlossene oder inaktive Aufgaben, um Ihren Arbeitsbereich organisiert zu halten</b>. Archivierte Aufgaben werden hier aufgelistet und können bei Bedarf einfach wiederhergestellt werden.</p>"
                    },
                    step5: {
                        title: "Abgeschlossene Aufgaben",
                        content: "<p>Zeigen Sie Ihre <b>abgeschlossenen Aufgaben</b> aus diesem Bereich an. Sie können den Status abgeschlossener Aufgaben ändern und sie bei Wunsch archivieren. Auf diese Weise können Sie eine Aufzeichnung Ihrer abgeschlossenen Arbeit führen und vergangene Leistungen analysieren.</p>"
                    }
                }
            },
            calendar: {
                title: "Kalender",
                content: "Verwalten Sie Ihren Besprechungs- und Aufgabenkalender.",
                steps: {
                    step1: {
                        title: "Kalender",
                        content: "<p>Planen Sie Ihre Besprechungen täglich einfach mit diesem interaktiven <b>Kalender</b>. Sie können neue Termine erstellen, bestehende Besprechungen über den Kalender aktualisieren oder sie absagen. Optimieren Sie Ihr Terminmanagement und kontrollieren Sie effektiv Ihren Zeitplan.</p>"
                    },
                    step2: {
                        title: "Reservierungswebsite",
                        content: "<p>Ermöglichen Sie Ihren Kunden, einfach Termine zu vereinbaren, indem Sie Ihre eigene <b>Reservierungswebsite</b> verwenden. Ihre Kunden können Reservierungen vornehmen, ihre bestehenden Termine anzeigen, aktualisieren oder stornieren über diese Seite.</p>"
                    },
                    step3: {
                        title: "Ihre Website anzeigen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um die von Ihnen erstellte Reservierungswebsite sofort anzuzeigen. <b>Überprüfen Sie die endgültige Version Ihrer Website</b> und erleben Sie, wie Ihre Kunden ihre Reservierungen sehen werden. Alle Ihre aktiven Reservierungen werden auf Ihrer Website aufgelistet.</p>"
                    },
                    step4: {
                        title: "Neue Reservierung erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>manuell eine neue Reservierung zu erstellen</b>. Durch Ausfüllen aller notwendigen Informationen können Sie den Termin schnell zu Ihrem Kalender hinzufügen und Ihre Besprechungen mit Ihren Kunden planen.</p>"
                    }
                }
            },
            websiteAnalysis: {
                title: "Website-Analyse",
                content: "Analysieren Sie das Besucherverhalten und gewinnen Sie Erkenntnisse.",
                steps: {
                    step1: {
                        title: "Gesamtbesucher",
                        content: "<p>Zeigen Sie die <b>Gesamtzahl der Besucher</b> Ihrer Website aus diesem Bereich an. Diese Metrik zeigt die Gesamtzahl der eindeutigen Besucher Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, die Gesamtreichweite Ihrer Seite zu verstehen.</p>"
                    },
                    step2: {
                        title: "Durchschnittliche Besucher",
                        content: "<p>Verfolgen Sie die <b>durchschnittliche tägliche oder periodische Anzahl der Besucher</b> Ihrer Website hier. Diese Metrik ist ein kritischer Indikator für die Bewertung der konsistenten Leistung Ihrer Seite über die Zeit.</p>"
                    },
                    step3: {
                        title: "Maximale Besucher",
                        content: "<p>Beobachten Sie die <b>Zeiten, in denen Ihre Website die höchste Anzahl von Besuchern erreicht hat</b> mit dieser Metrik. Sie zeigt die höchste Anzahl von Besuchern Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, Spitzenzeiten für Kampagnen oder Inhalte zu identifizieren.</p>"
                    },
                    step4: {
                        title: "Minimale Besucher",
                        content: "<p>Verfolgen Sie die <b>Zeiten, in denen Ihre Website die wenigsten Besucher erhalten hat</b> mit dieser Metrik. Sie zeigt die niedrigste Anzahl von Besuchern Ihrer Seite innerhalb eines bestimmten Zeitraums und hilft Ihnen, leistungsschwache Perioden zu identifizieren und notwendige Maßnahmen zu ergreifen.</p>"
                    }
                }
            },
            ticketSystem: {
                title: "Support-Ticket-System",
                content: "Organisieren Sie Kundenanfragen mit einem Ticket-System.",
                steps: {
                    step1: {
                        title: "Neuer Status",
                        content: "<p><b>Erstellen Sie neue Status</b>, um die Verwaltung Ihrer Support-Anfragen zu erleichtern. Zum Beispiel können Sie durch die Definition angepasster Status wie \"In Bearbeitung\", \"Gelöst\", \"Ausstehend\" den Ablauf von Anfragen transparenter gestalten.</p>"
                    },
                    step2: {
                        title: "Status",
                        content: "<p><b>Zeigen Sie die aktuellen Status</b> für jede hier geöffnete Support-Anfrage an. Durch die Verfolgung von Status wie \"Gelesen\", \"Beantwortet\", \"Storniert\" können Sie die aktuellen Phasen von Anfragen einfach sehen und ein effektives Prozessmanagement ermöglichen.</p>"
                    },
                    step3: {
                        title: "Ansichtsmodus",
                        content: "<p>Sie können zwischen <b>Listen- oder Kanban-Ansicht</b> wechseln, um Ihre Support-Anfragen effektiver zu verwalten. Durch Ändern des Ansichtsmodus können Sie die Status von Anfragen visuell verfolgen und das Layout wählen, das am besten zu Ihrem Arbeitsablauf passt.</p>"
                    }
                }
            },
            dynamicTables: {
                title: "Dynamische Tabellen",
                content: "Passen Sie Ihre Daten durch Filterung an und verwalten Sie sie.",
                steps: {
                    step1: {
                        title: "Kategorie erstellen",
                        content: "<p><b>Organisieren und verwalten Sie Ihre Daten besser, indem Sie Ihre Tabellen kategorisieren</b>. Durch die Verwendung der Kategorie-Erstellungsschaltfläche können Sie neue Kategorien definieren, Ihre Tabellen gruppieren und schneller auf die gesuchten Daten zugreifen.</p>"
                    },
                    step2: {
                        title: "Neue Tabelle erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>eine neue dynamische Tabelle zu erstellen, die auf Ihre Bedürfnisse zugeschnitten ist</b>. Durch Ausfüllen der erforderlichen Informationen auf dem Tabellenerstellungsbildschirm können Sie Ihre Daten in einer personalisierten Struktur speichern und verwalten.</p>"
                    },
                    step3: {
                        title: "Tabelle mit KI erstellen",
                        content: "<p>Verwenden Sie diese Schaltfläche, um <b>schnell neue Tabellen mit KI-Unterstützung zu erstellen</b>. Es reicht aus, die relevanten Informationen einzugeben, um eine Tabelle mit KI zu erstellen; das System hilft Ihnen dabei, effiziente Tabellen mit intelligenten Vorschlägen zu entwerfen.</p>"
                    }
                }
            },
            aiVoice: {
                title: "KI-Sprach-Agent",
                content: "Verwalten Sie die Gespräche Ihrer Benutzer mit KI-gestützten Sprach-Agenten.",
                steps: {
                    step1: {
                        title: "KI-Sprach-Agent-Integration",
                        content: "<p><b>Integrieren Sie Ihren KI-Sprach-Agent in Supsis</b>, um Ihre Kundenkommunikationsprozesse zu automatisieren und zu verbessern. Nach Abschluss der Integration können Sie Sprachinteraktionen effizienter verwalten und die Kundenzufriedenheit steigern.</p>"
                    }
                }
            }
        },
        common: {
            cancel: "Abbrechen",
            save: "Speichern",
            yes: "Ja",
            no: "Nein",
            create: "Erstellen",
            delete: "Löschen",
            edit: "Bearbeiten",
            add: "Hinzufügen",
            back: "Zurück",
            active: "Aktiv",
            inactive: "Inaktiv"
        },
        youtubeChannel: {
            youtubeIntegration: "YouTube-Integration",
            deleteYoutubeChannelInfo: "Möchten Sie diesen YouTube-Kanal wirklich löschen?",
            youtubeChannels: "YouTube-Kanäle",
            title: "YouTube-Kommentare",
            channelName: "Kanalname",
            channelDetail: "Kanaldetails",
            channelDetailDesc: "Verwalten Sie Ihren YouTube-Kanal",
            youtubeChannel: "YouTube-Kanal",
            status: "Status",
            active: "Aktiv",
            inactive: "Inaktiv",
            detail: "Detail",
            visibility: "Sichtbarkeit",
            videos: "Videos",
            comments: "Kommentare",
            visibilitySettings: "Sichtbarkeitseinstellungen",
            visibilityDescription: "Legen Sie fest, welche Benutzer und Abteilungen diesen Kanal sehen können",
            users: "Benutzer",
            departments: "Abteilungen",
            owners: "Besitzer",
            selectUsers: "Benutzer auswählen",
            selectDepartments: "Abteilungen auswählen",
            selectOwners: "Besitzer auswählen",
            deleteChannel: "Kanal löschen",
            deleteChannelDescription: "Möchten Sie diesen YouTube-Kanal wirklich löschen?",
            channelUpdatedSuccess: "Kanal erfolgreich aktualisiert",
            failedUpdateChannel: "Fehler beim Aktualisieren des Kanals",
            connectedSuccess: "YouTube-Konto erfolgreich verbunden",
            failedToCreateChannel: "Fehler beim Erstellen des Kanals",
            requiredChannel: "Kanalname ist erforderlich",
            oauthTimeout: "Autorisierungs-Zeitüberschreitung",
            all: "Alle",
            new: "Neu",
            replied: "Beantwortet",
            resolved: "Gelöst",
            searchComments: "Kommentare suchen",
            noCommentsFound: "Keine Kommentare gefunden",
            replies: "Antworten",
            like: "Gefällt mir",
            reply: "Antworten",
            replyToComment: "Auf Kommentar antworten",
            writeYourReply: "Antwort schreiben",
            pleaseEnterReply: "Bitte Antwort eingeben",
            replySuccess: "Antwort erfolgreich gesendet",
            errorSendingReply: "Fehler beim Senden der Antwort",
            statusUpdated: "Status aktualisiert",
            errorUpdatingStatus: "Fehler beim Aktualisieren des Status",
            errorFetchingComments: "Fehler beim Laden der Kommentare",
            commentLiked: "Kommentar mit „Gefällt mir“ markiert",
            errorLikingComment: "Fehler beim Markieren des Kommentars",
            noVideosFound: "Keine Videos gefunden",
            errorFetchingVideos: "Fehler beim Laden der Videos",
            refresh: "Aktualisieren",
            loadMore: "Mehr laden",
            ensureYouTubeAccount: "Stellen Sie sicher, dass Sie ein Google-/YouTube-Konto haben",
            ensureYouTubeChannel: "Stellen Sie sicher, dass Sie einen YouTube-Kanal haben",
            permissionDesc: "Supsis muss Zugriff auf Ihre YouTube-Kommentare haben.",
            connectToYouTube: "Mit YouTube verbinden",
            views: "Aufrufe",
            likes: "Gefällt mir",
            sync: "Synchronisieren",
            commentsSynced: "Kommentare synchronisiert",
            errorSyncingComments: "Fehler beim Synchronisieren der Kommentare",
            pending: "Ausstehend",
            rejected: "Abgelehnt",
            moderation: "Moderation",
            publish: "Veröffentlichen",
            holdForReview: "Zur Prüfung vorgelegt",
            reject: "Ablehnen",
            rejectAndBan: "Ablehnen und sperren",
            moderationSuccess: "Moderation erfolgreich",
            errorModeration: "Moderation fehlgeschlagen",
            videoDetail: "Videodetails",
            duration: "Dauer",
            showMore: "Mehr anzeigen",
            showLess: "Weniger anzeigen",
            loadingVideo: "Video wird geladen...",
            videoNotFound: "Video nicht gefunden",
            goBack: "Zurück",
            errorLoadingVideo: "Fehler beim Laden des Videos",
            videosSynced: "Videos synchronisiert",
            errorSyncingVideos: "Fehler beim Synchronisieren der Videos",
            selectVideo: "Video auswählen",
            allVideos: "Alle Videos",
            selectCommentToPreview: "Kommentar zur Vorschau auswählen",
            viewDetails: "Details anzeigen",
            published: "Veröffentlicht",
            heldForReview: "Zur Prüfung vorgelegt"
        },
        googleBusiness: {
            title: "Google-Bewertungen",
            channels: "Google-Business-Kanäle",
            channelName: "Kanalname",
            channelDetails: "Kanaldetails",
            connectToGoogleBusiness: "Mit Google Business verbinden",
            ensureGoogleAccount: "Stellen Sie sicher, dass Sie ein Google-Konto haben",
            ensureBusinessProfile: "Stellen Sie sicher, dass Sie ein Google-Business-Profil haben",
            permissionDesc: "Supsis muss Zugriff auf Ihre Google-Bewertungen haben.",
            requiredChannel: "Kanalname ist erforderlich",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            connectedSuccess: "Google-Business-Konto erfolgreich verbunden",
            oauthTimeout: "Autorisierung abgelaufen",
            deleteChannelInfo: "Möchten Sie diesen Google-Business-Kanal wirklich löschen?",
            deleteChannel: "Kanal löschen",
            deleteChannelDescription: "Möchten Sie diesen Google-Business-Kanal wirklich löschen?",
            detail: "Details",
            visibility: "Sichtbarkeit",
            locations: "Standorte",
            reviews: "Bewertungen",
            accountInfo: "Kontoinformationen",
            accountName: "Kontoname",
            accountId: "Konto-ID",
            status: "Status",
            enabled: "Aktiviert",
            disabled: "Deaktiviert",
            save: "Speichern",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            errorUpdatingChannel: "Fehler beim Aktualisieren des Kanals",
            visibilityDescription: "Festlegen, welche Benutzer und Abteilungen diesen Kanal sehen können",
            visibleToUsers: "Sichtbar für Benutzer",
            visibleToDepartments: "Sichtbar für Abteilungen",
            selectUsers: "Benutzer auswählen",
            selectDepartments: "Abteilungen auswählen",
            visibilityUpdated: "Sichtbarkeitseinstellungen aktualisiert",
            errorUpdatingVisibility: "Fehler beim Aktualisieren der Sichtbarkeit",
            sync: "Synchronisieren",
            refresh: "Aktualisieren",
            locationsSynced: "Standorte synchronisiert",
            errorSyncingLocations: "Fehler beim Synchronisieren der Standorte",
            errorFetchingLocations: "Fehler beim Laden der Standorte",
            noLocationsFound: "Keine Standorte gefunden",
            selectLocation: "Standort auswählen",
            allLocations: "Alle Standorte",
            allRatings: "Alle Bewertungen",
            all: "Alle",
            new: "Neu",
            replied: "Beantwortet",
            resolved: "Erledigt",
            noReviewsFound: "Keine Bewertungen gefunden",
            noComment: "Kein Kommentartext",
            selectReviewToPreview: "Bewertung zur Vorschau auswählen",
            yourReply: "Ihre Antwort",
            reply: "Antworten",
            updateReply: "Antwort aktualisieren",
            replyToReview: "Auf Bewertung antworten",
            writeYourReply: "Antwort schreiben",
            pleaseEnterReply: "Bitte Antwort eingeben",
            replySuccess: "Antwort erfolgreich gesendet",
            errorSendingReply: "Fehler beim Senden der Antwort",
            statusUpdated: "Status aktualisiert",
            errorUpdatingStatus: "Fehler beim Aktualisieren des Status",
            errorFetchingReviews: "Fehler beim Laden der Bewertungen"
        },
        googlePlay: {
            title: "Google-Play-Bewertungen",
            channels: "Google-Play-Kanäle",
            channelName: "Kanalname",
            channelDetails: "Kanaldetails",
            connectToGooglePlay: "Mit Google Play verbinden",
            ensureGoogleAccount: "Stellen Sie sicher, dass Sie ein Google-Konto haben",
            ensurePlayConsole: "Stellen Sie sicher, dass Sie ein Google-Play-Console-Konto haben",
            permissionDesc: "Supsis muss Zugriff auf Ihre Google-Play-Bewertungen haben.",
            requiredChannel: "Kanalname ist erforderlich",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            connectedSuccess: "Google-Play-Konto erfolgreich verbunden",
            oauthTimeout: "Autorisierung abgelaufen",
            deleteChannelInfo: "Möchten Sie diesen Google-Play-Kanal wirklich löschen?",
            deleteChannel: "Kanal löschen",
            deleteChannelDescription: "Möchten Sie diesen Google-Play-Kanal wirklich löschen?",
            detail: "Details",
            visibility: "Sichtbarkeit",
            apps: "Apps",
            reviews: "Bewertungen",
            status: "Status",
            enabled: "Aktiviert",
            disabled: "Deaktiviert",
            save: "Speichern",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            errorUpdatingChannel: "Fehler beim Aktualisieren des Kanals",
            visibilityDescription: "Festlegen, welche Benutzer und Abteilungen diesen Kanal sehen können",
            visibleToUsers: "Sichtbar für Benutzer",
            visibleToDepartments: "Sichtbar für Abteilungen",
            selectUsers: "Benutzer auswählen",
            selectDepartments: "Abteilungen auswählen",
            visibilityUpdated: "Sichtbarkeitseinstellungen aktualisiert",
            errorUpdatingVisibility: "Fehler beim Aktualisieren der Sichtbarkeit",
            addApp: "App hinzufügen",
            refresh: "Aktualisieren",
            noAppsFound: "Keine Apps gefunden",
            packageName: "Paketname",
            appName: "App-Name",
            appNamePlaceholder: "z. B.: Meine App",
            iconUrl: "Symbol-URL",
            fillRequiredFields: "Bitte füllen Sie die Pflichtfelder aus",
            appAdded: "App erfolgreich hinzugefügt",
            errorAddingApp: "Fehler beim Hinzufügen der App",
            syncReviews: "Bewertungen synchronisieren",
            reviewsSynced: "Bewertungen synchronisiert",
            errorSyncingReviews: "Fehler beim Synchronisieren der Bewertungen",
            removeApp: "App entfernen",
            removeAppConfirm: "Möchten Sie {name} wirklich entfernen? Alle zugehörigen Bewertungen werden ebenfalls gelöscht.",
            appRemoved: "App entfernt",
            errorRemovingApp: "Fehler beim Entfernen der App",
            errorFetchingApps: "Fehler beim Laden der Apps",
            selectApp: "App auswählen",
            allApps: "Alle Apps",
            allRatings: "Alle Bewertungen",
            all: "Alle",
            new: "Neu",
            replied: "Beantwortet",
            resolved: "Erledigt",
            noReviewsFound: "Keine Bewertungen gefunden",
            noComment: "Kein Kommentartext",
            selectReviewToPreview: "Bewertung zur Vorschau auswählen",
            yourReply: "Ihre Antwort",
            reply: "Antworten",
            updateReply: "Antwort aktualisieren",
            replyToReview: "Auf Bewertung antworten",
            writeYourReply: "Antwort schreiben (max. 350 Zeichen)",
            pleaseEnterReply: "Bitte Antwort eingeben",
            replyTooLong: "Antwort darf maximal 350 Zeichen haben",
            replySuccess: "Antwort erfolgreich gesendet",
            errorSendingReply: "Fehler beim Senden der Antwort",
            statusUpdated: "Status aktualisiert",
            errorUpdatingStatus: "Fehler beim Aktualisieren des Status",
            errorFetchingReviews: "Fehler beim Laden der Bewertungen",
            deviceInfo: "Geräteinformationen",
            device: "Gerät",
            appVersion: "App-Version",
            manufacturer: "Hersteller"
        },
        googleDrive: {
            title: "Google Drive",
            googleDriveChannels: "Google-Drive-Kanäle",
            googleDriveIntegration: "Google-Drive-Integration",
            channelName: "Kanalname",
            channelInfo: "Kanalinformationen",
            channelSettings: "Kanaleinstellungen",
            connectedAccount: "Verbundenes Konto",
            storageQuota: "Speicherkontingent",
            connectToGoogleDrive: "Mit Google Drive verbinden",
            ensureGoogleAccount: "Stellen Sie sicher, dass Sie ein Google-Konto haben",
            ensureGoogleDriveAccess: "Stellen Sie sicher, dass Sie Google-Drive-Zugriff haben",
            permissionDesc: "Supsis muss Zugriff auf Ihre Google-Drive-Dateien haben.",
            requiredChannel: "Kanalname ist erforderlich",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            connectedSuccess: "Google-Drive-Konto erfolgreich verbunden",
            oauthTimeout: "Autorisierung abgelaufen",
            deleteGoogleDriveChannelInfo: "Möchten Sie diesen Google-Drive-Kanal wirklich löschen?",
            deleteChannel: "Kanal löschen",
            deleteChannelDescription: "Möchten Sie diesen Google-Drive-Kanal wirklich löschen?",
            driveExplorer: "Drive-Explorer",
            myDrive: "Mein Drive",
            sharedDrives: "Freigegebene Laufwerke",
            searchFiles: "Dateien suchen...",
            noSharedDrives: "Keine freigegebenen Laufwerke gefunden",
            noFiles: "Keine Dateien gefunden",
            loadMore: "Mehr laden",
            filesSelected: "Dateien ausgewählt",
            downloadToSupsis: "In Supsis herunterladen",
            fileDownloaded: "Datei erfolgreich heruntergeladen",
            errorLoadingFiles: "Fehler beim Laden der Dateien",
            errorLoadingDrives: "Fehler beim Laden der Laufwerke",
            errorSearching: "Fehler bei der Suche",
            errorDownloading: "Fehler beim Herunterladen der Datei",
            fileName: "Dateiname",
            fileSize: "Größe",
            modifiedTime: "Geändert am",
            selectFile: "Datei auswählen",
            selectFileFromGoogleDrive: "Datei aus Google Drive auswählen",
            selectChannel: "Kanal auswählen",
            noChannelsAvailable: "Keine zugänglichen Google-Drive-Kanäle gefunden",
            selectedFiles: "Ausgewählte Dateien",
            upload: "Hochladen",
            selectUploadMethod: "Upload-Methode wählen:",
            uploadFromComputer: "Vom Computer hochladen",
            downloadingFiles: "Dateien werden heruntergeladen...",
            myChannel: "Meine",
            manageWhoCanAccess: "Festlegen, wer auf diesen Kanal zugreifen kann",
            download: "Herunterladen",
            openInNewTab: "In neuem Tab öffnen",
            openInGoogleDrive: "In Google Drive öffnen",
            fileType: "Dateityp",
            owner: "Besitzer",
            previewNotAvailable: "Vorschau für diesen Dateityp nicht verfügbar",
            byocTitle: "Eigene Google-Cloud-Anmeldedaten verwenden",
            byocDescription: "Für die Google-Drive-Integration müssen Sie OAuth-Client-Anmeldedaten in der Google Cloud Console erstellen.",
            clientId: "OAuth-Client-ID",
            clientIdPlaceholder: "xxxxxxxx.apps.googleusercontent.com",
            clientIdRequired: "Client-ID ist erforderlich",
            clientSecret: "OAuth-Client-Geheimnis",
            clientSecretPlaceholder: "GOCSPX-xxxxxxxxxx",
            clientSecretRequired: "Client-Geheimnis ist erforderlich",
            redirectUriCopied: "Weiterleitungs-URI kopiert",
            setupGuideTitle: "Einrichtungsanleitung (zum Aufklappen klicken)",
            setupStep1: "Gehen Sie zur Google Cloud Console und erstellen Sie ein neues Projekt oder wählen Sie ein bestehendes.",
            setupStep2: "Navigieren Sie zu APIs & Dienste > Anmeldedaten.",
            setupStep3: "Klicken Sie auf „+ ANMELDEDATEN ERSTELLEN“ > „OAuth-Client-ID“. Wählen Sie „Webanwendung“ als Anwendungstyp.",
            setupStep4: "Fügen Sie die folgende URL zum Abschnitt „Autorisierte Weiterleitungs-URIs“ hinzu:",
            setupStep5: "Aktivieren Sie „Google Drive API“ unter APIs & Dienste > Bibliothek.",
            setupStep6: "Kopieren Sie Client-ID und Client-Geheimnis und fügen Sie sie in die Felder oben ein."
        },
        appStore: {
            title: "App-Store-Bewertungen",
            channels: "App-Store-Kanäle",
            channelName: "Kanalname",
            channelDetails: "Kanaldetails",
            connectToAppStore: "Mit App Store verbinden",
            credentials: "API-Anmeldedaten",
            credentialsHelp: "App-Store-Connect-API-Anmeldedaten eingeben. API-Schlüssel erstellen unter",
            issuerId: "Issuer-ID",
            issuerIdPlaceholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
            keyId: "Key-ID",
            keyIdPlaceholder: "XXXXXXXXXX",
            privateKey: "Privater Schlüssel (.p8-Dateiinhalt)",
            privateKeyPlaceholder: "-----BEGIN PRIVATE KEY-----\n...\n-----END PRIVATE KEY-----",
            requiredField: "Dieses Feld ist erforderlich",
            validateCredentials: "Anmeldedaten prüfen",
            credentialsValid: "Anmeldedaten sind gültig",
            credentialsInvalid: "Ungültige Anmeldedaten",
            pleaseValidateFirst: "Bitte zuerst Anmeldedaten prüfen",
            failedToCreateChannel: "Kanal konnte nicht erstellt werden",
            connectedSuccess: "App-Store-Konto erfolgreich verbunden",
            deleteChannelInfo: "Möchten Sie diesen App-Store-Kanal wirklich löschen?",
            deleteChannel: "Kanal löschen",
            deleteChannelDescription: "Möchten Sie diesen App-Store-Kanal wirklich löschen?",
            detail: "Details",
            visibility: "Sichtbarkeit",
            apps: "Apps",
            reviews: "Bewertungen",
            status: "Status",
            enabled: "Aktiviert",
            disabled: "Deaktiviert",
            save: "Speichern",
            channelUpdated: "Kanal erfolgreich aktualisiert",
            errorUpdatingChannel: "Fehler beim Aktualisieren des Kanals",
            visibilityDescription: "Festlegen, welche Benutzer und Abteilungen diesen Kanal sehen können",
            visibleToUsers: "Sichtbar für Benutzer",
            visibleToDepartments: "Sichtbar für Abteilungen",
            selectUsers: "Benutzer auswählen",
            selectDepartments: "Abteilungen auswählen",
            visibilityUpdated: "Sichtbarkeitseinstellungen aktualisiert",
            errorUpdatingVisibility: "Fehler beim Aktualisieren der Sichtbarkeit",
            syncApps: "Apps synchronisieren",
            refresh: "Aktualisieren",
            noAppsFound: "Keine Apps gefunden",
            appsAutoFetch: "Apps werden automatisch aus App Store Connect geladen. „Apps synchronisieren“ klicken zum Aktualisieren.",
            appsSynced: "Apps erfolgreich synchronisiert",
            errorSyncingApps: "Fehler beim Synchronisieren der Apps",
            syncReviews: "Bewertungen synchronisieren",
            reviewsSynced: "Bewertungen synchronisiert",
            errorSyncingReviews: "Fehler beim Synchronisieren der Bewertungen",
            errorFetchingApps: "Fehler beim Laden der Apps",
            selectApp: "App auswählen",
            allApps: "Alle Apps",
            all: "Alle",
            new: "Neu",
            replied: "Beantwortet",
            resolved: "Erledigt",
            noReviewsFound: "Keine Bewertungen gefunden",
            noComment: "Kein Kommentartext",
            anonymous: "Anonym",
            selectReviewToPreview: "Bewertung zur Vorschau auswählen",
            yourReply: "Ihre Antwort",
            reply: "Antworten",
            edit: "Bearbeiten",
            delete: "Löschen",
            editReply: "Antwort bearbeiten",
            replyToReview: "Auf Bewertung antworten",
            writeYourReply: "Antwort schreiben",
            pleaseEnterReply: "Bitte Antwort eingeben",
            replySuccess: "Antwort erfolgreich gesendet",
            errorSendingReply: "Fehler beim Senden der Antwort",
            deleteResponse: "Antwort löschen",
            deleteResponseConfirm: "Möchten Sie diese Antwort wirklich löschen?",
            responseDeleted: "Antwort erfolgreich gelöscht",
            errorDeletingResponse: "Fehler beim Löschen der Antwort",
            statusUpdated: "Status aktualisiert",
            errorUpdatingStatus: "Fehler beim Aktualisieren des Status",
            errorFetchingReviews: "Fehler beim Laden der Bewertungen",
            territory: "Territorium",
            region: "Region"
        },
        LinkedinContacts: "LinkedIn-Kontakte",
        TelegramContacts: "Telegram-Kontakte",
        packages: {
            mostPopular: "AM BELIEBTESTEN",
            currency: "₺",
            activePlan: "AKTIVER PLAN"
        },
        totalCost: {
            title: "SUPSIS-KOSTEN",
            monthlyPayments: "Monatliche Zahlungen",
            currency: "₺",
            currencyMonthly: "₺ / Monat",
            oneTimePayments: "Einmalzahlungen",
            oneTimeDiscount: "Jahrespaket-Rabatt",
            currencyYearly: "₺ / Jahr",
            totalOneTimeCost: "Gesamtbetrag einmalig",
            totalTax: "MwSt. (18 %)",
            referenceCode: "Haben Sie einen Referenzcode?",
            referencePlaceholder: "Bitte Code eingeben",
            codeButton: "Anwenden",
            monthlyCost: "Monatlich von Ihrem Konto abgebuchter Betrag?",
            oneTimeFullCost: "Einmalbetrag inklusive aller Kosten?",
            payment: "Zahlung durchführen"
        },
        waba: {
            templateCreationFailed: "Vorlagenerstellung fehlgeschlagen",
            templateError_2388040: "Zeichenlimit überschritten",
            templateErrorDesc_2388040: "Ein Feld in Ihrer Vorlage hat das zulässige Zeichenlimit überschritten.",
            templateError_2388047: "Nachrichtenkopfformat ist falsch",
            templateErrorDesc_2388047: "Der Nachrichtenkopf enthält ungültige Formatierung.",
            templateError_2388072: "Nachrichtentextformat ist falsch",
            templateErrorDesc_2388072: "Der Nachrichtentext enthält ungültige Formatierung.",
            templateError_2388073: "Nachrichtenfußformat ist falsch",
            templateErrorDesc_2388073: "Der Nachrichtenfuß enthält ungültige Formatierung.",
            templateError_2388293: "Verhältnis Variablen zu Text überschreitet Limit",
            templateErrorDesc_2388293: "Diese Vorlage hat zu viele Variablen für ihre Länge. Reduzieren Sie die Variablen oder verlängern Sie den Text.",
            templateError_2388299: "Variablen am Anfang oder Ende nicht erlaubt",
            templateErrorDesc_2388299: "Variablen dürfen nicht am Anfang oder Ende der Vorlage stehen."
        },
        profile: {
            subtitle: "Kontoeinstellungen und Sitzungen verwalten"
        },
        integrations: {
            requiredField: "Dieses Feld ist erforderlich",
            existingChannels: "Vorhandene Kanäle",
            createNewChannel: "Neuen Kanal erstellen",
            channelName: "Kanalname",
            createChannel: "Kanal erstellen",
            channelCreated: "Kanal erfolgreich erstellt",
            channelCreateError: "Beim Erstellen des Kanals ist ein Fehler aufgetreten",
            channelActivated: "Kanal aktiviert",
            channelDeactivated: "Kanal deaktiviert",
            channelUpdateError: "Beim Aktualisieren des Kanals ist ein Fehler aufgetreten",
            deleteChannelConfirm: "Kanal löschen",
            deleteChannelConfirmContent: "Sind Sie sicher, dass Sie den Kanal {name} löschen möchten?",
            channelDeleted: "Kanal erfolgreich gelöscht",
            channelDeleteError: "Beim Löschen des Kanals ist ein Fehler aufgetreten",
            slackIntegration: "Slack-Integration",
            slackDescription: "Nachrichten über Supsis-Automatisierung und Chatbot an Ihren Slack-Arbeitsbereich senden.",
            slackSetupTitle: "Einrichtungsschritte:",
            slackStep1: "Gehen Sie zu api.slack.com/apps",
            slackStep2: "Wählen Sie Ihre bestehende Slack-App oder erstellen Sie eine neue",
            slackStep3: "Klicken Sie im linken Menü auf „Incoming Webhooks“ und schalten Sie es auf „Ein“",
            slackStep4: "Klicken Sie auf „Add New Webhook to Workspace“ und wählen Sie den Kanal für Ihre Nachrichten",
            slackCardDescription: "Nachrichten über Automatisierung und Chatbot an Slack-Kanäle senden",
            slackChannelNamePlaceholder: "z. B.: Support-Benachrichtigungen",
            slackWebhookUrl: "Webhook-URL",
            slackWebhookUrlPlaceholder: "https://hooks.slack.com/services/...",
            slackWebhookUrlHelper: "Slack-App > Incoming Webhooks > Add New Webhook to Workspace",
            slackWebhookUrlInvalid: "Bitte geben Sie eine gültige Slack-Webhook-URL ein",
            slackDefaultChannel: "Standardkanal (optional)",
            slackDefaultChannelPlaceholder: "#general",
            slackDefaultChannelHelper: "Wenn nicht angegeben, wird der mit dem Webhook verbundene Kanal verwendet",
            pushoverIntegration: "Pushover-Integration",
            pushoverCardDescription: "Push-Benachrichtigungen über Automatisierung und Chatbot an Ihre Geräte senden",
            pushoverDescription: "Push-Benachrichtigungen über Supsis-Automatisierung und Chatbot an Ihre Geräte senden. Konto und User Key/App Token erhalten Sie auf pushover.net.",
            pushoverChannelNamePlaceholder: "z. B.: Mobil-Benachrichtigungen",
            pushoverUserKey: "Benutzerschlüssel",
            pushoverUserKeyPlaceholder: "Pushover-Benutzerschlüssel",
            pushoverUserKeyHelper: "Erhältlich auf Ihrer pushover.net-Kontoseite",
            pushoverAppToken: "App-Token",
            pushoverAppTokenPlaceholder: "Pushover-App-Token",
            pushoverAppTokenHelper: "Erstellen Sie eine Anwendung auf pushover.net, um den Token zu erhalten"
        },
        "At the end of the month, an invoice will be created according to your usage amount": "Am Ende des Monats wird eine Rechnung entsprechend Ihrer Nutzungsmenge erstellt.",
        "No money will be withdrawn from your account": "Es wird kein Geld von Ihrem Konto abgebucht.",
        "Would you like to make default this story?": "Möchten Sie diese Story als Standard festlegen?",
        addWebhook: "Webhook hinzufügen",
        allIntegrations: "Alle Integrationen",
        editWebhook: "Webhook bearbeiten",
        integrateYourCBwithChatGpt3: "Der Chatbot kann mit GPT-4 integriert werden. Ein GPT-4-API-Schlüssel ist erforderlich.",
        integrateYourCBwithChatWidget: "Integrieren Sie Ihren Chatbot mit dem Chat-Widget.",
        integrateYourCBwithIntegratable: "Chat-Informationen einfach zwischen Chatbot und {integratable} austauschen.",
        integrateYourCBwithWebHook: "Chat-Informationen einfach zwischen Chatbot und Ihren Webdiensten austauschen.",
        newWebhook: "Neuer Webhook",
        webhookPassword: "Webhook-Passwort",
        webhookTitle: "Webhook-Bezeichnung",
        webhookToken: "Webhook-Token",
        webhookUrl: "Webhook-URL",
        webhookUsername: "Webhook-Benutzername",
        "{contentOfChatBubble}": "{contentOfChatBubble}",
        task_reports: {
            title: "Aufgabenberichte",
            date: "Datum",
            workflow: "Arbeitsablauf",
            select: "Auswählen",
            agent: "Agent",
            all: "Alle",
            select_workflow_to_view_reports: "Wählen Sie einen Arbeitsablauf aus, um Berichte anzuzeigen.",
            created_task: "Erstellte Aufgabe",
            updated_task: "Aktualisierte Aufgabe",
            assigned_tasks_by_personnel: "Zugewiesene Aufgaben nach Personal",
            assigned_task: "Zugewiesene Aufgabe",
            no_assigned_task_found_in_date_range: "Keine zugewiesenen Aufgaben im ausgewählten Datumsbereich gefunden.",
            updated_tasks: "Aktualisierte Aufgaben",
            task: "Aufgabe",
            current_stage: "Aktuelle Phase",
            assigned: "Zugewiesen",
            update: "Aktualisierung",
            no_updated_task_found_in_date_range: "Keine aktualisierten Aufgaben im ausgewählten Datumsbereich gefunden.",
            task_distribution_by_agent: "Aufgabenverteilung nach Agent",
            total: "Gesamt",
            no_assigned_task_found: "Keine zugewiesenen Aufgaben gefunden.",
            timeline: "Zeitachse",
            unassigned_tasks: "Nicht zugewiesene Aufgaben",
            transition_process: "Übergangsprozess",
            no_active_task_found_for_agent: "Keine aktiven Aufgaben für diesen Agenten gefunden.",
            select_agent_to_view_timeline: "Wählen Sie einen Agenten aus, um die Zeitachse anzuzeigen.",
            entry: "Eintritt",
            exit: "Austritt",
            still_in_this_stage: "Noch in dieser Phase",
            duration: "Dauer",
            day: "Tag",
            hour: "Stunde",
            max_30_days_range_warning: "Sie können einen Datumsbereich von bis zu 30 Tagen auswählen.",
            today: "Heute",
            this_week: "Diese Woche",
            this_month: "Diesen Monat",
            last_month: "Letzten Monat",
            unknown: "Unbekannt",
            unassigned: "Nicht zugewiesen",
            gantt: "Gantt",
            table: "Tabelle"
        },
        customBlockErrors: {
            BLOCK_NOT_FOUND: "Block nicht gefunden",
            BLOCK_NOT_APPROVED: "Dieser Block wurde noch nicht genehmigt",
            BLOCK_ALREADY_IMPORTED: "Dieser Block wurde bereits importiert",
            BLOCK_IMPORT_FAILED: "Block konnte nicht importiert werden"
        },
        developer: {
            webhookUrls: "Webhook-URLs",
            webhookUrlsDescription: "Eingehende Nachrichten werden an diese URLs weitergeleitet.",
            webhookNamePlaceholder: "Name (z. B. Mein System)",
            webhookUrlPlaceholder: "https://...",
            addWebhook: "Webhook hinzufügen",
            webhookSaved: "Webhook-URLs gespeichert.",
            webhookSaveError: "Speichern fehlgeschlagen.",
            webhookValidationError: "Alle Webhook-Felder müssen ausgefüllt sein.",
            messagingApi: "Messaging-API",
            messagingApiDescription: "Senden Sie Nachrichten über diesen Kanal von Ihren eigenen Systemen.",
            endpoint: "Endpunkt",
            authentication: "Authentifizierung",
            requestBody: "Anfragekörper (Beispiele)",
            webhookPayload: "Webhook-Payload (Eingehende Nachricht)",
            noToken: "Noch kein Token erstellt.",
            tokenGenerateWarning: "Wenn Sie auf Token generieren klicken, wird Ihr aktueller Token ungültig.",
            tokenGenerated: "Token erfolgreich erstellt.",
            tokenGenerateError: "Token konnte nicht erstellt werden.",
            copied: "Kopiert.",
            sendMessageDesc: "Sendet eine Nachricht über diesen Kanal an den angegebenen Kunden.",
            fromParamsDesc: "from: api (Standard) | user | chatbot. userId erforderlich bei from=user. chatbot sendet als Chatbot.",
            userIdParamsDesc: "userId (User ObjectId) ist erforderlich. Nachricht wird im Namen des angegebenen Benutzers gesendet.",
            fromUserIdParamsDesc: "from (User ObjectId) ist erforderlich. Nachricht wird im Namen des angegebenen Benutzers gesendet.",
            contactIdParamsDesc: "Dies ist die Besucher-ID. Sie können sie aus dem Feld visitor.id der Webhook-Payload entnehmen.",
            webhookEventReceived: "Eingehende Nachricht",
            webhookEventSent: "Ausgehende Nachricht",
            yourWebhookUrl: "<Ihre-Webhook-URL>",
            webhookPayloadDesc: "Bei jeder eingehenden Nachricht wird eine POST-Anfrage an Ihre Webhook-URLs gesendet.",
            webhookSentDesc: "Wenn per API gesendete Nachrichten verarbeitet werden, wird das message.sent-Event an den Webhook gesendet. status: sent (delivered, failed werden später hinzugefügt).",
            curlExample: "cURL-Beispiel",
        }
    }
};

export default messagesDE;
